import _, { range } from 'lodash';
import React, { useContext, useMemo, useState, useEffect, useRef, useCallback, Fragment, createContext, forwardRef, Children, createRef, useLayoutEffect } from 'react';
import { ThemeContext, Text as Text$1, Box, Drop, DropButton, ResponsiveContext, Keyboard, Button as Button$2, Layer, Grid as Grid$1, CheckBox as CheckBox$1, DataTable, TableHeader as TableHeader$2, TableRow, TableCell, TableBody as TableBody$2, Table as Table$3, TextInput as TextInput$1, Heading, Collapsible, Anchor, Form as Form$1, FormField as FormField$1, Select as Select$1, SelectMultiple as SelectMultiple$1, RadioButtonGroup as RadioButtonGroup$1, RadioButton as RadioButton$1, MaskedInput as MaskedInput$1, TextArea as TextArea$1, DateInput, Image as Image$1, Grommet } from 'grommet';
import styled, { keyframes } from 'styled-components';
import { __rest, __awaiter } from 'tslib';
import moment from 'moment';
import { hpe } from 'grommet-theme-hpe';
import { useTable, useSortBy } from 'react-table';
import { useDropzone } from 'react-dropzone';
import { timeFormat, arc, scaleTime, scaleLinear, select, axisBottom, scalePoint, axisLeft, line, area, extent } from 'd3';
import { CSVDownload } from 'react-csv';
import RIframe from 'react-iframe';

/* eslint-disable @typescript-eslint/indent */
/**
 * exported constants:
 *  * SizeKeys // Deprecating
 * WeightKeys, WeightType
 *  * (Color information moved to src/Theming folder)
 */
const WeightType = {
    bold: 700,
    medium: 600,
    normal: 400,
    light: 300,
};
const loginFormContainerWidth = '320px';
let config = {
    testIdAttribute: 'data-test-id',
};
const configure = (newConfig) => {
    config = Object.assign(Object.assign({}, config), newConfig);
};
const getTestIdAttribute = (value) => {
    const opts = {};
    if (typeof value !== 'undefined' && value !== null) {
        opts[`${config.testIdAttribute}`] = value;
        return opts;
    }
    return false;
};

const CuroColors = {
    default: {
        light: '#444444',
        dark: '#EEEEEE',
    },
    brand: {
        light: '#01A982',
        dark: '#01A982',
    },
    success: {
        light: '#01A982',
        dark: '#01A982',
    },
    error: {
        light: '#CA2B4E',
        dark: '#FC6161',
    },
    warning: {
        light: '#FC9935',
        dark: '#FC9935',
    },
    info: {
        light: '#1973CB',
        dark: '#11CCFF',
    },
    black: {
        light: '#000000',
        dark: '#FFFFFF',
    },
    slate: {
        light: '#425563',
        dark: '#C0CADC',
    },
    gray: {
        light: '#757575',
        dark: '#BDBDBD',
    },
    disabled: {
        light: '#999999',
        dark: '#606B7D',
    },
    white: {
        light: '#FFFFFF',
        dark: '#263040',
    },
    darkDefault: {
        light: '#EEEEEE',
        dark: '#444444',
    },
};
const InternalColors = {
    darkSlate: {
        light: '#0F2520',
        dark: '#F6F6F6',
    },
    focus: {
        light: '#14D3CA',
        dark: '#14D3CA',
    },
    dimGray: {
        light: '#666666',
        dark: '#BDBDBD',
    },
    mediumGray: {
        light: '#CCCCCC',
        dark: '#222A37',
    },
    gainsboro: {
        light: '#DDDDDD',
        dark: '#7887A1',
    },
    lightMediumGray: {
        light: '#EEEEEE',
        dark: '#404B5C',
    },
    coolGray: {
        light: '#E2E6EA',
        dark: '#404B5C',
    },
    neutral: {
        light: '#EEEEEE',
        dark: '#181B20',
    },
    solitude: {
        light: '#EFF1F5',
        dark: '#404B5C',
    },
    lightCoolGray: {
        light: '#F4F6F9',
        dark: '#202732',
    },
    lightGray: {
        light: '#F6F6F6',
        dark: '#404B5C',
    },
    lighterGray: {
        light: '#FAFAFA',
        dark: '#222A37',
    },
    lightSlate: {
        light: '#DCE0E8',
        dark: '#DCE0E8',
    },
    lighShadeCyne: {
        light: '#D4F6F4',
        dark: '#306360',
    },
    paleCyan: {
        light: '#EAFBFA',
        dark: '#315351',
    },
};
const ChartColors = {
    series1: {
        light: '#2AD2C9',
        dark: '#2AD2C9',
    },
    series2: {
        light: '#1973CB',
        dark: '#1973CB',
    },
    series3: {
        light: '#7630EA',
        dark: '#CCAAFF',
    },
    series4: {
        light: '#77BC1F',
        dark: '#77BC1F',
    },
    series5: {
        light: '#ACD9FF',
        dark: '#ACD9FF',
    },
    series6: {
        light: '#FFBC45',
        dark: '#FFE100',
    },
    series7: {
        light: '#F740FF',
        dark: '#F740FF',
    },
    series8: {
        light: '#425563',
        dark: '#EEEEEE',
    },
    forecast: {
        light: '#002E6D',
        dark: '#7887A1',
    },
};
// for deprecated ColorType compatibility
// old ColorType does not have dark theme colors
// @ts-ignore
const LightCuroColors = _.mapValues(CuroColors, 'light');
// To-Do: Remove ignore
// @ts-ignore
const LightInternalColors = _.mapValues(InternalColors, 'light');

const en = {
    // login page
    forgotPassword: 'Forgot password?',
    username: 'Username',
    password: 'Password',
    copyrightLabel: 'Hewlett Packard Enterprise Development LP',
    // charts
    last1Hour: '1H',
    last3Hours: '3H',
    last8Hours: '8H',
    last1Day: '1D',
    last1Week: '1W',
    last1Month: '1M',
    last3Months: '3M',
    last1Year: '1Y',
    all: 'All',
    realTime: 'Real-Time',
    custom: 'Custom',
    startTime: 'Start Time',
    startDate: '',
    endTime: 'End Time',
    endDate: 'End Date',
    pause: 'Pause',
    resume: 'Resume',
    setStartDate: 'Set start date',
    setEndDate: 'Set end date',
    // text input
    example: 'example',
    my: 'my',
    com: 'com',
    mm: 'mm',
    dd: 'dd',
    yyyy: 'yyyy',
    nnn: 'nnn',
    gb: 'gb',
    GB: 'GB',
    TB: 'TB',
    MB: 'MB',
    // tag
    clearAll: 'Clear All',
    // wizard
    cancel: 'Cancel',
    submit: 'Submit',
    // TaskManager
    viewDetails: 'View Details',
    acknowledge: 'Acknowledge',
    of: 'of',
    // icons
    alarm: 'Alarms',
    apps: 'Application',
    asterisk: 'Required',
    sun: 'Light Mode',
    moon: 'Dark Mode',
    bullet: 'Item',
    circle: 'Status',
    export: 'Export',
    calendar: 'Select Date',
    dashboard: 'Dashboard',
    analyticsDashboard: 'Dashboard',
    manage: 'Manage',
    hardware: 'Hardware',
    arrayStack: 'Arrays',
    headShelf: 'Head Shelf',
    expansionShelf: 'Expansion Shelf',
    node: 'Node',
    monitor: 'Monitor',
    home: 'Home',
    help: 'Help',
    lineChart: 'Line Chart',
    logo: 'HPE LOGO',
    nimble: 'Nimble LOGO',
    settings: 'Settings',
    flash: 'All Flash',
    spinner: 'Loading',
    refresh: 'Refresh',
    bookmark: 'Bookmark',
    favorite: 'Favorite',
    actions: 'Actions',
    tag: 'Tag',
    feedback: 'Feedback',
    system: 'System',
    upgrade: 'Upgrade',
    download: 'Download',
    downloadCloud: 'Cloud Download',
    pin: 'Pin',
    protected: 'Protected',
    notProtected: 'Not Protected',
    lock: 'Lock',
    storage: 'Storage',
    virtualMachine: 'Virtual Machine',
    exchange: 'Exchange',
    sharepoint: 'Sharepoint',
    virtualDesktop: 'Virtual Desktop',
    fileServer: 'File Server',
    multiple: 'Multiple',
    backup: 'Backup',
    unassigned: 'Unassigned',
    other: 'Other App Category',
    none: 'NONE',
    snapshot: 'Snapshot',
    snapshotRemote: 'Remote Snapshot',
    database: 'Database',
    databaseRemote: 'Remote Database',
    cloud: 'Cloud',
    clone: 'Clone',
    template: 'Template',
    folder: 'Folder',
    doc: 'Files',
    docBlank: 'New file',
    user: 'User',
    group: 'User Group',
    menu: 'Menu',
    add: 'Add',
    remove: 'Remove',
    close: 'Close',
    trash: 'Trash',
    edit: 'Edit',
    fit: 'Resize',
    filter: 'Filter',
    filterSm: 'Filter',
    moreVertical: 'moreVertical',
    more: 'More',
    line: 'Line',
    search: 'Search',
    collapseAll: 'Collapse all',
    expandAll: 'Expand all',
    login: 'Login',
    logout: 'Logout',
    error: 'Error',
    warning: 'Warning',
    success: 'Success',
    info: 'Info',
    disabled: 'Disabled',
    unknown: 'Unknown',
    inProgress: 'In Progress',
    ascend: 'Ascend',
    descend: 'Descend',
    sort: 'Sortable',
    table: 'Table',
    sortUp: 'Ascending',
    sortDown: 'Descending',
    arrowLeft: 'Previous',
    arrowRight: 'Next',
    arrowTwoWay: 'Bi-direction',
    up: 'Up',
    down: 'Down',
    right: 'Next',
    left: 'Previous',
    previous: 'Previous',
    next: 'Next',
    show: 'Show',
    hide: 'Hide',
    radial: 'Radial',
    // Table
    tableTitle: 'Table',
    tableNoItems: 'No records to show',
    tableTotal: 'Total Records:',
    // TODO: Remove when remove Deprecated Table V1 & V2, addRemove
    emptyListMsg: 'No element has been added',
    okCaps: 'OK',
    rowsSelected: 'Rows Selected',
    dash: '-',
    total: 'Total',
    noDataAvailable: 'No data available',
    tableLoadingMsg: 'Fetching table records. Please wait.',
    maxNoOfItemsAdded: 'Maximum number of items have been added',
    clear: 'Clear',
    cloudUpload: 'Cloud Upload',
    beacon: 'Beacon',
    link: 'Link',
    switch: 'Switch',
    gateway: 'GateWay',
    serverCluster: 'Server Cluster',
    collapse: 'Collapse',
    expand: 'Expand',
    task: 'Task',
    device: 'Device',
    cluster: 'Cluster',
    tree: 'Tree',
    share: 'Share',
    barChart: 'Bar Chart',
    homeRounded: 'Home Rounded',
};

const i18nConfigs = {
    t: () => { },
    prefix: '',
    separator: '',
};

const configI18n = ({ t, prefix = 'curo', separator = ':' }) => {
    i18nConfigs.t = t;
    i18nConfigs.prefix = prefix;
    i18nConfigs.separator = separator;
};
const getI18nStr = (key) => {
    const { t, prefix, separator } = i18nConfigs;
    if (prefix !== '' && separator !== '') {
        return t(`${prefix}${separator}${key}`);
    }
    return en[key];
};

function logger (msg, level) {
    if (process.env.NODE_ENV === 'development') {
        switch (level) {
            case 'warning':
                console.warn('CURO Warning: ', msg);
                break;
            case 'error':
                console.error('CURO Error: ', msg);
                break;
            default:
                console.log('CURO Logger: ', msg);
                break;
        }
    }
}

const dateFormat$1 = 'YYYY-MM-DD';
const getLongTimeDisplay = (seconds) => {
    return moment.unix(seconds).format('YYYY-MM-DD HH:mm');
};
const getFullTimeDisplay = (seconds) => {
    return moment.unix(seconds).format('YYYY-MM-DD HH:mm:ss');
};
const getMonthYear = (seconds) => {
    return moment.unix(seconds).format('MMM YYYY');
};
const getMonthYearByIso = (isoDate) => {
    const obj = isoDate ? moment(isoDate, dateFormat$1) : moment();
    return obj.format('MMMM YYYY');
};
const getPreviousMonth = (isoDate) => {
    const obj = isoDate ? moment(isoDate, dateFormat$1) : moment();
    return obj.subtract(1, 'month').format(dateFormat$1);
};
const getNextMonth = (isoDate) => {
    const obj = isoDate ? moment(isoDate, dateFormat$1) : moment();
    return obj.add(1, 'month').format(dateFormat$1);
};
const getDate = (seconds) => {
    const obj = seconds ? moment.unix(seconds) : moment();
    return obj.format(dateFormat$1);
};
const getHHMM = (seconds) => {
    return moment.unix(seconds).format('HH:mm');
};
const getHHMMSS = (seconds) => {
    return moment.unix(seconds).format('HH:mm:ss');
};
const getDateByString = (date) => {
    return moment(date).format('YYYY-MM-DD');
};
const getHHMMByString = (time) => {
    return moment(time, 'HH:mm', ':').format('HH:mm');
};
const getDateBySeconds = (time) => {
    return moment.unix(time).format(dateFormat$1);
};
const getLastSeconds = (num, unit) => {
    return moment()
        .subtract(num, unit)
        .startOf('day')
        .unix();
};
const dateMaskYYYYMMDD = [
    {
        length: 4,
        regexp: /^[1-2]$|^19$|^20$|^19[0-9]$|^20[0-9]$|^19[0-9][0-9]$|^20[0-9][0-9]$/,
        placeholder: getI18nStr('yyyy'),
    },
    { fixed: '-' },
    {
        length: [1, 2],
        regexp: /^1[0,1-2]$|^0?[1-9]$|^0$/,
        placeholder: getI18nStr('mm'),
    },
    { fixed: '-' },
    {
        length: [1, 2],
        regexp: /^[1-2][0-9]$|^3[0-1]$|^0?[1-9]$|^0$/,
        placeholder: getI18nStr('dd'),
    },
];
const timeMaskHHMM = [
    {
        length: [1, 2],
        regexp: /[0-1]?[0-9]|2[0-3]/,
        placeholder: 'hh',
    },
    { fixed: ':' },
    {
        length: [1, 2],
        regexp: /[0-5]|[0-5][0-9]/,
        placeholder: getI18nStr('mm'),
    },
];

const getColumnSize = (vSize, size) => {
    if (typeof size === 'string') {
        return size;
    }
    else if (vSize === 'xlarge' && size && size.xl) {
        return size.xl;
    }
    else if (vSize === 'large' && size && size.lg) {
        return size.lg;
    }
    else if (vSize === 'medium' && size && size.md) {
        return size.md;
    }
    else if (vSize === 'small' && size && size.sm) {
        return size.sm;
    }
    else {
        return undefined;
    }
};

// Grommet has not exported deepMerge in their latest version, so we exported Grommet's deepMerge in our utils.
const isObject = (item) => item && typeof item === 'object' && !Array.isArray(item);
const deepMerge = (target, ...sources) => {
    if (!sources.length) {
        return target;
    }
    // making sure to not change target (immutable)
    const output = Object.assign({}, target);
    sources.forEach((source) => {
        if (isObject(source)) {
            Object.keys(source).forEach(key => {
                if (isObject(source[key])) {
                    if (!output[key]) {
                        output[key] = Object.assign({}, source[key]);
                    }
                    else {
                        output[key] = deepMerge(output[key], source[key]);
                    }
                }
                else {
                    output[key] = source[key];
                }
            });
        }
    });
    return output;
};

const hpeTheme = hpe;
const checkboxBrand = CuroColors.brand["light"];
const white = CuroColors.white["light"];
const series1 = ChartColors.series1["light"];
const coolGray = InternalColors.coolGray["light"];
const gainsboroDark = InternalColors.gainsboro["dark"];
const ZIndex = {
    formHeader: 1,
    formFooter: 1,
    layer: 15,
    layerContainer: 18,
    // Select Container 20
    tooltip: 200,
};
const Opacity = {
    disabled: 0.3,
    strong: 0.8,
    loader: 0.35,
};
const headerTheme = {
    icon: {
        success: 'success',
        info: 'info',
        warning: 'warning',
        error: 'error',
    },
    background: {
        colors: {
            success: CuroColors.success,
            info: CuroColors.info,
            warning: CuroColors.warning,
            error: CuroColors.error,
        },
    },
};
const globalTheme = {
    // Grommet Layer component renders a root div (the one with tab index) and the Layer invoked by Curo is rendered within the container inside this root div.
    layer: {
        zIndex: ZIndex.layer,
        container: {
            zIndex: ZIndex.layerContainer,
        },
    },
    button: {
        border: {
            radius: '4px',
        },
        disabled: {
            opacity: 0.5,
        },
    },
    checkBox: {
        gap: '8px',
        border: { color: CuroColors.default },
        color: white,
        size: '20px',
        // extend: ({ disabled, theme }: any) => `
        // :hover {
        //   background-color: ${disabled
        //     ? 'none'
        //     : theme.global.colors['background-contrast'][theme.darkMode ? 'dark' : 'light']
        //   }
        // };
        //TODO: Comment next line and add above commented lines if you need hover background color for checkbox.
        extend: ({ disabled }) => `
      font-size: 16px; // default size
      width: auto;
      opacity: ${disabled ? Opacity.disabled : 1};
    `,
        icon: {
            extend: () => `
       background-color: ${checkboxBrand};
       stroke-width: 2px;
      `,
        },
        check: {
            extend: ({ checked, indeterminate, theme }) => `
       border: ${checked || indeterminate
                ? 'none'
                : `2px solid  ${CuroColors.default[theme.darkMode ? 'dark' : 'light']}`};
       svg{
         border-radius:4px;
       };
      `,
        },
        hover: {
            border: {
                color: checkboxBrand,
            },
        },
        toggle: {
            extend: ({ checked, theme }) => `
        background: ${checked ? series1 : theme.darkMode ? gainsboroDark : coolGray};
        border: none;
        box-shadow: none;
        border-radius: 10px;
       `,
            knob: {
                extend: ({ checked }) => `
        width: 24px;
        height: 24px;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.4);
        background: ${!checked && white};
       `,
            },
        },
    },
    formField: {
        border: {
            color: InternalColors.gainsboro,
            error: { color: CuroColors.error },
        },
        info: {
            color: InternalColors.gainsboro,
        },
        help: {
            color: InternalColors.gainsboro,
        },
        error: { color: CuroColors.error },
        label: {
            margin: {
                vertical: 'xxsmall',
            },
        },
        disabled: {
            background: {
                color: InternalColors.lighterGray,
            },
        },
        extend: () => `
      font-size: 16px;
      font-weight : ${WeightType.normal};
      width: auto;
      color: ${CuroColors.default}
    `,
    },
    radioButton: {
        gap: '8px',
        check: { color: CuroColors.brand },
        color: CuroColors.brand,
        border: { color: CuroColors.default },
        size: '20px',
        container: {
            extend: ({ disabled, theme }) => `
        :not(div):hover {
          background-color: ${disabled
                ? 'none'
                : theme.global.colors['background-contrast'][theme.darkMode ? 'dark' : 'light']};
        }
        font-size: 16px; // default size
        width: auto;
        padding: ${theme.global.edgeSize.xxsmall} ${theme.global.edgeSize.xsmall};
      `,
        },
    },
    radioButtonGroup: {
        container: {
            gap: 'none',
            margin: {
                vertical: 'none',
            },
        },
    },
    header: Object.assign({}, headerTheme),
    global: {
        input: {
            weight: 400,
        },
        drop: {
            border: {
                radius: '4px',
            },
        },
        font: {
            family: "'Metric', Arial, sans-serif",
            face: `
        @font-face {
          font-family: "Metric";
          src: url("https://d3hq6blov2iije.cloudfront.net/fonts/HPEXS-Metric-Fonts/MetricHPEXS-Regular.woff2") format('woff2'),
              url("https://d3hq6blov2iije.cloudfront.net/fonts/HPEXS-Metric-Fonts/MetricHPEXS-Regular.woff") format('woff');
        }
        @font-face {
          font-family: "Metric";
          src: url("https://d3hq6blov2iije.cloudfront.net/fonts/HPEXS-Metric-Fonts/MetricHPEXS-Bold.woff2") format('woff2'),
              url("https://d3hq6blov2iije.cloudfront.net/fonts/HPEXS-Metric-Fonts/MetricHPEXS-Bold.woff") format('woff');
          font-weight: 700;
        }
        @font-face {
          font-family: "Metric";
          src: url("https://d3hq6blov2iije.cloudfront.net/fonts/HPEXS-Metric-Fonts/MetricHPEXSSemibold-Regular.woff2") format('woff2'),
              url("https://d3hq6blov2iije.cloudfront.net/fonts/HPEXS-Metric-Fonts/MetricHPEXSSemibold-Regular.woff") format('woff');
          font-weight: 600;
        }
        @font-face {
          font-family: "Metric";
          src: url("https://d3hq6blov2iije.cloudfront.net/fonts/HPEXS-Metric-Fonts/MetricHPEXSMedium-Regular.woff2") format('woff2'),
              url("https://d3hq6blov2iije.cloudfront.net/fonts/HPEXS-Metric-Fonts/MetricHPEXSMedium-Regular.woff") format('woff');
          font-weight: 500;
        }
        @font-face {
          font-family: "Metric";
          src: url("https://d3hq6blov2iije.cloudfront.net/fonts/HPEXS-Metric-Fonts/MetricHPEXSLight-Regular.woff2") format('woff2'),
              url("https://d3hq6blov2iije.cloudfront.net/fonts/HPEXS-Metric-Fonts/MetricHPEXSLight-Regular.woff") format('woff');
          font-weight: 100;
        }
      `,
        },
        hover: { background: InternalColors.solitude },
        colors: Object.assign(Object.assign(Object.assign({}, CuroColors), InternalColors), { 'selected-background': InternalColors.lightSlate }),
        control: {
            border: {
                color: InternalColors.gainsboro,
            },
            disabled: {
                opacity: Opacity.disabled,
            },
        },
        // set custom breakpoints so we can see the changes
        breakpoints: {
            small: {
                value: 576,
            },
            medium: {
                value: 768,
            },
            large: {
                value: 992,
            },
            customBreakpoint: {
                value: 1080,
            },
            xlarge: {
                value: 3000,
            },
        },
        curo: {
            loader: {
                opacity: Opacity.loader,
            },
        },
    },
    accordion: {
        icons: { color: CuroColors.default },
        border: undefined,
    },
    textArea: {
        extend: ({ theme }) => `
    color: ${CuroColors.default[theme.darkMode ? 'dark' : 'light']};
   `,
    },
    textInput: {
        extend: ({ theme }) => `
    color: ${CuroColors.default[theme.darkMode ? 'dark' : 'light']};
   `,
    },
    maskedInput: {
        extend: ({ theme }) => `
    color: ${CuroColors.default[theme.darkMode ? 'dark' : 'light']};
   `,
    },
    select: {
        icons: {
            color: CuroColors.default,
        },
    },
};
const colorTheme = {
    isCuroTheme: true,
    curo: {
        colors: Object.assign({}, CuroColors),
        internalColors: Object.assign({}, InternalColors),
        chartColors: Object.assign({}, ChartColors),
    },
};
const StackedBarTheme = {
    global: {
        // Please do not change edgeSize, any change will impact all the shirt sizes across all components
        // edgeSize: {
        //   xsmall: '6px',
        //   small: '12px',
        //   medium: '24px',
        // },
        size: {
            xsmall: '96px',
            small: '192px',
            medium: '384px',
            large: '768px',
            xlarge: '1152px',
            xxlarge: '1536px',
        },
    },
    meter: {
        color: InternalColors.lightMediumGray,
        striped: InternalColors.mediumGray,
    },
};
const curoTheme = deepMerge(hpeTheme, globalTheme, StackedBarTheme, colorTheme);
const vegaTheme = deepMerge(curoTheme, {
    // TODO remove once vega has same behaviors
    // Table overlay
    global: {
        curo: {
            loader: {
                opacity: 0,
            },
        },
    },
});
const defaultTestTheme = Object.assign({ dark: false, darkMode: false }, curoTheme);

const getOpacityHex = (opacity) => {
    if (opacity !== undefined) {
        return Math.round(opacity * 255).toString(16).toUpperCase();
    }
    return '';
};
const isColorType = (obj) => isObject(obj) && !!obj.light && !!obj.dark;
const getCuroColorMapping = (colorKey) => `curo.colors.${colorKey}`;
const getInternalColorMapping = (colorKey) => `curo.internalColors.${colorKey}`;
const getChartColorMapping = (colorKey) => `curo.chartColors.${colorKey}`;
const getHeaderBackgroundMapping = (colorKey) => `header.background.colors.${colorKey}`;
const parseThemeColor = ({ mapping, theme, darkMode = false }) => {
    // @ts-ignore
    const colorSource = _.get(theme, mapping);
    if (isColorType(colorSource)) {
        return darkMode ? colorSource.dark : colorSource.light;
    }
    else {
        return colorSource;
    }
};
const getStyledColor = (styledComponentProps, mapping) => {
    const { theme } = styledComponentProps;
    return parseThemeColor({
        mapping,
        theme: theme && theme.isCuroTheme ? theme : defaultTestTheme,
        darkMode: theme.darkMode,
    });
};
const getStyledCuroColor = (styledComponentProps, colorKey, opacity) => {
    return `${getStyledColor(styledComponentProps, getCuroColorMapping(colorKey))}${getOpacityHex(opacity)}`;
};
const getStyledInternalColor = (styledComponentProps, colorKey) => {
    return getStyledColor(styledComponentProps, getInternalColorMapping(colorKey));
};
const getStyledChartColor = (styledComponentProps, colorKey) => {
    return getStyledColor(styledComponentProps, getChartColorMapping(colorKey));
};
const isStyledDark = (styledComponentProps) => styledComponentProps.theme.darkMode;

const curoColorSourceMap = {};
for (const key in CuroColors) {
    curoColorSourceMap[key] = getCuroColorMapping(key);
}
const internalColorSourceMap = {};
for (const key in InternalColors) {
    internalColorSourceMap[key] = getInternalColorMapping(key);
}
const chartColorSourceMap = {};
for (const key in ChartColors) {
    chartColorSourceMap[key] = getChartColorMapping(key);
}
const allColorsSourceMap = Object.assign(Object.assign(Object.assign({}, curoColorSourceMap), internalColorSourceMap), chartColorSourceMap);
for (const key in headerTheme.background.colors) {
    curoColorSourceMap[key] = getHeaderBackgroundMapping(key);
}

function useTheme() {
    return useContext(ThemeContext) || defaultTestTheme;
}
function useExtendedTheme(themeExtensionValue) {
    const theme = useTheme();
    const extendedTheme = useMemo(() => (themeExtensionValue ? deepMerge(theme, themeExtensionValue) : theme), [theme, themeExtensionValue]);
    return extendedTheme;
}
function useDarkMode(themeExtensionValue) {
    const theme = useExtendedTheme(themeExtensionValue);
    const { darkMode, dark: localDarkMode, autoTheme = true } = theme;
    return autoTheme ? localDarkMode : darkMode;
}
function useColors(colorSourceMap = allColorsSourceMap, themeExtensionValue) {
    const theme = useExtendedTheme(themeExtensionValue);
    const darkMode = useDarkMode();
    const colors = useMemo(() => {
        const result = {};
        for (const name in colorSourceMap) {
            result[name] = parseThemeColor({
                mapping: colorSourceMap[name],
                theme: theme.isCuroTheme ? theme : defaultTestTheme,
                darkMode,
            });
        }
        return result;
    }, [theme, darkMode, colorSourceMap]);
    return colors;
}
function useColor(mapping) {
    const dummySourceMap = useMemo(() => ({ [mapping]: mapping }), [mapping]);
    return useColors(dummySourceMap)[mapping];
}
function useCuroColors() {
    return useColors(curoColorSourceMap);
}
function useCuroColor(curoColorKey, opacity) {
    return `${useColor(getCuroColorMapping(curoColorKey))}${getOpacityHex(opacity)}`;
}
function useInternalColors() {
    return useColors(internalColorSourceMap);
}
function useInternalColor(internalColorKey, opacity) {
    if (internalColorKey === 'lightMediumGray') {
        logger('lightMediumGray is deprecated, user darkDefault instead', 'error');
    }
    return `${useColor(getInternalColorMapping(internalColorKey))}${getOpacityHex(opacity)}`;
}
function useChartColor(chartColorKey) {
    return useColor(getChartColorMapping(chartColorKey));
}
// used for flash message and modal header themes
function useHeaderTheme(type) {
    const theme = useTheme();
    const darkMode = useDarkMode();
    return useMemo(() => {
        return {
            // To-do: Remove ignore
            // @ts-ignore
            icon: _.get(theme, ['header', 'icon', type]),
            backgroundColor: parseThemeColor({
                mapping: getHeaderBackgroundMapping(type),
                theme,
                darkMode,
            }),
        };
    }, [theme, darkMode, type]);
}
function useLinearGradientId() {
    return useDarkMode() ? 'linear-gradient-dark' : 'linear-gradient-light';
}

/* eslint-disable @typescript-eslint/no-unused-expressions */
// default size, weights, color, as (tag)
const TextConfigs = {
    fine: ['12px', 'default', WeightType.normal, 'small'],
    label: ['14px', 'gray', WeightType.normal, 'span'],
    default: ['16px', 'default', WeightType.normal, 'span'],
    paragraph: ['16px', 'default', WeightType.normal, 'p'],
    title4: ['16px', 'default', WeightType.medium, 'h4'],
    title3: ['18px', 'default', WeightType.medium, 'h3'],
    title2: ['20px', 'default', WeightType.medium, 'h2'],
    title1: ['24px', 'default', WeightType.medium, 'h1'],
    jumbo: ['32px', 'default', WeightType.normal, 'span'],
};
const useTextColor = (type, status) => {
    const colors = useCuroColors();
    const colorKey = status || TextConfigs[type][1];
    return colors[colorKey];
};
const getTextWeight = (type, weight) => {
    return weight ? WeightType[weight] : TextConfigs[type][2];
};
const Text = ({ label, dataTestId, type = 'default', status, weight, nowrap, overflowWrap = false, className, children }) => {
    const labelConfig = TextConfigs[type];
    const color = useTextColor(type, status);
    const fontWeight = getTextWeight(type, weight);
    if (['light', 'bold'].includes(weight)) {
        logger(`font weight ${weight} is deprecated. Follow weight guideline.`, 'error');
    }
    const style = {};
    if (nowrap !== true) {
        style.whiteSpace = 'pre-wrap';
        style.margin = 0;
    }
    // in this order to avoid failed snapshots
    style.display = 'inline';
    if (overflowWrap) {
        style.overflowWrap = 'break-word';
        style.maxWidth = '100%';
    }
    const getStringLabel = () => {
        if (label === null || label === undefined) {
            return '';
        }
        return String(label);
    };
    const stringLabel = getStringLabel();
    return (React.createElement(Text$1, Object.assign({ size: labelConfig[0], weight: fontWeight, color: color, as: labelConfig[3], style: style, a11yTitle: stringLabel, className: className }, getTestIdAttribute(dataTestId)), stringLabel ? stringLabel : children));
};

const getColor = (props) => {
    const { btnType = 'plain', iconBtnType } = props;
    if (iconBtnType === 'noBorder') {
        return 'none';
    }
    if (iconBtnType === 'border') {
        return getStyledCuroColor(props, 'slate');
    }
    if (btnType === 'plain') {
        return 'none';
    }
    const typeArray = ['tertiary', 'dark'];
    return getStyledCuroColor(props, typeArray.includes(btnType) ? 'default' : 'success');
};
const getOutline = (props, isFocus, isHover) => {
    const { btnType, iconBtnType, disabled } = props;
    if (btnType === 'plain' || (disabled && iconBtnType === undefined)) {
        return 'none';
    }
    if (iconBtnType === 'noBorder' && !isFocus) {
        return 'none';
    }
    if (iconBtnType !== 'border' && !isFocus && !isHover) {
        return 'none';
    }
    const width = isHover && iconBtnType ? '2px' : '1px';
    const color = isFocus ? getStyledInternalColor(props, 'focus') : getColor(props);
    return `0px 0px 0px ${width} ${color}`;
};
// text type, weight, padding
const ButtonConfigs = {
    small: ['default', 'medium', '2px 20px'],
    medium: ['title3', 'medium', '6px 24px'],
};
const getPadding = ({ btnType, iconBtnType, btnSize }) => {
    if (iconBtnType) {
        return '8px';
    }
    return btnType === 'plain' ? '0px 0px' : ButtonConfigs[btnSize][2];
};
const getBorder = (props) => {
    const { btnType, iconBtnType } = props;
    if (iconBtnType || btnType === 'plain') {
        return '0px';
    }
    return `2px solid ${getColor(props)}`;
};
const getBg$1 = (props, isHover) => {
    const { btnType = 'plain', iconBtnType, disabled } = props;
    if (iconBtnType) {
        if (isHover) {
            return disabled ? 'none' : getStyledInternalColor(props, 'coolGray');
        }
        return 'none';
    }
    if (btnType === 'plain') {
        return 'none';
    }
    const typeArray = ['primary', 'submit', 'dark'];
    if (typeArray.includes(btnType)) {
        return getColor(props);
    }
    return 'none';
};
const getHeight$1 = ({ btnType, btnSize }) => {
    if (btnType === 'plain') {
        return undefined;
    }
    return `${btnSize === 'small' ? 32 : 40}px`;
};
const StyledButton$1 = styled.button.withConfig({ displayName: "StyledButton", componentId: "sc-q32wlq" }) `
  white-space: nowrap;
  text-align: ${({ btnType }) => `${btnType === 'plain' ? 'left' : 'center'}`};
  margin: ${({ btnType }) => `${btnType === 'plain' ? '0px 0px 0px 0px' : '2px 2px 2px 2px'}`};
  border-radius: ${({ btnType }) => (btnType === 'plain' ? undefined : '4px')};
  flex: ${({ stretch }) => `${stretch ? '1 0 auto' : 'none'}`};
  display: flex;
  align-items: center;
  flex-direction: row;
  cursor: ${({ disabled }) => `${disabled ? 'default' : 'pointer'}`};
  font: inherit;
  div, span, h1, h2, h3, h4 {
    display: flex;
    align-items: center;
    flex-direction: row;
  }
  padding: ${(props) => getPadding(props)};
  border: ${(props) => getBorder(props)};
  background: ${(props) => getBg$1(props, false)};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  height: ${(props) => getHeight$1(props)};
  box-shadow: ${(props) => getOutline(props, false, false)};
  &:hover:not([disabled]) {
    box-shadow: ${(props) => getOutline(props, false, true)};
    background: ${(props) => getBg$1(props, true)};
    svg {
      small,
      span,
      p,
      h1,
      h2,
      h3,
      h4 {
        color: ${(props) => getStyledCuroColor(props, 'black')};
      }
      path[fill=none],
      circle,
      rect,
      polygon {
        stroke: ${(props) => getStyledCuroColor(props, 'black')};
      }
    }
  }
  &:focus {
    outline: none;
    box-shadow: ${(props) => getOutline(props, true, false)};
  }
`;
const PrimitiveButton = ({ dataTestId, onClick, disabled = false, children, a11yTitle, className, size, type, iconBtnType, stretch, as, formId, }) => {
    return (React.createElement(StyledButton$1, Object.assign({ onClick: (event) => {
            if (onClick)
                onClick(event);
        }, disabled: disabled, btnType: type, type: as, iconBtnType: iconBtnType, btnSize: size, "aria-label": `${a11yTitle || 'button'}` }, getTestIdAttribute(dataTestId), { className: className, stretch: stretch, form: formId }), children));
};

// added children?: any; to keep backward compatibility for now
const ButtonBody$1 = ({ size = 'medium', dataTestId, label, children, type = 'primary', }) => {
    const typeArray = ['primary', 'submit', 'dark'];
    const isPrimary = typeArray.includes(type);
    if (label) {
        return (React.createElement(Text, { label: label, type: ButtonConfigs[size][0], status: isPrimary ? 'white' : 'default', weight: ButtonConfigs[size][1], dataTestId: `${dataTestId}-label` }));
    }
    if (children) {
        return children;
    }
    return React.createElement("div", null);
};
const getButtonType = (type) => {
    if (type === 'submit') {
        return 'submit';
    }
    if (type === 'reset') {
        return 'reset';
    }
    return 'button';
};
const Button$1 = ({ disabled = false, type = 'primary', size = 'medium', dataTestId, stretch = false, label, onClick, children, className, formId, }) => {
    const props = { disabled, type, size, dataTestId, stretch, label, onClick, children, className, formId };
    return (React.createElement(PrimitiveButton, { onClick: onClick, disabled: disabled, as: getButtonType(type), a11yTitle: label || 'button', dataTestId: dataTestId, type: type, size: size, className: className, formId: formId, stretch: stretch },
        React.createElement(ButtonBody$1, Object.assign({}, props))));
};

const defConst = {
    min: 50,
    minContent: 30,
    caret: 10,
    top: '0 12 10 0 20 12',
    bottom: '0 -2 10 10 20 -2',
    left: '0 10 12 0 12 20',
    right: '-2 0 10 10 -2 20',
};
const Caret = (props) => {
    var _a, _b;
    const darkMode = useDarkMode();
    useCuroColors();
    const { width, height, points, light, show, align, contentRef } = props;
    const [svgSize, setSvgSize] = useState([width, height, 'translate(0, 0)']);
    useEffect(() => {
        const { clientWidth = defConst.min, clientHeight = defConst.min } = (contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) || {};
        const getTransform = () => {
            if (align.includes('middle')) {
                return `translate(0, ${clientHeight / 2 - 20})`;
            }
            if (align.includes('right')) {
                return `translate(${clientWidth - 50}, 0)`;
            }
            if (align.includes('center')) {
                return `translate(${clientWidth / 2 - 15}, 0)`;
            }
            // left
            return 'translate(20, 0)';
        };
        const w = width === defConst.caret ? width : clientWidth;
        const h = height === defConst.caret ? height : clientHeight - 20;
        setSvgSize([w, h, getTransform()]);
    }, [(_a = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth, (_b = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight, align]);
    const { slate, black } = useCuroColors();
    return (React.createElement(Box, { flex: { shrink: 0 }, pad: "none", style: { width: svgSize[0], height: svgSize[1], zIndex: 1 } },
        React.createElement("svg", { width: svgSize[0], height: svgSize[1] }, light !== true && show && (contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) && (React.createElement("polygon", { strokeWidth: 0, points: points, fill: darkMode ? black : slate, transform: svgSize[2] })))));
};

const StyledBox$6 = styled(Box).withConfig({ displayName: "StyledBox", componentId: "sc-15vg5vj" }) `
  line-height: 1;
  button:disabled {
    pointer-events: none;
  }
`;
const Tooltip = (_a) => {
    var { eventType = 'hover', light = false, align = ['bottom', 'left'], noPad = false } = _a, rest = __rest(_a, ["eventType", "light", "align", "noPad"]);
    const mounted = useRef(true);
    const colors = useCuroColors();
    // const shadowDark = useCuroColor('white', 0.1);
    const shadowLight = useCuroColor('black', 0.1);
    const darkMode = useDarkMode();
    const contentRef = useRef({ current: {} });
    const { dataTestId, target, tooltip, nowrap, underline, onClickOutside } = rest;
    const targetRef = useRef(null);
    const targetTextLabel = typeof target === 'string' ? target : '';
    const targetText = React.createElement(Text, { label: targetTextLabel, dataTestId: `${dataTestId}-target-label` });
    const targetComponet = typeof target === 'string' ? targetText : target;
    const { clientWidth: docWidth, clientHeight: docHeight } = document.documentElement;
    const hoverRect = (targetRef &&
        targetRef.current &&
        targetRef.current.getBoundingClientRect()) || {
        width: 0,
        x: 0,
        y: 0,
        height: 0,
    };
    const toolTipWidth = (contentRef && contentRef.current && contentRef.current.clientWidth) || 350;
    const rx = hoverRect.x + hoverRect.width; // most right x
    const lx = hoverRect.x; // most left x
    const ty = hoverRect.y; // most top y
    const by = hoverRect.y + hoverRect.height; // most bottom y
    const isRightSpaceAvailable = rx + toolTipWidth <= window.scrollX + docWidth;
    const isLeftSpaceAvailable = lx - toolTipWidth >= 0;
    const isAboveSpaceAvailable = ty - 40 >= 0;
    const isBellowSpaceAvailable = by + 40 <= docHeight;
    const getAlignH = () => {
        if (align.includes('left')) {
            if (isRightSpaceAvailable) {
                return 'left';
            }
            return 'right';
        }
        if (align.includes('right')) {
            if (isLeftSpaceAvailable) {
                return 'right';
            }
            return 'left';
        }
        return 'center';
    };
    const getAlignV = () => {
        if (align.includes('top')) {
            if (isAboveSpaceAvailable) {
                return 'top';
            }
            return 'bottom';
        }
        if (align.includes('bottom')) {
            if (isBellowSpaceAvailable) {
                return 'bottom';
            }
            return 'top';
        }
        return 'middle';
    };
    const getTextStatus = () => {
        if (darkMode) {
            return light ? 'white' : 'darkDefault';
        }
        return light ? 'default' : 'white';
    };
    const tooltipText = (React.createElement(Text, { label: typeof tooltip === 'string' ? tooltip : '', status: getTextStatus(), dataTestId: `${dataTestId}-tip-label` }));
    const tipComponent = typeof tooltip === 'string' ? tooltipText : tooltip;
    const [showTip, setShowTip] = useState(false);
    const [mouseOverTip, setMouseOverTip] = useState(false);
    const dynamicAlignOptions = align.includes('middle') ? align : [getAlignH(), getAlignV()];
    const { pinnedEvent, refElement, width, height } = rest;
    const dropAlign = {};
    if (dynamicAlignOptions.includes('middle')) {
        dynamicAlignOptions.forEach(pos => {
            switch (pos) {
                case 'middle':
                    break;
                case 'right':
                    dropAlign.left = pos;
                    break;
                case 'left':
                    dropAlign.right = pos;
                    break;
            }
        });
    }
    else {
        dynamicAlignOptions.forEach(pos => {
            switch (pos) {
                case 'top':
                    dropAlign.bottom = pos;
                    break;
                case 'bottom':
                    dropAlign.top = pos;
                    break;
                case 'center':
                    break;
                case 'middle':
                    break;
                default:
                    dropAlign[pos] = pos; // left, right
            }
        });
    }
    // eventType === 'hover'
    const getHoverTargetStyle = () => {
        const hoverTargetStyle = {};
        if (nowrap === undefined && underline === undefined) {
            // for backward compatibility
            hoverTargetStyle.textDecoration = `3px underline dotted ${colors.default}`;
            hoverTargetStyle.textUnderlineOffset = '3px';
        }
        else if (underline) {
            hoverTargetStyle.borderBottom = `1px dotted ${colors.default}`;
            hoverTargetStyle.display = 'inline-block';
        }
        return hoverTargetStyle;
    };
    const hoverTargetProps = Object.assign({ onMouseOver: () => {
            setShowTip(true);
        }, onMouseLeave: () => {
            setTimeout(() => {
                if (mounted && mounted.current) {
                    setShowTip(false);
                }
            }, 200);
        }, onFocus: () => {
            setShowTip(true);
        }, onBlur: () => {
            setShowTip(false);
        }, style: getHoverTargetStyle() }, getTestIdAttribute(`${dataTestId}-target`));
    const hoverTargetComponent = eventType === 'hover' && (
    // @ts-ignore
    React.createElement(StyledBox$6, Object.assign({ ref: targetRef }, hoverTargetProps), targetComponet));
    const hoverTipProps = {
        onMouseOver: () => {
            setMouseOverTip(true);
        },
        onMouseLeave: () => {
            setMouseOverTip(false);
        },
        onFocus: () => {
            setMouseOverTip(true);
        },
        onBlur: () => {
            setMouseOverTip(false);
        },
    };
    const tipProps = eventType === 'hover' ? hoverTipProps : {};
    // eventType === 'click'
    const clickTargetComponent = eventType === 'click' && (React.createElement(Box, { ref: targetRef },
        React.createElement(Button$1, { type: "plain", label: typeof target === 'string' ? target : undefined, dataTestId: `${dataTestId}-target`, onClick: () => {
                setShowTip(!showTip);
            } }, typeof target !== 'string' && target)));
    // eventType === 'pinned' || eventType === 'mouse'
    const [top, setTop] = useState(0);
    const [left, setLeft] = useState(0);
    const setInvisibleTopLeft = (event) => {
        const { pageX, pageY } = event;
        setTop(pageY + 5);
        setLeft(pageX);
        setShowTip(true);
    };
    const initialRenderSetup = () => {
        if (pinnedEvent) {
            setInvisibleTopLeft(pinnedEvent);
        }
        else if (refElement && refElement.current) {
            targetRef.current = refElement.current;
            setShowTip(true);
        }
    };
    useEffect(initialRenderSetup, []); // componentDidMount for pinned
    useEffect(() => {
        function mouseMoveListener(event) {
            setInvisibleTopLeft(event);
        }
        if (eventType === 'mouse') {
            window.addEventListener('mousemove', mouseMoveListener);
        }
        return () => {
            if (eventType === 'mouse' && mounted) {
                window.removeEventListener('mousemove', mouseMoveListener);
            }
            // componentWillUnmount
            mounted.current = false;
        };
    }, [eventType]); // for mouse
    const getDropTarget = () => {
        if (refElement) {
            return null;
        }
        return (hoverTargetComponent ||
            clickTargetComponent || (React.createElement("span", Object.assign({ ref: targetRef, style: {
                visibility: 'hidden',
                position: 'absolute',
                top: `${top + 5}px`,
                left: `${left + 5}px`,
            } }, getTestIdAttribute('drop-target-div'))))); // invisibleDropTarget when eventType === 'mouse' || eventType === 'pinned' to event
    };
    const getBackgroundColor = () => {
        if (darkMode) {
            return light ? CuroColors.slate['light'] : colors.black;
        }
        return light ? colors.white : colors.slate;
    };
    return (React.createElement(React.Fragment, null,
        getDropTarget(),
        tooltip !== false && (showTip || mouseOverTip) && targetRef && targetRef.current && (
        // ThemeContext global.drop is shared with Select
        React.createElement(ThemeContext.Extend, { value: {
                global: {
                    drop: {
                        background: 'none',
                        zIndex: ZIndex.tooltip,
                        border: {
                            radius: '0px',
                        },
                        extend: {
                            padding: '0px',
                            maxWidth: width === undefined ? '360px' : `${width + 20}px`,
                            transitionDelay: '0.25s',
                        },
                    },
                },
            } },
            React.createElement(Drop, Object.assign({ target: targetRef.current, align: dropAlign, stretch: false, elevation: "xsmall" }, tipProps, getTestIdAttribute(dataTestId), { plain: light ? false : true, ref: contentRef, onClickOutside: onClickOutside }),
                !light && (React.createElement(Caret, { width: defConst.min, height: defConst.caret, points: defConst.top, show: dynamicAlignOptions.includes('bottom'), light: light, align: dynamicAlignOptions, contentRef: contentRef })),
                React.createElement(Box, { pad: "none", direction: "row", wrap: false },
                    !light && (React.createElement(Caret, { width: defConst.caret, height: defConst.minContent, points: defConst.left, show: dynamicAlignOptions.includes('middle') && dynamicAlignOptions.includes('right'), light: light, align: dynamicAlignOptions, contentRef: contentRef })),
                    React.createElement(Box, { pad: noPad ? 'none' : '10px', style: {
                            backgroundColor: getBackgroundColor(),
                            width,
                            minWidth: defConst.minContent,
                            height,
                            minHeight: defConst.minContent,
                            overflowWrap: 'break-word',
                            borderRadius: 5,
                            boxShadow: light ? `0px 2px 4px 2px ${shadowLight}` : 'none',
                            zIndex: 3,
                            overflowY: 'auto',
                        } }, tipComponent),
                    !light && (React.createElement(Caret, { width: defConst.caret, height: defConst.minContent, points: defConst.right, show: dynamicAlignOptions.includes('middle') && dynamicAlignOptions.includes('left'), light: light, align: dynamicAlignOptions, contentRef: contentRef }))),
                !light && (React.createElement(Caret, { width: defConst.min, height: defConst.caret, points: defConst.bottom, show: dynamicAlignOptions.includes('top'), light: light, align: dynamicAlignOptions, contentRef: contentRef })))))));
};

const IconSizes = ['xxsmall', 'xsmall', 'small', 'medium', 'large'];
const IconSizePxMap = {
    xxsmall: '8px',
    xsmall: '12px',
    small: '16px',
    medium: '18px',
    large: '24px',
    /** depracating fields, will be removed in next releases
     *  Use invalid values to force user updates
     *  Also error logged in console
     */
    default: '12px',
    xlarge: '12px',
    xxlarge: '12px',
};
const protectedD = 'M12,22 C12,22 3,18 3,5 C3,5 12,2 12,2 C12,2 21,5 21,5 C21,18 12,22 12,22 Z M4,11 L20,11 M12,2 L12,22';
const show = 'M12,17 C9.27272727,17 6,14.2222222 6,12 C6,9.77777778 9.27272727,7 12,7 C14.7272727,7 18,9.77777778 18,12 C18,14.2222222 14.7272727,17 12,17 Z M11,12 C11,12.55225 11.44775,13 12,13 C12.55225,13 13,12.55225 13,12 C13,11.44775 12.55225,11 12,11 C11.44775,11 11,11.44775 11,12 Z';
const docBlank = 'M14,1 L14,8 L21,8 M21,23 L3,23 L3,1 L15,1 L18,4 L21,7 L21,23 L21,23 L21,23 Z';
const vol = 'M7,23 L23,23 L23,7 L7,7 Z';
const customPath = {
    apps: 'M19,5 L21,5 L21,3 L19,3 L19,5 Z M11,5 L13,5 L13,3 L11,3 L11,5 Z M3,5 L5,5 L5,3 L3,3 L3,5 Z M19,13 L21,13 L21,11 L19,11 L19,13 Z M11,13 L13,13 L13,11 L11,11 L11,13 Z M3,13 L5,13 L5,11 L3,11 L3,13 Z M19,21 L21,21 L21,19 L19,19 L19,21 Z M11,21 L13,21 L13,19 L11,19 L11,21 Z M3,21 L5,21 L5,19 L3,19 L3,21 Z',
    home: 'M1,11 L12,2 L23,11 M15,23 L15,15 L15,15 L9,15 L9,23 M4,23 L4,9 M20,23 L20,9',
    dashboard: 'M9,15 L9,23 L1,23 L1,15 Z M23,15 L23,23 L15,23 L15,15 Z M9,1 L9,9 L1,9 L1,1 Z M23,1 L23,9 L15,9 L15,1 Z',
    analyticsDashboard: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M15,16 C15,14.3431458 13.6568542,13 12,13 C10.3431458,13 9,14.3431458 9,16 M5,5 L7,7 M12,7 L12,13 M12,3 L12,5 M19,12 L21,12 M3,12 L5,12 M17,7 L19,5 M3,17 L21,17',
    table: 'M8,5 L8,23 M16,5 L16,23 M1,11 L23,11 M1,5 L23,5 M1,17 L23,17 M1,1 L23,1 L23,23 L1,23 L1,1 Z',
    manage: 'M12,2 L22,7 L22,17 L12,22 L2,17 L2,7 L12,2 Z M2,7 L12,12 L22,7 M12,12 L12,21.9999998 L12,12 Z',
    system: 'M1,19 L23,19 L23,1 L1,1 L1,19 Z M5,23 L19,23 L5,23 Z M8,23 L16,23 L16,19 L8,19 L8,23 Z M7.757,5.757 L9.879,7.879 L7.757,5.757 Z M9,10 L6,10 L9,10 Z M9.879,12.121 L7.757,14.243 L9.879,12.121 Z M12,13 L12,16 L12,13 Z M14.121,12.121 L16.243,14.243 L14.121,12.121 Z M18,10 L15,10 L18,10 Z M16.243,5.757 L14.121,7.879 L16.243,5.757 Z M12,7 L12,4 L12,7 Z M12,7 C10.343,7 9,8.343 9,10 C9,11.657 10.343,13 12,13 C13.657,13 15,11.657 15,10 C15,8.343 13.657,7 12,7 L12,7 Z',
    monitor: 'M20,7 C21.25,8.67 22,10.75 22,13 C22,18.52 17.52,23 12,23 C6.48,23 2,18.52 2,13 C2,7.48 6.48,3 12,3 M12,1 L12,13 L21.6,5.8 C19.41,2.89 15.92,1 12,1 L12,1 Z',
    alarm: 'M4,19 L4,9 C4,4.582 7.582,1 12,1 C16.418,1 20,4.582 20,9 L20,19 M1,19 L23,19 M15,19 L15,20 C15,21.657 13.657,23 12,23 C10.343,23 9,21.657 9,20 L9,19',
    settings: 'M16,15 C20.0089021,14.9354541 23,11.9673591 23,8 C23,4.98813056 22.0029673,5.9851632 21,7 C20.0089021,7.97922849 18,10 18,10 L14,6 C14,6 16.0207715,3.99109792 17,3 C18.0148368,1.99703264 18.0148368,1 16,1 C12.0326409,0.999999999 9.05307486,3.99109792 9,8 C9.04154304,8.97626113 9,11 9,11 C7.11486635,12.8970031 4.65923194,15.3526375 3,17 C0.0682492584,19.9436202 4.05637975,23.9317507 7,21 C8.65052042,19.3376102 11.1126942,16.8754364 13,15 C13,15 15.0237389,14.958457 16,15 Z',
    bullet: 'M13,12 C13,11.448 12.552,11 12,11 C11.448,11 11,11.448 11,12 C11,12.552 11.448,13 12,13 C12.552,13 13,12.552 13,12 L13,12 Z',
    export: 'M19,13 L19,23 L1,23 L1,5 L1,5 L11,5 M14,1 L23,1 L23,10 M10,14 L22.9999998,1 L10,14 Z',
    refresh: 'M20 8c-1.403-2.96-4.463-5-8-5a9 9 0 1 0 0 18 9 9 0 0 0 9-9m0-9v6h-6',
    favorite: 'M1,8.4 C1,4 4.5,3 6.5,3 C9,3 11,5 12,6.5 C13,5 15,3 17.5,3 C19.5,3 23,4 23,8.4 C23,15 12,21 12,21 C12,21 1,15 1,8.4 Z',
    actions: 'M12,17.5 C15.0375661,17.5 17.5,15.0375661 17.5,12 C17.5,8.96243388 15.0375661,6.5 12,6.5 C8.96243388,6.5 6.5,8.96243388 6.5,12 C6.5,15.0375661 8.96243388,17.5 12,17.5 Z M12,6.5 L12,1 M12,23 L12,17.5 M1,12 L6.5,12 M17.5,12 L23,12 M4.4375,4.4375 L8.5625,8.5625 M15.4375,15.4375 L19.5625,19.5625 M19.5625,4.4375 L15.4375,8.5625 M8.5625,15.4375 L4.4375,19.5625',
    feedback: 'M9,7 L9,1 L23,1 L23,11 L20,11 L20,16 L15,12 M1,7 L15,7 L15,18 L9,18 L4,22 L4,18 L1,18 L1,7 Z',
    user: 'M8,24 L8,19 M16,24 L16,19 M3,24 L3,19 C3,14.0294373 7.02943725,11 12,11 C16.9705627,11 21,14.0294373 21,19 L21,24 M12,11 C14.7614237,11 17,8.76142375 17,6 C17,3.23857625 14.7614237,1 12,1 C9.23857625,1 7,3.23857625 7,6 C7,8.76142375 9.23857625,11 12,11 Z',
    group: 'M12,13 C14.209139,13 16,11.209139 16,9 C16,6.790861 14.209139,5 12,5 C9.790861,5 8,6.790861 8,9 C8,11.209139 9.790861,13 12,13 Z M6,22 L6,19 C6,15.6862915 8.6862915,13 12,13 C15.3137085,13 18,15.6862915 18,19 L18,22 M13,5 C13.4037285,3.33566165 15.0151447,2 17,2 C19.172216,2 20.98052,3.790861 21,6 C20.98052,8.209139 19.172216,10 17,10 L16,10 L17,10 C20.287544,10 23,12.6862915 23,16 L23,18 M11,5 C10.5962715,3.33566165 8.98485529,2 7,2 C4.82778404,2 3.01948003,3.790861 3,6 C3.01948003,8.209139 4.82778404,10 7,10 L8,10 L7,10 C3.71245602,10 1,12.6862915 1,16 L1,18',
    pin: 'M16,3 L10,9 C10,9 6,8 3,11 C3,11 13,21 13,21 C16,18 15,14 15,14 L21,8 L16,3 Z M1,23 L8,16 M14,1 L23,10',
    protectedD,
    notProtected: `${protectedD} M22,1 L3,20`,
    lock: 'M19,23 L19,11 L5,11 L5,23 L19,23 Z M12,15 L12,19 M17,11 L17,7 C17,4 17,1 12,1 C7,1 7,4 7,7 L7,11',
    storage: 'M2,5.07692308 C2,5.07692308 3.66666667,2 12,2 C20.3333333,2 22,5.07692308 22,5.07692308 L22,18.9230769 C22,18.9230769 20.3333333,22 12,22 C3.66666667,22 2,18.9230769 2,18.9230769 L2,5.07692308 Z M2,13 C2,13 5.33333333,16 12,16 C18.6666667,16 22,13 22,13 M2,7 C2,7 5.33333333,10 12,10 C18.6666667,10 22,7 22,7',
    virtualMachine: 'M1,23 L14,23 L14,10 L1,10 L1,23 Z M10,19 L23,19 L23,6 L10,6 L10,19 Z M5,14 L18,14 L18,1 L5,1 L5,14 Z',
    snapshot: 'M1,21 L1,7 L6,7 L8,3 L16,3 L18,7 L23,7 L23,21 L1,21 Z M12,18 C14.7614237,18 17,15.7614237 17,13 C17,10.2385763 14.7614237,8 12,8 C9.23857625,8 7,10.2385763 7,13 C7,15.7614237 9.23857625,18 12,18 Z',
    database: 'M1,2 L23,2 L23,9 L1,9 L1,2 Z M4,12 L5,12 L5,13 L4,13 L4,12 Z M4,5 L5,5 L5,6 L4,6 L4,5 Z M4,19 L5,19 L5,20 L4,20 L4,19 Z M1,16 L23,16 L23,23 L1,23 L1,16 Z M1,9 L23,9 L23,16 L1,16 L1,9 Z',
    cloud: 'M18,17 L18,18 C18,21 16,22 13,22 L11,22 C8,22 6,21 6,18 L6,17 C3.23857625,17 1,14.7614237 1,12 C1,9.23857625 3.23857625,7 6,7 L12,7 M6,7 L6,6 C6,3 8,2 11,2 L13,2 C16,2 18,3 18,6 L18,7 C20.7614237,7 23,9.23857625 23,12 C23,14.7614237 20.7614237,17 18,17 L12,17',
    clone: `${vol} M17,3.9997 L17,0.9997 L14,0.9997 M1,13.9997 L1,16.9997 L4,16.9997 M1,11.9997 L1,5.9997 L1,11.9997 Z M4,0.9997 L1,0.9997 L1,3.9997 M6,0.9997 L12,0.9997 L6,0.9997 Z`,
    vol,
    folder: 'M2,10 L2,6 L2,2 L10,2 L13,6 L22,6 L22,10 L2,10 Z M2,10 L22,10 L22,22 L2,22 L2,10 Z',
    doc: `${docBlank} M6,16 L16,16 L6,16 L6,16 Z M6,12 L18,12 L6,12 L6,12 Z M6,8 L11,8 L6,8 L6,8 Z`,
    docBlank,
    template: 'M10,11 L2,11 L2,23 L10,23 L10,11 Z M22,11 L14,11 L14,23 L22,23 L22,11 Z M22,1 L2,1 L2,7 L22,7 L22,1 Z',
    edit: 'm14 4 6 6-6-6zm8.294 1.294c.39.39.387 1.025-.008 1.42L9 20l-7 2 2-7L17.286 1.714a1 1 0 0 1 1.42-.008l3.588 3.588zM3 19l2 2m2-4 8-8',
    fit: 'M12 0v24V0zM0 12h24H0zm17 0c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5zm-5 9c-4.962 0-9-4.037-9-9s4.038-9 9-9 9 4.037 9 9-4.038 9-9 9z',
    question: 'M12,15 L12,14 C12,13 12,12.5 13,12 C14,11.5 15,11 15,9.5 C15,8.5 14,7 12,7 C10,7 9,8.26413718 9,10 M12,16 L12,18',
    search: 'm15 15 7 7-7-7zm-5.5 2a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15z',
    ascend: 'M2,8 L8,2 L14,8 M11,21 L22,21 M11,17 L19,17 M11,13 L16,13 M8,2 L8,22',
    show,
    hide: `${show} M20,5 L4,19`,
    exchange: 'M1,4 L23,4 L23,20 L1,20 Z M1,5 L12,13.5 L23,5',
    sharepoint: 'M1,1 L7,1 L7,7 L1,7 Z M17,1 L23,1 L23,7 L17,7 Z M17,17 L23,17 L23,23 L17,23 Z M1,17 L7,17 L7,23 L1,23 Z M7,4 L17,4 M20,7 L20,17 M17,20 L7,20 M4,17 L4,7',
    virtualDesktop: 'M1,1 L23,1 L23,19 L1,19 Z M5,23 L19,23 M12,19 L12,23',
    fileServer: 'M6,6 L1,6 L1,23, L8,23 L8,20 M6,1 L6,20 L18,20 L18,1 Z M18,6 L23,6 L23,23 L16,23 L16,20 M1,9 L6,9 M1,12 L6,12 M1,15 L6,15 M18,9 L23,9 M18,12 L23,12 M18,15 L23,15 M6,5 L18,5 M6,8 L18,8 M6,11 L18,11',
    backup: 'M1,12 C1,18.075 5.925,23 12,23 C18.075,23 23,18.075 23,12 C23,5.925 18.075,1 12,1 C7.563,1 4,4 2,7.5 M1,1 L1,8 L8,8 M16,17 L12,13 L12,6',
    downloadCloud: 'M6,17 C3.23857625,17 1,14.7614237 1,12 C1,9.23857625 3.23857625,7 6,7 L12,7 M6,7 L6,6 C6,3 8,2 11,2 L13,2 C16,2 18,3 18,6 L18,7 C20.7614237,7 23,9.23857625 23,12 C23,14.7614237 20.7614237,17 18,17 M12,12 L12,21 M8,17 L12,21 L16,17',
    moon: 'm18.25 18.78.531.846a1 1 0 0 0-.282-1.815l-.25.968zm0-13.56.249.97a1 1 0 0 0 .282-1.816l-.532.847zM14 21a8.962 8.962 0 0 0 4.781-1.374l-1.063-1.694A6.962 6.962 0 0 1 14 19v2zm-9-9a9 9 0 0 0 9 9v-2a7 7 0 0 1-7-7H5zm9-9a9 9 0 0 0-9 9h2a7 7 0 0 1 7-7V3zm4.781 1.374A8.962 8.962 0 0 0 14 3v2c1.368 0 2.641.391 3.718 1.067l1.063-1.693zm-.78-.122A8.004 8.004 0 0 0 12 12h2a6.003 6.003 0 0 1 4.499-5.81L18 4.251zM12 12c0 3.729 2.55 6.86 6 7.748l.499-1.937A6.003 6.003 0 0 1 14 12h-2z',
    sun: 'M12 1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1zM6 12a6 6 0 1 1 12 0 6 6 0 0 1-12 0zm6-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm1 12a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0v-2zm10-8a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1zM4 13a1 1 0 1 0 0-2H2a1 1 0 1 0 0 2h2zm15.778-8.778a1 1 0 0 1 0 1.414L18.364 7.05a1 1 0 1 1-1.414-1.414l1.414-1.414a1 1 0 0 1 1.414 0zM7.05 18.364a1 1 0 1 0-1.414-1.414l-1.414 1.414a1 1 0 1 0 1.414 1.414l1.414-1.414zM4.222 4.222a1 1 0 0 1 1.414 0L7.05 5.636A1 1 0 1 1 5.636 7.05L4.222 5.636a1 1 0 0 1 0-1.414zM18.364 16.95a1 1 0 0 0-1.414 1.414l1.414 1.414a1 1 0 0 0 1.414-1.414l-1.414-1.414z',
    sortUp: 'M12.0809 7.28641L12.4345 6.93286L12.788 7.28641L17 11.4984L16.2929 12.2055L12.9345 8.84707V16.9999H11.9345V8.84707L8.57605 12.2055L7.86895 11.4984L12.0809 7.28641Z',
    sortDown: 'M11.9191 16.7136L11.5655 17.0671L11.212 16.7136L7 12.5016L7.70711 11.7945L11.0655 15.1529V7.00009H12.0655V15.1529L15.4239 11.7945L16.1311 12.5016L11.9191 16.7136Z',
    sort: 'M15.2044 15.3211L16.8012 13.7243L17.5083 14.4314L15.058 16.8817L14.7044 17.2353L14.3509 16.8817L11.9006 14.4314L12.6077 13.7243L14.2044 15.3211V7.21705H15.2044V15.3211ZM9.30385 8.91421V17.0182H10.3038V8.91421L11.9006 10.511L12.6077 9.80385L10.1574 7.35355L9.80385 7L9.45029 7.35355L6.99999 9.80385L7.7071 10.511L9.30385 8.91421Z',
    cloudUpload: 'M6 17A5 5 0 0 1 6 7h6M6 7V6c0-3 2-4 5-4h2c3 0 5 1 5 4v1a5 5 0 0 1 0 10m-6-4v9m-4-6 3.965-4.035L16 16',
    link: 'M15.4241 1.70705C16.5957 0.535475 18.4952 0.535477 19.6668 1.70705L22.2929 4.33317C23.4645 5.50474 23.4645 7.40424 22.2929 8.57581L18.5759 12.2928C17.4043 13.4644 15.5048 13.4644 14.3332 12.2928L13.7273 11.6869L11.6869 13.7272L12.2929 14.3332C13.4645 15.5047 13.4645 17.4042 12.2929 18.5758L8.57587 22.2928C7.4043 23.4644 5.5048 23.4644 4.33323 22.2928L1.70711 19.6667C0.535536 18.4951 0.535538 16.5956 1.70711 15.4241L5.42414 11.707C6.59571 10.5355 8.49521 10.5355 9.66678 11.707L10.2727 12.313L12.3131 10.2727L11.7071 9.66672C10.5355 8.49514 10.5355 6.59565 11.7071 5.42408L15.4241 1.70705ZM15.1415 10.2727L17.7071 7.70705L16.2929 6.29284L13.7273 8.85846L13.1213 8.2525C12.7308 7.86198 12.7308 7.22882 13.1213 6.83829L16.8384 3.12126C17.2289 2.73074 17.862 2.73074 18.2526 3.12126L20.8787 5.74738C21.2692 6.13791 21.2692 6.77107 20.8787 7.16159L17.1617 10.8786C16.7711 11.2691 16.138 11.2691 15.7474 10.8786L15.1415 10.2727ZM8.85852 13.7272L8.25256 13.1213C7.86204 12.7307 7.22888 12.7307 6.83835 13.1213L3.12132 16.8383C2.7308 17.2288 2.7308 17.862 3.12132 18.2525L5.74744 20.8786C6.13797 21.2691 6.77113 21.2691 7.16166 20.8786L10.8787 17.1616C11.2692 16.7711 11.2692 16.1379 10.8787 15.7474L10.2727 15.1414L7.70711 17.707L6.2929 16.2928L8.85852 13.7272Z',
    switch: 'M5 1H6H6.5H7.5H12H16.8229H17.8229H18H19V2V22V23H18H6H5V22V2V1ZM7.5 11H12H16.8229H17V21H7V11H7.5ZM15 6C15 7.65685 13.6569 9 12 9C10.3431 9 9 7.65685 9 6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6ZM11 19V14H13V19H11ZM12 5.00195C11.4477 5.00195 11 5.44967 11 6.00195C11 6.55424 11.4477 7.00195 12 7.00195C12.5523 7.00195 13 6.55424 13 6.00195C13 5.44967 12.5523 5.00195 12 5.00195Z',
    gateway: 'M12 20v-5m0-6V4m-7 8h5m9 0h-5m-.969-4.031L12 9.344l-1.031-1.375h2.062zm-2.062 8.07L12 14.664l1.031 1.375H10.97zM6 13.031L4.625 12 6 10.969v2.062zm12-2.062L19.375 12 18 13.031V10.97zM12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1z',
    serverCluster: 'M1,8 L23,8 L23,1 L1,1 L1,8 Z M11,5 L12,5 L12,4 L11,4 L11,5 Z M19,5 L20,5 L20,4 L19,4 L19,5 Z M15,5 L16,5 L16,4 L15,4 L15,5 Z M11,12 L12,12 L12,11 L11,11 L11,12 Z M19,12 L20,12 L20,11 L19,11 L19,12 Z M15,12 L16,12 L16,11 L15,11 L15,12 Z M11,19 L12,19 L12,18 L11,18 L11,19 Z M19,19 L20,19 L20,18 L19,18 L19,19 Z M15,19 L16,19 L16,18 L15,18 L15,19 Z M1,15 L23,15 L23,8 L1,8 L1,15 Z M1,22 L23,22 L23,15 L1,15 L1,22 Z M21,23 L3,23',
    device: 'M2 7h20v14h-6l-4-4-4 4H2V7zm4-5 5 5h2l5-5',
    cluster: 'M8 9h8V1H8v8zM1 23h8v-8H1v8zm14 0h8v-8h-8v8zM5 15l3-6-3 6zm5 4h4-4zm6-10 3 6-3-6z',
    tree: 'M4 1h6v6H4V1zm12 10h4v4h-4v-4zm0 8h4v4h-4v-4zM7 7v14h9m-9-8h9',
    share: 'M11.6667 4.16732C11.6667 2.32637 13.159 0.833984 15 0.833984C16.8409 0.833984 18.3333 2.32637 18.3333 4.16732C18.3333 6.00827 16.8409 7.50065 15 7.50065C14.0453 7.50065 13.1844 7.09934 12.5767 6.45622L8.22978 9.17307C8.29739 9.43769 8.33332 9.71497 8.33332 10.0007C8.33332 10.2863 8.29739 10.5636 8.22978 10.8282L12.5767 13.5451C13.1844 12.902 14.0453 12.5006 15 12.5006C16.8409 12.5006 18.3333 13.993 18.3333 15.834C18.3333 17.6749 16.8409 19.1673 15 19.1673C13.159 19.1673 11.6667 17.6749 11.6667 15.834C11.6667 15.5483 11.7026 15.271 11.7702 15.0064L7.42323 12.2895C6.81555 12.9327 5.95464 13.334 4.99999 13.334C3.15904 13.334 1.66666 11.8416 1.66666 10.0007C1.66666 8.1597 3.15904 6.66732 4.99999 6.66732C5.95464 6.66732 6.81555 7.06863 7.42323 7.71175L11.7702 4.9949C11.7026 4.73028 11.6667 4.453 11.6667 4.16732ZM15 2.50065C14.0795 2.50065 13.3333 3.24684 13.3333 4.16732C13.3333 5.08779 14.0795 5.83398 15 5.83398C15.9205 5.83398 16.6667 5.08779 16.6667 4.16732C16.6667 3.24684 15.9205 2.50065 15 2.50065ZM4.99999 8.33398C4.07952 8.33398 3.33332 9.08018 3.33332 10.0007C3.33332 10.9211 4.07952 11.6673 4.99999 11.6673C5.92046 11.6673 6.66666 10.9211 6.66666 10.0007C6.66666 9.08018 5.92046 8.33398 4.99999 8.33398ZM13.3333 15.834C13.3333 14.9135 14.0795 14.1673 15 14.1673C15.9205 14.1673 16.6667 14.9135 16.6667 15.834C16.6667 16.7545 15.9205 17.5006 15 17.5006C14.0795 17.5006 13.3333 16.7545 13.3333 15.834Z',
    task: 'M12 20h12m-12-8h12M12 4h12M1 19l3 3 5-5m-8-6 3 3 5-5m0-8L4 6 1 3',
    help: 'M2 7a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7zm5-3a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7zm5 3.5c-1.448 0-2 1.052-2 1.5a1 1 0 1 1-2 0c0-1.552 1.448-3.5 4-3.5 1.156 0 2.17.289 2.909.935C15.664 7.096 16 8.017 16 9c0 1.188-.306 2.028-.882 2.668a4.313 4.313 0 0 1-.828.693 14.92 14.92 0 0 1-.368.235l-.018.011c-.124.078-.236.15-.347.223-.35.236-.493.412-.55.526-.046.088-.077.205-.028.438a1 1 0 0 1-1.958.412c-.126-.6-.083-1.197.204-1.759.273-.535.718-.942 1.218-1.277.14-.094.277-.18.399-.257l.009-.006c.122-.076.228-.142.328-.21.205-.136.346-.25.453-.368.174-.193.368-.516.368-1.329 0-.517-.164-.846-.409-1.06-.261-.229-.747-.44-1.591-.44zm0 8.281a1 1 0 1 0 0 2 1 1 0 0 0 0-2z',
    barChart: 'M0 22h24M22 2h-4v16h4V2zM6 6H2v12h4V6zm8 12h-4v-8h4v8z',
    homeRounded: 'M1 22V9.76a2 2 0 0 1 .851-1.636l9.575-6.72a1 1 0 0 1 1.149 0l9.574 6.72A2 2 0 0 1 23 9.76V22a1 1 0 0 1-1 1h-5.333a1 1 0 0 1-1-1v-5.674a1 1 0 0 0-1-1H9.333a1 1 0 0 0-1 1V22a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1z',
};
const Circle = (color, options) => {
    const { r = 11, fill = color, strokeWidth = 0 } = options || {};
    return (React.createElement("circle", { stroke: color, fill: fill, strokeWidth: strokeWidth, fillRule: "evenodd", cx: "12", cy: "12", r: r }));
};
const Polygon$1 = (points, color) => {
    return React.createElement("polygon", { points: points, fill: color });
};
const Path$1 = (d, color, options) => {
    const { fill = 'none', strokeWidth = 2, transform } = options || {};
    return React.createElement("path", { d: d, fill: fill, stroke: color, strokeWidth: strokeWidth, transform: transform });
};
const Rect = (color, options) => {
    const { width = 22, height = 22, x = 1, y = 1 } = options || {};
    return (React.createElement("rect", { width: width, height: height, x: x, y: y, fill: "none", stroke: color, strokeWidth: "2", rx: "2" }));
};
const getFgBg = (color, colorOrigin, white) => {
    const fgBg = { fg: colorOrigin, bg: white };
    const bgFg = { fg: white, bg: colorOrigin };
    return color === white ? bgFg : fgBg;
};
const Error = (color, { size, colors = LightCuroColors }) => {
    const { error = '', white = '' } = colors;
    const { fg, bg } = getFgBg(color, error, white);
    const d = 'M13.6986 0.705745C12.7605 -0.232359 11.2453 -0.238133 10.3014 0.705745L0.705745 10.3014C-0.232359 11.2395 -0.238133 12.7547 0.705745 13.6986L10.3014 23.2943C11.2395 24.2324 12.7547 24.2381 13.6986 23.2943L23.2943 13.6986C24.2324 12.7605 24.2381 11.2453 23.2943 10.3014L13.6986 0.705745Z';
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: d, fill: fg }),
        size !== 'xxsmall' && (React.createElement(React.Fragment, null,
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 7H13V14H11V7Z", fill: bg }),
            React.createElement("path", { d: "M13 16H11V18H13V16Z", fill: bg })))));
};
const Warning = (color, { size, colors = LightCuroColors }) => {
    const { warning = '', white = '' } = colors;
    const { fg, bg } = getFgBg(color, warning, white);
    const d = 'M12.8944 1.78885C12.5259 1.0518 11.4741 1.05181 11.1056 1.78885L0.723607 22.5528C0.391157 23.2177 0.874652 24 1.61803 24H22.382C23.1253 24 23.6088 23.2177 23.2764 22.5528L12.8944 1.78885Z';
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: d, fill: fg }),
        size !== 'xxsmall' && (React.createElement(React.Fragment, null,
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 10H13V17H11V10Z", fill: bg }),
            React.createElement("path", { d: "M13 19H11V21H13V19Z", fill: bg })))));
};
const Flash = (color) => {
    const d = 'M0.914062 13H6.91406L3.91406 22H5.91406L16.9141 8H10.9141L14.9141 0H3.91406L0.914062 13Z';
    return Path$1(d, color, { fill: color, strokeWidth: 0 });
};
const Success = (color, { size, colors = LightCuroColors }) => {
    const { success = '', white = '' } = colors;
    const { fg, bg } = getFgBg(color, success, white);
    const d = 'M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z';
    const dBg = 'M17.3604 8.46817L11.9059 16.1045L11.2569 17.0131L10.3636 16.3432L6 13.0705L7.30909 11.325L10.7795 13.9278L15.585 7.20001L17.3604 8.46817Z';
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: d, fill: fg }),
        size !== 'xxsmall' && (React.createElement(React.Fragment, null,
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: dBg, fill: bg })))));
};
const Info = (color, { size, colors = LightCuroColors }) => {
    const { info = '', white = '' } = colors;
    const { fg, bg } = getFgBg(color, info, white);
    return (React.createElement(React.Fragment, null,
        React.createElement("rect", { width: "24", height: "24", rx: "2", fill: fg }),
        size !== 'xxsmall' && (React.createElement(React.Fragment, null,
            React.createElement("path", { d: "M13 17H11V10H13V17Z", fill: bg }),
            React.createElement("path", { d: "M13 8H11V6H13V8Z", fill: bg })))));
};
const Disabled = (color, { size, colors = LightCuroColors }) => {
    const { disabled = '', white = '' } = colors;
    const { fg, bg } = getFgBg(color, disabled, white);
    return (React.createElement(React.Fragment, null,
        Circle(fg),
        size !== 'xxsmall' && Path$1('M5.5,12 L18.5,12', bg)));
};
const Unknown = (color, { colors = LightCuroColors }) => {
    const { default: defaultColor = '', white = '' } = colors;
    const { fg, bg } = getFgBg(color, defaultColor, white);
    return (React.createElement(React.Fragment, null,
        Circle(fg),
        Path$1(customPath.question, bg)));
};
const Close = (color, { colors = LightCuroColors }) => {
    const { default: defaultColor = '', white = '' } = colors;
    const { fg, bg } = getFgBg(color, defaultColor, white);
    return (React.createElement(React.Fragment, null,
        Circle(fg),
        Path$1('M7,7 L17,17 M7,17 L17,7', bg)));
};
const FilterSm = (color) => {
    const points = '6 8 11.667 12.667 11.667 18 12.333 18 12.333 12.667 18 8 18 6 6 6';
    return React.createElement("polygon", { points: points, fill: "none", stroke: color, strokeWidth: "1" });
};
const Remote = (color) => {
    return (React.createElement(React.Fragment, null,
        Polygon$1('5 21 19 21 19 23 5 23', color),
        Path$1('M12,18 L12,24', color)));
};
const SnapshotRemote = (color) => {
    return (React.createElement(React.Fragment, null,
        Path$1('M1,18 L1,6 L6,6 L8,2.6 L16,2.6 L18,6 L23,6 L23,18 L1,18 Z', color),
        React.createElement("circle", { fill: "none", stroke: color, strokeWidth: "2", cx: "12", cy: "11", r: "4.2" }),
        ";",
        Remote(color)));
};
const DatabaseRemote = (color) => {
    const d = 'M3.39,1.57 L20.61,1.57 L20.61,7.04 L3.39,7.04 L3.39,1.57 Z M5.74,9.39 L6.52,9.39 L6.52,10.17 L5.74,10.17 L5.74,9.39 Z M5.74,3.91 L6.52,3.91 L6.52,4.7 L5.74,4.7 L5.74,3.91 Z M5.74,14.9 L6.52,14.9 L6.52,15.7 L5.74,15.7 L5.74,14.9 Z M3.39,12.52 L20.61,12.52 L20.61,18 L3.39,18 L3.39,12.52 Z M3.39,7.04 L20.61,7.04 L20.61,12.52 L3.39,12.52 L3.39,7.04 Z';
    return (React.createElement(React.Fragment, null,
        Path$1(d, color),
        Remote(color)));
};
const Nimble = (color) => {
    const bottom = '17.78,12.50 16.56,13.12 18.94,14.36 12.00,17.88 5.08,14.36 7.46,13.12 6.25,12.50 2.68,14.38 12.00,19.26 21.35,14.38';
    const middle = '18.89,10.31 15.74,8.65 14.55,9.27 16.49,10.31 12.00,12.55 7.54,10.31 9.47,9.27 8.28,8.65 5.13,10.31 12.00,13.93';
    const topD = 'M12.00,4.81 L7.81,7.02 L12.00,9.22 L16.19,7.02 L12.00,4.81 M12.00,6.20 L13.64,7.02 L12.00,7.83 L10.36,7.02 L12.00,6.20';
    return (React.createElement(React.Fragment, null,
        Polygon$1(bottom, color),
        Polygon$1(middle, color),
        Path$1(topD, color, { fill: color, strokeWidth: 0 })));
};
const spin = keyframes `
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;
const SpinStyledPath = styled.path.withConfig({ displayName: "SpinStyledPath", componentId: "sc-1b2yxvh" }) `
  animation: ${spin} 2s infinite linear;
  transform-origin: 50% 50%;
`;
const Spinner = (color, { internalColors = LightInternalColors }) => {
    const d = 'M12 0 A12 12 0 0 1 24 12 L21 12 A12 9 0 0 0 12 3z';
    const dBg = 'M12 0 A12 12 0 0 0 12 24 A12 12 0 0 0 12 0 M12 3 A9 9 0 0 1 12 21 A9 9 0 0 1 12 3';
    const { solitude = '' } = internalColors;
    const fill = solitude;
    return (React.createElement(React.Fragment, null,
        Path$1(dBg, fill, { fill, strokeWidth: 0 }),
        React.createElement(SpinStyledPath, { d: d, fill: color, strokeWidth: "0" })));
};
const InProgress = (color) => {
    const d = 'M1,1 L23,1 M5,1 C5,1 5,3 5,6 C5,9 10,9.23530084 10,12 C10,14.7646992 5.00000001,15 5,18 C4.99999999,21 5,23 5,23 M19,1 C19,1 19,3 19,6 C19,9 14,9.23530084 14,12 C14,14.7646992 19,15 19,18 C19,21 19,23 19,23 M1,23 L23,23';
    const dTop = 'M10,4.5 L14,4.5 C14,4.5 14,6 14,6 C14,7 12,8 12,8 C12,8 10,7 10,6 C10,6 10,4.5 10,4.5 Z';
    const dBtm = 'M8,21 C8,19 12,17 12,17 C12,17 16,19 16,21 C16,21 16,23 16,23 L8,23 L8,21 Z';
    return (React.createElement(React.Fragment, null,
        Path$1(d, color),
        Path$1(dTop, color, { fill: color, strokeWidth: 0 }),
        Path$1(dBtm, color, { fill: color, strokeWidth: 0 })));
};
const More = (color) => {
    const d = 'M3,12 C3,10.8954 3.8954,10 5,10 C6.1046,10 7,10.8954 7,12 C7,13.1046 6.1046,14 5,14 C3.8954,14 3,13.1046 3,12 Z M10,12 C10,10.8954 10.8954,10 12,10 C13.1046,10 14,10.8954 14,12 C14,13.1046 13.1046,14 12,14 C10.8954,14 10,13.1046 10,12 Z M21,12 C21,10.8954 20.1046,10 19,10 C17.8954,10 17,10.8954 17,12 C17,13.1046 17.8954,14 19,14 C20.1046,14 21,13.1046 21,12 Z';
    return Path$1(d, color, { fill: color, strokeWidth: 0 });
};
const MoreVertical = (color) => {
    const d = 'M14,5 C14,6.1046 13.1046,7 12,7 C10.8954,7 10,6.1046 10,5 C10,3.8954 10.8954,3 12,3 C13.1046,3 14,3.8954 14,5 Z M14,12 C14,13.1046 13.1046,14 12,14 C10.8954,14 10,13.1046 10,12 C10,10.8954 10.8954,10 12,10 C13.1046,10 14,10.8954 14,12 Z M10,19 C10,20.1046 10.8954,21 12,21 C13.1046,21 14,20.1046 14,19 C14,17.8954 13.1046,17 12,17 C10.8954,17 10,17.8954 10,19 Z';
    return Path$1(d, color, { fill: color, strokeWidth: 0 });
};
const Hardware = (color) => {
    const d = 'M0,0 L1,0 L11,0 L12,0 L13,0 L23,0 L24,0 L24,1 L24,23 L24,24 L23,24 L13,24 L12,24 L11,24 L1,24 L0,24 L0,23 L0,1 L0,0 Z M11,2 L2,2 L2,22 L11,22 L11,2 Z M13,22 L22,22 L22,2 L13,2 L13,22 Z M7,17 L6,17 L6,18 L6,19 L6,20 L7,20 L8,20 L9,20 L9,19 L9,18 L9,17 L8,17 L7,17 Z M18,17 L17,17 L17,18 L17,19 L17,20 L18,20 L19,20 L20,20 L20,19 L20,18 L20,17 L19,17 L18,17 Z M4,4 L9,4 L9,6 L4,6 L4,4 Z M20,4 L15,4 L15,6 L20,6 L20,4 Z M4,8 L9,8 L9,10 L4,10 L4,8 Z M20,8 L15,8 L15,10 L20,10 L20,8 Z M4,12 L9,12 L9,14 L4,14 L4,12 Z M20,12 L15,12 L15,14 L20,14 L20,12 Z';
    return Path$1(d, color, { fill: color, strokeWidth: 0 });
};
const Tag$1 = (color) => {
    const d = 'M12.5858,0 L13,0 L23,0 L24,0 L24,1 L24,11 L24,11.4142 L23.7071,11.7071 L12.4142,23 C11.6331,23.781 10.3668,23.781 9.58576,23 L0.999971,14.4142 C0.218921,13.6332 0.218924,12.3668 0.999971,11.5858 L12.2929,0.292893 L12.5858,0 Z M13.41419,2 L2.41419,13 L11,21.5858 L22,10.5858 L22,2 L13.41419,2 Z M16,6 C16,4.89522 16.8952,4 18,4 C19.1048,4 20,4.89522 20,6 C20,7.10478 19.1048,8 18,8 C16.8952,8 16,7.10478 16,6 Z';
    return Path$1(d, color, { fill: color, strokeWidth: 0 });
};
const getCustomHeight = (size, isCustom, ratio) => {
    if (!isCustom) {
        return size;
    }
    const height = parseInt(size.split('px')[0], 10) / ratio;
    return `${height}px`;
};
const HPE = (color, size, dataTestId, isCustom) => {
    return (React.createElement("svg", Object.assign({ "aria-label": "Hpe", viewBox: "0 0 48 24", width: size, height: getCustomHeight(size, isCustom, 2 /* 48 / 24 */) }, getTestIdAttribute(dataTestId)),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 6H46V18H2V6ZM5 9H43V15H5V9Z", fill: color })));
};
const StyledBeacon = styled.svg.withConfig({ displayName: "StyledBeacon", componentId: "sc-crp983" }) `
  .pulse {
    fill: white;
    fill-opacity: 0;
    transform-origin: 50% 50%;
    animation-duration: 3s;
    animation-name: pulse;
    animation-iteration-count: infinite;
  }

  @keyframes pulse {
    from {
      stroke-width: 0px;
      stroke-opacity: 1;
      transform: scale(0.5);
    }
    to {
      stroke-width: 10px;
      stroke-opacity: 0;
      transform: scale(2);
    }
  }
`;
const Beacon = () => {
    const white = useCuroColor('white');
    const brand = useCuroColor('brand');
    return (React.createElement(StyledBeacon, { width: "40", height: "40", fill: "none" },
        React.createElement("circle", { className: "pulse", cx: "50%", cy: "50%", r: "6", stroke: brand }),
        React.createElement("circle", { cx: "50%", cy: "50%", r: "7", fill: white, stroke: brand, strokeWidth: "2" }),
        React.createElement("circle", { cx: "50%", cy: "50%", r: "2", fill: brand, stroke: brand, strokeWidth: "2" })));
};
const HeadShelf = (color, size, dataTestId, isCustom) => {
    const d = 'M22,0.5 C22.4142136,0.5 22.7892136,0.667893219 23.0606602,0.939339828 C23.3321068,1.21078644 23.5,1.58578644 23.5,2 L23.5,2 L23.5,10 C23.5,10.4142136 23.3321068,10.7892136 23.0606602,11.0606602 C22.7892136,11.3321068 22.4142136,11.5 22,11.5 L22,11.5 L2,11.5 C1.58578644,11.5 1.21078644,11.3321068 0.939339828,11.0606602 C0.667893219,10.7892136 0.5,10.4142136 0.5,10 L0.5,10 L0.5,2 C0.5,1.58578644 0.667893219,1.21078644 0.939339828,0.939339828 C1.21078644,0.667893219 1.58578644,0.5 2,0.5 L2,0.5 Z';
    const pos = {
        y: 3,
        width: 8,
        height: 6,
        strokeWidth: 0,
        fill: color,
    };
    return (React.createElement("svg", Object.assign({ "aria-label": "expansion-shelf", viewBox: "0 0 24 12", width: size, height: getCustomHeight(size, isCustom, 2) }, getTestIdAttribute(dataTestId)),
        Path$1(d, color, { strokeWidth: 1 }),
        [3, 13].map(x => (React.createElement("rect", Object.assign({ key: `${x}`, x: x }, pos))))));
};
const Node$1 = (color, size, dataTestId, isCustom) => {
    const pos = {
        x: 10,
        width: 5,
        height: 2,
        strokeWidth: 0,
        fill: color,
    };
    const d = 'M22,0.5 C22.4142136,0.5 22.7892136,0.667893219 23.0606602,0.939339828 C23.3321068,1.21078644 23.5,1.58578644 23.5,2 L23.5,2 L23.5,7 C23.5,7.41421356 23.3321068,7.78921356 23.0606602,8.06066017 C22.7892136,8.33210678 22.4142136,8.5 22,8.5 L22,8.5 L2,8.5 C1.58578644,8.5 1.21078644,8.33210678 0.939339828,8.06066017 C0.667893219,7.78921356 0.5,7.41421356 0.5,7 L0.5,7 L0.5,2 C0.5,1.58578644 0.667893219,1.21078644 0.939339828,0.939339828 C1.21078644,0.667893219 1.58578644,0.5 2,0.5 L2,0.5 Z';
    return (React.createElement("svg", Object.assign({ "aria-label": "node", viewBox: "0 0 24 9", width: size, height: getCustomHeight(size, isCustom, 2.67) }, getTestIdAttribute(dataTestId)),
        Path$1(d, color, { strokeWidth: 1 }),
        [2, 5].map(y => (React.createElement("rect", Object.assign({ key: `${y}`, y: y }, pos))))));
};
const ExpansionShelf = (color, size, dataTestId, isCustom) => {
    const pos = {
        y: 3,
        width: 3,
        height: 4,
        strokeWidth: 0,
        fill: color,
    };
    const d = 'M22,0.5 C22.4142136,0.5 22.7892136,0.667893219 23.0606602,0.939339828 C23.3321068,1.21078644 23.5,1.58578644 23.5,2 L23.5,2 L23.5,8 C23.5,8.41421356 23.3321068,8.78921356 23.0606602,9.06066017 C22.7892136,9.33210678 22.4142136,9.5 22,9.5 L22,9.5 L2,9.5 C1.58578644,9.5 1.21078644,9.33210678 0.939339828,9.06066017 C0.667893219,8.78921356 0.5,8.41421356 0.5,8 L0.5,8 L0.5,2 C0.5,1.58578644 0.667893219,1.21078644 0.939339828,0.939339828 C1.21078644,0.667893219 1.58578644,0.5 2,0.5 L2,0.5 Z';
    return (React.createElement("svg", Object.assign({ "aria-label": "expansion-shelf", viewBox: "0 0 24 10", width: size, height: getCustomHeight(size, isCustom, 2.4) }, getTestIdAttribute(dataTestId)),
        Path$1(d, color, { strokeWidth: 1 }),
        [3, 8, 13, 18].map(x => (React.createElement("rect", Object.assign({ key: `${x}`, x: x }, pos))))));
};
const ArrayStack = (color, size, dataTestId, isCustom) => {
    const singleArray = (translate) => {
        const d = 'M8.5,5.5 C9.19035594,5.5 9.81535594,5.77982203 10.267767,6.23223305 C10.720178,6.68464406 11,7.30964406 11,8 C11,8.69035594 10.720178,9.31535594 10.267767,9.76776695 C9.81535594,10.220178 9.19035594,10.5 8.5,10.5 C7.80964406,10.5 7.18464406,10.220178 6.73223305,9.76776695 C6.27982203,9.31535594 6,8.69035594 6,8 C6,7.30964406 6.27982203,6.68464406 6.73223305,6.23223305 C7.18464406,5.77982203 7.80964406,5.5 8.5,5.5 Z';
        return (React.createElement("g", { transform: translate },
            React.createElement("rect", { x: "1", y: "1", width: "56", height: "14", rx: "3", stroke: color, fillRule: "evenodd", fill: "none", strokeWidth: "2" }),
            React.createElement("path", { fillRule: "evenodd", fill: "none", d: d, strokeWidth: "2", stroke: color })));
    };
    return (React.createElement("svg", Object.assign({ "aria-label": "Hpe", viewBox: "0 0 58 54", width: size, height: getCustomHeight(size, isCustom, 58 / 54) }, getTestIdAttribute(dataTestId)),
        singleArray(),
        singleArray('translate(0, 19)'),
        singleArray('translate(0, 38)')));
};
const Descend = (color) => {
    return Path$1(customPath.ascend, color, { transform: 'matrix(1 0 0 -1 0 24)' });
};
const Radial = (color) => {
    return Circle(color, { fill: 'none', strokeWidth: 2 });
};
const Upgrade = (color) => {
    return (React.createElement(React.Fragment, null,
        Circle(color, { fill: 'none', strokeWidth: 2 }),
        Path$1('M12,18 L12,8 M17,12 L12,7 L7,12', color)));
};
const boxShadow = 'M2.88,5.76 C2.88,4.169424 4.169424,2.88 5.76,2.88 L21.12,2.88 C22.710624,2.88 24,4.169424 24,5.76 L24,21.12 C24,22.710624 22.710624,24 21.12,24 L5.76,24 C4.169424,24 2.88,22.710624 2.88,21.12 L2.88,5.76 Z M5.76,4.8 C5.2298112,4.8 4.8,5.2298112 4.8,5.76 L4.8,21.12 C4.8,21.650208 5.2298112,22.08 5.76,22.08 L21.12,22.08 C21.650208,22.08 22.08,21.650208 22.08,21.12 L22.08,5.76 C22.08,5.2298112 21.650208,4.8 21.12,4.8 L5.76,4.8 Z M18.24,0 C19.52,0 20.424,0.64 20.952,1.92 L3.84,1.92 C2.56,1.92 1.92,2.56 1.92,3.84 L1.92,20.952 L1.92,20.952 C0.64,20.424 0,19.52 0,18.24 L0,2.88 L0,2.88 C0,0.96 1.92,0 3.84,0 L18.24,0 L18.24,0 Z';
const CollapseAll = (color) => {
    const d = `${boxShadow} M19.2,12.48 L19.2,14.4 L7.68,14.4 L7.68,12.48 L19.2,12.48 Z`;
    return Path$1(d, color, { fill: color, strokeWidth: 0 });
};
const ExpandAll = (color) => {
    const d = `${boxShadow} M7.68,12.48 L19.2,12.48 L19.2,14.4 L7.68,14.4 L7.68,12.48 Z M14.4,14.4 L14.4,19.2 L12.48,19.2 L12.48,14.4 L14.4,14.4 Z M14.4,7.68 L14.4,12.48 L12.48,12.48 L12.48,7.68 L14.4,7.68 Z`;
    return Path$1(d, color, { fill: color, strokeWidth: 0 });
};
const Other = (color) => {
    const d = 'M5,1 L19,1 M2,4 L22,4';
    return (React.createElement(React.Fragment, null,
        Path$1(d, color),
        Rect(color, { width: 22, height: 14, x: 1, y: 8 })));
};
const Unassigned = (color) => {
    return (React.createElement(React.Fragment, null,
        Path$1(customPath.question, color),
        Rect(color)));
};

const IconDefaultStatusObj = {
    error: 'error',
    warning: 'warning',
    logo: 'brand',
    nimble: 'brand',
    success: 'success',
    info: 'info',
    disabled: 'disabled',
    spinner: 'brand',
};
// string: grommet icon name
const IconSourceObj = {
    logo: { svg: HPE },
    nimble: { icon: Nimble },
    // page header related
    apps: { d: customPath.apps },
    menu: { d: 'M2,19 L22,19 M2,5 L22,5 M2,12 L22,12' },
    home: { d: customPath.home },
    homeRounded: { d: customPath.homeRounded },
    dashboard: { d: customPath.dashboard },
    analyticsDashboard: { d: customPath.analyticsDashboard },
    table: { d: customPath.table },
    manage: { d: customPath.manage },
    hardware: { icon: Hardware },
    arrayStack: { svg: ArrayStack },
    headShelf: { svg: HeadShelf },
    expansionShelf: { svg: ExpansionShelf },
    node: { svg: Node$1 },
    system: { d: customPath.system },
    monitor: { d: customPath.monitor },
    help: { d: customPath.help, fillRule: 'evenodd', strokeWidth: 0 },
    alarm: { d: customPath.alarm },
    settings: { d: customPath.settings },
    pause: { d: 'M3 21h6V3H3v18zm12 0h6V3h-6v18z' },
    resume: { d: 'M1 20h5V4H1v16zm10-1 11-7-11-7v14z' },
    flash: { icon: Flash },
    beacon: { svg: Beacon },
    // others
    asterisk: { d: 'M12,1 L12,23 M2,6 L22,18 M22,6 L2,18' },
    sun: { d: customPath.sun, fillRule: 'evenodd', strokeWidth: 0 },
    moon: { d: customPath.moon, fillRule: 'nonzero', strokeWidth: 0 },
    bullet: { d: customPath.bullet },
    circle: {
        icon: (color) => {
            return Circle(color, { r: 6 });
        },
    },
    export: { d: customPath.export },
    calendar: { d: 'M2,5 L22,5 L22,22 L2,22 L2,5 Z M18,5 L18,1 M6,5 L6,1 M2,10 L22,10' },
    lineChart: { d: 'M1,16 L8,9 L13,14 L23,4 M0,22 L23.999,22 M16,4 L23,4 L23,11' },
    upgrade: { icon: Upgrade },
    download: { d: 'M1,17 L1,23 L23,23 L23,17 M12,2 L12,19 M5,12 L12,19 L19,12' },
    downloadCloud: { d: customPath.downloadCloud },
    cloudUpload: { d: customPath.cloudUpload },
    spinner: { icon: Spinner },
    refresh: { d: customPath.refresh },
    bookmark: { d: 'M5,1 L5,22 L12,17 L19,22 L19,1 Z' },
    favorite: { d: customPath.favorite },
    actions: { d: customPath.actions },
    tag: { icon: Tag$1 },
    feedback: { d: customPath.feedback },
    user: { d: customPath.user },
    group: { d: customPath.group },
    // data storage related
    pin: { d: customPath.pin },
    protected: { d: customPath.protectedD },
    notProtected: { d: customPath.notProtected },
    lock: { d: customPath.lock },
    storage: { d: customPath.storage },
    virtualMachine: { d: customPath.virtualMachine },
    exchange: { d: customPath.exchange },
    sharepoint: { d: customPath.sharepoint },
    virtualDesktop: { d: customPath.virtualDesktop },
    link: { d: customPath.link, clipRule: 'evenodd', fillRule: 'evenodd', strokeWidth: 0 },
    fileServer: { d: customPath.fileServer },
    multiple: { d: `${customPath.vol} M17,7 L17,1 L1,1 L1,17 L7,17` },
    backup: { d: customPath.backup },
    unassigned: { icon: Unassigned },
    other: { icon: Other },
    none: { d: ' ' },
    snapshot: { d: customPath.snapshot },
    snapshotRemote: { icon: SnapshotRemote },
    database: { d: customPath.database },
    databaseRemote: { icon: DatabaseRemote },
    switch: { d: customPath.switch },
    gateway: { d: customPath.gateway },
    serverCluster: { d: customPath.serverCluster },
    cloud: { d: customPath.cloud },
    clone: { d: customPath.clone },
    template: { d: customPath.template },
    folder: { d: customPath.folder },
    doc: { d: customPath.doc },
    docBlank: { d: customPath.docBlank },
    task: { d: customPath.task, strokeWidth: 2 },
    device: { d: customPath.device },
    cluster: { d: customPath.cluster },
    tree: { d: customPath.tree },
    // form related
    add: { d: 'M12 22V2M2 12h20' },
    remove: { d: 'm3 3 18 18M3 21 21 3' },
    close: { icon: Close },
    trash: { d: 'M4 5h16v18H4V5zM1 5h22M9 1h6v4H9V1zm0 0h6v4H9V1zm6 8v10M9 9v10' },
    edit: { d: customPath.edit },
    fit: { d: customPath.fit, strokeWidth: 1.8 },
    filter: { d: 'm3 6 7 7v8h4v-8l7-7V3H3z' },
    filterSm: { icon: FilterSm },
    moreVertical: { icon: MoreVertical },
    more: { icon: More },
    line: { d: 'M3,11.7 L21,11.7 L21,12.3 L3,12.3 Z' },
    search: { d: customPath.search },
    collapseAll: { icon: CollapseAll },
    expandAll: { icon: ExpandAll },
    login: { d: 'M9,15 L9,22 L22,22 L22,2 L9,2 L9,9 M18,12 L0,12 M13,7 L18,12 L13,17' },
    logout: { d: 'M13,9 L13,2 L1,2 L1,22 L13,22 L13,15 M22,12 L5,12 M17,7 L22,12 L17,17' },
    ascend: { d: customPath.ascend },
    descend: { icon: Descend },
    sort: { d: customPath.sort, clipRule: 'evenodd', fillRule: 'evenodd', strokeWidth: 0 },
    sortUp: { d: customPath.sortUp, clipRule: 'evenodd', fillRule: 'evenodd', strokeWidth: 0 },
    sortDown: { d: customPath.sortDown, clipRule: 'evenodd', fillRule: 'evenodd', strokeWidth: 0 },
    arrowLeft: { d: 'M18 12.4H6M11.4 7 6 12.4l5.4 5.4' },
    arrowRight: { d: 'M6 12.4h12M12.6 7l5.4 5.4-5.4 5.4' },
    arrowTwoWay: { d: 'M2 7h18m-4-5 5 5-5 5m6 5H4m4-5-5 5 5 5' },
    up: { d: 'M18,15 L12,9 L6,15' },
    down: { d: 'M18,9 L12,15 L6,9' },
    right: { d: 'M9,6 L15,12 L9,18' },
    left: { d: 'M15,6 L9,12 L15,18' },
    previous: { d: 'M17,2 L7,12 L17,22' },
    next: { d: 'M7,2 L17,12 L7,22' },
    show: { d: customPath.show },
    hide: { d: customPath.hide },
    radial: { icon: Radial },
    // Status
    error: { icon: Error },
    warning: { icon: Warning },
    success: { icon: Success },
    info: { icon: Info },
    disabled: { icon: Disabled },
    unknown: { icon: Unknown },
    inProgress: { icon: InProgress },
    clear: {
        d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M5,5 L19,19',
    },
    share: { d: customPath.share, fillRule: 'evenodd', strokeWidth: 1 },
    barChart: { d: customPath.barChart, strokeWidth: 2 }
};

const getSvgComponent = ({ icon, d, strokeWidth = 2, fillRule, clipRule }, color, size, colors, internalColors) => {
    if (icon) {
        return icon(color, { size, colors, internalColors });
    }
    return (React.createElement("path", { fill: fillRule ? color : 'none', fillRule: fillRule, stroke: color, clipRule: clipRule, strokeWidth: strokeWidth, d: d }));
};
const PrimitiveIcon = ({ size = 'medium', dataTestId, name, status, className, }) => {
    if (typeof size !== 'number' && !IconSizes.includes(size)) {
        logger(`Icon size ${size} is deprecated. Follow size guideline for the icon size usage`, 'error');
    }
    const iconStatus = status || IconDefaultStatusObj[name] || 'default';
    const colors = useCuroColors();
    const internalColors = useInternalColors();
    const svgColor = colors[iconStatus];
    const iconSource = IconSourceObj[name];
    if (!iconSource) {
        return React.createElement("div", null);
    }
    const { svg, icon, d } = iconSource;
    if (!(d || icon || svg)) {
        return React.createElement("div", null);
    }
    const isCustom = typeof size === 'number';
    const width = isCustom ? `${size}px` : IconSizePxMap[size];
    if (svg) {
        return svg(svgColor, width, dataTestId, isCustom);
    }
    return (React.createElement("svg", Object.assign({ "aria-label": name, viewBox: "0 0 24 24", width: width, height: width }, getTestIdAttribute(dataTestId), { className: className }), getSvgComponent(iconSource, svgColor, size, colors, internalColors)));
};

const IconTooltipWrapper = (props) => {
    const { tooltip, onClick } = props, primitiveProps = __rest(props, ["tooltip", "onClick"]);
    const targetComponent = React.createElement(PrimitiveIcon, Object.assign({}, primitiveProps));
    if ([undefined, '', false].includes(tooltip)) {
        return targetComponent;
    }
    const { name, dataTestId } = props;
    const iconTooltip = tooltip === true ? getI18nStr(name) : tooltip;
    return (React.createElement(Tooltip, { dataTestId: `${dataTestId}-tip`, tooltip: iconTooltip, target: targetComponent, align: ['bottom', 'center'] }));
};
const Icon = (_a) => {
    var { size = 'medium', tooltip = false, className } = _a, rest = __rest(_a, ["size", "tooltip", "className"]);
    const targetComponent = React.createElement(IconTooltipWrapper, Object.assign({}, rest, { size: size, tooltip: tooltip }));
    const { onClick, dataTestId } = rest;
    if (!onClick) {
        return targetComponent;
    }
    return (React.createElement(Button$1, { type: "plain", dataTestId: `${dataTestId}-click-container`, onClick: onClick, className: className }, targetComponent));
};

/* eslint-disable @typescript-eslint/indent */
// Styling for moreVertical
// To-Do: Use IconButton
const StyledDropButton = styled(DropButton).withConfig({ displayName: "StyledDropButton", componentId: "sc-3c09m2" }) `
  &:hover {
    background-color: ${props => props['data-bgcolor']};
    box-shadow: none;
  }
`;
const StyledBox$5 = styled(Box).withConfig({ displayName: "StyledBox", componentId: "sc-hhhzkr" }) `
  &:hover {
    background-color: ${props => props['data-hover-bg'] ? getStyledInternalColor(props, 'solitude') : undefined};
  }
`;
/**
 * This button type provides means to place secondary actions related to the task flow or contextual to the page in the application.  <br /> Link to UX pattern : https://confluence.eng.nimblestorage.com/display/UX/Dropdown+Actions+Menu+Button
 */
const DropdownActionMenu = (props) => {
    const curoColors = useCuroColors();
    const internalColors = useInternalColors();
    const vSize = useContext(ResponsiveContext);
    const [activeIndex, setActiveIndex] = useState(-1);
    const [open, setOpen] = useState(false);
    const { label, content, secondary: secondaryProp, splitButtonAction, closeOnClick = true, size = 'medium', disabled, dataTestId, responsive, moreVertical, } = props;
    // moreVertical styling is same as secondary
    const secondary = secondaryProp || moreVertical;
    if (splitButtonAction && moreVertical)
        logger('splitButtonAction cannot be used along with moreVertical', 'warning');
    const [itemCount, setItemCount] = useState(0);
    const disabledIndices = [];
    // Get the total content items by flattening the array
    useEffect(() => {
        const arrToFlatten = [...content];
        arrToFlatten.reduce((acc, val) => acc.concat(val), []);
        let totalCount = 0;
        arrToFlatten.forEach((item) => {
            if (Array.isArray(item)) {
                item.forEach((groupedItem) => {
                    if (groupedItem.disabled || groupedItem.isHeader)
                        disabledIndices.push(totalCount + item.length);
                });
                totalCount += item.length;
            }
            else {
                if (item.disabled)
                    disabledIndices.push(totalCount);
                totalCount++;
            }
        });
        setItemCount(totalCount);
    }, [content, disabledIndices]);
    const [newOptionSelected, setNewOptionSelected] = useState(false);
    const dropContent = (index, item, border = undefined, isHeaderElement = false) => {
        const contentOnClick = () => {
            if (item.onClick) {
                item.onClick();
                setNewOptionSelected(true);
            }
            if (closeOnClick)
                setOpen(false);
        };
        const chooseBackground = () => {
            if (item.selected && !newOptionSelected && !item.disabled) {
                return internalColors.lightSlate;
            }
            if (activeIndex === index || (item.active && activeIndex === -1)) {
                return internalColors.lightSlate;
            }
            return 'none';
        };
        const renderContent = () => {
            let labelContent = item.content;
            // Condition applied when there is a header  present in the object
            if (item === null || item === void 0 ? void 0 : item.isHeader) {
                labelContent = (React.createElement(Text$1, Object.assign({ style: {
                        fontSize: '14px',
                        height: '40px',
                    }, weight: 600 }, getTestIdAttribute(`${dataTestId}-heading-text`)), item.content));
            }
            return (React.createElement(Button$2, Object.assign({ label: labelContent, plain: true, style: {
                    height: size === 'small' ? '32px' : '40px',
                    padding: isHeaderElement && !(item === null || item === void 0 ? void 0 : item.isHeader) ? '0 10px' : '',
                    pointerEvents: (item === null || item === void 0 ? void 0 : item.isHeader) ? 'none' : 'auto',
                    fontSize: '16px',
                }, onClick: contentOnClick, disabled: item.disabled }, getTestIdAttribute(`${dataTestId}-${item.dataTestId}`))));
        };
        return (React.createElement(StyledBox$5, Object.assign({ key: new Date().getMilliseconds.toString() + item.dataTestId, border: border, background: chooseBackground(), onClick: () => !(item === null || item === void 0 ? void 0 : item.isHeader), pad: "0 12px", style: {
                minHeight: 'auto',
            }, "data-hover-bg": item.disabled !== undefined }, getTestIdAttribute(`${dataTestId}-${item.dataTestId}-container`)), renderContent()));
    };
    const ref = useRef(null);
    const currentRef = ref && ref.current;
    const [buttonWidth, setButtonWidth] = useState();
    useEffect(() => {
        // 40 is the width of the icon button on the right
        // @ts-ignore
        setButtonWidth(currentRef && currentRef.offsetWidth + 40);
    }, [currentRef]);
    const dropLabel = (React.createElement(React.Fragment, null,
        (vSize !== 'small' || splitButtonAction) && !responsive && !moreVertical && (React.createElement(Box, { direction: "row", align: "center", style: { maxHeight: '100%' } },
            label && !splitButtonAction && (React.createElement(Text$1, Object.assign({ color: !secondary ? curoColors.white : curoColors.default, margin: { right: 'small' }, style: { fontSize: '18px' }, weight: 600 }, getTestIdAttribute(`${dataTestId}-label-text`)), label)),
            React.createElement(Icon, { name: open ? 'up' : 'down', status: secondary ? 'success' : 'white', dataTestId: `${dataTestId}-drop-icon`, size: "large" }))),
        (vSize === 'small' || responsive || moreVertical) && !splitButtonAction && (React.createElement(Box, null,
            React.createElement(Icon, { name: moreVertical ? 'moreVertical' : 'more', size: size === 'small' ? 'small' : 'large', status: !secondary ? 'white' : 'black', dataTestId: `${dataTestId}-more-icon` })))));
    const displayContent = () => {
        let count = 0;
        return (content &&
            content.map((item) => {
                if (Array.isArray(item)) {
                    const isHeaderPresent = item.some(val => val === null || val === void 0 ? void 0 : val.isHeader);
                    return item.map((groupedItem, groupIndex) => {
                        let border = groupIndex === item.length - 1 ? { side: 'bottom' } : undefined;
                        border = groupIndex === 0 ? { side: 'top' } : undefined;
                        return dropContent(count++, groupedItem, border, isHeaderPresent);
                    });
                }
                return dropContent(count++, item, undefined);
            }));
    };
    const isDisabled = useCallback((index) => disabledIndices.includes(index), [
        disabledIndices,
    ]);
    const onNextOption = useCallback((event) => {
        event.preventDefault();
        if (!open)
            setOpen(true);
        else {
            let nextActiveIndex = activeIndex + 1;
            while (nextActiveIndex < itemCount &&
                isDisabled(activeIndex > 1 ? nextActiveIndex + 1 : nextActiveIndex)) {
                nextActiveIndex += 1;
            }
            if (nextActiveIndex !== itemCount) {
                setActiveIndex(nextActiveIndex);
            }
        }
    }, [activeIndex, isDisabled, itemCount, open]);
    const onPreviousOption = useCallback((event) => {
        event.preventDefault();
        let nextActiveIndex = activeIndex - 1;
        while (nextActiveIndex >= 0 &&
            isDisabled(activeIndex < 2 ? nextActiveIndex : nextActiveIndex + 1)) {
            nextActiveIndex -= 1;
        }
        if (nextActiveIndex >= 0) {
            setActiveIndex(nextActiveIndex);
        }
    }, [activeIndex, isDisabled]);
    const onSelectOption = useCallback((event) => {
        event.preventDefault();
        setOpen(false);
    }, []);
    const CustomDropButton = moreVertical ? StyledDropButton : DropButton;
    return (React.createElement(Keyboard, { onEnter: onSelectOption, onUp: onPreviousOption, onDown: onNextOption },
        React.createElement(Box, Object.assign({ direction: "row", align: "center" }, props, getTestIdAttribute(dataTestId)),
            splitButtonAction && label && (React.createElement(Button$2, Object.assign({ ref: ref, label: label, secondary: secondary, primary: !secondary, onClick: splitButtonAction, disabled: disabled, style: {
                    height: size === 'medium' ? '40px' : '32px',
                    marginRight: '1px',
                    borderRadius: '4px 0 0 4px',
                    fontSize: '18px',
                    fontWeight: 600,
                    minWidth: '85px',
                    padding: size === 'small' ? '0px 10px' : undefined,
                    color: !secondary ? curoColors.white : curoColors.default,
                } }, getTestIdAttribute(`${dataTestId}-default-action`)))),
            React.createElement(CustomDropButton, Object.assign({ className: responsive ? 'drop-down-with-more-icon' : 'drop-down-action', label: dropLabel, disabled: disabled, primary: !secondary, dropAlign: { top: 'bottom', right: 'right' }, dropContent: React.createElement(Box, { background: "white", style: { overflowY: 'auto', minWidth: `${buttonWidth}px` } }, displayContent()), onClose: /* istanbul ignore next */ () => setOpen(false), onOpen: /* istanbul ignore next */ () => setOpen(true), 
                // Adding to match height of the CURO button
                style: {
                    height: size === 'medium' ? '40px' : '32px',
                    padding: splitButtonAction ? '4px 6px 4px 6px' : undefined,
                    borderRadius: splitButtonAction ? '0 4px 4px 0' : undefined,
                    border: moreVertical ? 'none' : undefined,
                }, open: open, "data-bgcolor": internalColors.solitude }, getTestIdAttribute(`${dataTestId}-drop-button`))))));
};

/** Yields left and right section of a row to the user.
 *
 * Recommendation: Place primary, secondary and tertiary buttons on the right hand side in that order. Place optional supportive link or button on left hand side.
 * */
const ActionRow = ({ dataTestId, a11yTitle, leftElement, primaryAction, secondaryAction, tertiaryAction, }) => {
    // For small screens (mobile view) show the CTA button and others go in a dropdown.
    const getResponsiveContent = () => {
        // If leftElement is provied, add it to the dropdown.
        const dropContent = [];
        if (leftElement) {
            dropContent.push({
                content: leftElement,
                dataTestId: `${dataTestId}-${leftElement.props.dataTestId}`,
                disabled: leftElement.props.disabled,
            });
        }
        [secondaryAction, tertiaryAction].forEach(rightButton => {
            if (rightButton) {
                // If user provided button is a dropdown, show that to a group within this main dropdown.
                if (rightButton.type === DropdownActionMenu) {
                    const dropdown = rightButton;
                    let { content } = dropdown.props;
                    if (dropdown.props.disabled) {
                        content = content.map((entry) => {
                            // eslint-disable-next-line no-param-reassign
                            entry.disabled = true;
                            return entry;
                        });
                    }
                    dropContent.push(content);
                }
                else {
                    // /If user has provided a button, add that to common group
                    const button = rightButton;
                    dropContent.push({
                        content: button.props.label,
                        onClick: () => button.props.onClick(),
                        dataTestId: `${dataTestId}-${button.props.dataTestId}`,
                        disabled: button.props.disabled,
                    });
                }
            }
        });
        return (React.createElement(Box, Object.assign({ direction: "row", align: "center", justify: "end" }, getTestIdAttribute(dataTestId), { a11yTitle: a11yTitle, gap: "8px" }),
            dropContent.length > 0 && (React.createElement(DropdownActionMenu, { content: dropContent, dataTestId: `${dataTestId}-secondary-dropdown-action-button`, secondary: true })),
            primaryAction));
    };
    const getContent = () => {
        return (React.createElement(Box, Object.assign({ direction: "row" }, getTestIdAttribute(dataTestId), { a11yTitle: a11yTitle, justify: leftElement ? 'between' : 'end', align: "center" }),
            leftElement && (React.createElement(Box, Object.assign({ direction: "row", justify: "start", align: "center" }, getTestIdAttribute(`${dataTestId}-left-container`)), leftElement)),
            React.createElement(Box, Object.assign({ direction: "row", justify: "end", align: "center" }, getTestIdAttribute(`${dataTestId}-right-container`), { gap: "8px" }),
                tertiaryAction,
                secondaryAction,
                primaryAction)));
    };
    const screenWidth = useContext(ResponsiveContext);
    if (screenWidth === 'small') {
        return getResponsiveContent();
    }
    return getContent();
};

/**
 * A flexible and extensible content container with multiple variants. (Not recommended for use unless for compatibility issues.)
 */
const Panel = (_a) => {
    var { pad = 'small', noPad, children, border, background, backgroundColor, a11yTitle, fill, noMarginBottom, centerChildren, align, justify, onClick, noShrink, borderRadius, dataTestId, gridArea, basis, width, gap = 'none', panelRef, overflow = 'visible', direction = 'column', boxShadow = false } = _a, rest = __rest(_a, ["pad", "noPad", "children", "border", "background", "backgroundColor", "a11yTitle", "fill", "noMarginBottom", "centerChildren", "align", "justify", "onClick", "noShrink", "borderRadius", "dataTestId", "gridArea", "basis", "width", "gap", "panelRef", "overflow", "direction", "boxShadow"]);
    const curoColors = useCuroColors();
    const internalColors = useInternalColors();
    let bg;
    if (backgroundColor) {
        bg = curoColors[backgroundColor] || internalColors[backgroundColor];
    }
    else if (background) {
        if (typeof background === 'string') {
            const isCustomBg = background.startsWith('url') || background.startsWith('#');
            if (!isCustomBg) {
                logger('"background" with color name is not supported in CURO. Please use backgroundColor with curo color names instead.', 'error');
            }
        }
        bg = background;
    }
    return (React.createElement(Box, Object.assign({ direction: direction, pad: noPad ? 'none' : pad, a11yTitle: a11yTitle }, getTestIdAttribute(dataTestId), { margin: { bottom: !noMarginBottom ? 'small' : undefined }, border: border, background: bg, align: centerChildren ? 'center' : align, justify: centerChildren ? 'center' : justify, fill: fill, ref: panelRef, basis: basis, gap: gap, overflow: overflow, flex: { shrink: noShrink ? 0 : 1 }, round: borderRadius && typeof (borderRadius) === 'boolean' ?
            '4px' :
            typeof (borderRadius) === 'number' ?
                `${borderRadius}px` :
                undefined, style: {
            boxShadow: boxShadow ? '0px 0px 4px rgba(0, 0, 0, 0.2)' : 'none',
        }, gridArea: gridArea, onClick: onClick }, rest, { width: width }), children));
};

const StyledLink = styled.a.withConfig({ displayName: "StyledLink", componentId: "sc-ljkbda" }) `
  color: inherit;
  text-decoration: none;
  line-height: 1;
  &:focus, &:active {
    color: inherit;
    text-decoration: none;
  }
  &:hover {
    color: inherit;
    text-decoration: ${({ hoverLine }) => hoverLine};
  }
  padding: 0px 0px;
`;
const DisabledStyledLink = styled.span.withConfig({ displayName: "DisabledStyledLink", componentId: "sc-i4or7x" }) `
  text-decoration: none;
  opacity: ${Opacity.disabled};
`;
const getAs = (as, onClick) => {
    if (as) {
        return as;
    }
    if (onClick) {
        return 'button';
    }
    return 'anchor';
};
const Link = ({ label, dataTestId, href, onClick, type, weight, disabled = false, children, nowrap, as: baseAs, className, }) => {
    const textType = type || (onClick ? 'title4' : 'default');
    const as = getAs(baseAs, onClick);
    const labelText = (React.createElement(Text, { label: label || '', type: textType, status: "info", weight: weight, dataTestId: `${dataTestId}-label`, nowrap: nowrap }));
    const child = label ? labelText : children;
    if (as === 'button') {
        return (React.createElement(Button$1, { type: "plain", dataTestId: `${dataTestId}-button`, onClick: onClick, className: className, disabled: disabled }, child));
    }
    const color = useTextColor(textType, 'info');
    if (as === 'anchor' && href && !disabled) {
        return (React.createElement(StyledLink, Object.assign({ href: href, style: { textDecorationColor: color }, target: href.startsWith('http') ? '_blank' : '' }, getTestIdAttribute(dataTestId), { onClick: onClick, className: className, hoverLine: label !== undefined ? 'underline' : 'none' }), child));
    }
    return (React.createElement(DisabledStyledLink, Object.assign({}, getTestIdAttribute(dataTestId), { className: className }), child));
};

const ButtonBody = ({ children, size, label, status, dataTestId, labelFirst, icon, }) => {
    if (children) {
        return children;
    }
    const type = size === 'small' ? 'default' : 'title1';
    const sizeName = size === 'small' ? 'small' : 'large';
    const getLabel = () => {
        if (typeof label === 'string') {
            return (React.createElement(Text, { label: label, type: type, status: status || 'slate', weight: "normal", dataTestId: `${dataTestId}-text` }));
        }
        return label;
    };
    const space = icon && React.createElement(Text, { label: " ", weight: "normal", type: type, dataTestId: `${dataTestId}-space` });
    const iconComp = (icon && React.createElement(PrimitiveIcon, { name: icon, status: status, size: sizeName, dataTestId: `${dataTestId}-icon` }));
    if (labelFirst) {
        return (React.createElement("div", null,
            label && (React.createElement(React.Fragment, null,
                getLabel(),
                space)),
            iconComp));
    }
    return (React.createElement("div", null,
        iconComp,
        label && (React.createElement(React.Fragment, null,
            space,
            getLabel()))));
};
const Button = (props) => {
    const { onClick, disabled, type, border, a11yTitle, icon, size, dataTestId, className } = props;
    return (React.createElement(PrimitiveButton, { dataTestId: dataTestId, size: size || 'small', onClick: onClick, disabled: disabled, as: type || 'button', a11yTitle: `${a11yTitle || icon}`, iconBtnType: border ? 'border' : 'noBorder', className: className },
        React.createElement(ButtonBody, Object.assign({}, props))));
};
const IconButton = ({ size = 'small', border = false, disabled = false, labelFirst = false, tooltip = false, dataTestId, icon, label, onClick, status, children, a11yTitle, type, className, tooltipAlign, }) => {
    const iconTooltip = tooltip === true && icon ? getI18nStr(icon) : tooltip;
    const hasTooltip = ![undefined, false].includes(tooltip);
    const props = {
        size,
        border,
        disabled,
        labelFirst,
        dataTestId,
        icon,
        label,
        onClick,
        status,
        children,
        a11yTitle,
        type,
        className,
    };
    if (!icon && !label) {
        logger('Please either use Label or Icon property in IconButton', 'error');
    }
    if (hasTooltip) {
        return (React.createElement(Tooltip, { dataTestId: `${dataTestId}-tip`, tooltip: iconTooltip, target: React.createElement(Button, Object.assign({}, props)), align: tooltipAlign }));
    }
    return React.createElement(Button, Object.assign({}, props));
};

/** An overlay dialog. It has 3 sections.<br/>1. The header section indicates whether modal is for a warning, error etc. <br/> 2.Content section in the middle is the body of the modal. <br/> 3.Footer section shows the modal buttons. <br/> UX design - https://confluence.eng.nimblestorage.com/display/UX/Modal+Containers <br/><br/> Visual design - https://confluence.eng.nimblestorage.com/display/UX/Modal+Containers#ModalContainers-VisualDesign and as per UX visual design for header follows https://confluence.eng.nimblestorage.com/display/UXPatternLibrary/Flash+messaging+and+Global+messaging */
const Modal = ({ dataTestId, a11yTitle, title, type = 'plain', plainModalIconName, isSidePanel = false, primaryText, primaryAction, primaryDisabled, secondaryText, secondaryAction, secondaryDisabled, supportiveLink, supportiveLinkText, closeAction = undefined, size = 'medium', children, hasForm = false, isBlocking = false, blockingMsg, formId, height, footer: userFooter, slideLeft = false, slideModalType, slideRight, }) => {
    const isNotPlainModal = type !== 'plain';
    const screenWidth = useContext(ResponsiveContext);
    const showHeader = !!title;
    const showFooter = primaryText || secondaryText || supportiveLink || userFooter;
    const headerTheme = useHeaderTheme(type);
    /** Header */
    const header = showHeader && (React.createElement(Box, Object.assign({ direction: "row" }, getTestIdAttribute(`${dataTestId}-header`), { style: { minHeight: '32px' }, justify: "between", align: "center" }),
        React.createElement(Box, { direction: "row", align: "center" },
            (isNotPlainModal || plainModalIconName) && (React.createElement(Box, { pad: { top: '4px', bottom: '4px', right: '20px' } },
                React.createElement(Icon, { dataTestId: `${dataTestId}-header-icon`, name: (isNotPlainModal ? headerTheme.icon : plainModalIconName), size: "large" }))),
            React.createElement(Text, { dataTestId: `${dataTestId}-header-title`, label: title, type: "title1", weight: "medium" })),
        closeAction && (React.createElement(IconButton, { icon: "remove", dataTestId: `${dataTestId}-header-close-icon`, onClick: closeAction }))));
    /** Content */
    const isTitleIconPresent = isNotPlainModal || plainModalIconName;
    const content = (React.createElement(Box, Object.assign({ margin: {
            top: showHeader ? '20px' : undefined,
            bottom: showFooter ? '20px' : undefined,
        } }, getTestIdAttribute(`${dataTestId}-content`), { fill: "vertical", style: { overflowY: hasForm ? 'visible' : 'auto' } }),
        typeof children === 'string' && (React.createElement(Text, { dataTestId: `${dataTestId}-content-text`, label: children })),
        typeof children !== 'string' && children));
    /** Footer */
    const primaryActionButton = (React.createElement(Button$1, { key: `${dataTestId}-footer-primary-button`, dataTestId: `${dataTestId}-footer-primary-button`, label: primaryText, onClick: () => {
            if (primaryAction) {
                primaryAction();
            }
        }, disabled: primaryDisabled, type: hasForm ? 'submit' : 'primary', formId: formId }));
    const secondaryActionButton = (React.createElement(Button$1, { key: `${dataTestId}-footer-secondary-button`, dataTestId: `${dataTestId}-footer-secondary-button`, label: secondaryText, onClick: () => {
            if (secondaryAction) {
                secondaryAction();
            }
        }, disabled: secondaryDisabled, type: "tertiary" }));
    let modalPrimaryAction;
    let modalSecondaryAction;
    if (primaryAction || primaryText) {
        modalPrimaryAction = primaryActionButton;
    }
    if (secondaryAction) {
        modalSecondaryAction = secondaryActionButton;
    }
    const leftLink = () => {
        if (supportiveLink) {
            if (typeof supportiveLinkText === 'string') {
                return (React.createElement(Link, { dataTestId: `${dataTestId}-supportive-link`, href: supportiveLink, label: supportiveLinkText }));
            }
            return supportiveLinkText;
        }
        return undefined;
    };
    const footerEl = showFooter && (React.createElement(Box, Object.assign({ style: { minHeight: '40px', paddingLeft: isTitleIconPresent ? '44px' : '' } }, getTestIdAttribute(`${dataTestId}-footer`)),
        React.createElement(ActionRow, { dataTestId: `${dataTestId}-footer-action-row`, a11yTitle: "Action row for modal", leftElement: leftLink(), primaryAction: modalPrimaryAction, tertiaryAction: modalSecondaryAction })));
    /** Blocking Modal Body */
    const blockingModalBody = (React.createElement(Box, { justify: "center", align: "center", gap: "small", style: { height: '100vh' } },
        React.createElement(Icon, { dataTestId: `${dataTestId}-spinner-icon`, name: "spinner", size: 36 }),
        blockingMsg && (React.createElement(Text, { dataTestId: `${dataTestId}-blocking-modal-msg`, status: "black", label: blockingMsg }))));
    /** Non Blocking Modal Body */
    /* User provides desired modal width using attr size = small or medium or large or xlarge.
    VD has provided fixed px values of modal width for different screen sizes.
    Desktop small - 600px, medium - 720px, large - 840px, xlarge - 1000px
    Mobile/Small Screens -  all dialogs are 100% width
    Modal as side panel width - 440px
    */
    // TODO: move to ThemeConstants once finalized
    let modalWidth;
    const modalWidthConfig = {
        small: '600px',
        medium: '720px',
        large: '840px',
        xlarge: '1000px',
        sidePanel: '440px',
        full: '90vw',
    };
    if (screenWidth === 'small') {
        modalWidth = '100%';
    }
    else if (isSidePanel) {
        modalWidth = modalWidthConfig.sidePanel;
    }
    else if (size === 'full') {
        modalWidth = modalWidthConfig.full;
    }
    else {
        switch (screenWidth) {
            case 'medium':
                modalWidth = ['small', 'medium'].includes(size)
                    ? modalWidthConfig[size]
                    : modalWidthConfig.medium;
                break;
            case 'large':
                modalWidth = ['small', 'medium', 'large'].includes(size)
                    ? modalWidthConfig[size]
                    : modalWidthConfig.large;
                break;
            default:
                // screen width xlarge
                modalWidth = modalWidthConfig[size];
                break;
        }
    }
    const topBorder = isNotPlainModal ? `solid 8px ${headerTheme.backgroundColor}` : '';
    const padding = `40px 40px 40px 40px`;
    const nonBlockingModalBody = (React.createElement(Box, { round: isSidePanel || screenWidth === 'small' ? '0px' : '8px', width: modalWidth, style: {
            // maxWidth: screenWidth === 'small' ? '100%' : '768px',
            // eslint-disable-next-line no-nested-ternary
            maxHeight: !isSidePanel ? (screenWidth === 'small' ? '100%' : '90vh') : undefined,
            // minHeight: '35vh', // Removed as per email from UX on May 11th with subject Reg. upcoming demo for Fleet
            // eslint-disable-next-line no-nested-ternary
            height: !isSidePanel ? (screenWidth === 'small' ? '100%' : height) : undefined,
            borderTop: topBorder,
            padding,
        }, justify: "between" },
        React.createElement(Box, { height: "100%" },
            header,
            content),
        userFooter && userFooter,
        !userFooter && footerEl));
    const modalBody = isBlocking ? blockingModalBody : nonBlockingModalBody;
    const white = useCuroColor('white');
    const mediumGray = useInternalColor('mediumGray');
    const numModalWidth = parseInt(modalWidth.replace(/\D/g, ''));
    const slideLeftModalPosition = numModalWidth / 2 - 40;
    const leftValue = size === 'full' ? '-40%' : -slideLeftModalPosition;
    const modalStyle = {
        background: isBlocking ? mediumGray : white,
        borderRadius: isSidePanel || screenWidth === 'small' ? '0px' : '8px',
    };
    const primarySliderModalStyle = Object.assign(Object.assign({}, modalStyle), { position: 'absolute', top: '50%', left: leftValue, transition: `1s cubic-bezier(0.25,0.1,0.25,1)` });
    const secondarySliderModalStyle = Object.assign(Object.assign({}, modalStyle), { position: 'absolute', top: '50%', left: '150%', transition: `1s cubic-bezier(0.25,0.1,0.25,1)` });
    const defaultModalStyle = Object.assign(Object.assign({}, modalStyle), { position: 'absolute', top: '50%', left: '50%', transition: `1s cubic-bezier(0.25,0.1,0.25,1)` });
    const getLayerStyle = () => {
        if (slideModalType === 'primary') {
            return slideLeft ? primarySliderModalStyle : defaultModalStyle;
        }
        if (slideModalType === 'secondary') {
            return slideRight ? secondarySliderModalStyle : defaultModalStyle;
        }
        return modalStyle;
    };
    return (
    // Responsive attr is true by default for Layer. It means it will take full width and height on mobile.
    // ZIndex is controller by global theme - layer.container.zIndex
    React.createElement(Layer, Object.assign({ modal: true, position: isSidePanel ? 'right' : 'center' }, getTestIdAttribute(dataTestId), { "aria-label": a11yTitle, full: isBlocking || (isSidePanel && 'vertical'), style: getLayerStyle() }), modalBody));
};

/* eslint-disable @typescript-eslint/indent */
/** The responsive grid use Flexbox under the hood, and exposed several flex properties in the API. <br>
 Default Row component with children. Represents the horizontal axis oriented from the left to the right
*/
const Row = ({ dataTestId, children, a11yTitle, wrap = true, align = 'center', justify, fill, gridArea, noPad = false, gap = 'none', pad = 'small', role, }) => {
    return (React.createElement(Box, Object.assign({ direction: "row", wrap: wrap, a11yTitle: a11yTitle, width: "100%", fill: fill, pad: noPad ? 'none' : pad }, getTestIdAttribute(dataTestId), { align: align, gap: gap, gridArea: gridArea, justify: justify, role: role }), children));
};

const Column = ({ dataTestId, children, size, expand, align, justify, fill, alignSelf, offset, a11yTitle, gap = 'none', noPad = false, gridArea, pad = 'small', role, colRef, }) => {
    const [basisPercent, setBasisPercent] = useState(size);
    const vSize = useContext(ResponsiveContext);
    useEffect(() => {
        const colSize = getColumnSize(vSize, size);
        if (colSize)
            setBasisPercent(colSize);
    }, [size, vSize]);
    const customShrink = { flexGrow: 1, flexBasis: 0 };
    return (React.createElement(Box, Object.assign({ a11yTitle: a11yTitle, pad: noPad ? 'none' : pad }, getTestIdAttribute(dataTestId), { width: basisPercent, style: expand ? customShrink : undefined, align: align, gap: gap, fill: fill, justify: justify, alignSelf: alignSelf, gridArea: gridArea, margin: { left: offset }, role: role, ref: colRef }), children));
};

/* eslint-disable @typescript-eslint/indent */
const Grid = (props) => {
    const { dataTestId, a11yTitle, children, areas, gap, rows, columns, fill } = props;
    return (React.createElement(Grid$1, Object.assign({}, getTestIdAttribute(dataTestId), { a11yTitle: a11yTitle, rows: rows, columns: columns, areas: areas, gap: gap, fill: fill }), children));
};

/* eslint-disable no-nested-ternary */
const pulse = keyframes `
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
`;
const SkeletonBox = styled(Box).withConfig({ displayName: "SkeletonBox", componentId: "sc-64nul1" }) `
  display: block;
  background-color: rgba(0, 0, 0, 0.11);
  animation: ${pulse} 1.8s ease-in-out 0.9s infinite;
`;
/**
 * A flexible and extensible content container with multiple variants.
 */
const Skeleton = ({ type, height = '100%', width = '100%', dataTestId, rectBorderRadius, }) => {
    return (React.createElement(SkeletonBox, Object.assign({ height: typeof height === 'number' ? `${height}px` : height, round: type === 'text' ? '4px' : type === 'circle' ? '50%' : undefined, width: width, style: { borderRadius: rectBorderRadius } }, getTestIdAttribute(dataTestId))));
};

const StyledLoading = styled.div.withConfig({ displayName: "StyledLoading", componentId: "sc-1a8n0au" }) `
  position: fixed;
  background: ${(props) => getStyledCuroColor(props, 'black', Opacity.loader)};
  > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    text-align: center;
  }
`;
const LoadingLayer = ({ loadingMsg, targetRef, dataTestId, height, }) => {
    const [size, setSize] = useState({ w: '100% ', h: '100%' });
    const localRef = useRef(null);
    const initialRenderSetup = () => {
        if (targetRef && targetRef.current) {
            localRef.current = targetRef.current;
        }
    };
    useEffect(initialRenderSetup, []); // componentDidMount
    useEffect(() => {
        const handleResize = () => {
            if (localRef && localRef.current) {
                const { clientWidth: w, clientHeight: h1, offsetTop } = localRef.current;
                const remainingHeight = window.innerHeight - offsetTop;
                const h = h1 > remainingHeight ? remainingHeight : h1;
                if (w !== size.w || h !== size.h) {
                    setSize({ w, h });
                }
            }
        };
        if (localRef && localRef.current) {
            handleResize();
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [localRef, height]);
    return (React.createElement(StyledLoading, Object.assign({ style: { width: size.w, height: size.h } }, getTestIdAttribute(dataTestId)),
        React.createElement(Box, { fill: true, align: "center", justify: "center" },
            React.createElement(Icon, { name: "spinner", size: 48, dataTestId: `${dataTestId}-icon` }),
            loadingMsg && typeof loadingMsg === 'string' && (React.createElement(React.Fragment, null,
                React.createElement(Text, { label: " ", dataTestId: "space-padding" }),
                React.createElement(Text, { label: loadingMsg, dataTestId: `${dataTestId}-loading-msg` }))))));
};
const LoadingContainerWrapper = (_a) => {
    var { isLoading, loadingMsg, skeleton, dataTestId = 'loading-layer', children, height, setRef, pad = 'none', noMarginBottom = true, size, expand, style, containerRef, gap } = _a, rest = __rest(_a, ["isLoading", "loadingMsg", "skeleton", "dataTestId", "children", "height", "setRef", "pad", "noMarginBottom", "size", "expand", "style", "containerRef", "gap"]);
    if (size !== undefined || expand !== undefined) {
        return (React.createElement(Column, Object.assign({ noPad: pad === 'none', pad: pad, colRef: containerRef, size: size, expand: expand }, rest, { fill: true }), children));
    }
    return (React.createElement(Box, Object.assign({ style: style, ref: containerRef, pad: pad }, getTestIdAttribute(dataTestId), rest), children));
};
const LoadingContainer = (props) => {
    const containerRef = useRef(null);
    const { isLoading, loadingMsg, skeleton, children, height, dataTestId, setRef } = props;
    useEffect(() => {
        if (setRef && containerRef && containerRef.current) {
            setRef(containerRef);
        }
    }, [containerRef]);
    return (React.createElement(LoadingContainerWrapper, Object.assign({}, props, { containerRef: containerRef }),
        isLoading && skeleton === true && height && (React.createElement(Skeleton, { width: "100%", height: `${height}px`, dataTestId: "skeleton-panel-header" })),
        isLoading && typeof skeleton !== 'boolean' && skeleton,
        isLoading && !skeleton && containerRef && (React.createElement(LoadingLayer, { isLoading: isLoading, targetRef: containerRef, dataTestId: dataTestId, loadingMsg: loadingMsg, height: height })),
        (!skeleton || !isLoading) && children));
};

const TableContainer = ({ children, dataTestId, a11yTitle = 'Data Table', fullHeight, isLoading, loadingMsg, setTableRef, data, }) => {
    const [loaderRef, setLoaderRef] = useState();
    const [height, setHeight] = useState();
    useEffect(() => {
        if (loaderRef && loaderRef.current) {
            setTableRef(loaderRef);
            const h = loaderRef.current.clientHeight;
            if (h !== height) {
                setHeight(h);
            }
        }
    }, [loaderRef, data.length]);
    return (React.createElement(LoadingContainer, { isLoading: isLoading, loadingMsg: loadingMsg, height: height, setRef: setLoaderRef, role: "table", a11yTitle: a11yTitle, basis: fullHeight ? 'full' : undefined, flex: fullHeight ? { shrink: 1, grow: 1 } : false, fill: fullHeight ? undefined : 'horizontal', dataTestId: dataTestId, style: fullHeight ? { overflowX: 'hidden', width: '100%' } : { overflowX: 'hidden', overflowY: 'auto' } }, children));
};

const getFormattedColunmSize = (size) => {
    // truncate without rounding to 2 decimal places
    return `${Math.floor(size * 100) / 100}%`;
};
const TableHeaderPadding = {
    horizontal: '12px',
    vertical: '6px',
};
const TableHeaderCheckboxPadding = {
    left: '12px',
    right: '0px',
    vertical: '7px',
};
const TableBodyPadding = {
    horizontal: '12px',
    vertical: '8px',
};
const TableBodyCheckBoxPadding = {
    left: '12px',
    right: '0px',
    vertical: '8px',
};
const TableFooterPadding = {
    horizontal: '12px',
    vertical: '12px',
};

/* eslint-disable consistent-return */
const StyledSpan$1 = styled.span.withConfig({ displayName: "StyledSpan", componentId: "sc-pjjj2w" }) `
  overflow: hidden;
  width: 100%;
  -webkit-box-orient: vertical;
`;
const TruncateTarget = (props) => {
    const { label, dataTestId, type, status, weight, href, disabled = false } = props;
    const { truncateType = 'end', targetRef, textOverflow = 'ellipsis', lineCount } = props;
    const color = useTextColor(type, href ? 'info' : status);
    const style = {
        direction: truncateType === 'start' ? 'rtl' : 'ltr',
        color,
        fontWeight: getTextWeight(type, weight),
        textOverflow: lineCount > 1 ? 'clip' : textOverflow,
        whiteSpace: lineCount > 1 ? 'normal' : 'nowrap',
        display: lineCount > 1 ? '-webkit-box' : 'block',
        WebkitLineClamp: lineCount,
    };
    const textProps = { label, dataTestId, type, status, weight, nowrap: true };
    const linkProps = { href, label, dataTestId, type, weight, nowrap: true, disabled };
    const targetComponent = href ? React.createElement(Link, Object.assign({}, linkProps)) : React.createElement(Text, Object.assign({}, textProps));
    return (React.createElement(StyledSpan$1, Object.assign({ style: style, ref: targetRef }, getTestIdAttribute(`${dataTestId}-truncate-target`)), targetComponent));
};
const Truncate = ({ type = 'default', lineCount = 1, truncateType = 'end', tooltip, label, dataTestId, status, weight, href, disabled, }) => {
    const targetRef = useRef(null);
    const [hasTooltip, setHasTooltip] = useState(false);
    const commonProps = {
        label,
        dataTestId,
        type,
        status,
        weight,
        href,
        lineCount,
        disabled,
    };
    const truncateTargetProps = Object.assign(Object.assign({}, commonProps), { truncateType, targetRef });
    const truncatedTarget = React.createElement(TruncateTarget, Object.assign({}, truncateTargetProps));
    const [middleTruncatedTarget, setMiddleTruncatedTarget] = useState(truncatedTarget);
    useEffect(() => {
        if (truncateType !== 'middle')
            return;
        const middleTimeout = setTimeout(() => {
            if (targetRef && targetRef.current) {
                const { clientHeight, scrollHeight, clientWidth, scrollWidth } = targetRef.current;
                const isTruncated = lineCount > 1 ? clientHeight < scrollHeight : clientWidth < scrollWidth;
                setHasTooltip(isTruncated);
                if (isTruncated && truncateType === 'middle') {
                    const leftProps = Object.assign(Object.assign({}, commonProps), { truncateType: 'end' });
                    const rightProps = Object.assign(Object.assign({}, commonProps), { truncateType: 'start', textOverflow: 'clip' });
                    const newTarget = (React.createElement(Row, { noPad: true, dataTestId: `${dataTestId}-row` },
                        React.createElement(Column, { noPad: true, dataTestId: `${dataTestId}-left`, size: "55%" },
                            React.createElement(TruncateTarget, Object.assign({}, leftProps))),
                        React.createElement(Column, { noPad: true, dataTestId: `${dataTestId}-right`, size: "45%" },
                            React.createElement(TruncateTarget, Object.assign({}, rightProps)))));
                    setMiddleTruncatedTarget(newTarget);
                }
            }
        }, 20);
        return () => clearTimeout(middleTimeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [truncateType]);
    useEffect(() => {
        if (truncateType === 'middle')
            return;
        const handleResize = () => setTimeout(() => {
            if (targetRef && targetRef.current) {
                const { clientHeight, scrollHeight, clientWidth, scrollWidth } = targetRef.current;
                const isTruncated = lineCount > 1 ? clientHeight < scrollHeight : clientWidth < scrollWidth;
                setHasTooltip(isTruncated);
            }
        }, 40);
        const startEndTruncateTimeout = handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            clearTimeout(startEndTruncateTimeout);
            window.removeEventListener('resize', handleResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [truncateType]);
    const target = truncateType === 'middle' ? middleTruncatedTarget : truncatedTarget;
    const tooltipIsPresent = () => {
        if (tooltip === false) {
            // disable Truncate tooltip
            return false;
        }
        if (hasTooltip || ![undefined, false].includes(tooltip)) {
            // truncated or custom tooltip
            return true;
        }
        // tooltip === undefined && hasTooltip === false
        return false;
    };
    return (React.createElement(Tooltip, { tooltip: tooltipIsPresent() &&
            ([undefined, true, false].includes(tooltip) ? label : tooltip), target: target, dataTestId: dataTestId, nowrap: true }));
};

const getBgColor$1 = (props, hasBg) => {
    return hasBg ? getStyledInternalColor(props, 'lighterGray') : 'transparent';
};
const StyledCellBox = styled(Box).withConfig({ displayName: "StyledCellBox", componentId: "sc-kaaq0j" }) `
  background-color: ${(props) => getBgColor$1(props, props.isSorted)};
  &:hover {
    background: ${(props) => getBgColor$1(props, props.hasClick)};
  }
  &:focus {
    box-shadow: none;
  }
`;
const HeaderCellItemWrapper = (props) => {
    const { alignHeader, index, onToggleSelectAll, sortable, borderLeft, colId, children, onToggleSelect, } = props;
    const getPadding = () => {
        const hasSelectAll = index === 0 && !borderLeft && onToggleSelectAll !== undefined;
        if (hasSelectAll) {
            return 'none';
        }
        if (index === 0 && !borderLeft && onToggleSelect) {
            if (!onToggleSelectAll && sortable) {
                return { left: '45px' };
            }
            return {
                left: '56px',
                right: '12px',
                vertical: '6px',
            };
        }
        if (sortable) {
            return 'none';
        }
        return TableHeaderPadding;
    };
    const topColor = useInternalColor('gainsboro');
    const lftColor = useInternalColor('gainsboro', index > 0 || borderLeft ? 1 : 0);
    return (React.createElement(Box, Object.assign({ direction: "row", alignContent: "start", justify: alignHeader, fill: true, pad: getPadding(), style: {
            borderLeft: `1px solid ${lftColor}`,
            borderTop: `1px solid ${topColor}`,
        } }, getTestIdAttribute(`${colId}-header-row`)), children));
};
const SortableHeaderCard = (props) => {
    const { header, property, truncateHeader, alignHeader, sorter = {}, colId, justifyHeader, } = props;
    const { sortKey, sortDir, onSort } = sorter;
    const [isHover, setIsHover] = useState(false);
    const HeaderText = truncateHeader ? Truncate : Text;
    const hoverProps = {
        onMouseOver: () => {
            setIsHover(true);
        },
        onMouseLeave: () => {
            setIsHover(false);
        },
        onFocus: () => {
            setIsHover(true);
        },
        onBlur: () => {
            setIsHover(false);
        },
        onClick: () => {
            if (onSort) {
                onSort(property);
            }
        },
    };
    const getIconName = () => {
        if (property !== sortKey && !isHover) {
            return 'none';
        }
        if (property === sortKey) {
            return sortDir === 'asc' ? 'sortUp' : 'sortDown';
        }
        return 'sort';
    };
    return (React.createElement(StyledCellBox, Object.assign({ direction: "row", fill: true, hasClick: onSort !== undefined, isSorted: property === sortKey, justify: alignHeader }, hoverProps, { pad: {
            horizontal: '12px',
            vertical: '6px',
        } }, getTestIdAttribute(`${colId}-sort-row`)),
        React.createElement(Column, { pad: { vertical: '4px' }, justify: justifyHeader, expand: true, dataTestId: `${colId}-title-col` },
            typeof header !== 'string' && header,
            typeof header === 'string' && (React.createElement(HeaderText, { label: header, dataTestId: `${colId}-title`, type: "label", status: "default", weight: "medium" }))),
        React.createElement(Column, { noPad: true, justify: justifyHeader, dataTestId: `${colId}-sort-col` }, (property === sortKey || isHover) && (React.createElement(Icon, { name: getIconName(), dataTestId: `${colId}-sort-icon`, status: "default", size: "large" })))));
};
const HeaderCellItemCard = (props) => {
    const { sortable, header, justifyHeader } = props;
    if (sortable) {
        return React.createElement(SortableHeaderCard, Object.assign({}, props));
    }
    if (typeof header !== 'string') {
        return header;
    }
    const { alignHeader, colId, truncateHeader } = props;
    const HeaderText = truncateHeader ? Truncate : Text;
    return (React.createElement(Column, { align: alignHeader, justify: justifyHeader, dataTestId: `${colId}-text-col`, pad: "4px 0px" },
        React.createElement(HeaderText, { label: header, dataTestId: `${colId}-text`, type: "label", status: "default", weight: "medium" })));
};
const HeaderCellItemSelectAll = (props) => {
    const { onToggleSelectAll, sortable, colId, selectAllStatus, justifyHeader } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(Column, { pad: TableHeaderCheckboxPadding, justify: justifyHeader, dataTestId: `${colId}-checkbox-col` },
            React.createElement(CheckBox$1, Object.assign({ checked: selectAllStatus === 'partial' ? false : selectAllStatus, onChange: (event) => {
                    onToggleSelectAll(event.target.checked);
                } }, getTestIdAttribute(`${colId}-select-all`), { label: "", name: "selectAll", indeterminate: selectAllStatus === 'partial' }))),
        React.createElement(Column, { pad: sortable ? 'none' : TableHeaderPadding, expand: true, dataTestId: `${colId}-header-col`, justify: justifyHeader },
            React.createElement(HeaderCellItemCard, Object.assign({}, props)))));
};
const HeaderCellItemContent = (props) => {
    const { index, borderLeft, onToggleSelectAll } = props;
    if (index === 0 && !borderLeft && onToggleSelectAll !== undefined) {
        return React.createElement(HeaderCellItemSelectAll, Object.assign({}, props));
    }
    return React.createElement(HeaderCellItemCard, Object.assign({}, props));
};
const HeaderCellItem = (props) => {
    return (React.createElement(HeaderCellItemWrapper, Object.assign({}, props),
        React.createElement(HeaderCellItemContent, Object.assign({}, props))));
};

const SuperHeaderCell = ({ dataTestId, id, header, index }) => {
    const colId = dataTestId || id;
    const topColor = useInternalColor('gainsboro');
    const lftColor = useInternalColor('gainsboro', index > 0 ? 1 : 0);
    const lighterGray = useInternalColor('lighterGray');
    return (React.createElement(Box, Object.assign({ direction: "row", alignContent: "start", justify: "center", fill: "horizontal", style: {
            background: lighterGray,
            borderLeft: `1px solid ${lftColor}`,
            borderTop: `1px solid ${topColor}`,
            padding: '3px 12px',
        } }, getTestIdAttribute(`${colId}-header-row`)),
        typeof header !== 'string' && header,
        typeof header === 'string' && (React.createElement(Text, { label: header, dataTestId: `${colId}-text`, status: "default", type: "fine" }))));
};
const TableHeaderCell = (props) => {
    const { sortable = false, alignHeader, columns = [], dataTestId, size, id, colsCount, sorter, justifyHeader, index } = props;
    const colId = dataTestId || id;
    const colSize = size || getFormattedColunmSize(100 / colsCount);
    if (columns.length < 1) {
        // No children
        return (React.createElement(Column, { role: "columnheader", a11yTitle: "Table Header Cell", dataTestId: `${colId}-cell`, size: colSize, align: sortable ? undefined : alignHeader, justify: justifyHeader, noPad: true, fill: "vertical" },
            React.createElement(HeaderCellItem, Object.assign({}, props))));
    }
    // Has children
    return (React.createElement(Column, { role: "columnheader", a11yTitle: "Table Header Cell Group", dataTestId: `${colId}-cell`, size: colSize, justify: "end", align: sortable ? undefined : alignHeader, noPad: true },
        React.createElement(SuperHeaderCell, Object.assign({}, props)),
        React.createElement(Box, Object.assign({ role: "row", "aria-label": "columnheaderGroup", direction: "row", fill: true }, getTestIdAttribute(`${colId}-row`)), columns &&
            columns.map((sub, colI) => (
            // eslint-disable-next-line react/no-array-index-key
            React.createElement(Fragment, { key: `${sub.property}-${colI}` },
                React.createElement(TableHeaderCell, Object.assign({}, sub, { id: `${colId}-${colI}`, colsCount: columns.length, index: colI, sorter: sorter, borderLeft: index > 0 ? true : false, colId: sub.dataTestId || `${colId}-${colI}`, justifyHeader: justifyHeader }))))))));
};

const TableHeader$1 = ({ dataTestId, columns, sorter, onToggleSelectAll, selectAllStatus, onToggleSelect, }) => {
    const dimGray = useInternalColor('dimGray');
    const hasSubCol = columns.some(({ columns }) => {
        return columns && columns.length > 0;
    });
    const justifyHeader = hasSubCol ? 'end' : 'center';
    return (React.createElement(Box, Object.assign({ role: "rowgroup", direction: "row", a11yTitle: "Table-Header" }, getTestIdAttribute(dataTestId), { style: { borderBottom: `2px solid ${dimGray}` }, flex: { shrink: 0 } }),
        React.createElement(Row, { noPad: true, dataTestId: `${dataTestId}-row` }, columns.map((column, rowIdx) => (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement(Fragment, { key: `${column.property}-${rowIdx}` },
            React.createElement(TableHeaderCell, Object.assign({}, column, { id: `${dataTestId}-${rowIdx}`, colsCount: columns.length, sorter: sorter, index: rowIdx, onToggleSelectAll: onToggleSelectAll, selectAllStatus: selectAllStatus, colId: column.dataTestId || `${dataTestId}-${rowIdx}`, alignHeader: column.alignHeader || 'start', truncateHeader: column.truncateHeader !== false, justifyHeader: justifyHeader, onToggleSelect: onToggleSelect }))))))));
};

const TableBodyCell = (props) => {
    const { property, truncateBody, render, item, dataTestId = 'cell', onToggleSelect, dataIdx, index, second = false, selectedStatusArr = [], } = props;
    if (!second && index === 0 && onToggleSelect !== undefined) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Column, { pad: TableBodyCheckBoxPadding, dataTestId: `${dataTestId}-checkbox-col` },
                React.createElement(CheckBox$1, Object.assign({ checked: ((selectedStatusArr instanceof Array && selectedStatusArr.length > 0 && selectedStatusArr[dataIdx]) ? true : false), onChange: (event) => {
                        onToggleSelect(dataIdx, event.target.checked);
                    } }, getTestIdAttribute(`${dataTestId}-checkbox`), { label: "", name: `select-${dataIdx}` }))),
            React.createElement(Column, { fill: true, justify: "center", pad: TableBodyPadding, expand: true, dataTestId: `${dataTestId}-text-col` },
                React.createElement(TableBodyCell, Object.assign({}, props, { second: true })))));
    }
    let data = '';
    const propertyKeys = property.split('.');
    propertyKeys.forEach((key, keyI) => {
        if (keyI === 0) {
            data = item[key];
        }
        else if (typeof data === 'object') {
            data = data[key];
        }
    });
    if (render) {
        data = render(item, dataIdx);
    }
    if (data === null || data === undefined) {
        data = '';
    }
    if (typeof data !== 'string') {
        return data;
    }
    if (truncateBody) {
        return React.createElement(Truncate, { label: data, dataTestId: `${dataTestId}-label` });
    }
    return React.createElement(Text, { label: data, dataTestId: `${dataTestId}-label`, overflowWrap: true });
};
TableBodyCell.defaultProps = {
    onToggleSelect: undefined,
    selectedStatusArr: [],
    second: false,
};

const getPercentage = (per) => {
    return Number(per.split('%')[0]);
};
const getChildSize = (pa, sub) => {
    const subNum = getPercentage(sub);
    const paNum = getPercentage(pa);
    return getFormattedColunmSize((subNum * paNum) / 100);
};
const initSizeInfo = {
    sm: '0%',
    md: '0%',
    lg: '0%',
    xl: '0%',
};
const getSizeFromParent = (parentSize, subLen, size) => {
    const newSize = size || getFormattedColunmSize(100 / subLen);
    let childInfo = initSizeInfo;
    let parentInfo = initSizeInfo;
    if (typeof newSize === 'string' && typeof parentSize === 'string') {
        return getChildSize(parentSize, newSize);
    }
    if (typeof newSize === 'string') {
        childInfo = {
            sm: newSize,
            md: newSize,
            lg: newSize,
            xl: newSize,
        };
    }
    if (typeof parentSize === 'string') {
        parentInfo = {
            sm: parentSize,
            md: parentSize,
            lg: parentSize,
            xl: parentSize,
        };
    }
    const sizeInfo = Object.assign({}, initSizeInfo);
    ['sm', 'md', 'lg', 'xl'].forEach(key => {
        sizeInfo[key] = getChildSize(parentInfo[key], childInfo[key]);
    });
    return sizeInfo;
};
const getFlatColumns = (columns) => {
    if (!columns || columns.length < 1) {
        return columns;
    }
    const noChildren = columns.every(col => {
        return !col.columns || col.columns.length < 1;
    });
    const len = columns.length;
    const rootCols = columns.map(col => {
        return Object.assign(Object.assign({}, col), { alignBody: col.alignBody || 'start', size: col.size || getFormattedColunmSize(100 / len) });
    });
    if (noChildren) {
        return rootCols;
    }
    const cols = [];
    rootCols.forEach(col => {
        const subLen = col.columns ? col.columns.length : 0;
        if (col.columns && subLen > 0) {
            const newSubCols = col.columns.map(subCol => {
                return Object.assign(Object.assign({}, subCol), { size: getSizeFromParent(col.size, subLen, subCol.size) });
            });
            cols.push(...newSubCols);
        }
        else {
            cols.push(col);
        }
    });
    return cols;
};
const getSize = (columns) => {
    const isSizePercent = columns.every(({ size }) => {
        return typeof size === 'string';
    });
    if (isSizePercent) {
        let sizeNum = 0;
        columns.forEach(col => {
            sizeNum += getPercentage(col.size);
        });
        return `${sizeNum}%`;
    }
    const sizeInfo = {
        sm: 0,
        md: 0,
        lg: 0,
        xl: 0,
    };
    columns.forEach(col => {
        ['sm', 'md', 'lg', 'xl'].forEach(key => {
            const sizeStr = typeof col.size === 'object' ? col.size[key] : col.size;
            sizeInfo[key] += getPercentage(sizeStr || '0%');
        });
    });
    return {
        sm: `${sizeInfo.sm}%`,
        md: `${sizeInfo.md}%`,
        lg: `${sizeInfo.lg}%`,
        xl: `${sizeInfo.xl}%`,
    };
};
const getColWithSizes = (columns) => {
    if (columns.some(({ bodyColspan }) => {
        return bodyColspan && bodyColspan > 1;
    })) {
        const spliceIndexes = [];
        columns.forEach((col, index) => {
            const { bodyColspan = 1 } = col;
            if (bodyColspan > 1) {
                spliceIndexes.push([index + 1, bodyColspan - 1]);
                // eslint-disable-next-line no-param-reassign
                col.size = getSize(columns.slice(index, index + bodyColspan));
            }
        });
        for (let i = spliceIndexes.length - 1; i >= 0; i--) {
            columns.splice(...spliceIndexes[i]);
        }
    }
    return columns;
};
const getTdColumns = (columns) => {
    const flatColumns = getFlatColumns(columns);
    return getColWithSizes(flatColumns);
};
const getBgColor = (props) => {
    return getStyledInternalColor(props, 'lighShadeCyne');
};
const StyledTableRow = styled(Box).withConfig({ displayName: "StyledTableRow", componentId: "sc-j3m7xf" }) `
  overflow: visible;
  background-color: ${(props) => {
    if (props.selected) {
        return getStyledInternalColor(props, 'paleCyan');
    }
    if (props.even) {
        return getStyledCuroColor(props, 'white');
    }
    return getStyledInternalColor(props, 'lighterGray');
}};
  border-bottom: 1px solid ${props => getStyledCuroColor(props, 'white')};
  &:hover {
    background-color: ${props => getBgColor(props)};
  }
  &:focus {
    box-shadow: none;
  }
`;

// scrollbar width less than 12px content padding to not hide right align content
const StyledScrollBox = styled(Box).withConfig({ displayName: "StyledScrollBox", componentId: "sc-1qpsng5" }) `
  overflow-x: hidden;
  /* Chrome, Edge, Safari and others */
  &::-webkit-scrollbar {
    width: 6px;
    padding: 2px;
  }
  &::-webkit-scrollbar-track {
    background-color: ${props => getStyledInternalColor(props, 'lighterGray')};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${props => getStyledCuroColor(props, 'black', 0.3)};
    border-radius: 8px;
  }
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: ${props => `${getStyledCuroColor(props, 'black', 0.3)} ${getStyledInternalColor(props, 'lighterGray')}`}
`;
const FullHeightWrapper = ({ children, dataTestId, tableRef, noData, defaultScroll }) => {
    var _a;
    const ScrollBox = defaultScroll ? Box : StyledScrollBox;
    const [width, setWidth] = useState('100%');
    useEffect(() => {
        const handleResize = () => {
            var _a;
            setWidth(((_a = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || '100%');
        };
        if (tableRef && tableRef.current) {
            handleResize();
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [tableRef]);
    return (React.createElement(Box, Object.assign({ role: "rowgroup", a11yTitle: "Table-Body", flex: { shrink: 1, grow: 1 }, style: { overflow: 'hidden' } }, getTestIdAttribute(dataTestId)),
        React.createElement(ScrollBox, Object.assign({ role: "rowgroup", a11yTitle: "Table-Body-Scroll-Container", style: { overflowY: noData ? 'hidden' : 'auto', overflowX: 'hidden' } }, getTestIdAttribute(`${dataTestId}-scroll-container`)),
            React.createElement(Box, Object.assign({ flex: { shrink: 1, grow: 1 }, style: {
                    minWidth: width,
                    minHeight: noData ? (_a = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight : undefined
                } }, getTestIdAttribute(`${dataTestId}-content-container`)), children))));
};
const NoScrollWrapper = ({ children, dataTestId }) => {
    return (React.createElement(Box, Object.assign({ role: "rowgroup", "aria-label": "Table-Body" }, getTestIdAttribute(dataTestId), { style: { minHeight: '256px' } }), children));
};
const NoData = ({ emptyTableMsg, dataTestId }) => {
    const lighterGray = useInternalColor('lighterGray');
    return (React.createElement(Box, Object.assign({ role: "rowgroup", a11yTitle: "Table Body No Data", flex: { shrink: 0, grow: 1 }, fill: "vertical" }, getTestIdAttribute(dataTestId), { style: { backgroundColor: lighterGray } }),
        React.createElement(Column, { role: "row", a11yTitle: "Table Body No Data Container", pad: "large", align: "center", dataTestId: `${dataTestId}-col` },
            typeof emptyTableMsg === 'string' && (React.createElement(Text, { dataTestId: `${dataTestId}-text`, label: emptyTableMsg, status: "gray" })),
            typeof emptyTableMsg !== 'string' && emptyTableMsg)));
};
const TableBodyRow = ({ item, dataIdx, dataColumns, selectedStatusArr, onToggleSelect, onRowClick, dataTestId, }) => {
    const rowProps = {};
    if (onRowClick) {
        rowProps.onClick = () => {
            onRowClick(dataIdx);
        };
    }
    return (React.createElement(StyledTableRow, Object.assign({ role: "row", a11yTitle: "Table Body Row", direction: "row", flex: { shrink: 0 }, selected: ((selectedStatusArr instanceof Array && selectedStatusArr.length > 0 && selectedStatusArr[dataIdx]) ? true : false), even: dataIdx % 2 === 0 }, rowProps, getTestIdAttribute(dataTestId)), dataColumns.map((cellItem, index) => (React.createElement(Column
    // eslint-disable-next-line react/no-array-index-key
    , { 
        // eslint-disable-next-line react/no-array-index-key
        key: `${cellItem.property}-${dataIdx}-${index}`, size: cellItem.size, role: "cell", a11yTitle: "Table Body Cell", pad: index === 0 && onToggleSelect !== undefined ? 'none' : TableBodyPadding, align: cellItem.alignBody, dataTestId: `${dataTestId}-cell-${index}` },
        React.createElement(Row, { noPad: true, align: "start", justify: cellItem.alignBody },
            React.createElement(TableBodyCell, Object.assign({}, cellItem, { item: item, dataTestId: `${dataTestId}-cell-${index}`, onToggleSelect: onToggleSelect, index: index, dataIdx: dataIdx, selectedStatusArr: selectedStatusArr }))))))));
};
const TableBody$1 = ({ data, columns, fullHeight, emptyTableMsg, isLoading, onToggleSelect, selectedStatusArr, onRowClick, dataTestId, tableRef, defaultScroll, }) => {
    const Wrapper = fullHeight ? FullHeightWrapper : NoScrollWrapper;
    const dataColumns = getTdColumns(columns);
    return (React.createElement(Wrapper, { dataTestId: dataTestId, tableRef: tableRef, noData: isLoading !== true && data.length < 1, defaultScroll: defaultScroll },
        data.length > 0 &&
            data.map((item, dataIdx) => (React.createElement(TableBodyRow
            // eslint-disable-next-line react/no-array-index-key
            , { 
                // eslint-disable-next-line react/no-array-index-key
                key: item.id ? item.id : `key-${dataIdx}`, item: item, dataIdx: dataIdx, dataColumns: dataColumns, selectedStatusArr: selectedStatusArr, onRowClick: onRowClick, onToggleSelect: onToggleSelect, dataTestId: `${dataTestId}-row-${dataIdx}` }))),
        isLoading !== true && data.length < 1 && (React.createElement(NoData, { emptyTableMsg: emptyTableMsg, dataTestId: `${dataTestId}-no-data` }))));
};

/* eslint-disable no-alert */
const border = (props) => props['data-type-card-filter'] || props['data-type-card-filter-with-value']
    ? undefined
    : `1px solid ${getStyledCuroColor(props, 'slate')}`;
const borderLeftColor = (props) => {
    if (props['data-type-card-filter'] || props['data-type-card-filter-with-value'])
        return undefined;
    const colorKey = props['data-selected'] && props['data-position'] !== 'start' ? 'white' : 'slate';
    return getStyledCuroColor(props, colorKey);
};
const getStyledDisabledBorder = (props) => `1px solid ${getStyledCuroColor(props, 'disabled')}`;
const borderTop = (props) => props['data-disabled'] &&
    !props['data-type-card-filter'] &&
    !props['data-type-card-filter-with-value']
    ? getStyledDisabledBorder(props)
    : undefined;
const borderBottom = (props) => props['data-disabled'] &&
    !props['data-type-card-filter'] &&
    !props['data-type-card-filter-with-value']
    ? getStyledDisabledBorder(props)
    : undefined;
const borderLeft = (props) => props['data-disabled'] &&
    props['data-position'] === 'start' &&
    !props['data-type-card-filter'] &&
    !props['data-type-card-filter-with-value']
    ? getStyledDisabledBorder(props)
    : undefined;
const borderRight = (props) => props['data-disabled'] &&
    props['data-position'] === 'end' &&
    !props['data-type-card-filter'] &&
    !props['data-type-card-filter-with-value']
    ? getStyledDisabledBorder(props)
    : undefined;
const borderRightStyle = (props) => props['data-position'] === 'end' &&
    !props['data-type-card-filter'] &&
    !props['data-type-card-filter-with-value']
    ? 'solid'
    : 'none';
const borderRadius$2 = (props) => {
    if (props['data-type-card-filter'] || props['data-type-card-filter-with-value'])
        return '4px 4px 4px 4px';
    if (props['data-position'] === 'start')
        return '4px 0 0 4px';
    if (props['data-position'] === 'end')
        return '0 4px 4px 0';
    return '0';
};
const paddingLeft = (props) => {
    if (props['data-linear']) {
        return undefined;
    }
    if (props['data-type-card-filter'] || props['data-type-card-filter-with-value']) {
        return '12px';
    }
    return '16px';
};
const paddingRight = (props) => {
    if (props['data-linear']) {
        return undefined;
    }
    if (props['data-type-card-filter'] || props['data-type-card-filter-with-value']) {
        return '12px';
    }
    return '16px';
};
const height = (props) => {
    if (props['data-linear']) {
        return '20px';
    }
    if (props['data-type-card-filter']) {
        return '24px';
    }
    if (props['data-type-card-filter-with-value']) {
        return '60px';
    }
    return '32px';
};
const width$1 = (props) => {
    if (props['data-linear']) {
        return '30px';
    }
    return undefined;
};
const backgroundColor = (props) => {
    if (props['data-selected']) {
        if (props['data-type-card-filter']) {
            return getStyledInternalColor(props, 'solitude');
        }
        return getStyledCuroColor(props, 'slate');
    }
    if (props['data-type-card-filter-with-value']) {
        return getStyledInternalColor(props, 'solitude');
    }
    return 'transparent';
};
const opacity = (props) => {
    if (props['data-type-card-filter-with-value'] && props['data-disabled']) {
        return 0.6;
    }
    return undefined;
};
const StyledBox$4 = styled(Box).withConfig({ displayName: "StyledBox", componentId: "sc-x4r13k" }) `
  align-items: center;
  justify-content: center;
  border: ${props => border(props)};
  height: ${props => height(props)};
  width: ${props => width$1(props)};
  padding-left: ${props => paddingLeft(props)};
  padding-right: ${props => paddingRight(props)};
  border-radius: ${props => borderRadius$2(props)};
  border-right-style: ${props => borderRightStyle(props)};
  border-left-color: ${props => borderLeftColor(props)};
  cursor: pointer;
  background-color: ${props => backgroundColor(props)};
  // For a disabled div top border should have a opacity of 40%
  border-top: ${props => borderTop(props)};
  // For a disabled div bottom border should have a opacity of 40%
  border-bottom: ${props => borderBottom(props)};
  // For a disabled div left border should have a opacity of 40% if it is left end
  border-left: ${props => borderLeft(props)};
  // For a disabled div right border should have a opacity of 40% if it is right end
  border-right: ${props => borderRight(props)};
  opacity: ${props => opacity(props)};
  pointer-events: ${props => (props['data-disabled'] || props['data-readonly'] ? 'none' : 'auto')};
`;
const labelFontSize = (props) => {
    if (props['data-type-card-filter']) {
        return TextConfigs.label[0]; // 14px
    }
    if (props['data-type-card-filter-with-value']) {
        return TextConfigs.title1[0]; // 24px
    }
    return TextConfigs.default[0]; // 16px
};
const labelFontWeight = (props) => {
    if (props['data-selected']) {
        if (props['data-type-card-filter']) {
            return WeightType.normal;
        }
        if (props['data-type-card-filter-with-value']) {
            return WeightType.medium; // semi bold
        }
        return WeightType.bold;
    }
    if (props['data-type-card-filter-with-value']) {
        return WeightType.medium; // semi bold
    }
    return WeightType.normal;
};
const getTextColor = (props) => {
    if (props['data-selected']) {
        if (props['data-type-card-filter']) {
            return getStyledCuroColor(props, 'slate');
        }
        return getStyledCuroColor(props, 'white');
    }
    return getStyledCuroColor(props, 'slate');
};
const labelTextColor = getTextColor;
const Label$1 = styled.span.withConfig({ displayName: "Label", componentId: "sc-ys4dvi" }) `
  font-size: ${props => labelFontSize(props)};
  font-weight: ${props => labelFontWeight(props)};
  color: ${props => labelTextColor(props)};
`;
const footerFontSize = (props) => {
    if (props['data-type-card-filter-with-value']) {
        return TextConfigs.label[0]; // 14px
    }
    return TextConfigs.default[0]; // 16px
};
const footerTextColor = getTextColor;
const Footer = styled.span.withConfig({ displayName: "Footer", componentId: "sc-10kq2qj" }) `
  font-size: ${props => footerFontSize(props)};
  font-weight: normal;
  color: ${props => footerTextColor(props)};
`;
/** Toggle buttons can be used to group related options. <br /> Link to UX Pattern : https://confluence.eng.nimblestorage.com/display/UX/Toggle+Button <br /> Card Filter Visual Design: https://confluence.eng.nimblestorage.com/pages/viewpage.action?pageId=151265816
 */
const ToggleButton = ({ options, multiSelect = false, defaultOptions, linearNavigation, type = undefined, stretchCardFilter = false, reset, dataTestId, readOnly = false, }) => {
    if (!multiSelect && defaultOptions && defaultOptions.length > 1)
        console.error('Provide a single default option as this is not a multi-select toggle button');
    if (linearNavigation && (defaultOptions || multiSelect)) {
        console.error('When linearNaviagtion prop is used, providing defaultOptions or multiSelect props is of no effect');
    }
    const [selected, setSelected] = useState(defaultOptions && !linearNavigation ? defaultOptions : []);
    // If defaultOptions array changes dynamically via user actions, the component will update the selected array in here
    if (defaultOptions) {
        useEffect(() => {
            setSelected(defaultOptions && !linearNavigation ? defaultOptions : []);
        }, [defaultOptions, defaultOptions.length, linearNavigation]);
    }
    const buttonPosition = (index) => {
        if (index === 0)
            return 'start';
        if (index === options.length - 1)
            return 'end';
        return undefined;
    };
    const buttonSelected = (index) => {
        return !!selected.includes(index);
    };
    const buttonClick = (index, onClick, clickToUnselect = true) => {
        const array = selected && [...selected];
        if (!linearNavigation) {
            if (multiSelect) {
                if (selected && selected.includes(index)) {
                    const elIndex = array.indexOf(index);
                    if (elIndex > -1 && clickToUnselect) {
                        array.splice(elIndex, 1);
                    }
                }
                else {
                    array.push(index);
                }
            }
            else if (!clickToUnselect ? array[0] !== index : !undefined) {
                array.pop();
                if (!selected.includes(index))
                    array.push(index);
            }
        }
        setSelected(array);
        return onClick && onClick(array);
    };
    const [hover, setHover] = useState(undefined);
    const buttonContent = (option, index) => {
        const buttonText = (React.createElement(Label$1, { style: { opacity: option.disabled ? '40%' : undefined }, "data-selected": !option.disabled && buttonSelected(index), "data-type-card-filter": type === 'cardFilter', "data-type-card-filter-with-value": type === 'cardFilterWithValue' }, option.label));
        const footerText = option.footer && (React.createElement(Footer, { style: { opacity: option.disabled ? '40%' : undefined }, "data-selected": !option.disabled && buttonSelected(index), "data-type-card-filter": type === 'cardFilter', "data-type-card-filter-with-value": type === 'cardFilterWithValue' }, option.footer));
        const setIconStatus = () => {
            if (!option.disabled && (selected.includes(index) || (hover === index && linearNavigation))) {
                return 'white';
            }
            if (option.disabled) {
                return 'disabled';
            }
            return undefined;
        };
        if (option.label && option.icon) {
            return (React.createElement(Box /* gap="8px" */, { justify: "center", align: "center" },
                React.createElement(Box, { direction: "row", align: "center", gap: "xsmall" },
                    buttonText,
                    React.createElement(Icon, { tooltip: "", name: option.icon, dataTestId: option.dataTestId
                            ? `${dataTestId}-${option.dataTestId}-icon`
                            : `${dataTestId}-${option.icon}` || `${dataTestId}-${option.label}`, size: linearNavigation ? 'xsmall' : 'medium', status: setIconStatus() })),
                footerText));
        }
        if (option.label) {
            return (React.createElement(Box /* gap="8px" */, { justify: "center", align: "center" },
                buttonText,
                footerText));
        }
        if (option.icon) {
            return (React.createElement(Icon, { tooltip: "", name: option.icon, dataTestId: option.dataTestId
                    ? `${dataTestId}-${option.dataTestId}-icon`
                    : `${dataTestId}-${option.icon}`, size: linearNavigation ? 'xsmall' : 'medium', status: setIconStatus() }));
        }
        return undefined;
    };
    const colors = useColors();
    const getButtonHoverStyles = (option, index) => {
        if (hover === index && !option.disabled && !buttonSelected(index)) {
            if (linearNavigation) {
                return { background: colors.slate };
            }
            if (type === 'cardFilter') {
                return { background: colors.lightGray };
            }
            if (type === 'cardFilterWithValue') {
                return { background: colors.coolGray };
            }
            return { background: colors.solitude };
        }
        return undefined;
    };
    useEffect(() => {
        if (Array.isArray(reset) && reset.length > 0) {
            const arr = [...selected];
            reset.forEach((elToBeReset) => {
                const index = arr.indexOf(elToBeReset);
                if (index > -1) {
                    arr.splice(index, 1);
                }
            });
            setSelected(arr);
        }
        else if (reset === 'all')
            setSelected([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reset]);
    return (React.createElement(Box, Object.assign({ direction: "row" }, getTestIdAttribute(dataTestId), { gap: type === 'cardFilter' || type === 'cardFilterWithValue' ? '2px' : undefined, align: "center" }), options.map((option, index) => (option.label || option.icon) && (React.createElement(StyledBox$4, Object.assign({ responsive: false, "data-linear": linearNavigation, "data-type-card-filter": type === 'cardFilter', "data-type-card-filter-with-value": type === 'cardFilterWithValue', "data-position": buttonPosition(index), "data-selected": !option.disabled && buttonSelected(index), "data-disabled": option.disabled, onMouseEnter: () => setHover(index), onMouseLeave: () => setHover(undefined), "data-readonly": readOnly, onClick: () => {
            if (!option.disabled && !readOnly) {
                buttonClick(index, option.onClick, option.clickToUnselect);
            }
        }, key: index.toString(), 
        // onKeyDown={handleKeyDown}
        tabIndex: !option.disabled ? 0 : undefined, style: getButtonHoverStyles(option, index) }, getTestIdAttribute(option.dataTestId ? `${dataTestId}-${option.dataTestId}` : undefined), { fill: type === 'cardFilterWithValue' && stretchCardFilter ? 'horizontal' : undefined }), buttonContent(option, index))))));
};

const TableFooter$1 = ({ msg = {}, pagination, data, dataTestId, selectedCount, footerLabel, }) => {
    const { selectedRowsMsg = getI18nStr('rowsSelected'), totalRowsMsg = getI18nStr('tableTotal'), } = msg;
    const getFooterLabel = () => {
        if (footerLabel !== undefined) {
            if (typeof footerLabel === 'string') {
                return (React.createElement(Text, { label: footerLabel, dataTestId: `${dataTestId}-footer-label`, type: "label", status: "default" }));
            }
            return footerLabel;
        }
        if (pagination === undefined) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Text, { label: totalRowsMsg, dataTestId: `${dataTestId}-total-rows-label`, type: "label" }),
                React.createElement(Text, { label: ` ${data.length}`, dataTestId: `${dataTestId}-total-rows`, type: "label", status: "default", weight: "medium" })));
        }
        // default pagination label
        return (React.createElement(React.Fragment, null,
            React.createElement(Column, { noPad: true, dataTestId: `${dataTestId}-pagination-range` },
                React.createElement(Text, { label: `${pagination.startRow} - ${pagination.endRow}`, dataTestId: `${dataTestId}-pagination-range-label`, type: "label", status: "default", weight: "medium" })),
            React.createElement(Column, { noPad: true, dataTestId: `${dataTestId}-pagination-total` },
                React.createElement(Text, { label: ` ${getI18nStr('of')} ${pagination.totalRows}`, dataTestId: `${dataTestId}-pagination-total-label`, type: "label" }))));
    };
    const backgroundColor = useInternalColor('lightCoolGray');
    return (React.createElement(Box, Object.assign({ role: "rowgroup", direction: "row", a11yTitle: "Table Footer", flex: { shrink: 0 }, style: { backgroundColor } }, getTestIdAttribute(dataTestId), { pad: TableFooterPadding }),
        React.createElement(Column, { size: "50%", align: "start", dataTestId: `${dataTestId}-left`, noPad: true }, selectedCount !== undefined && (React.createElement(Row, { noPad: true, dataTestId: `${dataTestId}-selected-row` },
            React.createElement(Text, { label: selectedRowsMsg, dataTestId: `${dataTestId}-selected-label`, type: "label" }),
            React.createElement(Text, { label: " ", dataTestId: "space", type: "label" }),
            React.createElement(Text, { label: String(selectedCount), dataTestId: `${dataTestId}-selected-value`, type: "label", status: "default", weight: "medium" })))),
        React.createElement(Column, { dataTestId: `${dataTestId}-right`, size: "50%", align: "end", noPad: true },
            React.createElement(Row, { noPad: true, justify: "end", dataTestId: `${dataTestId}-total-row` },
                getFooterLabel(),
                pagination && (React.createElement(React.Fragment, null,
                    React.createElement(Column, { noPad: true, dataTestId: `${dataTestId}-pagination-nav-vol` },
                        React.createElement(Text, { label: "   ", dataTestId: "space", type: "label" })),
                    React.createElement(Column, { noPad: true, dataTestId: `${dataTestId}-pagination-nav-vol` },
                        React.createElement(ToggleButton, { dataTestId: `${dataTestId}-pagination-nav`, linearNavigation: true, options: [
                                {
                                    icon: 'previous',
                                    onClick: pagination.onPrevious,
                                    disabled: pagination.startRow <= 1,
                                    dataTestId: `${dataTestId}-previous-btn`,
                                },
                                {
                                    icon: 'next',
                                    onClick: pagination.onNext,
                                    disabled: pagination.endRow >= pagination.totalRows,
                                    dataTestId: `${dataTestId}-next-btn`,
                                },
                            ] }))))))));
};

const Table$2 = (_a) => {
    var { data = [], noHeader = false, noFooter = false, a11yTitle = getI18nStr('tableTitle'), fullHeight = false, isLoading = false, emptyTableMsg = getI18nStr('tableNoItems'), sorter = {}, selector = {}, footer = {}, defaultScroll = false } = _a, rest = __rest(_a, ["data", "noHeader", "noFooter", "a11yTitle", "fullHeight", "isLoading", "emptyTableMsg", "sorter", "selector", "footer", "defaultScroll"]);
    const { dataTestId, columns, loadingMsg } = rest;
    const { onToggleSelect, onToggleSelectAll, selectAllStatus, selectedStatusArr, selectedCount, onRowClick, } = selector;
    const [tableRef, setTableRef] = useState(null);
    // TODO: Remove ThemeContext after checkbox issues fixed in form
    return (React.createElement(TableContainer, { dataTestId: dataTestId, a11yTitle: a11yTitle, fullHeight: fullHeight, isLoading: isLoading, data: data, loadingMsg: loadingMsg, setTableRef: setTableRef },
        noHeader === false && columns.length > 0 && (React.createElement(TableHeader$1, { dataTestId: `${dataTestId}-header`, columns: columns, sorter: sorter, onToggleSelectAll: onToggleSelectAll, selectAllStatus: selectAllStatus, onToggleSelect: selector === null || selector === void 0 ? void 0 : selector.onToggleSelect })),
        React.createElement(TableBody$1, { fullHeight: fullHeight, data: data, columns: columns, emptyTableMsg: emptyTableMsg, isLoading: isLoading, onToggleSelect: onToggleSelect, selectedStatusArr: selectedStatusArr, onRowClick: onRowClick, dataTestId: `${dataTestId}-body`, tableRef: tableRef, defaultScroll: defaultScroll }),
        noFooter === false && (React.createElement(TableFooter$1, Object.assign({}, footer, { dataTestId: `${dataTestId}-footer`, data: data, selectedCount: selectedCount })))));
};

/** Deprecated, DO NOT USE */
/** Takes table header, table data and footer in JSON format. User can provide default sort column and make columns non-sortable. User can control how cell data renders. Supports select all functionality. */
const Table$1 = ({ tableHeader, tableData, showHeader = true, tableFooter = undefined, paginatedTableFooter = undefined, goToPreviousPage = undefined, goToNextPage = undefined, sortKey = undefined, sortDir = 'asc', dataTestId, a11yTitle, isLoading = false, loadingMsg = getI18nStr('tableLoadingMsg'), emptyTableMsg = getI18nStr('noDataAvailable'), }) => {
    logger('TableDeprecated is deperecated, use Table instead.', 'error');
    /** Header */
    /** Massaging user given header and body to conform to Grommet interface */
    const columns = tableHeader.map((item, index) => {
        return {
            property: item.property,
            header: showHeader && (React.createElement(Box, { style: {
                    height: '40px',
                    // borderLeft: !resizeColumns && index !== 0 ? '1px solid #ddd' : undefined,
                    borderLeft: index !== 0 ? '1px solid #ddd' : undefined,
                    padding: '0px 10px 0px 10px',
                }, justify: "center" },
                React.createElement(Text, { dataTestId: `${dataTestId}-${item.header}-header-text`, label: item.header, type: "label", weight: "medium", status: "default" }))),
            render: item.render,
            sortable: item.sortable,
            align: item.justify,
            size: item.size && item.size,
        };
    });
    /** Footer */
    const getSelectedRowsElement = (selectedRows, selectedRowsMsg) => {
        if (selectedRows !== undefined) {
            return (React.createElement(Box, { direction: "row", align: "center", gap: "5px" },
                React.createElement(Text, { dataTestId: `${dataTestId}-footer-selected-rows-count-label`, type: "label", label: selectedRowsMsg || `${getI18nStr('rowsSelected')} ` }),
                React.createElement(Text, { dataTestId: `${dataTestId}-footer-selected-rows-count`, type: "label", label: `${selectedRows}`, weight: "medium", status: "default" })));
        }
        return undefined;
    };
    let leftContent;
    let rightContent;
    if (paginatedTableFooter) {
        const { startRow, endRow, totalRows, isPreviousPageDisabled = false, isNextPageDisabled = false, selectedRows, selectedRowsMsg, } = paginatedTableFooter;
        const selectedRowsElement = getSelectedRowsElement(selectedRows, selectedRowsMsg);
        const paginationElement = (React.createElement(Box, { direction: "row", align: "center", gap: "12px" },
            React.createElement(Box, { direction: "row" },
                React.createElement(Text, { dataTestId: `${dataTestId}-footer-start-row-index`, type: "label", label: `${startRow}`, weight: "medium", status: "default" }),
                React.createElement(Text, { dataTestId: `${dataTestId}-footer-dash`, type: "label", label: getI18nStr('dash'), weight: "medium", status: "default" }),
                React.createElement(Text, { dataTestId: `${dataTestId}-footer-end-row-index`, type: "label", label: `${endRow}`, weight: "medium", status: "default" }),
                React.createElement(Text, { dataTestId: `${dataTestId}-footer-of`, type: "label", label: " of " }),
                React.createElement(Text, { dataTestId: `${dataTestId}-footer-total-rows-count`, type: "label", label: `${totalRows}` })),
            React.createElement(ToggleButton, { linearNavigation: true, options: [
                    {
                        icon: 'previous',
                        onClick: goToPreviousPage,
                        disabled: isPreviousPageDisabled,
                        dataTestId: `${dataTestId}-footer-previous-page-button`,
                    },
                    {
                        icon: 'next',
                        onClick: goToNextPage,
                        disabled: isNextPageDisabled,
                        dataTestId: `${dataTestId}-footer-next-page-button`,
                    },
                ] })));
        leftContent = selectedRowsElement;
        rightContent = paginationElement;
    }
    else if (tableFooter) {
        const { totalRows, totalRowsMsg, selectedRows, selectedRowsMsg, } = tableFooter;
        const selectedRowsElement = getSelectedRowsElement(selectedRows, selectedRowsMsg);
        const totalRowsElement = (React.createElement(Box, { direction: "row", align: "center", gap: "5px" },
            React.createElement(Text, { dataTestId: `${dataTestId}-footer-total-rows-count-label`, type: "label", label: totalRowsMsg || `${getI18nStr('total')} ` }),
            React.createElement(Text, { dataTestId: `${dataTestId}-footer-total-rows-count`, type: "default", label: `${totalRows}`, weight: "medium" })));
        leftContent = selectedRowsElement;
        rightContent = totalRowsElement;
    }
    const TableFooter = (tableFooter || paginatedTableFooter) && (React.createElement(Box, Object.assign({ direction: "row", justify: leftContent ? 'between' : 'end', style: {
            height: '40px',
            backgroundColor: '#F4F6F9',
            borderTop: '1px solid #eeeeee',
            padding: '0px 12px 0px 12px',
        } }, getTestIdAttribute(`${dataTestId}-footer`)),
        leftContent && leftContent,
        rightContent));
    const [sort, setSort] = useState({
        property: showHeader && sortKey,
        direction: sortDir,
    });
    /** Empty Table */
    const emptyTableBox = (
    // TODO: Once min table height spec is given, remove bottom padding
    React.createElement(Box, { direction: "row", justify: "center", style: {
            padding: '40px 0px 40px 0px',
            backgroundColor: '#FAFAFA',
            borderTop: '2px solid #666',
        } },
        React.createElement(Text, { dataTestId: `${dataTestId}-no-data-available-label`, type: "default", status: "gray", label: emptyTableMsg })));
    /** Loading Icon */
    const loadingIconBox = (React.createElement(Box, { align: "center", gap: "small", background: { color: '#FAFAFA' }, pad: { vertical: '40px' } },
        React.createElement(Icon, { dataTestId: `${dataTestId}-loading-icon`, name: "spinner", status: "gray", size: "xlarge" }),
        React.createElement(Text, { dataTestId: `${dataTestId}-loading-msg`, label: loadingMsg, type: "default", status: "gray" })));
    // Q) If we use Grommet size prop, it will give a fixed height to the table and records will scroll within it. But then Grommet will give width to all cells.
    return (React.createElement(Column, { noPad: true },
        React.createElement(DataTable, Object.assign({}, getTestIdAttribute(dataTestId), { a11yTitle: a11yTitle, columns: columns, data: tableData, 
            // sortable={showHeader && !!sortKey}
            sort: showHeader && sortKey ? sort : undefined, onSort: showHeader && sortKey ? setSort : undefined, background: {
                header: showHeader ? '#fff' : '',
                body: ['#fff', '#fafafa'],
            }, 
            // TODO: Ask Grommet - How to add both bottom and vertical border in below syntax?
            // Spec - Top 1px solid #ddd and bottom 2px solid #666
            border: showHeader && {
                header: { side: 'horizontal', color: '#666', size: '1px' },
            }, pad: {
                body: { vertical: '16px', left: '10px' },
                header: { vertical: '0px', horizontal: '0px' },
            }, 
            // TODO: Grommet does not allow styling this vertical border they add to resize the column
            // Grommet spec says this cannot be used with size prop that controls height and gives scroll bar
            // resizeable={showHeader && resizeColumns}
            resizeable: false, primaryKey: false })),
        tableData.length === 0 && (isLoading ? loadingIconBox : emptyTableBox),
        TableFooter && TableFooter));
};

/**
 * `<input>` elements of type checkbox are rendered by default as boxes that are checked (ticked) when activated, like you might see in an official government paper form. The exact appearance depends upon the operating system configuration under which the browser is running. Generally this is a square but it may have rounded corners. A checkbox allows you to select single values for submission in a form (or not).
 */
const CheckBox = (props) => {
    const { name } = props;
    const { info, dataTestId = name, checked, indeterminate = false } = props;
    const ref = useRef(null);
    useEffect(() => {
        var _a;
        if (((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.parentElement.className.search('FormField')) !== -1) {
            ref.current.parentElement.style.border = 'none';
        }
    }, []);
    return (
    // Adding a pad to be consistent with radio
    React.createElement(Box, { direction: "row", ref: ref, align: "center", pad: { horizontal: '6px', vertical: '3px' }, gap: "small" },
        React.createElement(CheckBox$1, Object.assign({ "aria-checked": checked, indeterminate: indeterminate }, getTestIdAttribute(dataTestId), props)),
        info && (React.createElement(Icon, { name: "info", dataTestId: `${dataTestId}-info-tooltip`, status: "info", size: "xsmall", tooltip: info }))));
};

/** Deprecated, DO NOT USE */
const TableHeader = (props) => {
    const { headerGroups, sortType, dataTestId } = props;
    const getSortIcon = (isColumnSorted, isDescSort) => {
        if (isColumnSorted) {
            return isDescSort ? (React.createElement(Icon, { name: "sortDown", dataTestId: "descSort" })) : (React.createElement(Icon, { name: "sortUp", dataTestId: "ascSort" }));
        }
        return React.createElement(Icon, { name: "sort", dataTestId: "unsorted", status: "disabled" });
    };
    const getColumnTitle = (column, styleAsGroupedHeader) => {
        let columnHeaderValue = column.render('Header');
        if (typeof columnHeaderValue === 'string') {
            columnHeaderValue = styleAsGroupedHeader ? (React.createElement(Text, { label: columnHeaderValue, dataTestId: `${dataTestId}-table-header-column-title-${columnHeaderValue}`, type: "fine" })) : (React.createElement(Text, { label: columnHeaderValue, dataTestId: `${dataTestId}-table-header-column-title-${columnHeaderValue}`, type: "label", status: "default", weight: "medium" }));
        }
        return columnHeaderValue;
    };
    const areHeadersGrouped = headerGroups.length > 1;
    return (React.createElement(TableHeader$2, Object.assign({}, getTestIdAttribute(`${dataTestId}-table-header`)), headerGroups.map((headerGroup, headerGroupIndex) => {
        const styleAsGroupedHeader = areHeadersGrouped && headerGroupIndex === 0;
        return (React.createElement(TableRow, Object.assign({}, headerGroup.getHeaderGroupProps(), { style: {
                height: styleAsGroupedHeader ? '20px' : '40px',
                backgroundColor: styleAsGroupedHeader ? '#fafafa' : '#fff',
                borderTop: '1px solid #ddd',
                borderBottom: styleAsGroupedHeader ? '1px solid #ddd' : '2px solid #666',
            } }), headerGroup.headers.map((column, index) => {
            // console.log(column);
            const isAllRowsSelect = column.id === 'selection';
            const isGroupHeader = column.headers !== undefined;
            // Show sort direction only if sorting is enabled for table and the column header is not a group header and it is not the select all header and user has not disabled sorting for this column.
            const showSortDirection = sortType !== 'unsorted' &&
                !isGroupHeader &&
                !isAllRowsSelect &&
                column.sortable !== false;
            const getHeaderPropsArgs = sortType !== 'unsorted' && column.sortable !== false
                ? column.getSortByToggleProps()
                : undefined;
            // eslint-disable-next-line no-nested-ternary
            const colJustify = column.justify && column.justify === 'right' ? 'end' : 'between';
            const justify = isGroupHeader ? 'center' : colJustify;
            return (React.createElement(TableCell, Object.assign({ scope: "col" }, column.getHeaderProps(getHeaderPropsArgs), { style: {
                    borderLeft: index !== 0 ? '1px solid #ddd' : undefined,
                    padding: isAllRowsSelect ? undefined : '0px 12px 0px 12px',
                    backgroundColor: column.isSorted ? '#fafafa' : undefined,
                } }),
                React.createElement(Column, { noPad: true, size: column.size },
                    React.createElement(Box, { direction: "row", gap: justify === 'end' ? 'small' : undefined, align: "center", 
                        // justify={isGroupHeader ? 'center' : 'start'}
                        justify: justify },
                        getColumnTitle(column, styleAsGroupedHeader),
                        showSortDirection && getSortIcon(column.isSorted, column.isSortedDesc)))));
        })));
    })));
};

/** Deprecated, DO NOT USE */
// import { Truncate } from '../../Truncate/Truncate';
const TableBody = (props) => {
    const { getTableBodyProps, rowsArr, prepareRow } = props;
    // Replace empty by '-' and string by Truncate - BREAKS external sort
    //   const getDisplayValue = (cell: any) => {
    //     const cellValue = cell.render('Cell');
    //     if (cellValue.props.column.id === 'selection') {
    //       // Checkbox
    //     } else if (cellValue.props.cell.value === undefined) {
    //       cellValue.props.cell.value = '-';
    //     } else if (typeof cellValue.props.cell.value === 'string') {
    //       // If user provides string, truncate it
    //       cellValue.props.cell.value = (
    //         <Truncate dataTestId="" label={cellValue.props.cell.value} status="default" />
    //       );
    //     } else {
    //       // If user provides non-string, show user input
    //       // displayValue = cellValue;
    //     }
    //     return cellValue;
    //   };
    return (React.createElement(TableBody$2, Object.assign({}, getTableBodyProps()), rowsArr.map((row, index) => {
        prepareRow(row);
        /** Set row background */
        // Row highlight background color Teal #14D3CA at 10%
        const TEAL_BKGRND_WITH_OPACTITY = 'rgb(20, 211, 202, 0.1)';
        // Highlight the selected row
        let background;
        if (row.original.selected) {
            background = TEAL_BKGRND_WITH_OPACTITY;
        }
        else {
            background = index % 2 === 0 ? '#fff' : '#fafafa';
        }
        // Highlight the row when user hovers on it
        const showHighlight = (e) => {
            e.currentTarget.style.background = TEAL_BKGRND_WITH_OPACTITY;
        };
        const resetHighlight = (e) => {
            e.currentTarget.style.background = background;
        };
        return (React.createElement(TableRow, Object.assign({}, row.getRowProps(), { style: {
                background,
            }, onMouseEnter: showHighlight, onMouseLeave: resetHighlight }), row.cells.map((cell) => {
            return (React.createElement(TableCell, Object.assign({ scope: "row" }, cell.getCellProps(), { colSpan: cell.column.colSpan }),
                React.createElement(Box, { direction: "row", justify: cell.column.justify === 'right' ? 'end' : 'start' }, cell.render('Cell'))));
        })));
    })));
};

/** Deprecated, DO NOT USE */
const TableFooter = (props) => {
    const { footer, data, noOfRowsSelected, onToggleSelect, dataTestId, isLoading } = props;
    /** General Footer */
    const getFooter = () => {
        const totalRowsMsgLabel = footer && footer.msg && footer.msg.totalRowsMsg
            ? footer.msg.totalRowsMsg
            : getI18nStr('total');
        const totalRows = footer && footer.data && footer.data.totalRows ? footer.data.totalRows : data.length;
        const selectedRowsMsgLabel = footer && footer.msg && footer.msg.selectedRowsMsg
            ? footer.msg.selectedRowsMsg
            : getI18nStr('rowsSelected');
        const selectedRows = footer && footer.data && footer.data.selectedRows
            ? footer.data.selectedRows
            : noOfRowsSelected;
        const selectedRowsPart = onToggleSelect && (React.createElement(Text, { dataTestId: `${dataTestId}-footer-selected-rows`, label: `${selectedRowsMsgLabel} : ${selectedRows}` }));
        const totalRowsPart = (React.createElement(Text, { dataTestId: `${dataTestId}-footer-total-rows`, label: `${totalRowsMsgLabel} : ${totalRows}` }));
        return (React.createElement(Box, { direction: "row", justify: onToggleSelect ? 'between' : 'end', align: "center", style: {
                height: '40px',
                borderTop: '1px solid #eee',
                backgroundColor: '#f4f6f9',
                padding: '0px 10px 0px 10px',
            } },
            !isLoading && selectedRowsPart,
            !isLoading && totalRowsPart));
    };
    /** Paginated Footer */
    const getPaginationFooterElement = () => {
        const startRow = footer && footer.data && footer.data.startRow;
        const endRow = footer && footer.data && footer.data.endRow;
        const totalRows = footer && footer.data && footer.data.totalRows;
        const isPreviousPageDisabled = footer && footer.pageNavigation && footer.pageNavigation.pageGoPrevDisabled;
        const isNextPageDisabled = footer && footer.pageNavigation && footer.pageNavigation.pageGoNextDisabled;
        const goToPreviousPage = footer && footer.pageNavigation && footer.pageNavigation.onPagePrevious;
        const goToNextPage = footer && footer.pageNavigation && footer.pageNavigation.onPageNext;
        return (React.createElement(Box, { direction: "row", align: "center", gap: "12px" },
            React.createElement(Box, { direction: "row" },
                React.createElement(Text, { dataTestId: `${dataTestId}-footer-start-row-index`, type: "label", label: `${startRow}`, weight: "medium", status: "default" }),
                React.createElement(Text, { dataTestId: `${dataTestId}-footer-dash`, type: "label", label: getI18nStr('dash'), weight: "medium", status: "default" }),
                React.createElement(Text, { dataTestId: `${dataTestId}-footer-end-row-index`, type: "label", label: `${endRow}`, weight: "medium", status: "default" }),
                React.createElement(Text, { dataTestId: `${dataTestId}-footer-of`, type: "label", label: " of " }),
                React.createElement(Text, { dataTestId: `${dataTestId}-footer-total-rows-count`, type: "label", label: `${totalRows}` })),
            React.createElement(ToggleButton, { linearNavigation: true, options: [
                    {
                        icon: 'previous',
                        onClick: goToPreviousPage,
                        disabled: isPreviousPageDisabled,
                        dataTestId: `${dataTestId}-footer-previous-page-button`,
                    },
                    {
                        icon: 'next',
                        onClick: goToNextPage,
                        disabled: isNextPageDisabled,
                        dataTestId: `${dataTestId}-footer-next-page-button`,
                    },
                ] })));
    };
    const getPaginatedFooter = () => {
        const selectedRowsMsgLabel = footer && footer.msg && footer.msg.selectedRowsMsg
            ? footer.msg.selectedRowsMsg
            : getI18nStr('rowsSelected');
        const selectedRows = footer && footer.data && footer.data.selectedRows
            ? footer.data.selectedRows
            : noOfRowsSelected;
        return (React.createElement(Box, { direction: "row", justify: onToggleSelect ? 'between' : 'end', align: "center", style: {
                height: '40px',
                borderTop: '1px solid #eee',
                backgroundColor: '#f4f6f9',
                padding: '0px 10px 0px 10px',
            } },
            !isLoading && onToggleSelect && (React.createElement(Text, { dataTestId: `${dataTestId}-footer-selected-rows`, label: `${selectedRowsMsgLabel} : ${selectedRows}` })),
            !isLoading && getPaginationFooterElement()));
    };
    return footer && footer.pageNavigation ? getPaginatedFooter() : getFooter();
};

/** Deprecated, DO NOT USE */
/**
 * TODO's:
 * 1. Update description
 * 2. Update data test ID's
 * 3. Check if React table alows changing header props to camel case.
 * 4. Click anywhere in row to select it - for DCS
 */
const StyledEmptyTableBox = styled(Box).withConfig({ displayName: "StyledEmptyTableBox", componentId: "sc-1u34p7r" }) `
  padding-top: 40px;
  min-height: 256px; // Spec mentions minHeight is approx 256p or 6 rows. Update when sticky footer gets implemented.
  background-color: #fafafa;
`;
const Table = ({ dataTestId, a11yTitle, columns, data = [], emptyTableMsg = getI18nStr('noDataAvailable'), sorter, isLoading, loadingMsg = getI18nStr('tableLoadingMsg'), noHeader = false, onToggleSelect, onToggleSelectAll, noFooter = false, footer, }) => {
    logger('ReactTable is deperecated, use Table instead.', 'error');
    /** React Table takes Header and Cell but our convention is camel case cell and header. Refactor the data for the same.  */
    const refactorColumn = (column) => {
        if (column.header) {
            // eslint-disable-next-line no-param-reassign
            column.Header = column.header;
        }
        if (column.cell) {
            // eslint-disable-next-line no-param-reassign
            column.Cell = column.cell;
        }
    };
    columns.forEach((column) => {
        refactorColumn(column);
        if (column.columns) {
            column.columns.forEach((nestedColumn) => {
                refactorColumn(nestedColumn);
            });
        }
    });
    /** Sorting */
    const isSortingEnabled = sorter && sorter.sortKey;
    let memoizedSortBy;
    let sortType = 'unsorted';
    if (isSortingEnabled) {
        const { sortKey, sortDir = 'asc', onSort } = sorter;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        memoizedSortBy = useMemo(() => [{ id: sortKey, desc: sortDir === 'desc' }], [sortKey, sortDir]);
        sortType = onSort ? 'externalSort' : 'localSort';
    }
    const sortBy = sortType !== 'unsorted' && memoizedSortBy;
    /** Row selection */
    let noOfRowsSelected = 0;
    // Add checkbox for row selection
    const tableHooks = (hooks) => {
        // Get no of selected rows
        // eslint-disable-next-line no-unused-expressions
        data &&
            data.forEach((record) => {
                if (record.selected) {
                    noOfRowsSelected++;
                }
            });
        const allRowsSelected = data && noOfRowsSelected === data.length;
        const someRowsSelected = data && noOfRowsSelected > 0 && noOfRowsSelected < data.length;
        return (onToggleSelect &&
            onToggleSelectAll &&
            hooks.visibleColumns.push((tableColumns) => [
                {
                    id: 'selection',
                    Header: () => {
                        return (React.createElement(CheckBox, { name: `${dataTestId}-select-all-checkbox`, checked: allRowsSelected, indeterminate: someRowsSelected, onChange: e => {
                                onToggleSelectAll({
                                    currentValue: e.target.checked,
                                });
                            } }));
                    },
                    Cell: ({ row }) => (React.createElement("div", null,
                        React.createElement(CheckBox, { name: `${dataTestId}-row-${row.id}-checkbox`, checked: row.original.selected, onChange: e => {
                                onToggleSelect({
                                    index: row.id,
                                    currentValue: e.target.checked,
                                    rowData: row.original,
                                });
                            } }))),
                },
                ...tableColumns,
            ]));
    };
    /* Get React Table Props */
    const useTableOptions = {
        columns,
        data,
        initialState: {},
    };
    // Sorting settings
    if (sortType !== 'unsorted') {
        useTableOptions.disableSortRemove = true;
        useTableOptions.initialState.sortBy = sortBy;
        if (sortType === 'externalSort') {
            useTableOptions.manualSortBy = true;
        }
    }
    // Pagination settings
    // if (pagination) {
    //   useTableOptions.manualPagination = true;
    //   useTableOptions.pageCount = pagination.pageCount;
    //   useTableOptions.initialState.pageIndex = pagination.pageIndex;
    //   useTableOptions.initialState.pageSize = pagination.pageSize;
    // }
    const isPaginationEnabled = footer && footer.pageNavigation;
    if (isPaginationEnabled) {
        useTableOptions.manualPagination = true;
    }
    // Getting Table Instance using useTable hook
    const tableInstance = useTable(useTableOptions, useSortBy, /* usePagination, */ tableHooks);
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, state, visibleColumns, } = tableInstance;
    // Call user sort fn when sort column or direction changes
    useEffect(() => {
        // Handling 1 column sort for now
        if (sortBy && sortBy.length > 0 && sorter && sorter.onSort) {
            sorter.onSort({ key: state.sortBy[0].id, direction: state.sortBy[0].desc ? 'desc' : 'asc' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.sortBy]);
    // Wihtout pagination iterate over rows and For pagination iterate over page
    // const rowsArr = state.pageIndex ? page : rows;
    const rowsArr = rows;
    /* Empty Table */
    const EmptyTableBox = (React.createElement(StyledEmptyTableBox, { direction: "row", justify: "center" },
        React.createElement(Text, { dataTestId: `${dataTestId}-empty-table-msg`, label: emptyTableMsg, type: "default", status: "gray" })));
    /* Loading Indicator */
    const LoadingIndicator = (React.createElement("tbody", null,
        React.createElement("tr", null,
            React.createElement("td", { colSpan: visibleColumns.length },
                React.createElement(Box, { align: "center" },
                    React.createElement(Icon, { dataTestId: `${dataTestId}-loading-icon`, size: "xlarge", status: "gray", name: "spinner" }),
                    loadingMsg && (React.createElement(Text, { dataTestId: `${dataTestId}-loading-msg`, label: loadingMsg, type: "default", status: "gray" })))))));
    return (React.createElement(React.Fragment, null,
        React.createElement(Table$3, Object.assign({}, getTableProps(), getTestIdAttribute(dataTestId), { a11yTitle: a11yTitle }),
            !noHeader && (React.createElement(TableHeader, { headerGroups: headerGroups, sortType: sortType, dataTestId: dataTestId })),
            isLoading ? (LoadingIndicator) : (React.createElement(TableBody, { getTableBodyProps: getTableBodyProps, rowsArr: rowsArr, prepareRow: prepareRow }))),
        data.length === 0 && EmptyTableBox,
        !noFooter && (React.createElement(TableFooter, { footer: footer, data: data, noOfRowsSelected: noOfRowsSelected, onToggleSelect: onToggleSelect, dataTestId: dataTestId, isLoading: isLoading }))));
};

/**
 * Link to UX Pattern: https://confluence.eng.nimblestorage.com/display/UX/Wizard+Pattern
 */
const Wizard = ({ children: childrenRaw, title, onNext, onPrevious, onSubmit, onCancel, cancelButtonText = getI18nStr('cancel'), nextButtonText = getI18nStr('next'), nextButtonTooltip, previousButtonTooltip, submitButtonText = getI18nStr('submit'), hidePrimary = false, disablePrimary = false, disableCancel = false, disablePrevious = false, disableSubmit = false, formId, hidePrevious = false, hideCancel = false, previousButtonText = getI18nStr('previous'), currentStep, isVertical = false, disableResponsive = false, dataTestId, showSubmit, noBackground = false, }) => {
    const colors = useCuroColors();
    const internalColors = useInternalColors();
    const vSize = useContext(ResponsiveContext);
    const errorState = () => !isVertical && (childrenRaw.type || childrenRaw.length > 5 || childrenRaw.length < 2);
    if (errorState())
        return (React.createElement(Text, { label: "Step count should be less than 5 or greater than 2", type: "title1", status: "error", dataTestId: `${dataTestId}-error` }));
    const children = childrenRaw.filter((child) => React.isValidElement(child));
    const stepTitle = children[currentStep - 1] &&
        children[currentStep - 1].props &&
        children[currentStep - 1].props.label
        ? children[currentStep - 1].props.label
        : undefined;
    const isLastEl = currentStep === children.length;
    const totalSteps = children.length;
    const hideFooter = hideCancel && hidePrevious && hidePrimary;
    const getDisabledStatusPrimary = () => {
        if (children[currentStep] && children[currentStep].props.disabled)
            return true;
        if (isLastEl && disableSubmit)
            return true;
        if (disablePrimary)
            return true;
        return false;
    };
    const getDisabledStatusPrevious = () => {
        if (children[currentStep - 2] && children[currentStep - 2].props.disabled)
            return true;
        if (disablePrevious)
            return true;
        return false;
    };
    const getPrimaryButtonState = () => {
        if (showSubmit && !isLastEl)
            return 'secondary';
        if (formId)
            return 'submit';
        return 'primary';
    };
    const getPrimaryButton = (React.createElement(Button$1, { disabled: getDisabledStatusPrimary(), formId: formId, type: getPrimaryButtonState(), onClick: isLastEl ? onSubmit : onNext, label: isLastEl ? submitButtonText : nextButtonText, dataTestId: `${dataTestId}-next-button` }));
    const getPreviousButton = (React.createElement(Box, { margin: { right: 'small' } },
        React.createElement(Button$1, { disabled: getDisabledStatusPrevious(), onClick: onPrevious, label: previousButtonText, type: "secondary", dataTestId: `${dataTestId}-previous-button` })));
    const content = (React.createElement(Box, Object.assign({}, getTestIdAttribute(dataTestId), { height: "100%", background: noBackground ? undefined : colors.white }),
        title && (React.createElement(Row, { pad: { vertical: 'small' } },
            React.createElement(Text, { label: title, dataTestId: `${dataTestId}-wizard-title`, weight: "medium", type: "title1" }))),
        React.createElement(Box, { flex: { shrink: 0 }, direction: isVertical ? 'column' : 'row', justify: "center", align: "start", margin: "small" }, React.Children.map(children, (child, index) => {
            return React.cloneElement(child, { index, currentStep, isVertical, totalSteps });
        })),
        !isVertical && (React.createElement(Box, { fill: true, overflow: "auto", margin: { top: 'small' } }, children[currentStep - 1] && children[currentStep - 1].props.children)),
        !hideFooter && (React.createElement(Box, { direction: "row", justify: !hideCancel ? 'between' : 'end', pad: { vertical: 'small' }, margin: { top: 'small' }, style: { minHeight: '65px' } },
            !hideCancel && (React.createElement(Button$1, { label: cancelButtonText, onClick: onCancel, disabled: disableCancel, type: "tertiary", dataTestId: `${dataTestId}-cancel-button` })),
            React.createElement(Box, { direction: "row", align: "center" },
                !hidePrimary && !isLastEl && showSubmit && (React.createElement(Box, { margin: { right: 'small' } },
                    React.createElement(Button$1, { formId: formId, type: "submit", onClick: onSubmit, label: submitButtonText, dataTestId: `${dataTestId}-submit-button` }))),
                !hidePrevious && !previousButtonTooltip && getPreviousButton,
                !hidePrevious && previousButtonTooltip && (React.createElement(Tooltip, { target: getPreviousButton, tooltip: previousButtonTooltip, dataTestId: `${dataTestId}-previous-button-tooltip`, underline: false })),
                !hidePrimary && !nextButtonTooltip && getPrimaryButton,
                !hidePrimary && nextButtonTooltip && (React.createElement(Tooltip, { target: getPrimaryButton, tooltip: nextButtonTooltip, dataTestId: `${dataTestId}-next-button-tooltip`, underline: false })))))));
    const responsiveContent = (React.createElement(Box, Object.assign({}, getTestIdAttribute(dataTestId), { height: "100%", background: noBackground ? undefined : colors.white }),
        React.createElement(Box, { margin: { vertical: 'medium' }, direction: "row", justify: "between", flex: { shrink: 0 } },
            title && (React.createElement(Row, { noPad: true },
                React.createElement(Text, { type: "title1", dataTestId: `${dataTestId}-wizard-title`, label: title, weight: "medium" }))),
            React.createElement(IconButton, { disabled: disableCancel, onClick: onCancel, icon: "remove", dataTestId: `${dataTestId}-cancel-icon` })),
        React.createElement(Box, { direction: "row", justify: "between", margin: { vertical: 'small' }, flex: { shrink: 0 } },
            React.createElement(IconButton, { disabled: getDisabledStatusPrevious(), onClick: onPrevious, icon: "previous", dataTestId: `${dataTestId}-previous-icon` }),
            React.createElement(Row, { noPad: true, justify: "center" },
                React.createElement(Text, { type: "title1", dataTestId: `${dataTestId}-wizard-stepper`, label: `${currentStep} of ${children.length}`, weight: "normal" })),
            React.createElement(IconButton, { onClick: onNext, disabled: getDisabledStatusPrimary(), icon: "next", dataTestId: `${dataTestId}-next-icon` })),
        React.createElement(Box, { margin: { top: 'small' }, overflow: "auto", background: vSize === 'small' || vSize === 'medium' ? internalColors.lightGray : 'none', pad: vSize === 'small' || vSize === 'medium' ? 'small' : 'none' },
            stepTitle && (React.createElement(Text, { dataTestId: `${dataTestId}-wizard-step-title`, weight: "medium", label: stepTitle, type: "title3" })),
            children[currentStep - 1] && children[currentStep - 1].props.children),
        !hidePrimary && isLastEl && (React.createElement(Box, { direction: "row", justify: "end", margin: { vertical: 'small' }, flex: { shrink: 0 } },
            React.createElement(Button$1, { stretch: true, disabled: getDisabledStatusPrimary(), label: submitButtonText, formId: formId, type: formId ? 'submit' : 'primary', onClick: onSubmit, dataTestId: `${dataTestId}-primary-button` })))));
    return (React.createElement(ResponsiveContext.Consumer, null, (size) => {
        // To-Do: disableResponsive is a temp solution for fleet
        if (!errorState())
            return (size === 'small' || size === 'medium') && !isVertical && !disableResponsive
                ? responsiveContent
                : content;
        return undefined;
    }));
};

/* eslint-disable no-nested-ternary */
const styledBrand = (props) => getStyledCuroColor(props, 'brand');
// previously #ddd
const styledDisabled = (props) => getStyledInternalColor(props, isStyledDark(props) ? 'gainsboro' : 'coolGray');
// previously #999
const styledGray = (props) => getStyledInternalColor(props, isStyledDark(props) ? 'gainsboro' : 'coolGray');
const HorizontalCircle = styled.div.withConfig({ displayName: "HorizontalCircle", componentId: "sc-thxl8o" }) `
  box-sizing: border-box;
  border-radius: 50%;
  height: 24px;
  position: relative;
  min-width: 24px;
  border: 2px solid ${styledGray};
  &.visited {
    border: 2px solid ${styledBrand};
    &.visited::after {
      content: '';
      background-color: transparent;

      /* position the checkbox */
      position: absolute;
      left: 7px;
      top: 3px;

      /* setting the checkbox */
      /* short arm */
      width: 4px;
      border-bottom: 2px solid ${styledBrand};
      /* long arm */
      height: 10px;
      border-right: 2px solid ${styledBrand};

      /* rotate the mirrored L to make it a checkbox */
      transform: rotate(45deg);
      -o-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
    }
  }
  &.current {
    border: 2px solid ${styledBrand};
    &.current::after {
      content: '';
      position: absolute;
      left: 4px;
      top: 4px;
      border-radius: 50%;
      width: 12px;
      height: 12px;
      background: ${styledBrand};
    }
  }
  &.disabled {
    cursor: default;
    box-shadow: none;
    background: ${styledDisabled};
    border-color: ${styledDisabled};
  }
  // To-Do: Add Styled for skipped
  &.skipped {
    background: ${styledGray};
    border-color: ${styledGray};
  }
`;
const VerticalCircle = styled.div.withConfig({ displayName: "VerticalCircle", componentId: "sc-1vjcoue" }) `
  box-sizing: border-box;
  border-radius: 50%;
  height: 14px;
  position: relative;
  min-width: 14px;
  margin-top: ${props => props['data-vSize'] === "small" ? '7px' : '5px'};
  border: 2px solid ${styledGray};
  flex-shrink: 0;
  &.visited {
    border: 2px solid ${styledBrand};
    background: ${styledBrand};
  }
  &.current {
    border: 5px solid ${styledBrand};
    &.visited::after {
      content: '';
      background-color: transparent;
    }
  }
  &.disabled {
    cursor: default;
    box-shadow: none;
    background: ${styledDisabled};
    border-color: ${styledDisabled};
  }
  // To-Do: Add Styled for skipped
  &.skipped {
    background: ${styledGray};
    border-color: ${styledGray};
  }
  // &:after {
  //   content: '';
  //   width: 0;
  //   height: 32px;
  //   position: absolute;
  //   border: 1px solid black;
  //   top: 8px;
  // }
`;
const lineStylesMixin = (props) => `
  &.visited {
    border-color: ${styledBrand(props)};
  }
  &.current {
    border-color: ${styledBrand(props)};
  }
  &.disabled {
    border-color: ${styledDisabled(props)};
  }
  // To-Do: Add Styled for skipped
  // &.skipped {
  //   border-color: ${styledGray(props)};
  // }
`;
const HorizontalLine = styled(Box).withConfig({ displayName: "HorizontalLine", componentId: "sc-21rhqu" }) `
  border-top: 2px solid ${styledGray};
  align-self: center;
  width: calc(50% - 12px);
  ${lineStylesMixin}
`;
const VerticalLine = styled(Box).withConfig({ displayName: "VerticalLine", componentId: "sc-1xcshp4" }) `
  border-left: 2px solid ${styledGray};
  height: 100%;
  margin-left: 6px;
  margin-bottom: -12px;
  ${lineStylesMixin}
  &.current{
    border-color: ${styledGray};
  }
`;
const A = styled.a.withConfig({ displayName: "A", componentId: "sc-78v75s" }) `
  &:link {
    text-decoration: inherit;
    color: inherit;
    cursor: auto;
  }

  &:visited {
    text-decoration: inherit;
    color: inherit;
    cursor: auto;
  }
`;
const WizardStep = ({ label, disabled, skipped, index, currentStep, onNodeClick, visited, dataTestId, isVertical, totalSteps, link, }) => {
    const currentNode = currentStep === index + 1;
    const vSize = useContext(ResponsiveContext);
    // To-Do: Refactor below 2 functions
    const status = (type) => {
        if (currentNode)
            return 'current';
        if (disabled)
            return 'disabled';
        if (skipped)
            return 'skipped';
        if ((currentStep && currentStep > index) || (type === 'circle' && visited))
            return 'visited';
        return undefined;
    };
    const horizontalLineStatus = (type) => {
        if (currentNode && type === 'leadingLine')
            return 'current';
        if (currentStep && currentStep > index + 1)
            return 'visited';
        return undefined;
    };
    const verticalStep = (React.createElement(A, Object.assign({ href: link || undefined, style: { pointerEvents: !disabled ? 'all' : 'none' } }, getTestIdAttribute(dataTestId)),
        React.createElement(Box, { direction: "row", margin: { top: 'xsmall' }, style: { minHeight: '40px' }, onClick: 
            /* istanbul ignore next */ () => !disabled && onNodeClick && onNodeClick(index + 1) },
            React.createElement(Box, null,
                React.createElement(VerticalCircle, { "data-label": label, className: status('circle'), "data-vSize": vSize }),
                totalSteps && totalSteps > index + 1 && React.createElement(VerticalLine, { className: status('line') })),
            React.createElement(Box, null,
                React.createElement(Text$1, { margin: { left: 'small' }, color: `${currentNode ? 'black' : disabled ? '#888' : null}`, weight: currentNode ? 600 : 'normal' }, label)))));
    const horizontalStep = (React.createElement(A, Object.assign({ href: link || undefined, style: { width: '100%', pointerEvents: !disabled ? 'all' : 'none' } }, getTestIdAttribute(dataTestId)),
        React.createElement(Box, null,
            React.createElement(Box, { direction: "row", justify: index === 0 ? 'end' : undefined },
                index > 0 && React.createElement(HorizontalLine, { className: horizontalLineStatus('leadingLine') }),
                React.createElement(Box, { onClick: 
                    /* istanbul ignore next */ () => !disabled && onNodeClick && onNodeClick(index + 1) },
                    React.createElement(HorizontalCircle, { className: status('circle') })),
                totalSteps && index + 1 < totalSteps && (React.createElement(HorizontalLine, { className: horizontalLineStatus('trailingLine') }))),
            React.createElement(Box, { align: "center", pad: { top: 'xsmall' } },
                React.createElement(Text$1, { color: `${currentNode ? 'brand' : disabled ? '#888' : null}` }, label)))));
    return isVertical ? verticalStep : horizontalStep;
};

/* eslint-disable @typescript-eslint/indent */
const Shuttle$1 = (props) => {
    logger('Shuttle is deperecated, use Shuttlev2 instead.', 'error');
    const { dataTestId, leftItems, rightItems, rightHeading, leftHeading, removeButtonLabel, leftEmptyMessage, rightEmptyMessage, addButtonLabel, } = props;
    const arrOfStrings = [];
    const [selectedItemsLeft, setSelectedItemsLeft] = useState(arrOfStrings);
    const [selectedItemsRight, setSelectedItemsRight] = useState(arrOfStrings);
    const [leftItemsMutable, setLeftItemsMutable] = useState(leftItems ? [...leftItems] : []);
    const [rightItemsMutable, setRightItemsMutable] = useState(rightItems ? [...rightItems] : []);
    const selectItem = (index, panel) => {
        const currentPanel = panel === 'left' ? selectedItemsLeft : selectedItemsRight;
        const setCurrentPanel = panel === 'left' ? setSelectedItemsLeft : setSelectedItemsRight;
        // @ts-ignore
        if (currentPanel && currentPanel.includes(index)) {
            const arr = [...currentPanel];
            arr.splice(arr.indexOf(index), 1);
            setCurrentPanel(arr);
        }
        else {
            const arr = [...currentPanel];
            arr.push(index);
            setCurrentPanel(arr);
        }
    };
    const addItems = () => {
        const arrLeftItemsObj = {};
        leftItemsMutable.forEach((element, index) => {
            arrLeftItemsObj[index] = element;
        });
        const arrRightItems = [...rightItemsMutable];
        selectedItemsLeft.forEach((itemIndex) => {
            delete arrLeftItemsObj[itemIndex];
            arrRightItems.push(leftItemsMutable[itemIndex]);
        });
        setLeftItemsMutable(Object.values(arrLeftItemsObj));
        setSelectedItemsLeft([]);
        setRightItemsMutable(arrRightItems);
    };
    const removeItems = () => {
        const arrRightItemsObj = {};
        rightItemsMutable.forEach((element, index) => {
            arrRightItemsObj[index] = element;
        });
        const arrLeftItems = [...leftItemsMutable];
        selectedItemsRight.forEach((itemIndex) => {
            delete arrRightItemsObj[itemIndex];
            arrLeftItems.push(rightItemsMutable[itemIndex]);
        });
        setLeftItemsMutable(arrLeftItems);
        setSelectedItemsRight([]);
        setRightItemsMutable(Object.values(arrRightItemsObj));
    };
    const ShuttlePanel = ({ left }) => {
        const itemsList = left ? leftItemsMutable : rightItemsMutable;
        const selectedItemsList = left ? selectedItemsLeft : selectedItemsRight;
        return (React.createElement(Box, Object.assign({ style: {
                minWidth: '192px',
                overflow: 'auto',
                borderRadius: '4px',
            }, elevation: "medium", margin: { top: 'small' }, basis: "350px", border: { color: 'light-3' } }, getTestIdAttribute(`${dataTestId}-${left ? 'left' : 'right'}-panel`)),
            itemsList &&
                itemsList.map((item, index) => (React.createElement(Box, { key: index, border: { side: 'bottom', color: 'light-3' }, pad: "small", style: { minHeight: '50px' }, justify: "center", background: selectedItemsList.includes(index) ? 'light-3' : undefined, onClick: () => selectItem(index, left ? 'left' : 'right'), animation: selectedItemsList[selectedItemsList.length - 1] === index
                        ? {
                            type: 'zoomIn',
                            duration: 500,
                            size: 'medium',
                        }
                        : undefined, "data-test-id": `${dataTestId}-${left ? 'left' : 'right'}-panel-item-${index}` }, item))),
            itemsList.length === 0 && (React.createElement(Box, { pad: "small", align: "center" }, left ? leftEmptyMessage : rightEmptyMessage))));
    };
    const setDisabled = (buttonType) => {
        if (selectedItemsLeft.length > 0 && selectedItemsRight.length > 0)
            return true;
        if (buttonType === 'add')
            return leftItemsMutable.length === 0;
        if (buttonType === 'remove')
            return rightItemsMutable.length === 0;
        return undefined;
    };
    return (React.createElement(Box, Object.assign({ direction: "row" }, getTestIdAttribute(dataTestId)),
        React.createElement(Box, { align: "center" },
            leftHeading && (React.createElement(Text, { label: leftHeading, type: "title2", dataTestId: `${dataTestId}-left-heading` })),
            React.createElement(ShuttlePanel, { left: true })),
        React.createElement(Box, { pad: { horizontal: 'medium' }, gap: "small", align: "center", justify: "center" },
            React.createElement(Button$1, { type: "primary", disabled: setDisabled('add'), dataTestId: `${dataTestId}-add-button`, onClick: addItems },
                React.createElement(Box, { direction: "row", align: "center", gap: "xsmall" },
                    addButtonLabel && (React.createElement(Text, { type: "title4", status: "white", label: addButtonLabel, dataTestId: "" })),
                    React.createElement(Icon, { name: "next", status: "white", dataTestId: `${dataTestId}-add-button-icon` }))),
            React.createElement(Button$1, { type: "primary", disabled: setDisabled('remove'), dataTestId: `${dataTestId}-remove-button`, onClick: removeItems },
                React.createElement(Box, { direction: "row", align: "center", gap: "xsmall" },
                    removeButtonLabel && (React.createElement(Text, { type: "title4", status: "white", label: removeButtonLabel, dataTestId: "" })),
                    React.createElement(Icon, { name: "previous", status: "white", dataTestId: `${dataTestId}-remove-button-icon` })))),
        React.createElement(Box, { align: "center" },
            rightHeading && (React.createElement(Text, { label: rightHeading, type: "title2", dataTestId: `${dataTestId}-right-heading` })),
            React.createElement(ShuttlePanel, { left: false }))));
};

/* eslint-disable @typescript-eslint/indent */
const Shuttle = ({ leftTable, rightTable, onMoveLeftClick, onMoveRightClick, onMoveRightDisabled, onMoveLeftDisbled, size = 'medium', dataTestId, }) => {
    const ShuttlePanel = ({ side }) => {
        return (React.createElement(Box, Object.assign({ style: {
                minWidth: '192px',
                overflow: 'auto',
                borderRadius: '4px',
            }, elevation: "medium", margin: { top: 'small' }, basis: size }, getTestIdAttribute(`${dataTestId}-${side === 'left' ? 'left' : 'right'}-panel`)), side === 'left' ? leftTable : rightTable));
    };
    const backgroundColor = useCuroColor('white');
    return (React.createElement(Box, Object.assign({ pad: "small", justify: "center", background: backgroundColor, direction: "row" }, getTestIdAttribute(dataTestId)),
        React.createElement(ShuttlePanel, { side: "left" }),
        React.createElement(Box, { pad: { horizontal: 'medium' }, gap: "small", align: "center", justify: "center" },
            React.createElement(IconButton, { icon: "next", onClick: onMoveRightClick, disabled: onMoveRightDisabled, dataTestId: "add", border: true }),
            React.createElement(IconButton, { icon: "previous", onClick: onMoveLeftClick, disabled: onMoveLeftDisbled, dataTestId: "add", border: true })),
        React.createElement(ShuttlePanel, { side: "right" })));
};

const StyledBox$3 = styled(Box).withConfig({ displayName: "StyledBox", componentId: "sc-1pc3w1v" }) `
  text-decoration-line: underline;
  text-decoration-color: ${props => props["data-textdecorationcolor"]};
  padding: 8px;
  border-radius: 4px;
  &:hover {
    background-color:  ${props => props["data-backgroundcolor"]};
  }
`;
/** Use this component to provide feedback for user actions or to notify users about events. */
const FlashMessage = ({ dataTestId, a11yTitle, type, title, description, action, container = undefined, onClose = undefined, autoClose = false, duration = 5000, }) => {
    /** Handling close action and timer */
    const [showFlashMessage, setShowFlashMessage] = useState(true);
    const timerId = useRef(null);
    const colors = useCuroColors();
    const headerTheme = useHeaderTheme(type);
    const clearTimer = () => {
        if (timerId.current) {
            clearTimeout(timerId.current);
            timerId.current = null;
        }
    };
    const closeAction = () => {
        setShowFlashMessage(false);
        clearTimer();
        if (onClose) {
            onClose();
        }
    };
    useEffect(() => {
        if (autoClose) {
            // Called when component mounts
            timerId.current = setTimeout(() => {
                closeAction();
            }, duration);
            // Called when component unmounts
            return () => {
                clearTimer();
            };
        }
        return undefined;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /** Flash message */
    const targetRef = useRef();
    const headerIconEl = (React.createElement(Icon, { dataTestId: `${dataTestId}-${type}-icon`, name: headerTheme.icon, status: "white", size: "large" }));
    const spacerEl = React.createElement(Text, { dataTestId: "", type: "default", label: "  ", status: "white" });
    const titleEl = title && (
    // TODO: Text is translted to span element but computed CSS shows it has display block, why?
    React.createElement(Text, { dataTestId: `${dataTestId}-title`, type: "default", weight: "medium", label: `${title}`, status: "white" }));
    const descriptionEl = description && (
    // TODO: Text is translted to span element but computed CSS shows it has display webkit-box, why? */}
    React.createElement(Truncate, { dataTestId: `${dataTestId}-description`, type: "default", label: `${description}`, status: "white" }));
    // UX spec had light mode #444444 and dark mode as #FFFFFF. But following our curo color map dark mode should be #EEEEEE
    // const backgroundColor = useDarkMode() ? 'rgb(255, 255, 255, 0.2)' : 'rgb(68, 68, 68, 0.2)';
    const backgroundColor = useCuroColor('default', 0.2);
    const textDecorationColor = colors.white;
    const getActionEl = () => {
        const { text, href, onClick } = action;
        const textEl = (React.createElement(StyledBox$3, { "data-textdecorationcolor": textDecorationColor, "data-backgroundcolor": backgroundColor },
            React.createElement(Text, { dataTestId: `${dataTestId}-link-text`, label: text, status: "white", weight: "medium" })));
        if (href) {
            return (
            // Passing nowrap = true for link does not add css - white-space: nowrap.
            React.createElement(Link, { dataTestId: `${dataTestId}-link`, href: href }, textEl));
        }
        return (React.createElement(Button$1, { dataTestId: `${dataTestId}-action`, type: "plain", onClick: onClick }, textEl));
    };
    const closeIcon = (React.createElement(Icon, { dataTestId: `${dataTestId}-close-icon`, size: "medium", name: "remove", onClick: closeAction, status: "white" }));
    const isViewportSmall = useContext(ResponsiveContext) === 'small';
    const FlashMsg = (React.createElement(ThemeContext.Extend, { value: { autoTheme: false } },
        React.createElement(Layer, Object.assign({ modal: false, position: "top", responsive: false, target: container && targetRef.current, animation: "slide" }, getTestIdAttribute(dataTestId), { "aria-label": a11yTitle, style: { background: 'transparent', boxShadow: 'none', minWidth: 'fit-content' } }),
            React.createElement(Box, Object.assign({ direction: "row" }, getTestIdAttribute(`${dataTestId}-body`), { background: { color: headerTheme.backgroundColor }, align: "center", justify: "between", style: {
                    borderRadius: isViewportSmall ? undefined : '25px',
                    paddingLeft: '14px',
                    paddingRight: isViewportSmall ? '16px' : '20px',
                    // Not required .. we are center aligning them with min height 50px.
                    // If we apply padding top 12 px as per the design, the content looks closer to bottom and is not centered. Shall we add bottom padding as well?
                    // paddingTop: isViewportSmall ? '12px' : undefined,
                    width: isViewportSmall ? '100vw' : undefined,
                    minWidth: isViewportSmall ? undefined : '40vw',
                    maxWidth: isViewportSmall ? undefined : '90vw',
                    height: isViewportSmall ? undefined : '50px',
                    minHeight: isViewportSmall ? '50px' : undefined,
                    maxHeight: isViewportSmall ? '64px' : undefined,
                } }),
                React.createElement(Box, { direction: "row", align: "center", gap: "10px" },
                    headerIconEl,
                    React.createElement(Panel, { noPad: true, noMarginBottom: true },
                        React.createElement(Row, { noPad: true, align: "center" },
                            React.createElement(Column, { noPad: true }, titleEl),
                            title && React.createElement(Column, { noPad: true }, spacerEl),
                            React.createElement(Column, { noPad: true, expand: true }, descriptionEl),
                            description && React.createElement(Column, { noPad: true }, spacerEl),
                            action && React.createElement(Column, { noPad: true }, getActionEl())))),
                React.createElement(Box, { style: { paddingLeft: '20px' } }, closeIcon)))));
    /** Flash Msg within container */
    const [, setShowDrop] = useState(false);
    useEffect(() => {
        setShowDrop(true);
    }, []);
    const FlashMsgWithinContainer = (React.createElement(React.Fragment, null,
        React.createElement(Box, Object.assign({ ref: targetRef }, getTestIdAttribute(`${dataTestId}-container`)), container),
        showFlashMessage && targetRef.current && FlashMsg));
    const FlashMsgOutsideContainer = React.createElement(React.Fragment, null, showFlashMessage && FlashMsg);
    return container ? FlashMsgWithinContainer : FlashMsgOutsideContainer;
};

const StyledBoxAddMultiple = styled(Box).withConfig({ displayName: "StyledBoxAddMultiple", componentId: "sc-1lv0w8f" }) `
  // Added this to overwrite browser's default styling on input fields
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
  }
  input:-webkit-autofill {
    -webkit-text-fill-color: ${props => getStyledCuroColor(props, 'default')};
  }
`;
const StyledTextInputAddMultiple = styled(TextInput$1).withConfig({ displayName: "StyledTextInputAddMultiple", componentId: "sc-ubb48m" }) `
  ::placeholder {
    color: ${props => getStyledCuroColor(props, 'disabled')};
  }
  &:focus {
    box-shadow: none;
  }
  ::-ms-reveal,
  ::-ms-clear {
    display: none;
  }
`;
const StyledIconButton$1 = styled(IconButton).withConfig({ displayName: "StyledIconButton", componentId: "sc-1mcxyks" }) `
  margin-top: 7px;
`;
const AddRemoveItem = ({ dataTestId, children, onRemove, hideRemove, disableRemove = false, addMultiple, removeTooltip, }) => {
    const colors = useInternalColors();
    return (React.createElement(React.Fragment, null, addMultiple ? (React.createElement(React.Fragment, null,
        React.createElement(Box, { direction: "row", justify: "between", align: "center", style: {
                padding: '0px 0px 0px 12px',
                backgroundColor: colors.solitude,
                borderRadius: addMultiple ? '4px' : undefined,
                marginBottom: addMultiple ? '4px' : undefined,
            } },
            React.createElement(Text, { label: children.content, dataTestId: "card-text" }),
            React.createElement(IconButton, { dataTestId: `${dataTestId}-remove-icon`, icon: "remove", size: "small", onClick: onRemove, disabled: disableRemove, tooltip: removeTooltip })))) : (React.createElement(Box, Object.assign({ direction: "row", gap: "20px" }, getTestIdAttribute(dataTestId)),
        children,
        !hideRemove && (React.createElement(StyledIconButton$1, { icon: "remove", type: "button", dataTestId: `${dataTestId}-close`, size: "small", onClick: onRemove, disabled: disableRemove, tooltip: removeTooltip }))))));
};
const AddRemove = ({ dataTestId, addBtnPosition: btnPosition, addDisabled, children, title, emptyListMsg = getI18nStr('emptyListMsg'), onAdd, addMultiple = false, addMultiplePlaceholder, helpText, hideMaxLimitReachedMsg = false, maxLimitReachedMsg = getI18nStr('maxNoOfItemsAdded'), listItemsHeader }) => {
    /* istanbul ignore else */
    if (btnPosition) {
        logger('addBtnPosition will be deperecated, and the default value will be top.', 'error');
    }
    let addBtnPosition = btnPosition || 'top';
    const colors = useInternalColors();
    const [addMultipleItem, setAddMultipleItem] = useState('');
    const showMaxLimitReachedMsg = addDisabled && !hideMaxLimitReachedMsg;
    const onAddItems = () => {
        let itemArr = [];
        const itemArray = [];
        setAddMultipleItem('');
        if (addMultipleItem.indexOf(',') !== -1) {
            itemArr = addMultipleItem.split(',');
            itemArr.map(arrItem => {
                /* istanbul ignore else */
                if (arrItem !== ',' && arrItem.trim() !== '') {
                    itemArray.push({ content: arrItem.trim() });
                }
            });
            /* istanbul ignore else */
            if (onAdd)
                onAdd(itemArray);
        }
        else if (onAdd)
            onAdd(addMultipleItem);
    };
    const handleKeyUp = (e) => {
        const keyPressed = e.key;
        if (keyPressed === 'Enter' || keyPressed === ',') {
            onAddItems();
        }
    };
    const onClickToAddMultipleItem = () => {
        onAddItems();
    };
    const listItemsHeaderBox = (React.createElement(Box, Object.assign({ pad: { bottom: '12px' } }, getTestIdAttribute(`${dataTestId}-list-items-header`), { style: { borderBottom: `1px solid ${colors.gainsboro}` } }), listItemsHeader));
    return (React.createElement(Box, Object.assign({ gap: "small" }, getTestIdAttribute(dataTestId)),
        React.createElement(Box, { direction: "row", justify: "between", align: "center", pad: !addMultiple ? { bottom: 'small' } : { bottom: '0px' }, border: !addMultiple && { side: 'bottom' } },
            typeof title === 'string' && (React.createElement(Text, { label: title, type: addMultiple ? 'label' : 'title2', dataTestId: `${dataTestId}-title` })),
            typeof title !== 'string' && title,
            !addMultiple && addBtnPosition === 'top' && (React.createElement(IconButton, { icon: "add", type: "button", onClick: onAdd, disabled: addDisabled, dataTestId: `${dataTestId}-add` }))),
        listItemsHeader && listItemsHeaderBox,
        addMultiple && (React.createElement(React.Fragment, null,
            React.createElement(StyledBoxAddMultiple, { direction: "row", style: {
                    border: `1px solid ${colors.gainsboro}`,
                    marginBottom: '8px',
                }, round: "4px", align: "center" },
                React.createElement(StyledTextInputAddMultiple, { plain: true, name: "add-multiple-input", onChange: (e) => {
                        setAddMultipleItem(e.target.value);
                    }, onKeyUp: (e) => handleKeyUp(e), value: addMultipleItem, placeholder: addMultiplePlaceholder }),
                React.createElement(IconButton, { icon: "add", type: "button", onClick: onClickToAddMultipleItem, dataTestId: `${dataTestId}-add` })),
            React.createElement(Text, { dataTestId: `${dataTestId}-add-multiple-help-text`, type: "label", label: helpText }),
            React.createElement(Box, { pad: { bottom: 'small' } }),
            React.createElement(Box, null, children))),
        !addMultiple &&
            (children ? (React.createElement(Box, { gap: "small" }, children)) : (React.createElement(Box, { height: "50px", margin: { vertical: 'xsmall' }, align: "center", justify: "center", border: { side: 'horizontal' }, background: colors.lighterGray },
                React.createElement(Text, { label: emptyListMsg, status: "gray", dataTestId: `${dataTestId}-empty-list-msg` })))),
        !addMultiple && addBtnPosition === 'bottom' && (React.createElement(Box, { style: { width: 'max-content' } },
            React.createElement(Button$1, { type: "secondary", onClick: onAdd, disabled: addDisabled, label: "Add", dataTestId: `${dataTestId}-add` }))),
        showMaxLimitReachedMsg && (React.createElement(Text, { dataTestId: `${dataTestId}-max-limit-reached-msg`, label: maxLimitReachedMsg, status: "info" }))));
};

const Node = ({ index, itemToAdd, removeItem, dataTestId, addMultiple, listItemsHeader, isRemoveIconRightAligned, itemsCount, minLimit, }) => {
    const colors = useColors();
    const elementDataTestId = `${dataTestId}-node`;
    let nodeBgColor;
    if (addMultiple) {
        nodeBgColor = colors.solitude;
    }
    else if (listItemsHeader) {
        // Case where content has a table
        nodeBgColor = index % 2 === 0 ? colors.white : colors.lighterGray;
    }
    else {
        nodeBgColor = undefined;
    }
    // Paddings are different for the 3 different use cases. Changing visuals as per use case is not good from dev standpoint.
    let padding;
    if (addMultiple) {
        padding = '0px 0px 0px 12px';
    }
    else if (isRemoveIconRightAligned) {
        // Inside Modal use case
        padding = '6px 20px 6px 10px';
    }
    else {
        padding = '6px 0px 6px 0px';
    }
    return (React.createElement(Box, Object.assign({ key: index }, getTestIdAttribute(`${elementDataTestId}-${index}-container`), { direction: "row", justify: isRemoveIconRightAligned ? 'between' : 'start', align: "center", gap: isRemoveIconRightAligned ? undefined : '20px', style: {
            padding,
            backgroundColor: nodeBgColor,
            borderRadius: addMultiple ? '4px' : undefined,
            marginBottom: addMultiple ? '4px' : undefined,
        } }),
        React.createElement(Box, Object.assign({}, getTestIdAttribute(`${elementDataTestId}-${index}`)), addMultiple ? (React.createElement(Truncate, { dataTestId: `${elementDataTestId}-${index}-text`, label: itemToAdd, type: "label", status: "slate" })) : (itemToAdd)),
        React.createElement(IconButton, { dataTestId: `${elementDataTestId}-${index}-remove-icon`, icon: "remove", size: "small", onClick: () => {
                removeItem(index);
            }, disabled: itemsCount <= minLimit })));
};
/** Container that renders a dynamic list of JSX Elements. Click the '+' icon to add the user given title3 to the list. Click the 'X' icon to remove that title3 from the list. */
const AddRemoveControlled = ({ dataTestId, a11yTitle, title = getI18nStr('add'), emptyListMsg = getI18nStr('emptyListMsg'), listItemsHeader, item, listItems = [], addMultiple = false, addMultiplePlaceholder = '', helpText = '', isRemoveIconRightAligned = false, minLimit = 0, maxLimit = -1, hideMaxLimitReachedMsg = false, maxLimitReachedMsg = getI18nStr('maxNoOfItemsAdded'), onDelete, onAdd, }) => {
    logger('AddRemoveControlled is deperecated, use AddRemove instead.', 'error');
    const initialItemList = listItems;
    const [itemList, setItemList] = useState(initialItemList);
    const [multiInputElValue, setMultiInputElValue] = useState('');
    const colors = useInternalColors();
    const itemsCount = itemList.filter(entry => entry !== undefined).length;
    // Removes item from the nodeList at the provided index
    const removeItem = (index) => {
        const newItemList = [...itemList];
        // Splicing messes up list ordering.
        // newItemList.splice(index, 1);
        delete newItemList[index];
        setItemList(newItemList);
        // Provide user the index of the element that is removed
        if (onDelete)
            onDelete(index);
    };
    /** For default use case, adds the user provided item to the nodeList.
     * For addMultiple use case, splits the text entered in the i/p box by comma. It trims the extra comma at the end of the entered text.
     * Then adds each item of the array to the nodeList.
     *
     * A row is rendered for each item in the nodeList.
     */
    const addItem = () => {
        const arr = [...itemList];
        if (addMultiple) {
            const len = multiInputElValue.length;
            const val = multiInputElValue.substr(len - 1, 1) === ','
                ? multiInputElValue.substring(0, len - 1)
                : multiInputElValue;
            const multiInputArr = val.split(',');
            multiInputArr.forEach(arrItem => {
                if (arrItem !== ',' && arrItem.trim() !== '') {
                    arr.push(arrItem);
                }
            });
            setMultiInputElValue('');
        }
        else {
            arr.push(item);
        }
        // ItemList.length provides the index at which the element will be added.
        if (onAdd)
            onAdd(itemList.length);
        setItemList(arr);
    };
    /** Applies for addMultiple use case. While entering text if user hits the Enter key or ',' then accept that input and create rows for them */
    const handleKeyPress = (e) => {
        const keyPressed = e.key;
        if (keyPressed === 'Enter' || keyPressed === ',') {
            // TODO: Since we capture comma e.target.value does not contain comma. Hence on line 115 when we set value='' it removed everything except comma
            setMultiInputElValue(e.target.value);
            addItem();
        }
    };
    const headerBox = (React.createElement(Box, null,
        React.createElement(Box, { direction: "row", justify: "between", align: "center", style: {
                borderBottom: addMultiple ? 'undefined' : `1px solid ${colors.gainsboro}`,
                padding: addMultiple ? undefined : '0px 20px 0px 10px',
            } },
            React.createElement(Text, { dataTestId: `${dataTestId}-title`, label: title, type: addMultiple ? 'label' : 'title3' }),
            React.createElement(IconButton, { dataTestId: `${dataTestId}-add-icon`, icon: "add", size: "small", status: "slate", onClick: () => addItem(), disabled: maxLimit !== -1 && itemsCount === maxLimit })),
        addMultiple && (React.createElement(Box, { gap: "8px", style: { paddingBottom: '12px' } },
            React.createElement(TextInput$1, { "data-test-id": `${dataTestId}-add-multiple-input`, name: "add-multiple-input", placeholder: addMultiplePlaceholder, onChange: (e) => {
                    setMultiInputElValue(e.target.value);
                }, onKeyPress: (e) => handleKeyPress(e), value: multiInputElValue }),
            React.createElement(Text, { dataTestId: `${dataTestId}-add-multiple-help-text`, type: "label", label: helpText })))));
    const noChildrenBox = (React.createElement(Box, { direction: "row", justify: "center", align: "center", style: {
            backgroundColor: colors.lighterGray,
            height: '50px',
            borderBottom: `1px solid ${colors.gainsboro}`,
        } },
        React.createElement(Text, { dataTestId: `${dataTestId}-no-children-label`, type: "default", status: "gray", label: emptyListMsg })));
    const listItemsHeaderBox = (React.createElement(Box, Object.assign({}, getTestIdAttribute(`${dataTestId}-list-items-header`), { style: { borderBottom: `1px solid ${colors.gainsboro}` } }), listItemsHeader));
    const bodyPadding = addMultiple || isRemoveIconRightAligned ? undefined : '6px 0px 6px 0px';
    const showMaxLimitReachedMsg = maxLimit !== -1 && !hideMaxLimitReachedMsg && itemsCount === maxLimit;
    return (React.createElement(Box, Object.assign({}, getTestIdAttribute(dataTestId), { a11yTitle: a11yTitle }),
        headerBox,
        listItemsHeader && listItemsHeaderBox,
        itemsCount === 0 && noChildrenBox,
        itemsCount > 0 && (React.createElement(Box, Object.assign({}, getTestIdAttribute(`${dataTestId}-body`), { justify: "between", style: { padding: bodyPadding } }), itemList
            .map((itemToAdd, index) => {
            if (!itemToAdd) {
                return undefined;
            }
            const props = {
                index,
                itemToAdd,
                removeItem,
                dataTestId,
                addMultiple,
                listItemsHeader,
                isRemoveIconRightAligned,
                itemsCount,
                minLimit,
            };
            return React.createElement(Node, Object.assign({ key: `${dataTestId}-${index}` }, props));
        })
            .reverse())),
        showMaxLimitReachedMsg && (React.createElement(Text, { dataTestId: `${dataTestId}-max-limit-reached-msg`, label: maxLimitReachedMsg, status: "info" }))));
};

/* eslint-disable @typescript-eslint/no-unused-expressions */
const Div$2 = styled.div.withConfig({ displayName: "Div", componentId: "sc-129rezu" }) `
  display: flex;
  flex-direction: row;
  border-radius: 4px;
  height: 28px;
  background: ${props => getStyledInternalColor(props, 'coolGray')};
  width: fit-content;
`;
const Tab$1 = styled(Box).withConfig({ displayName: "Tab", componentId: "sc-w8nqss" }) `
  cursor: pointer;
  padding: 0 20px 0 20px;
  transition: all 0.1s ease;
  align-self: center;
  &.selected {
    box-shadow: ${props => isStyledDark(props)
    ? `0px 0px 4px 0px ${getStyledCuroColor(props, 'black', 0.2)}`
    : `0px 0px 3px 0px ${getStyledCuroColor(props, 'black', 0.7)}`};
    background: ${props => getStyledCuroColor(props, isStyledDark(props) ? 'slate' : 'white')};
    padding: 5.5px 20px 5.5px 20px;
    border-radius: 4px;
    border: 1px solid
      ${props => isStyledDark(props)
    ? getStyledCuroColor(props, 'slate')
    : getStyledInternalColor(props, 'gainsboro')};
  }
`;
/** A vertically stacked list of headers that can be clicked to reveal content associated with them */
const Slider = ({ options, activeTab, activeTabOnMount, onTabClick, dataTestId, }) => {
    const darkMode = useDarkMode();
    const [selected, setSelected] = useState((activeTab && activeTab - 1) || (activeTabOnMount && activeTabOnMount - 1) || 0);
    useEffect(() => {
        if (activeTab)
            setSelected(activeTab - 1);
    }, [activeTab]);
    const tabClick = (index) => {
        if (onTabClick) {
            onTabClick(options && options[index]);
        }
        if (!activeTab) {
            setSelected(index);
        }
    };
    const handleKeyDown = (e) => {
        if (e.key === 'ArrowRight' && selected < options.length - 1) {
            setSelected(selected + 1);
        }
        if (e.key === 'ArrowLeft' && selected > 0) {
            setSelected(selected - 1);
        }
    };
    const disabledColor = useCuroColor('disabled');
    return (React.createElement(Div$2, Object.assign({}, getTestIdAttribute(dataTestId)), options &&
        options.map((option, index) => (React.createElement(Tab$1, { "data-firstel": index === 0, key: index.toString(), onClick: (e) => {
                tabClick(index);
                if (option.onClick)
                    option.onClick(e);
            }, onKeyDown: handleKeyDown, className: selected === index ? 'selected' : undefined, "data-test-id": option.dataTestId ? `${dataTestId}-${option.dataTestId}` : undefined, tabIndex: 0, id: option.id, style: {
                borderRight: index !== options.length - 1 ? `1px solid ${disabledColor}` : 'none',
                borderLeft: '1px solid transparent',
            } },
            React.createElement(Text, { status: darkMode && selected === index ? 'white' : 'slate', label: option.label, dataTestId: `${dataTestId}-label` }))))));
};

const hasAlienType = (children) => {
    let hasAlien = false;
    if (children) {
        if (Array.isArray(children)) {
            children.map((child) => {
                // any does not exist in JSX.Element[]
                if (child.type.name !== 'TreeItem') {
                    hasAlien = true;
                }
                return '';
            });
        }
        else {
            return children.type.name !== 'TreeItem';
        }
    }
    return hasAlien;
};
const StyledBox$2 = styled(Box).withConfig({ displayName: "StyledBox", componentId: "sc-kazb28" }) `
  cursor: pointer;
  background: none;
  &:hover {
    background: ${props => getStyledInternalColor(props, 'solitude')};
  }
  border-radius: 4px;
  margin: 2px;
  &:focus {
    box-shadow: 0px 0px 0px 1px ${props => getStyledInternalColor(props, 'focus')};
    background: none;
  }
`;
const TreeItem = ({ children, label, dataTestId, icon, isOpen, onClick }) => {
    const [open, setOpen] = useState(isOpen === true);
    const toggleState = () => setOpen(!open);
    if (hasAlienType(children)) {
        logger('Only use TreeItem component as child', 'error');
    }
    const lightGray = useInternalColor('lightGray');
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledBox$2, Object.assign({ direction: "row", onClick: toggleState, style: {
                alignItems: 'center',
            }, flex: { shrink: 0 } }, getTestIdAttribute(dataTestId)),
            React.createElement(Column, { noPad: true },
                children && (React.createElement(Icon, { name: open ? 'down' : 'right', tooltip: getI18nStr(open ? 'collapse' : 'expand'), size: "small", dataTestId: `${dataTestId}-fold` })),
                children === undefined && (React.createElement(Icon, { name: "none", size: "small", dataTestId: `${dataTestId}-none` }))),
            React.createElement(Box, { pad: { right: '4px' } }),
            icon && (React.createElement(React.Fragment, null,
                React.createElement(Column, null,
                    React.createElement(Icon, { name: icon, size: "small", dataTestId: `${dataTestId}-icon` })),
                React.createElement(Text, { type: "label", label: " ", dataTestId: `${dataTestId}-space` }))),
            React.createElement(Column, { noPad: true, expand: true },
                React.createElement(Box, { onClick: onClick },
                    typeof label === 'string' && (React.createElement(Text, { type: "label", label: label, dataTestId: `${dataTestId}-label` })),
                    typeof label !== 'string' && label))),
        children && open && (React.createElement(Box, { direction: "column", flex: { shrink: 0 }, style: {
                marginLeft: '18px',
                background: lightGray,
            } }, children))));
};
const TreeView = ({ children, dataTestId }) => {
    if (hasAlienType(children)) {
        logger('Only use TreeItem component as child', 'error');
    }
    return (React.createElement(Column, { noPad: true, dataTestId: dataTestId }, children));
};

const StyledParagraph = styled.div.withConfig({ displayName: "StyledParagraph", componentId: "sc-1tt7y89" }) `
  line-height: 0%;
  padding: 0px;
  margin: 0px;
  text-align: ${props => props['data-align']};
`;
const Paragraph = ({ children, dataTestId, className, textAlign = 'start', }) => {
    return (React.createElement(StyledParagraph, Object.assign({}, getTestIdAttribute(dataTestId), { className: className, "data-align": textAlign }), children));
};

const AccordionContext = createContext({});
const AccordionPanel = forwardRef((_a, ref) => {
    var { children, header, label, onMouseOut, onMouseOver, onFocus, onBlur, dataTestId } = _a, rest = __rest(_a, ["children", "header", "label", "onMouseOut", "onMouseOver", "onFocus", "onBlur", "dataTestId"]);
    const { accordion } = useTheme();
    const { active, animate, onPanelChange } = useContext(AccordionContext);
    const [hover, setHover] = useState(undefined);
    const [focus, setFocus] = useState(false);
    const headingColor = accordion.hover ? accordion.hover.heading.color : accordion.hover.color;
    const { border: contentBorder } = accordion;
    const { border: panelBorder } = accordion.panel;
    let abutMargin;
    /*istanbul ignore else*/
    if (panelBorder)
        abutMargin = {
            bottom: '5px',
        };
    return (React.createElement(Box, { ref: ref, flex: false, 
        // onClick={onClick}
        border: panelBorder, margin: abutMargin },
        React.createElement(Box, { role: "tab", "aria-selected": active, "aria-expanded": active, onClick: onPanelChange, onMouseOver: (event) => {
                setHover(headingColor);
                /*istanbul ignore else*/
                if (onMouseOver)
                    onMouseOver(event);
            }, onMouseOut: (event) => {
                setHover(undefined);
                /*istanbul ignore else*/
                if (onMouseOut)
                    onMouseOut(event);
            }, onFocus: (event) => {
                setHover(headingColor);
                setFocus(true);
                /*istanbul ignore else*/
                if (onFocus)
                    onFocus(event);
            }, onBlur: (event) => {
                setHover(undefined);
                setFocus(false);
                /*istanbul ignore else*/
                if (onBlur)
                    onBlur(event);
            }, style: focus ? { zIndex: 1, boxShadow: 'none' } : undefined }, header || (React.createElement(Box, Object.assign({ align: "center", direction: "row", justify: "between" }, rest),
            typeof label === 'string' ? (React.createElement(Box, { pad: { horizontal: 'xsmall' } },
                React.createElement(Heading, { level: (accordion.heading && accordion.heading.level) || 4, margin: (accordion.heading && accordion.heading.margin) || undefined, color: hover }, label))) : (label),
            React.createElement(Icon, { name: active ? 'up' : 'down', tooltip: getI18nStr(active ? 'collapse' : 'expand'), size: "large", dataTestId: `${dataTestId}-accordion-icon` })))),
        React.createElement(Box, { border: contentBorder }, animate ? React.createElement(Collapsible, { open: active }, children) : active && children)));
});

const StyledAccordionPanel = styled(AccordionPanel).withConfig({ displayName: "StyledAccordionPanel", componentId: "sc-50lq01" }) `
  & > div:first-child {
    width: 100%;
    justify-content: center;
  }
  border-bottom: solid 1px ${props => getStyledInternalColor(props, 'lightMediumGray')};
  padding: 6px 12px 6px 12px;
`;
const activeAsArray = (active) => (typeof active === 'number' ? [active] : active);
/** A vertically stacked list of headers that can be clicked to reveal content associated with them. <br /> Link to UX pattern : https://confluence.eng.nimblestorage.com/display/UX/Accordion+Pattern */
const Accordion = ({ dataTestId, panels, header, a11yTitle, contentBorder = false, onActive, activeIndex, animate = false, multiple = false, noContentMargin = false, }) => {
    const [activeIndexes, setActiveIndexes] = useState([]);
    const [stateActiveIndex, setStateActiveIndex] = useState(undefined);
    const derivedActiveIndexes = activeAsArray(activeIndex) || [];
    if ((typeof activeIndex !== 'undefined' || activeIndex !== stateActiveIndex) &&
        derivedActiveIndexes.join() !== activeIndexes.join()) {
        setActiveIndexes(derivedActiveIndexes);
        setStateActiveIndex(activeIndex);
    }
    const getAccordionContext = useCallback((index) => {
        const onPanelChange = (nextIndex) => {
            let nextActiveIndexes = [...(activeIndexes || [])];
            const nextActiveIndex = nextActiveIndexes.indexOf(nextIndex);
            if (nextActiveIndex > -1) {
                nextActiveIndexes.splice(nextActiveIndex, 1);
            }
            else if (multiple) {
                nextActiveIndexes.push(nextIndex);
            }
            else {
                nextActiveIndexes = [nextIndex];
            }
            setActiveIndexes(nextActiveIndexes);
            /* istanbul ignore else */
            if (onActive) {
                onActive(nextActiveIndexes);
            }
        };
        return {
            active: activeIndexes.indexOf(index) > -1,
            animate,
            onPanelChange: () => onPanelChange(index),
        };
    }, [activeIndexes, animate, multiple, onActive]);
    const lighterGray = useInternalColor('lighterGray');
    const white = useCuroColor('white');
    // Never use setState on onMouseOver or onMouseOut events as overflow scroll behaviour gets weird & jumpy, instead use the behaviour below
    const changeBackground = (e) => {
        e.currentTarget.style.background = lighterGray;
    };
    const resetBackground = (e) => {
        e.currentTarget.style.background = 'transparent';
    };
    const content = panels.map((child, index) => (React.createElement(StyledAccordionPanel, Object.assign({ onMouseEnter: changeBackground, onMouseLeave: resetBackground, key: index.toString(), dataTestId: `${dataTestId}-${child.dataTestId}`, label: React.createElement(Box, { style: { minHeight: '44px' } }, typeof child.label === 'string' ? (React.createElement(Text, { label: child.label, type: 'title4', dataTestId: `${dataTestId}-${child.dataTestId}-accordion-panel-title` })) : (child.label)) }, getTestIdAttribute(`${dataTestId}-${child.dataTestId}-accordion-panel`)),
        React.createElement(Box, { style: { minHeight: '96px' }, pad: "12px", background: white }, child.content))));
    const Elements = Children.toArray(content);
    return (React.createElement(Box, null,
        header && (React.createElement(Box, { pad: { horizontal: '12px', vertical: '6px' }, border: { side: 'bottom' }, flex: { shrink: 0 } }, header)),
        React.createElement("div", null),
        React.createElement(Box, Object.assign({ role: "tablist" }, getTestIdAttribute(dataTestId), { a11yTitle: a11yTitle, margin: !noContentMargin ? 'small' : undefined, style: { border: contentBorder && !noContentMargin ? `1px solid ${lighterGray}` : undefined } }), Elements.length &&
            Elements.filter((child) => child).map((child, index) => (React.createElement(AccordionContext.Provider, { key: index.toString(), value: getAccordionContext(index) }, child))))));
};

/** DO NOT USE, This component is specific to dynamic tabs, We will remove this one in future. */
const CustomBox = styled(Box).withConfig({ displayName: "CustomBox", componentId: "sc-jias95" }) `
  &::-webkit-scrollbar {
    display: none;
  }
  //Added to hide scrollbar in firefox
   scrollbar-width: none;
`;
const Carousel$1 = ({ gap, incrementBy = 1, maxItems = 3, children, dataTestId, rightEnd, animation: animate = true, activeIndexOnMount, }) => {
    const [firstItem, setFirstItem] = useState(0);
    const [animation, setAnimation] = useState();
    const [width, setWidth] = useState(undefined);
    const [childernCount, setChildernCount] = useState(children.length);
    const animationDuration = 500;
    const slideIn = (side) => {
        return {
            type: side === 'left' ? 'slideLeft' : 'slideRight',
            delay: 0,
            duration: animationDuration,
            size: 'xlarge',
        };
    };
    const clearAnimation = () => {
        setTimeout(() => {
            setAnimation(undefined);
        }, animationDuration);
    };
    const leftArrowVisible = firstItem > 0;
    const rightArrowVisible = firstItem + maxItems < children.length;
    const handleRightClick = useCallback(() => {
        if (rightArrowVisible) {
            setFirstItem(firstItem + incrementBy);
            setAnimation(slideIn('left'));
            clearAnimation();
        }
    }, [firstItem, incrementBy, rightArrowVisible]);
    const handleLeftClick = () => {
        if (leftArrowVisible) {
            setFirstItem(firstItem - incrementBy);
            setAnimation(slideIn('right'));
            clearAnimation();
        }
    };
    const activeItems = children.slice(firstItem, firstItem + maxItems);
    useEffect(() => {
        if (rightEnd) {
            for (let i = 0; i < children.length; i++) {
                handleRightClick();
            }
        }
        if (children.length < childernCount) {
            handleLeftClick();
        }
        setChildernCount(children.length);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [children.length, rightEnd]);
    useEffect(() => {
        if (activeIndexOnMount !== undefined) {
            let rangeIndex = 0;
            const rangeArray = range(0, children.length);
            // Finding the range index which has activeIndexOnMount  in the activeItems set to show in UI
            rangeArray.some(idx => {
                const slicedItems = rangeArray.slice(idx, idx + maxItems);
                if (slicedItems.includes(activeIndexOnMount)) {
                    rangeIndex = idx;
                    return true;
                }
                return false;
            });
            setFirstItem(rangeIndex);
        }
    }, [activeIndexOnMount, children.length, maxItems]);
    const getIcon = (name, visible, onClick) => {
        return (React.createElement(IconButton, { icon: name, onClick: onClick, disabled: !visible, size: "medium", dataTestId: `${dataTestId}-${name}` }));
    };
    const visibility = animation;
    const childRef = useRef();
    useEffect(() => {
        var _a, _b;
        setWidth(((_b = (_a = childRef.current) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.offsetWidth) - 80);
    }, [childRef, setWidth]);
    return (React.createElement(Box, Object.assign({ direction: "row", fill: true, justify: "between", gap: "small", align: "center" }, getTestIdAttribute(dataTestId), { ref: childRef }),
        React.createElement("span", { style: animate ? { visibility: visibility ? 'hidden' : 'visible' } : undefined }, getIcon('previous', leftArrowVisible, handleLeftClick)),
        React.createElement(CustomBox, { animation: animate ? animation : undefined, direction: "row", style: { maxWidth: width, overflowX: 'scroll' }, gap: gap }, activeItems),
        React.createElement("span", { style: animate ? { visibility: visibility ? 'hidden' : 'visible' } : undefined }, getIcon('next', rightArrowVisible, handleRightClick))));
};

const TabsContext = React.createContext({});

/* eslint-disable @typescript-eslint/indent */
const Tabs = ({ onTabChange, activeTabOnMount, activeTab, children, tooltip, onAdd, dataTestId, showScroll, responsive = false, addDisabled = false, addDisabledMessage, }) => {
    // Deprecation warning
    if (showScroll !== undefined)
        logger('showScroll has been deprecated !', 'error');
    // calculating parent width and children width size for dynamic tab
    const tabContainerRef = useRef();
    const container = tabContainerRef && tabContainerRef.current && tabContainerRef.current;
    const tabContainerSize = container && container.offsetWidth;
    const toolTipsAddContainer = container && container.childNodes[0].childNodes[0].childNodes[1];
    const tooltipAddSize = toolTipsAddContainer && toolTipsAddContainer.offsetWidth;
    const childContainer = container && container.childNodes[0].childNodes[0];
    const EnabledTabs = [];
    const [maxValue, setMaxValue] = useState();
    const [isAddDisabled, setIsAddDisabled] = useState(false);
    const [maxChildLength, setMaxChildLength] = useState(1);
    const [isRightEnd, setIsRightEnd] = useState(false);
    const vSize = useContext(ResponsiveContext);
    const [screenSize, setScreenSize] = useState('');
    // calculating max value for carousel
    useEffect(() => {
        if (responsive) {
            let sumofTabSize = 0;
            if (maxChildLength >= children.length) {
                setMaxValue(undefined);
                setIsRightEnd(false);
            }
            for (let i = 0; i < children.length && childContainer; i++) {
                const childrenByIndex = childContainer && childContainer.childNodes[i];
                if (childrenByIndex) {
                    sumofTabSize += childrenByIndex && childrenByIndex.offsetWidth;
                    if (tabContainerSize - tooltipAddSize < sumofTabSize) {
                        if (maxValue === undefined) {
                            const finalIndex = i;
                            setMaxValue(finalIndex);
                            setMaxChildLength(finalIndex);
                            setIsRightEnd(true);
                            break;
                        }
                    }
                }
            }
        }
    }, [
        children,
        childContainer,
        maxChildLength,
        tabContainerSize,
        tooltipAddSize,
        maxValue,
        screenSize,
        responsive,
    ]);
    useEffect(() => {
        setMaxValue(undefined);
        // Added setTime to do calcualtion after carousal hidden, to sync childnodes length
        setTimeout(() => {
            setScreenSize(vSize);
        });
    }, [vSize]);
    React.Children.forEach(children, (child, index) => {
        if (!child.props.disabled)
            EnabledTabs.push(index);
    });
    // Maintains active tab
    const [active, setActive] = useState(activeTab ? activeTab - 1 : (activeTabOnMount && activeTabOnMount - 1) || EnabledTabs[0]);
    // const [currentTabObject, setCurrentTabObject] = useState();
    const onActive = (index) => {
        if (!activeTab)
            setActive(index);
    };
    useEffect(() => {
        if (activeTab)
            setActive(activeTab - 1);
    }, [activeTab]);
    // disabled add button
    useEffect(() => {
        setIsAddDisabled(addDisabled);
    }, [addDisabled]);
    // Handle Left & Right Navigation from keyboard.
    // To-Do: Space or Enter: Activates the tab if it was not activated automatically on focus.
    const handleKeyDown = (e) => {
        // Handle Right Arrow
        if (e.key === 'ArrowRight' && active < children.length - 1) {
            let nextTab = active + 1;
            while (children[nextTab].props.disabled) {
                if (nextTab < children.length - 1)
                    nextTab++;
                else
                    return undefined;
            }
            // onTabChange(children[nextTab].props);
            // To-do: Pass index
            const { label, link, disabled, badgeCount, dataTestId: TabDataTestId } = children[nextTab].props;
            onTabChange({ tabIndex: nextTab + 1, label, link, disabled, badgeCount, TabDataTestId });
            setActive(nextTab);
        }
        // Handle Left Arrow
        if (e.key === 'ArrowLeft' && active > 0) {
            let prevTab = active - 1;
            while (children[prevTab].props.disabled) {
                if (prevTab > 0)
                    prevTab--;
                else
                    return undefined;
            }
            // onTabChange(children[prevTab].props);
            // To-do: Pass index
            const { label, link, disabled, badgeCount, dataTestId: TabDataTestId } = children[prevTab].props;
            onTabChange({ tabIndex: active, label, link, disabled, badgeCount, TabDataTestId });
            setActive(prevTab);
        }
        return undefined;
    };
    const body = React.Children.map(children, (child, index) => (React.createElement(TabsContext.Provider, { value: {
            index,
            active,
            onActive,
            onTabChange,
            handleKeyDown,
            TabsDataTestId: dataTestId,
        } }, child)));
    const { label: tooltipLabel, content: tooltipContent } = tooltip || {};
    return (React.createElement(Box, Object.assign({ fill: true, a11yTitle: "tabs" }, getTestIdAttribute(dataTestId), { ref: tabContainerRef }),
        React.createElement(Box, { direction: "row", border: {
                side: 'bottom',
                color: 'light-4',
                style: 'solid',
            }, align: "center", justify: "between", flex: { shrink: 0 }, style: maxValue && responsive ? {} : { minWidth: 'fit-content' } },
            React.createElement(Box, { direction: "row" },
                maxValue === undefined && body,
                maxValue && responsive && (React.createElement(Carousel$1, { dataTestId: `${dataTestId}-carousel`, maxItems: maxValue, rightEnd: isRightEnd, animation: false, activeIndexOnMount: active }, body)),
                maxValue && !responsive && body),
            (tooltip || onAdd) && (React.createElement(Box, { direction: "row", align: "center", gap: "xsmall" },
                onAdd && (React.createElement(Tooltip, { tooltip: addDisabled && addDisabledMessage ? addDisabledMessage : false, dataTestId: `${dataTestId}-add-disabled-tooltip`, target: React.createElement(IconButton, { icon: "add", dataTestId: `${dataTestId}-add`, disabled: isAddDisabled, onClick: onAdd }) })),
                tooltip && (React.createElement(Tooltip, { dataTestId: `${dataTestId}-tooltip`, target: typeof tooltip !== 'object'
                        ? (React.createElement(Icon, { status: "default", size: "medium", name: "info", dataTestId: `${dataTestId}-tooltip-icon` }))
                        : tooltipLabel, tooltip: typeof tooltip !== 'object' ? tooltip : tooltipContent }))))),
        React.createElement(Box, Object.assign({}, getTestIdAttribute(`${dataTestId}-children-box`), { fill: true, overflow: { vertical: 'auto' } }), children && children[active] && children[active].props && children[active].props.children)));
};

const getBackground = (props) => {
    const colorType = props['data-badge-type'] === 'info'
        ? 'info'
        : // default background
            'error';
    return getStyledCuroColor(props, colorType);
};
const getBadgeContent = (count) => {
    if (count === undefined || count < 1) {
        return undefined;
    }
    return count > 99 ? '99+' : `${count}`;
};
const getBadgeWidth = (count) => {
    if (count === undefined) {
        return 17;
    }
    return 17 + (count.length - 1) * 7;
};
const TabBox$1 = styled(Box).withConfig({ displayName: "TabBox", componentId: "sc-8vlqvw" }) `
  display: flex;
  flex-direction: row;
  padding: 12px 16px 12px 16px;
  // transition: all 0.1s ease;
  min-width: fit-content; 
  min-width: -moz-fit-content; /* FireFox */
  min-width: -webkit-fit-content; /* Safari */
  &[data-badge-count]:after {
    content: attr(data-badge-count);
    position: relative;
    left: 2px;
    font-size: 14px;
    font-weight: semi-bold;
    background: ${props => getBackground(props)};
    color: ${props => getStyledCuroColor(props, isStyledDark(props) ? 'black' : 'white')};
    width: ${props => `${getBadgeWidth(props['data-badge-count'])}px`};
    height: 17px;
    text-align: center;
    line-height: 18px;
    border-radius: 50%;
    padding: ${props => (props['data-badge-count'] > 9 ? '0 1px' : undefined)};
    box-shadow: 0 0 1px #333;
  }
  &:hover{
    border-bottom: ${props => !props['data-active'] && `4px solid ${getStyledInternalColor(props, 'lightCoolGray')}`};
  }
`;
const TextWrapper = styled(Box).withConfig({ displayName: "TextWrapper", componentId: "sc-1kvnqff" }) `
   span {
      &:hover {
        color: ${props => getStyledCuroColor(props, 'default')};
    }
   `;
const Tab = (_a) => {
    var { label, link, disabled = false, badge, as: Comp, dataTestId, status = 'none' } = _a, rest = __rest(_a, ["label", "link", "disabled", "badge", "as", "dataTestId", "status"]);
    const { index, active, onActive, onTabChange, handleKeyDown, TabsDataTestId } = useContext(TabsContext);
    const darkMode = useDarkMode();
    const tabIndex = index + 1;
    const badgeCount = typeof badge === 'number' ? badge : badge && badge.count;
    const badgeType = typeof badge === 'object' ? badge && badge.type : undefined;
    const activeBorderType = {
        side: 'bottom',
        size: 'medium',
        color: index === active ? 'brand' : 'transparent',
    };
    const tabItem = () => {
        const Content = (React.createElement(TextWrapper, { "data-darkmode": darkMode },
            React.createElement(Row, { gap: 'xsmall', pad: 'noPad' },
                status !== 'none' && React.createElement(Icon, { size: 'xxsmall', name: status, dataTestId: `${dataTestId}-status-icon` }),
                React.createElement(Text, { weight: index === active ? 'medium' : 'normal', status: index === active ? 'default' : 'gray', dataTestId: `${dataTestId}-tab-text`, nowrap: true }, label))));
        if (Comp) {
            return (React.createElement(Comp, Object.assign({ onClick: 
                /* istanbul ignore next */ () => {
                    onActive(index);
                    onTabChange({
                        tabIndex,
                        label,
                        link,
                        disabled,
                        badgeCount,
                        TabDataTestId: dataTestId,
                    });
                }, 
                // Do not overwrite styling when using Link
                style: { textDecoration: 'none', color: 'inherit' }, tabIndex: -1 }, rest), Content));
        }
        return (React.createElement(Button$2, { onClick: 
            /* istanbul ignore next */ () => {
                onActive(index);
                onTabChange({ tabIndex, label, link, disabled, badgeCount, TabDataTestId: dataTestId });
            }, tabIndex: -1 }, Content));
    };
    return (React.createElement(TabBox$1, Object.assign({ onKeyDown: handleKeyDown, tabIndex: !disabled ? 0 : -1, alignSelf: "center", 
        // Set border when tab is active
        // TODO: cannot pass eslint, need to reorg the code
        border: activeBorderType, style: {
            pointerEvents: disabled ? 'none' : 'auto',
        }, "data-badge-count": getBadgeContent(badgeCount), "data-badge-type": badgeType, "data-active": index === active }, getTestIdAttribute(dataTestId && `${TabsDataTestId}-${dataTestId}`)), tabItem()));
};

/** Page Header is located at the top of all content pages. It provides the container structure to support the display of optional elements that are used for specific use cases. <br /> Link to UX pattern : https://confluence.eng.nimblestorage.com/display/UX/Header+Pattern#HeaderPattern-AdditionalVisualDesignInfo  */
const PageHeader = ({ title, actions, toolbar, contextualInfo, timestamp, navClick, dataTestId, }) => {
    const size = useContext(ResponsiveContext);
    const pageTitle = (React.createElement(Box, { direction: "row", align: "center", gap: "xsmall" },
        navClick && (React.createElement(IconButton, { icon: "menu", size: "medium", onClick: navClick, dataTestId: `${dataTestId}-menu` })),
        typeof title === 'string' && (React.createElement(Text, { dataTestId: `${dataTestId}-title`, type: "title1", label: title })),
        typeof title !== 'string' && title));
    const desktop = (React.createElement(Box, Object.assign({ direction: "row", align: "center", justify: "between", gap: "small", fill: "horizontal" }, getTestIdAttribute(dataTestId)),
        React.createElement(Box, { pad: { left: '8px' }, gap: "small", style: { minWidth: 'fit-content' } },
            pageTitle,
            contextualInfo && React.createElement(Box, { align: "start" }, contextualInfo)),
        React.createElement(Box, { direction: "row", gap: "20px", align: "center", justify: "end", wrap: true },
            timestamp && (React.createElement(Box, { align: "end" },
                React.createElement("span", { style: { fontSize: 'smaller', textAlign: 'end' } }, timestamp))),
            toolbar && (React.createElement(Box, { direction: "row", align: "center", gap: "small" }, toolbar)),
            actions && (React.createElement(Box, { direction: "row", gap: "small", align: "center" }, actions)))));
    const tablet = (React.createElement(Box, Object.assign({ fill: "horizontal", gap: "small" }, getTestIdAttribute(dataTestId)),
        React.createElement(Box, { direction: "row", justify: "between" },
            pageTitle,
            React.createElement(Box, { direction: "row", gap: "small" },
                toolbar && (React.createElement(Box, { direction: "row", gap: "small", align: "center" }, toolbar)),
                actions && (React.createElement(Box, { direction: "row", gap: "small", align: "center" }, actions)))),
        React.createElement(Box, { direction: "row", justify: contextualInfo ? 'between' : 'end' },
            contextualInfo && React.createElement(Box, { align: "start" }, contextualInfo),
            timestamp && (React.createElement(Box, { align: "center" },
                React.createElement("span", { style: { fontSize: '12px' } }, timestamp))))));
    const timestampAndToolbar = timestamp && toolbar;
    const timestampAndActions = timestamp && actions;
    const toolbarAndActions = toolbar && actions;
    const mobileFlow = () => {
        if ((!timestampAndActions || !timestampAndToolbar || !toolbarAndActions) && !contextualInfo)
            return 'row';
        return 'column';
    };
    const mobile = (React.createElement(Box, Object.assign({ direction: mobileFlow(), fill: "horizontal", gap: "small", justify: "between" }, getTestIdAttribute(dataTestId)),
        React.createElement(Box, { direction: "row", wrap: true, gap: "small", align: "center", justify: "between" },
            pageTitle,
            timestamp && (React.createElement(Box, null,
                React.createElement("span", { style: { fontSize: '12px' } }, timestamp)))),
        React.createElement(Box, { direction: "row", wrap: true, gap: "small", align: "center", justify: "between" },
            toolbar && (React.createElement(Box, { direction: "row", gap: "small", align: "center" }, toolbar)),
            actions && (React.createElement(Box, { direction: "row", gap: "small", align: "center" }, actions))),
        contextualInfo && React.createElement(Box, null, contextualInfo)));
    if (size === 'large' || size === 'xlarge')
        return desktop;
    if (size === 'medium')
        return tablet;
    if (size === 'small')
        return mobile;
    return null;
};

const StyledIconButton = styled(IconButton).withConfig({ displayName: "StyledIconButton", componentId: "sc-uw8186" }) `
  height: 100%;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.199902);
`;
const Carousel = ({ gap, incrementBy = 1, maxItems = 3, children, dataTestId, rightEnd, animation: animate = true, activeIndexOnMount, }) => {
    const [firstItem, setFirstItem] = useState(0);
    const [animation, setAnimation] = useState();
    const [childernCount, setChildernCount] = useState(children.length);
    const animationDuration = 500;
    const slideIn = (side) => {
        return {
            type: side === 'left' ? 'slideLeft' : 'slideRight',
            delay: 0,
            duration: animationDuration,
            size: 'xlarge',
        };
    };
    const clearAnimation = () => {
        setTimeout(() => {
            setAnimation(undefined);
        }, animationDuration);
    };
    const leftArrowVisible = firstItem > 0;
    const rightArrowVisible = firstItem + maxItems < children.length;
    const handleRightClick = useCallback(() => {
        if (rightArrowVisible) {
            setFirstItem(firstItem + incrementBy);
            setAnimation(slideIn('left'));
            clearAnimation();
        }
    }, [firstItem, incrementBy, rightArrowVisible]);
    const handleLeftClick = () => {
        if (leftArrowVisible) {
            setFirstItem(firstItem - incrementBy);
            setAnimation(slideIn('right'));
            clearAnimation();
        }
    };
    const activeItems = children.slice(firstItem, firstItem + maxItems);
    useEffect(() => {
        if (rightEnd) {
            for (let i = 0; i < children.length; i++) {
                handleRightClick();
            }
        }
        if (children.length < childernCount) {
            handleLeftClick();
        }
        setChildernCount(children.length);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [children.length, rightEnd]);
    useEffect(() => {
        if (activeIndexOnMount !== undefined) {
            let rangeIndex = 0;
            const rangeArray = range(0, children.length);
            // Finding the range index which has activeIndexOnMount  in the activeItems set to show in UI
            rangeArray.some(idx => {
                const slicedItems = rangeArray.slice(idx, idx + maxItems);
                if (slicedItems.includes(activeIndexOnMount)) {
                    rangeIndex = idx;
                    return true;
                }
                return false;
            });
            setFirstItem(rangeIndex);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getIcon = (name, visible, onClick) => {
        return (React.createElement(StyledIconButton, { icon: name, onClick: onClick, disabled: !visible, size: "medium", dataTestId: `${dataTestId}-${name}` }));
    };
    const visibility = animation;
    return (React.createElement(Box, Object.assign({ direction: "row", fill: true, justify: "between", gap: "small", align: "center", background: "#f4f6f9", overflow: { vertical: 'hidden', horizontal: 'hidden' } }, getTestIdAttribute(dataTestId)),
        React.createElement("span", { style: animate
                ? { visibility: visibility ? 'hidden' : 'visible', alignSelf: 'stretch' }
                : { alignSelf: 'stretch' } }, getIcon('previous', leftArrowVisible, handleLeftClick)),
        React.createElement(Box, { animation: animate ? animation : undefined, direction: "row", gap: gap, pad: "medium", overflow: { vertical: 'hidden', horizontal: 'hidden' } }, activeItems),
        React.createElement("span", { style: animate
                ? { visibility: visibility ? 'hidden' : 'visible', alignSelf: 'stretch' }
                : { alignSelf: 'stretch' } }, getIcon('next', rightArrowVisible, handleRightClick))));
};

const Div$1 = styled.div.withConfig({ displayName: "Div", componentId: "sc-198i6ho" }) `
  display: flex;
  align-items: center;
  flex-flow: row wrap;
  row-gap: 12px;
  padding: 8px 0 8px 12px;
`;
const chipMixin = (props) => `
  display: flex;
  border-radius: 18px;
  height: 32px;
  background: ${getStyledInternalColor(props, 'solitude')};
  align-items: center;
  margin-right: 12px;
`;
const textMixin = (props) => `
  font-size: 14px;
  color: ${getStyledCuroColor(props, 'slate')};
`;
const ChipItem = styled.div.withConfig({ displayName: "ChipItem", componentId: "sc-1wj1y8s" }) `
  ${chipMixin}
`;
const Label = styled.span.withConfig({ displayName: "Label", componentId: "sc-1qkiu61" }) `
  margin: 0 12px 0 12px;
  white-space: nowrap;
  ${textMixin}
`;
const Count = styled.span.withConfig({ displayName: "Count", componentId: "sc-iw5plh" }) `
  ${textMixin}
  color: ${props => getStyledCuroColor(props, 'info')};
`;
const ClearAll = styled.span.withConfig({ displayName: "ClearAll", componentId: "sc-1hjwmgl" }) `
  font-size: 14px;
  color: ${props => getStyledCuroColor(props, 'info')};
  cursor: pointer;
`;
const StyledIconDiv = styled.div.withConfig({ displayName: "StyledIconDiv", componentId: "sc-1n92aru" }) `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18px;
  width: 18px;
  margin-right: 8px;
`;
const ShowMore = styled.span.withConfig({ displayName: "ShowMore", componentId: "sc-aa57ij" }) `
  cursor: pointer;
  ${chipMixin}
  padding: 0 5px;
`;
/** Tags are compact elements that represent an input, attribute, or action.
 */
const Tag = ({ label, onDelete, dataTestId }) => {
    return (React.createElement(ChipItem, Object.assign({ tabIndex: 0 }, getTestIdAttribute(dataTestId)),
        React.createElement(Label, null, label),
        React.createElement(StyledIconDiv, null,
            React.createElement(Icon, { name: "close", size: "medium", status: "slate", dataTestId: `${dataTestId}-close`, onClick: onDelete }))));
};
const TagContainer = ({ children, clearAllAction, showMore, dataTestId, }) => (React.createElement(Div$1, Object.assign({ tabIndex: 0 }, getTestIdAttribute(`${dataTestId}-container`)),
    children,
    showMore && (React.createElement(ShowMore, Object.assign({ onClick: showMore.onShowMore, tabIndex: 0 }, getTestIdAttribute(`${dataTestId}-show-more`)),
        React.createElement(Icon, { name: "add", size: "xsmall", status: "slate", dataTestId: `${dataTestId}-show-more-icon` }),
        React.createElement(Count, null, showMore.count ? showMore.count : 1))),
    clearAllAction && (React.createElement(ClearAll, Object.assign({ tabIndex: 0, onClick: clearAllAction }, getTestIdAttribute(`${dataTestId}-clear-all`)), getI18nStr('clearAll')))));

/* eslint-disable no-nested-ternary */
/** Breadcrumbs allow users to make selections from a range of values.
 */
const Breadcrumbs = ({ maxItems, options, status, noExpand, statusInfo, toolbar, 
// To-Do: Update the API name to be more appropriate
primary, onBreadcrumbClick, onPrimaryClick, dataTestId, }) => {
    if (statusInfo) {
        logger('statusInfo will be deprecated. Pass JSX Element for staus to show tooltip.', 'error');
    }
    const tooltipArr = [];
    Object.entries(options).map(() => tooltipArr.push(false));
    const [over, setOver] = useState(tooltipArr);
    // const [showStatusOnHover, setShowStatusOnHover] = useState<boolean>(false);
    // Added to prevent a change in the order of hooks
    const [optionsInstance] = useState(options);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const inputRef = optionsInstance.map(() => useRef(null));
    const statusRef = useRef();
    const visibleBreadcrumbs = [...options];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    let collapsedBreadcrumbs;
    const size = useContext(ResponsiveContext);
    const [responsiveMaxItems, setResponsiveMaxItems] = useState(maxItems || options.length);
    const [collapsed, setCollapsed] = useState(responsiveMaxItems < options.length);
    const [showPrimary, setShowPrimary] = useState(true);
    const [showUnderLine, setShowUnderLine] = useState(false);
    // const [pageTitleOnlyWithPrimary, setPageTitleOnlyWithPrimary] = useState<boolean>(false);
    // useEffect(() => {
    //   if (options.length === 1 && showPrimary && primary) {
    //     setPageTitleOnlyWithPrimary(true);
    //   }
    // }, [options, primary, showPrimary]);
    const colors = useCuroColors();
    if (toolbar && Array.isArray(toolbar) && toolbar.length > 2) {
        window.alert('The number of elements in toolbar can be a maximum of 2');
    }
    useEffect(() => {
        const setCollapsedBasedOnSize = (limit) => {
            if (options.length <= responsiveMaxItems ||
                (options.length <= limit && responsiveMaxItems >= limit))
                setCollapsed(false);
            else
                setCollapsed(true);
        };
        if (size === 'xlarge') {
            setResponsiveMaxItems(maxItems && maxItems < 4 ? maxItems : 4);
            setCollapsedBasedOnSize(4);
            setShowPrimary(true);
            setShowUnderLine(false);
        }
        else if (size === 'large') {
            setResponsiveMaxItems(maxItems && maxItems < 3 ? maxItems : 3);
            setCollapsedBasedOnSize(3);
            setShowPrimary(true);
            setShowUnderLine(false);
        }
        else if (size === 'medium' || size === 'small') {
            setResponsiveMaxItems(maxItems && maxItems < 1 ? maxItems : 1);
            setCollapsedBasedOnSize(1);
            if (options.length === 1)
                setShowPrimary(true);
            else
                setShowPrimary(false);
            setShowUnderLine(true);
        }
    }, [maxItems, options.length, responsiveMaxItems, size]);
    if (collapsed && responsiveMaxItems) {
        collapsedBreadcrumbs = visibleBreadcrumbs.splice(0, options.length - responsiveMaxItems);
    }
    const breadcrumbStyles = (index) => {
        const lastEl = index === visibleBreadcrumbs.length - 1;
        // To-Do: If the micro-app name has any breadcrumb nodes after it or a page title after it, style it as a green breadcrumb (normal 18px green). COnfirm with UX !
        // if (pageTitleOnlyWithPrimary) return '#2AA882';
        return {
            color: lastEl ? colors.default : over[index] ? colors.info : colors.gray,
            fontWeight: lastEl ? '600' : 'normal',
            fontSize: lastEl ? '24px' : '18px',
            cursor: lastEl ? 'auto' : 'pointer',
            whiteSpace: 'nowrap',
            textDecorationLine: showUnderLine || over[index] ? 'underline' : 'none',
            textDecorationStyle: showUnderLine || over[index] ? 'dotted' : undefined,
            textDecorationSkipInk: 'none',
            textAlign: 'center',
            margin: '0 10px',
        };
    };
    const statusAndToolbar = (isSmallScreen) => (React.createElement(React.Fragment, null,
        status && (React.createElement(React.Fragment, null,
            React.createElement(Box, Object.assign({ margin: { left: !showUnderLine ? '20px' : '0' }, pad: { right: '10px' }, gap: "5px", direction: "row", align: "center", ref: statusRef, onFocus: () => { }, onBlur: () => { } }, getTestIdAttribute(`${dataTestId}-status`)),
                typeof status === 'string' && (React.createElement(Box, { gap: "5px", direction: "row", align: "center" },
                    React.createElement(Icon, { name: status === 'online' ? 'success' : 'error', dataTestId: `${dataTestId}-status-icon`, status: isSmallScreen ? 'white' : 'default' }),
                    React.createElement(Text, { label: status, dataTestId: `${dataTestId}-status-Text`, status: isSmallScreen ? 'white' : 'default' }))),
                typeof status !== 'string' && status))),
        toolbar && (React.createElement(Box, { align: "center", gap: "10px", pad: { left: '10px' }, direction: "row", border: status ? { side: 'left' } : undefined }, toolbar))));
    const ContentComp = ({ option, index, }) => {
        let { as: Comp } = option;
        if (!Comp)
            Comp = Anchor;
        const target = (React.createElement(Comp, Object.assign({ href: Comp === Anchor && option.link ? option.link : undefined, to: Comp !== Anchor && option.link ? option.link : undefined }, getTestIdAttribute(`${dataTestId}-${option.dataTestId}-breadcrumb`), { style: breadcrumbStyles(index), ref: inputRef[index], onMouseEnter: 
            /* istanbul ignore next */ () => {
                const arr = [...over];
                arr[index] = true;
                setOver(arr);
            }, onMouseOut: 
            /* istanbul ignore next */ () => {
                const arr = [...over];
                arr[index] = false;
                setOver(arr);
            }, onFocus: /* istanbul ignore next */ () => { }, onBlur: /* istanbul ignore next */ () => { }, onClick: (e) => {
                // Tp-Do: This line added so the last breadcrumb's link is not functionable. Need to not allow link prop for last breadcrumb
                if (index === visibleBreadcrumbs.length - 1)
                    e.preventDefault();
                if (onBreadcrumbClick && index < options.length - 1) {
                    e.preventDefault();
                    onBreadcrumbClick(option);
                }
            }, tabIndex: 0 }), option.label));
        return (React.createElement(React.Fragment, { key: index.toString() },
            collapsed && index === 0 && (React.createElement(Box, { pad: { horizontal: 'xsmall' }, style: { cursor: !noExpand ? 'pointer' : 'no-drop' }, align: "center", tabIndex: 0 },
                React.createElement(Tooltip, { dataTestId: `${dataTestId}-collapsed-tip`, target: React.createElement(IconButton, { icon: "more", size: "small", dataTestId: `${dataTestId}-collapsed`, onClick: () => {
                            if (!noExpand) {
                                setCollapsed(false);
                            }
                        } }), tooltip: React.createElement(React.Fragment, null,
                        !showPrimary && primary && (React.createElement(Box, { margin: { vertical: 'xsmall' }, style: { color: colors.brand } },
                            React.createElement(Text, { label: primary.label, dataTestId: `${dataTestId}-primary-label`, status: "white" }))),
                        collapsedBreadcrumbs &&
                            collapsedBreadcrumbs.map((breadcrumb, i) => (React.createElement(Box, { key: i.toString(), margin: { vertical: 'xsmall' } },
                                React.createElement(Text, { label: breadcrumb.label, dataTestId: `${dataTestId}-breadcrumb-${i}`, status: "white" }))))) }))),
            (index !== 0 || collapsed) && React.createElement("span", { style: { color: colors.default } }, "/"),
            option.tooltip ? (React.createElement(Tooltip, { dataTestId: option.dataTestId || 'breaducrumb-option', target: target, tooltip: React.createElement(Box, { direction: "column", align: "center", gap: "medium", style: { color: colors.white } },
                    option.tooltip,
                    size === 'small' && (React.createElement(Box, { direction: "row", align: "center" }, statusAndToolbar(true)))), underline: false })) : (target)));
    };
    const [overPrimary, setOverPrimary] = useState(false);
    const ShowPrimary = () => {
        let { as: Comp } = primary;
        if (!Comp)
            Comp = Anchor;
        return (React.createElement(React.Fragment, null,
            React.createElement(Comp, Object.assign({ href: Comp === Anchor ? primary === null || primary === void 0 ? void 0 : primary.link : undefined, to: Comp !== Anchor ? primary === null || primary === void 0 ? void 0 : primary.link : undefined, style: {
                    fontWeight: 'normal',
                    fontSize: '21px',
                    textDecorationLine: overPrimary ? 'underline' : 'none',
                    textDecorationStyle: overPrimary ? 'dotted' : undefined,
                    textDecorationSkipInk: 'none',
                    textAlign: 'center',
                    color: overPrimary ? colors.info : colors.brand,
                } }, getTestIdAttribute((primary === null || primary === void 0 ? void 0 : primary.dataTestId) && `${dataTestId}-${primary.dataTestId}-breadcrumb`), { onClick: 
                /* istanbul ignore next */ (e) => {
                    if (onPrimaryClick) {
                        e.preventDefault();
                        onPrimaryClick();
                    }
                }, onMouseOver: () => setOverPrimary(true), onMouseLeave: () => setOverPrimary(false), onFocus: () => { }, onBlur: () => { }, tabIndex: 0 }), primary === null || primary === void 0 ? void 0 : primary.label),
            React.createElement("span", { style: { color: colors.default, marginLeft: '8px' } }, "/")));
    };
    return (React.createElement(Box, Object.assign({ direction: "row", align: "center" }, getTestIdAttribute(dataTestId)),
        showPrimary && primary && React.createElement(ShowPrimary, null),
        !collapsed &&
            options.map((option, index) => (React.createElement(ContentComp, { option: option, index: index, key: option.label }))),
        collapsed &&
            visibleBreadcrumbs.map((option, index) => (React.createElement(ContentComp, { option: option, index: index, key: option.label }))),
        size !== 'small' && React.createElement(Box, { direction: "row" }, statusAndToolbar(false))));
};

const useFormField = () => { };
const FormContext = createContext({ useFormField });

/* eslint-disable no-restricted-syntax */
const ErrorBox = styled(Box).withConfig({ displayName: "ErrorBox", componentId: "sc-d4lg2n" }) `
  transition: all 0.1s ease;
  box-shadow: ${props => !props['data-visible'] && props['data-browsersupport'] ? '0 6px 4px -4px #ddd' : ''};
  position: ${props => (props['data-browsersupport'] ? 'sticky' : '')};
  top: ${props => (props['data-browsersupport'] ? '-1px' : '')};
  z-index: ${ZIndex.formHeader};
`;
const FooterBox = styled(Box).withConfig({ displayName: "FooterBox", componentId: "sc-1c49ewp" }) `
  transition: all 0.1s ease;
  box-shadow: ${props => !props['data-visible'] && props['data-browsersupport'] ? '0 -4px 10px -4px #9c9c9c' : ''};
  position: ${props => (props['data-browsersupport'] ? 'sticky' : '')};
  bottom: ${props => (props['data-browsersupport'] ? '0' : '')};
  z-index: ${ZIndex.formFooter};
`;
const Div = styled.div.withConfig({ displayName: "Div", componentId: "sc-f1zxdq" }) `
  height: 0.5px;
`;
/**
 * There are two primary ways of managing Form state. <br>
 * <u>Controlled</u>:
 * A controlled Form is similar to a controlled input element in React. The value state is held by the caller and connected to the Form via value and onChange.<br>
 * <u>Uncontrolled</u>:
 * An uncontrolled Form is similar to an uncontrolled input element in React. The value state is held by the Form.
 * <br />
 * Link to UX Pattern: https://confluence.eng.nimblestorage.com/display/UX/Forms+Pattern
 */
const Form = (props) => {
    const { formTitle, submitButtonContent, submitButtonDisabled, resetButtonContent, children, onValidate, cancelButtonContent, validate = 'blur', onCancel, alignFormFooter = 'end', customError, noStickyFooter = false, dataTestId, id, } = props;
    const white = useCuroColor('white');
    const allowedProps = ['onSubmit', 'onCancel', 'onReset', 'onChange', 'children', 'value'];
    const size = useContext(ResponsiveContext);
    const updatedProps = Object.keys(props)
        .filter(key => allowedProps.includes(key))
        .reduce((obj, key) => {
        // eslint-disable-next-line no-param-reassign
        obj[key] = props[key];
        return obj;
    }, {});
    const stickyError = useRef(null);
    const stickyFooter = useRef(null);
    const [isTopSentinelVisible, setTopSentinelsVisibility] = useState(undefined);
    const [isBottomSentinelVisible, setBottomSentinelsVisibility] = useState(undefined);
    // Using seperate useEffects to prevent memory leak
    useEffect(() => {
        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(([entry]) => setTopSentinelsVisibility(entry.isIntersecting));
            const observable = stickyError.current;
            if (observable) {
                observer.observe(observable);
            }
            return () => {
                observer.unobserve(observable);
            };
        }
        return undefined;
    }, []);
    // Using seperate useEffects to prevent memory leak
    useEffect(() => {
        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(([entry]) => setBottomSentinelsVisibility(entry.isIntersecting));
            const observable = stickyFooter.current;
            if (observable) {
                observer.observe(observable);
            }
            return () => {
                if (observable)
                    observer.unobserve(observable);
            };
        }
        return undefined;
    }, []);
    const isFooterPresent = submitButtonContent || resetButtonContent || cancelButtonContent;
    // To-Do: Had to check for type of button content as CURO button only allows string type for label prop
    const generateSubmitButton = () => {
        if (submitButtonContent && typeof submitButtonContent === 'string') {
            return (React.createElement(Button$1, { type: "submit", dataTestId: `${dataTestId}-submit-button`, label: submitButtonContent, disabled: submitButtonDisabled }));
        }
        if (submitButtonContent) {
            return (React.createElement(Button$1, { type: "submit", dataTestId: `${dataTestId}-submit-button`, disabled: submitButtonDisabled }, submitButtonContent));
        }
        return undefined;
    };
    // To-Do: Had to check for type of button content as CURO button only allows string type for label prop
    const generateResetButton = () => {
        if (resetButtonContent && typeof resetButtonContent === 'string') {
            return (React.createElement(Button$1, { label: resetButtonContent, type: "reset", dataTestId: `${dataTestId}-reset-button` }));
        }
        if (resetButtonContent) {
            return (React.createElement(Button$1, { type: "reset", dataTestId: `${dataTestId}-reset-button` }, resetButtonContent));
        }
        return undefined;
    };
    // To-Do: Had to check for type of button content as CURO button only allows string type for label prop
    const generateCancelButton = () => {
        if (cancelButtonContent && typeof cancelButtonContent === 'string') {
            return (React.createElement(Button$1, { dataTestId: `${dataTestId}-cancel-button`, label: cancelButtonContent, type: "tertiary", onClick: 
                /* istanbul ignore next */
                (e) => {
                    if (onCancel)
                        onCancel(e);
                } }));
        }
        if (cancelButtonContent) {
            return (React.createElement(Button$1, { dataTestId: `${dataTestId}-cancel-button`, type: "tertiary", onClick: 
                /* istanbul ignore next */
                (e) => {
                    if (onCancel)
                        onCancel(e);
                } }, cancelButtonContent));
        }
        return undefined;
    };
    const footer = () => {
        return (React.createElement(FooterBox, { direction: "row", pad: { vertical: 'small' }, wrap: size === 'small', gap: size === 'small' ? 'none' : 'small', justify: alignFormFooter, background: `${!isBottomSentinelVisible && !noStickyFooter ? white : ''}`, "data-visible": !noStickyFooter && isBottomSentinelVisible, "data-browsersupport": !noStickyFooter && 'IntersectionObserver' in window },
            generateCancelButton(),
            generateResetButton(),
            generateSubmitButton()));
    };
    // const [formFieldCount, setFormFieldCount] = useState(0);
    // useEffect(() => {
    //   let counter = 0;
    //   // @ts-ignore
    //   const childType = (child: any) => {
    //     if (!child) return true;
    //     if (Array.isArray(child)) {
    //       return child.map((el: any) => childType(el));
    //     }
    //     if (
    //       (child.type.displayName === 'FormField' || child.type.name === 'FormField') &&
    //       (child.props.validate || child.props.required)
    //     ) {
    //       counter++;
    //       return true;
    //     }
    //     return childType(child.props.children);
    //   };
    //   React.Children.map(children, child => {
    //     childType(child);
    //   });
    //   setFormFieldCount(counter);
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);
    const [, setFieldState] = useState();
    const useFormField = ({ name, required, validate: validateArg }) => {
        useEffect(() => {
            setFieldState((prevValue) => {
                // @ts-ignore
                const nextValue = Object.assign({}, prevValue);
                if (required) {
                    nextValue[name] = true;
                }
                return nextValue;
            });
        }, [name, required, validateArg]);
    };
    const CustomOnValidate = (validationResults) => {
        const customValidationResults = { infos: {}, errors: {}, valid: validationResults.valid };
        const { infos, errors } = customValidationResults;
        Object.entries(validationResults.infos).map(([key, value]) => {
            if (typeof value === 'string')
                infos[key] = value;
            else
                infos[key] = value && value.props && value.props.children[1].props.children;
            return undefined;
        });
        Object.entries(validationResults.errors).map(([key, value]) => {
            if (typeof value === 'string')
                errors[key] = value;
            else
                errors[key] = value && value.props && value.props.children[1].props.children;
            return undefined;
        });
        return onValidate && onValidate(customValidationResults);
    };
    return (React.createElement(Form$1, Object.assign({}, updatedProps, { onValidate: CustomOnValidate, validate: validate, messages: { required: 'Required' }, 
        //to-do: Validate the use case of using overflow
        style: { overflow: 'auto', maxHeight: '100%', padding: '0 3px 0 3px' } }, getTestIdAttribute(dataTestId), { id: id }),
        React.createElement(Div, Object.assign({}, getTestIdAttribute(`${dataTestId}-top-sentinel`), { ref: stickyError })),
        (formTitle || customError) && (React.createElement(ErrorBox, { pad: { vertical: 'small' }, background: `${!isTopSentinelVisible ? white : ''}`, "data-visible": isTopSentinelVisible, "data-browsersupport": 'IntersectionObserver' in window },
            formTitle && React.createElement(Text, { label: formTitle, type: "title3", dataTestId: `${dataTestId}-title` }),
            customError && (React.createElement(Box, Object.assign({}, getTestIdAttribute(`${dataTestId}-custom-error`)), customError)))),
        React.createElement(FormContext.Provider, { value: { useFormField } }, children),
        isFooterPresent && (React.createElement(React.Fragment, null,
            footer(),
            React.createElement(Div, Object.assign({}, getTestIdAttribute(`${dataTestId}-bottom-sentinel`), { ref: stickyFooter }))))));
};

const FieldSet = ({ fieldSetTitle, fieldSetDesc, dataTestId, tooltip, children, }) => {
    return (React.createElement(Box, Object.assign({}, getTestIdAttribute(dataTestId)),
        (fieldSetTitle || fieldSetDesc) && (React.createElement(Box, { pad: { vertical: 'small' } },
            React.createElement(Row, { noPad: true },
                fieldSetTitle && (React.createElement(Text, { label: fieldSetTitle, type: "title4", dataTestId: `${dataTestId}-title` })),
                tooltip && (React.createElement(Tooltip, { tooltip: tooltip, target: React.createElement(Box, { margin: { left: '4px' } },
                        React.createElement(Icon, { name: "info", dataTestId: `${dataTestId}-info-tooltip`, status: "info", size: "xsmall" })), dataTestId: `${dataTestId}-info-tooltip-content` }))),
            fieldSetDesc && (React.createElement(Text, { label: fieldSetDesc, type: "paragraph", dataTestId: `${dataTestId}-desc` })))),
        children));
};

/* eslint-disable @typescript-eslint/indent */
const getBg = (props) => {
    if (props.disabled) {
        return getStyledInternalColor(props, 'lighterGray');
    }
    return getStyledCuroColor(props, 'white');
};
const StyledGrommetFormField = styled(FormField$1).withConfig({ displayName: "StyledGrommetFormField", componentId: "sc-1g5p0ta" }) `
  & input {
    border: none;
  }
  & label + div {
    background-color: ${props => getBg(props)};
    pointer-events: ${props => (props.disabled ? 'none' : 'initial')};
  }
  //When label is not passed to form field, the next line will apply the style to 'div' as label+div wont work if label is not there.
  & > :first-child {
    background-color: ${props => (!props.label ? getBg(props) : '')};
    pointer-events: ${props => (props.disabled ? 'none' : 'initial')};
  }
  // Refer to line 188 of themeConstants
  div:nth-child(3) {
    margin-bottom: 0;
  }
  & button {
    border: none;
  }
`;
const FormField = (props) => {
    const { name } = props;
    const { tooltip, label, children, validate, required, customError, border = true, dataTestId = name, } = props;
    if (label && typeof label !== 'string')
        logger('FormField label only supports string type, Other types were deprecated', 'error');
    const form = useContext(FormContext);
    // @ts-ignore
    form.useFormField({
        name,
        required,
        validate,
    });
    const toolTip = tooltip && label && (React.createElement(Tooltip, { tooltip: tooltip, target: React.createElement(Box, { margin: { left: '4px' } },
            React.createElement(Icon, { name: "info", dataTestId: `${dataTestId}-info-tooltip`, status: "info", size: "xsmall" })), dataTestId: `${dataTestId}-info-tooltip-content` }));
    const fieldLabel = (React.createElement(Box, Object.assign({ direction: "row", align: "center" }, getTestIdAttribute(`${dataTestId}-label`)),
        required && label ? (React.createElement(Box, { direction: "row", gap: "xxsmall", align: "center" },
            React.createElement(Text$1, { style: { lineHeight: '0px' }, color: "status-critical" }, "*"),
            label)) : (label),
        toolTip));
    let { name: elType } = children && children.type;
    const { displayName: elTypeAlt } = children && children.type;
    const { invalid } = children && children.props;
    if (!elType && elTypeAlt)
        elType = elTypeAlt;
    const noBorderInputs = [
        'CheckBox',
        'RadioButton',
        'RadioButtonGroup',
        elType === 'TextInput' && invalid ? 'TextInput' : null,
    ];
    const colors = useCuroColors();
    const errorMessage = (status, message) => (React.createElement(Row, { wrap: false, align: "start", noPad: true, dataTestId: `${dataTestId}-validation-message` },
        status === 'error' && (
        // height of icon must be equal to the line height of sibling text
        React.createElement(Box, { flex: { shrink: 0 }, height: "20px", justify: "center" },
            React.createElement(Icon, { name: "error", size: "xxsmall", status: "error", dataTestId: `${dataTestId}-validation-icon` }))),
        React.createElement(Text$1, { margin: {
                left: `${status === 'error' ? '4px' : null}`,
            }, style: {
                fontSize: '14px',
                lineHeight: '20px',
                color: status === 'error' ? colors.error : colors.default,
            } }, message)));
    const validatorFunctionArray = validate &&
        validate.map((validation) => {
            if (typeof validation === 'object') {
                const { regexp, status, message } = validation;
                return {
                    regexp,
                    message: errorMessage(status, message),
                    status,
                };
            }
            return (value) => {
                const validationResult = validation(value);
                const { status = undefined, message = undefined } = validationResult || {};
                return (validationResult && {
                    message: errorMessage(status, message),
                    status,
                });
            };
        });
    const customErrorFormatted = () => errorMessage('error', customError);
    const hideBorder = () => {
        if (noBorderInputs.includes(elType))
            return true;
        if (!border)
            return true;
        return false;
    };
    return (React.createElement(StyledGrommetFormField, Object.assign({}, getTestIdAttribute(dataTestId), props, { validate: validatorFunctionArray, 
        // This change where we hide the border for checkbox & radio is not working for fleet app in staging, hence added parent ref no border for check,radio seperately
        contentProps: { border: { color: hideBorder() ? 'transparent !important' : undefined } }, label: label ? fieldLabel : undefined, error: customError ? customErrorFormatted() : undefined })));
};

const StyledSelect = styled(Select$1).withConfig({ displayName: "StyledSelect", componentId: "sc-1kin02f" }) `
  ::placeholder {
    color: ${props => getStyledCuroColor(props, 'disabled')};
  }
  font-size: 16px;
`;
const Select = (props) => {
    const { name } = props;
    const { dataTestId = name } = props;
    return React.createElement(StyledSelect, Object.assign({}, getTestIdAttribute(dataTestId), props));
};

const StyledSelectMultiple = styled(SelectMultiple$1).withConfig({ displayName: "StyledSelectMultiple", componentId: "sc-cixfip" }) `
  ::placeholder {
    color: ${props => getStyledCuroColor(props, 'disabled')};
  }
  font-size: 16px;
`;
const SelectMultiple = (props) => {
    const { name } = props;
    const { dataTestId = name } = props;
    return (React.createElement(ThemeContext.Extend, { value: {
            button: {
                default: {
                    color: useCuroColor('info'),
                    font: {
                        size: 'xsmall'
                    },
                },
                hover: {
                    extend: {
                        textDecoration: 'underline'
                    }
                },
                extend: {
                    text: {
                        font: {
                            weight: 'normal',
                        },
                    }
                }
            },
        } },
        React.createElement(StyledSelectMultiple, Object.assign({}, getTestIdAttribute(dataTestId), props))));
};

/* eslint-disable @typescript-eslint/indent */
const RadioButtonGroup = (props) => {
    const { name } = props;
    const { dataTestId = name } = props;
    const ref = useRef(null);
    useEffect(() => {
        var _a;
        if (((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.parentElement.className.search('FormField')) !== -1) {
            ref.current.parentElement.style.border = 'none';
        }
    }, []);
    return React.createElement(RadioButtonGroup$1, Object.assign({ ref: ref }, getTestIdAttribute(dataTestId), props));
};

const RadioButton = (props) => {
    const { name } = props;
    const { selected, dataTestId = name } = props;
    const ref = useRef(null);
    useEffect(() => {
        var _a;
        if (((_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.parentElement.className.search('FormField')) !== -1) {
            ref.current.parentElement.style.border = 'none';
        }
    }, []);
    return (React.createElement(RadioButton$1, Object.assign({ ref: ref }, getTestIdAttribute(dataTestId), { checked: selected }, props)));
};

const StyledBox$1 = styled(Box).withConfig({ displayName: "StyledBox", componentId: "sc-1jb1e9s" }) `
  // Added this to overwrite browser's default styling on input fields
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
  }
  input:-webkit-autofill {
    -webkit-text-fill-color: ${props => getStyledCuroColor(props, 'default')};
  }
`;
const StyledTextInput$2 = styled(TextInput$1).withConfig({ displayName: "StyledTextInput", componentId: "sc-ufr4jo" }) `
  ::placeholder {
    color: ${props => getStyledCuroColor(props, 'disabled')};
  }
  &:focus {
    box-shadow: none;
  }
  ::-ms-reveal,
  ::-ms-clear {
    display: none;
  }
  font-size: 16px;
`;
const MaskedInput = styled(MaskedInput$1).withConfig({ displayName: "MaskedInput", componentId: "sc-nq17n0" }) `
  ::placeholder {
    color: ${props => getStyledCuroColor(props, 'disabled')};
  }
  &:focus {
    box-shadow: none;
  }
  font-size: 16px;
`;
const TextInput = (props) => {
    const { name } = props;
    const { type, value, onChange, readOnly, disabled, dataTestId = name, showPassword = true, placeholder, className, mask, invalid, } = props;
    const colors = useColors();
    const [reveal, setReveal] = useState(false);
    const [, setReadOnlyPassword] = useState(true);
    const [, setPasswordInFocus] = useState(false);
    const [inFormfield, setInFormfield] = useState(true);
    const pwdRef = useRef(null);
    const IPv4ElementRegExp = /^[0-1][0-9][0-9]$|^2[0-4][0-9]$|^25[0-5]$|^[0-9][0-9]$|^[0-9]$/;
    const errorBorderStyling = {
        border: invalid ? `solid 1px ${colors.error}` : undefined,
    };
    if (type && mask)
        logger('Passing mask along with type will render mask useless');
    useEffect(() => {
        var _a;
        if (((_a = pwdRef === null || pwdRef === void 0 ? void 0 : pwdRef.current) === null || _a === void 0 ? void 0 : _a.parentElement.className.search('FormField')) === -1) {
            setInFormfield(false);
        }
        else {
            setInFormfield(true);
        }
    }, []);
    if (type === 'ipv4')
        return (React.createElement(MaskedInput, Object.assign({ mask: [
                {
                    length: [1, 3],
                    regexp: IPv4ElementRegExp,
                    placeholder: 'xxx',
                },
                { fixed: '.' },
                {
                    length: [1, 3],
                    regexp: IPv4ElementRegExp,
                    placeholder: 'xxx',
                },
                { fixed: '.' },
                {
                    length: [1, 3],
                    regexp: IPv4ElementRegExp,
                    placeholder: 'xxx',
                },
                { fixed: '.' },
                {
                    length: [1, 3],
                    regexp: IPv4ElementRegExp,
                    placeholder: 'xxx',
                },
            ], value: value, onChange: onChange, readOnly: readOnly, name: name, disabled: disabled, className: className, style: errorBorderStyling }, getTestIdAttribute(dataTestId))));
    if (type === 'email')
        return (React.createElement(MaskedInput, Object.assign({ mask: [
                {
                    regexp: /^[\w\-_.]+$/,
                    placeholder: getI18nStr('example'),
                },
                { fixed: '@' },
                {
                    regexp: /^[\w]+$/,
                    placeholder: getI18nStr('my'),
                },
                { fixed: '.' },
                {
                    regexp: /^[\w]+$/,
                    placeholder: getI18nStr('com'),
                },
            ], value: value, onChange: onChange, readOnly: readOnly, name: name, disabled: disabled, className: className, style: errorBorderStyling }, getTestIdAttribute(dataTestId))));
    if (type === 'date')
        return (React.createElement(MaskedInput, Object.assign({ mask: [
                {
                    length: [1, 2],
                    regexp: /^1[0,1-2]$|^0?[1-9]$|^0$/,
                    placeholder: getI18nStr('mm'),
                },
                { fixed: '/' },
                {
                    length: [1, 2],
                    regexp: /^[1-2][0-9]$|^3[0-1]$|^0?[1-9]$|^0$/,
                    placeholder: getI18nStr('dd'),
                },
                { fixed: '/' },
                {
                    length: 4,
                    regexp: /^[1-2]$|^19$|^20$|^19[0-9]$|^20[0-9]$|^19[0-9][0-9]$|^20[0-9][0-9]$/,
                    placeholder: getI18nStr('yyyy'),
                },
            ], value: value, onChange: onChange, readOnly: readOnly, name: name, disabled: disabled, className: className, style: errorBorderStyling }, getTestIdAttribute(dataTestId))));
    if (type === 'size')
        return (React.createElement(MaskedInput, Object.assign({ mask: [
                {
                    length: [1, 4],
                    options: [1, 2, 4, 8, 16, 32, 64, 128, 256, 512, 1024],
                    regexp: /^\d{1,4}$/,
                    placeholder: getI18nStr('nnn'),
                },
                { fixed: ' ' },
                {
                    length: 2,
                    options: [getI18nStr('MB'), getI18nStr('GB'), getI18nStr('TB')],
                    regexp: /^[mgt]b$|^[MGT]B$|^[mMgGtT]$/,
                    placeholder: getI18nStr('gb'),
                },
            ], value: value, readOnly: readOnly, onChange: onChange, name: name, disabled: disabled, className: className, style: errorBorderStyling }, getTestIdAttribute(dataTestId))));
    if (type === 'dateRange')
        return (React.createElement(MaskedInput, Object.assign({ mask: [
                {
                    length: [1, 2],
                    regexp: /^1[0,1-2]$|^0?[1-9]$|^0$/,
                    placeholder: getI18nStr('mm'),
                },
                { fixed: '/' },
                {
                    length: [1, 2],
                    regexp: /^[1-2][0-9]$|^3[0-1]$|^0?[1-9]$|^0$/,
                    placeholder: getI18nStr('dd'),
                },
                { fixed: '/' },
                {
                    length: 4,
                    regexp: /^[1-2]$|^19$|^20$|^19[0-9]$|^20[0-9]$|^19[0-9][0-9]$|^20[0-9][0-9]$/,
                    placeholder: getI18nStr('yyyy'),
                },
                { fixed: ' - ' },
                {
                    length: [1, 2],
                    regexp: /^1[0,1-2]$|^0?[1-9]$|^0$/,
                    placeholder: getI18nStr('mm'),
                },
                { fixed: '/' },
                {
                    length: [1, 2],
                    regexp: /^[1-2][0-9]$|^3[0-1]$|^0?[1-9]$|^0$/,
                    placeholder: getI18nStr('dd'),
                },
                { fixed: '/' },
                {
                    length: 4,
                    regexp: /^[1-2]$|^19$|^20$|^19[0-9]$|^20[0-9]$|^19[0-9][0-9]$|^20[0-9][0-9]$/,
                    placeholder: getI18nStr('yyyy'),
                },
            ], value: value, readOnly: readOnly, name: name, onChange: onChange, disabled: disabled, className: className, style: errorBorderStyling }, getTestIdAttribute(dataTestId))));
    const setBorder = () => {
        if (invalid)
            return `solid 1px ${colors.error}`;
        if (!inFormfield)
            return `1px solid ${colors.gainsboro}`;
        return undefined;
    };
    if (type === 'password' && showPassword)
        // Grommet's TextInput has a Icon prop but it is not clickable
        return (React.createElement(StyledBox$1, { direction: "row", style: { border: setBorder() }, round: "4px", ref: pwdRef, align: "center" },
            React.createElement(StyledTextInput$2, Object.assign({ plain: true, type: reveal ? 'text' : 'password' }, getTestIdAttribute(dataTestId), { value: value, name: name, onChange: onChange, autoComplete: "new-password", 
                // Prevent auto-fill
                // To-Do: Commented auto-fill functionality for time being based on
                // automation QA teams request, will uncomment once QA team is able to update their tests
                // readOnly={readOnlyPassword}
                // readOnly={readOnlyPassword}
                onFocus: () => {
                    setReadOnlyPassword(false);
                    setPasswordInFocus(true);
                }, onBlur: () => setPasswordInFocus(false), disabled: disabled, className: className, placeholder: placeholder })),
            React.createElement(Box, { margin: { horizontal: 'small' } },
                React.createElement(Icon, { name: reveal ? 'show' : 'hide', size: "large", onClick: () => setReveal(!reveal), dataTestId: `${dataTestId}-password-visibility` }))));
    if (type === 'password' && !showPassword)
        // Grommet's TextInput has a Icon prop but it is not clickable
        return (React.createElement(StyledTextInput$2, Object.assign({ style: errorBorderStyling, type: "password" }, getTestIdAttribute(dataTestId), props)));
    return mask ? (React.createElement(MaskedInput, Object.assign({ style: errorBorderStyling, type: type }, getTestIdAttribute(dataTestId), props))) : (React.createElement(StyledTextInput$2, Object.assign({ style: errorBorderStyling, type: type }, getTestIdAttribute(dataTestId), props)));
};

const StyledTextArea = styled(TextArea$1).withConfig({ displayName: "StyledTextArea", componentId: "sc-vvm3xe" }) `
  ::placeholder {
    color: ${props => getStyledCuroColor(props, 'disabled')};
  }
`;
const TextArea = (props) => {
    const { name } = props;
    const { noOfLines = 5, dataTestId = name } = props;
    return React.createElement(StyledTextArea, Object.assign({}, getTestIdAttribute(dataTestId), { rows: noOfLines }, props));
};

const DateSelector = (props) => {
    const { name } = props;
    const { dataTestId = name } = props;
    // @ts-ignore
    return React.createElement(DateInput, Object.assign({ format: "mm/dd/yyyy" }, getTestIdAttribute(dataTestId), props));
};

const StyledTextInput$1 = styled.input.withConfig({ displayName: "StyledTextInput", componentId: "sc-goy6o9" }) `
  font-family: monospace;
  border-radius: 6px;
  border: 1px solid lightgrey;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px 0px;
  margin: 4px;
  padding-left: 8px;
  width: 36px;
  height: 42px;
  font-size: 32px;
  box-sizing: border-box;
  color: ${props => getStyledCuroColor(props, 'default')};
  background-color: ${props => getStyledCuroColor(props, 'white')};
  &:focus {
    outline-color: ${props => getStyledInternalColor(props, 'focus')};
  }
`;
const DigitInput = (props) => {
    const { numOfDigits = 6, type = 'number', onChange, dataTestId } = props;
    const [valueChanged, setValueChanged] = useState(false);
    const inputRef = Array(numOfDigits)
        .fill(0)
        // eslint-disable-next-line react-hooks/rules-of-hooks
        .map(() => useRef(null));
    const checkType = (entry) => {
        if (type === 'number' && /^\d+$/.test(entry))
            return true;
        if (type === 'letter' && /^[a-zA-Z]+$/.test(entry))
            return true;
        return undefined;
    };
    const handleBackspace = (e, index) => {
        e.preventDefault();
        setValueChanged(true);
        if (index === 0)
            e.target.value = '';
        if (inputRef[index - 1] && inputRef[index - 1].current) {
            inputRef[index - 1].current.focus();
            inputRef[index - 1].current.select();
            e.target.value = '';
        }
    };
    useEffect(() => {
        let value = '';
        for (let i = 0; i < numOfDigits; i++) {
            value += inputRef[i].current.value;
        }
        if (onChange && valueChanged)
            onChange(value);
        setValueChanged(false);
    }, [numOfDigits, inputRef, onChange, valueChanged]);
    return (React.createElement(Box, { direction: "row", align: "center", "data-test-id": dataTestId }, Array(numOfDigits)
        .fill(0)
        .map((_val, index) => (React.createElement(Keyboard, { key: index, onBackspace: (e) => handleBackspace(e, index) },
        React.createElement(StyledTextInput$1, { ref: inputRef[index], maxLength: 1, "data-test-id": `input-${index}`, onChange: (e) => {
                setValueChanged(true);
                const currentEntry = e.target.value;
                if (!checkType(currentEntry))
                    e.target.value = '';
                else if (inputRef[index + 1] && inputRef[index + 1].current) {
                    inputRef[index + 1].current.focus();
                }
            } }))))));
};

const SIZE = {
    B: 'bytes',
    KB: 'KB',
    MB: 'MB',
    GB: 'GB',
};
const calculateFileSize = (size) => {
    let adjustedSize = size;
    let count = 0;
    let suffix;
    while (adjustedSize > 1000) {
        adjustedSize /= 1000;
        count += 1;
    }
    if (count === 0) {
        suffix = SIZE.B;
    }
    else if (count === 1) {
        suffix = SIZE.KB;
    }
    else if (count === 2) {
        suffix = SIZE.MB;
    }
    else {
        suffix = SIZE.GB;
    }
    const calculatedSize = {
        value: adjustedSize,
        suffix,
    };
    return calculatedSize;
};

const fileType = ['image/png', 'image/jpeg', 'image/apng', 'image/avif', 'image/gif', 'image/svg+xml', 'image/webp', 'image/bmp', 'image/x-icon', 'image/tiff'];
const FileInfo = ({ file, showPreview, showFileSize, removeFile }) => {
    const colors = useColors();
    return (React.createElement(React.Fragment, null,
        showPreview && (React.createElement(Box, { width: "xxsmall", height: "xxsmall" }, fileType.includes(file.type) ? (React.createElement(Image$1, { src: file.preview, fit: "cover" })) : (React.createElement(Column, { align: "center" },
            React.createElement(Icon, { size: "large", name: "doc", dataTestId: "file-preview-icon" }))))),
        React.createElement(Column, { noPad: true, align: "center" },
            React.createElement(Text$1, { color: colors.default, weight: 400 }, file.name)),
        showFileSize && (React.createElement(Column, { noPad: true },
            React.createElement(Row, { noPad: true },
                React.createElement(Column, { noPad: true },
                    React.createElement(Text$1, { textAlign: "center", color: colors.default, weight: 400 },
                        calculateFileSize(file.size).value.toFixed(1),
                        " ",
                        calculateFileSize(file.size).suffix)),
                React.createElement(Column, { pad: { left: 'small' }, align: "end" },
                    React.createElement(RemoveButton, { file: file, removeFile: removeFile })))))));
};
const RemoveButton = ({ file, removeFile }) => (React.createElement(Icon, { name: "remove", dataTestId: "remove", onClick: () => removeFile(file), size: 'xsmall' }));

const File = ({ file, removeFile, showPreview, showFileSize }) => {
    return (React.createElement(Row, { fill: "horizontal", justify: 'between', pad: { bottom: 'small' } },
        React.createElement(FileInfo, { file: file, showFileSize: showFileSize, showPreview: showPreview, removeFile: removeFile })));
};

const DropzoneContainer = forwardRef((_a, ref) => {
    var { children, isDragActive, files, error } = _a, rest = __rest(_a, ["children", "isDragActive", "files", "error"]);
    const colors = useColors();
    const dragActiveBorder = useChartColor('series1');
    return (React.createElement(Box, Object.assign({ background: colors.white, border: {
            color: isDragActive ? dragActiveBorder : error ? colors.error : colors.disabled,
            style: 'dashed',
            size: 'small',
        }, height: {
            min: 'small',
        }, align: files.length ? 'stretch' : 'center', justify: "center", pad: "xsmall", ref: ref }, rest), children));
});

const DefaultMessage = ({ dataTestId }) => {
    const info = useCuroColor('info');
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { status: 'gray', dataTestId: `${dataTestId}-default-drop-message`, type: "title4", weight: "normal" }, "Drag and drop files to attach"),
        React.createElement(Text, { status: 'gray', dataTestId: `${dataTestId}-default-drop-message`, type: "title4", weight: "normal" },
            "or ",
            React.createElement(Anchor, { color: info }, "browse"),
            " your files to upload.")));
};

/* eslint-disable react/no-array-index-key */
const Dropzone = ({ accept, maxSize, minSize, multiple, onAddFiles, uploadError, showPreview, myFiles, setMyFiles, disabled, dataTestId, setRejectedFiles, }) => {
    const containerRef = createRef();
    const [error, setError] = useState(false);
    const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
        /* istanbul ignore else */
        if (uploadError)
            uploadError(rejectedFiles.map((file) => file.errors[0]));
        if (rejectedFiles.length > 0) {
            setRejectedFiles(rejectedFiles);
            setError(true);
        }
        /* istanbul ignore else */
        if (!disabled) {
            if (showPreview) {
                // Accepted files is read-only.
                acceptedFiles.map((file) => Object.assign(file, {
                    preview: URL.createObjectURL(file),
                }));
            }
            if (!multiple && acceptedFiles.length > 0) {
                setMyFiles([...acceptedFiles]);
                setRejectedFiles([]);
                setError(false);
            }
            else {
                // @ts-ignore
                setMyFiles([...myFiles, ...acceptedFiles]);
            }
            /* istanbul ignore else */
            if (onAddFiles) {
                onAddFiles(acceptedFiles);
            }
            // commenting this code, As we are replacing existing file if multiple false and single file available
            // if (!multiple && myFiles.length === 0 && acceptedFiles.length > 0) {
            //   // When only single file allowed
            //   // setDisabled(true);
            // }
        }
    }, [uploadError, disabled, showPreview, myFiles, onAddFiles, multiple]);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        accept,
        maxSize,
        minSize,
        multiple,
        noClick: myFiles.length,
        onDrop,
    });
    return (React.createElement(DropzoneContainer, Object.assign({ isDragActive: isDragActive, files: myFiles, ref: containerRef, error: error }, getRootProps(), { "data-test-id": "drop-zone" }),
        React.createElement("input", Object.assign({ "data-test-id": "drop-input" }, getInputProps())),
        React.createElement(Box, { align: "center", justify: "between" },
            React.createElement(Icon, { size: "large", status: "disabled", name: "cloudUpload", dataTestId: "file-upload-icon" }),
            React.createElement(DefaultMessage, { dataTestId: dataTestId }))));
};

const FileInput = ({ multiple = true, accept, addFiles, maxSize, minSize, deleteFiles, uploadError, dataTestId, errorMessage, }) => {
    var _a;
    const background = useInternalColor('lightCoolGray');
    const [myFiles, setMyFiles] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [rejectedFiles, setRejectedFiles] = useState([]);
    const showPreview = false;
    const showFileSize = true;
    const removeFile = (file) => {
        const newFiles = [...myFiles];
        // @ts-ignore
        newFiles.splice(newFiles.indexOf(file), 1);
        setMyFiles(newFiles);
        if (deleteFiles) {
            deleteFiles(newFiles);
        }
        if (newFiles.length === 0) {
            setDisabled(false);
        }
    };
    const currentFiles = myFiles.map((file, index) => (React.createElement(File, { file: file, key: index.toString(), removeFile: removeFile, showPreview: showPreview, showFileSize: showFileSize })));
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, Object.assign({}, getTestIdAttribute(dataTestId), { onDrop: event => event.preventDefault(), pad: "20px", background: background }),
            React.createElement(Dropzone, { multiple: multiple, accept: accept, uploadError: uploadError, showPreview: showPreview, minSize: minSize, maxSize: maxSize, onAddFiles: addFiles, myFiles: myFiles, setMyFiles: setMyFiles, disabled: disabled, setDisabled: setDisabled, dataTestId: dataTestId, setRejectedFiles: setRejectedFiles })),
        myFiles.length ? (React.createElement(Box, { border: "horizontal", margin: { vertical: 'medium' }, pad: { top: 'small', right: 'medium', left: 'medium' } }, currentFiles)) : (undefined),
        rejectedFiles.length ? (React.createElement(Row, { fill: "horizontal", pad: "small", gap: "small" },
            React.createElement(Column, { noPad: true },
                React.createElement(Icon, { name: "error", dataTestId: "error-icon", size: "xxsmall" })),
            React.createElement(Column, { noPad: true, expand: true },
                React.createElement(Text, { label: errorMessage || `${(_a = rejectedFiles[0].errors[0]) === null || _a === void 0 ? void 0 : _a.message}`, type: "label", status: "error", dataTestId: `${dataTestId}-rejected-message` })))) : (undefined)));
};

function DarkModeProvider(props) {
    const { dark, light, forced, theme, children } = props;
    const value = useMemo(() => (Object.assign(Object.assign({}, theme), { darkMode: !!dark || !light, autoTheme: !forced })), [dark, light, forced, theme]);
    return React.createElement(ThemeContext.Extend, { value: value }, children);
}

/* eslint-disable no-nested-ternary */
const absoluteBlack = LightCuroColors.black;
const lightGray = InternalColors.lightGray['light'];
const darkSlate = InternalColors.darkSlate['light'];
const mediumGray = InternalColors.mediumGray['light'];
const LoginPageThemeExension = {
    formField: {
        border: {
            color: mediumGray,
        },
    },
};
const StyledTextInput = styled(TextInput$1).withConfig({ displayName: "StyledTextInput", componentId: "sc-lc2h00" }) `
  background: transparent;
  color: ${LightCuroColors.white};
`;
const StyledFormField = styled(FormField).withConfig({ displayName: "StyledFormField", componentId: "sc-1ucsnax" }) `
  & label + div {
    background-color: transparent;
  }
`;
const LoginPage = ({ backgroundImage, theme = 'dark', usernameFieldLabel = getI18nStr('username'), passwordFieldLabel = getI18nStr('password'), logo, alt, secondaryLogo, defaultUsername, usernameFieldValidation, passwordFieldValidation, onSubmit, onChange, customError, submitButtonContent, submitButtonDisabled, onForgotPassword, dataTestId, copyrightMessage, }) => {
    const [reveal, setReveal] = useState(false);
    const forgotPassword = onForgotPassword && (React.createElement(Button$1, { type: "plain", dataTestId: "forgot-password", onClick: onForgotPassword },
        React.createElement(Text, { label: getI18nStr('forgotPassword'), status: "info", weight: "medium", dataTestId: "remember", nowrap: true })));
    const fieldSet = (React.createElement(FieldSet, { dataTestId: "login-fieldset" },
        React.createElement(StyledFormField, { required: true, disabled: !!defaultUsername, label: usernameFieldLabel, validate: usernameFieldValidation, name: "username" },
            React.createElement(StyledTextInput, { style: { boxShadow: 'none' }, name: "username", disabled: !!defaultUsername, value: defaultUsername || undefined, "data-test-id": "username-text-input" })),
        React.createElement(StyledFormField, { label: passwordFieldLabel, validate: passwordFieldValidation, name: "password" },
            React.createElement(Box, { direction: "row", round: "4px", align: "center" },
                React.createElement(StyledTextInput, { name: "password", type: reveal ? 'text' : 'password', style: { boxShadow: 'none' }, "data-test-id": "password-text-input" }),
                React.createElement(Box, { margin: { horizontal: 'small' } },
                    React.createElement(Icon, { name: reveal ? 'show' : 'hide', size: "large", onClick: () => { setReveal(!reveal); }, dataTestId: `${dataTestId}-password-visibility-login` }))))));
    const footer = (React.createElement(Row, { align: "center", pad: "medium", justify: secondaryLogo ? 'between' : 'end' },
        secondaryLogo && React.createElement("img", { src: secondaryLogo, alt: alt, style: { width: '100px' } }),
        copyrightMessage && copyrightMessage.trim() !== '' && (React.createElement(Text, { type: "fine", label: `\u00A9 ${copyrightMessage}`, status: "default", dataTestId: "copyright" }))));
    let background;
    if (!!backgroundImage) {
        background = `url(${backgroundImage})`;
    }
    else {
        background = theme === 'dark' ? darkSlate : lightGray;
    }
    const submitButton = (React.createElement(DarkModeProvider, { light: true, forced: true },
        React.createElement(Button$1, { type: "submit", stretch: true, dataTestId: `${dataTestId}-submit-button`, label: typeof submitButtonContent === 'string' ? submitButtonContent : undefined, disabled: submitButtonDisabled }, typeof submitButtonContent !== 'string' ? submitButtonContent : undefined)));
    return (React.createElement(ThemeContext.Extend, { value: LoginPageThemeExension },
        React.createElement(Panel, Object.assign({}, getTestIdAttribute(dataTestId), { fill: true, align: "center", justify: "between", background: background }),
            React.createElement(Row, null),
            React.createElement(Box, { round: "small", pad: "medium", background: { color: absoluteBlack, opacity: Opacity.strong } },
                React.createElement(Panel, { noMarginBottom: true, noPad: true, noShrink: true },
                    React.createElement(Row, { pad: { horizontal: 'small' } },
                        React.createElement(Column, { pad: { top: 'small', bottom: 'small' }, size: loginFormContainerWidth },
                            React.createElement("img", { src: logo, alt: alt }))),
                    React.createElement(Row, null,
                        React.createElement(Column, { gap: "small", fill: true, noPad: true, size: loginFormContainerWidth },
                            React.createElement(Form, { alignFormFooter: "start", onSubmit: onSubmit, onChange: onChange, customError: customError, dataTestId: "login-form" },
                                fieldSet,
                                React.createElement(Row, { pad: { top: 'small' } }, submitButton)))),
                    React.createElement(Row, { pad: { horizontal: 'small' } }, forgotPassword))),
            footer)));
};

const Image = ({ a11yTitle, alignSelf, fallback, fill, src, gridArea, margin, opacity, dataTestId, }) => {
    return (React.createElement(Image$1, Object.assign({ a11yTitle: a11yTitle }, getTestIdAttribute(dataTestId), { alignSelf: alignSelf, fallback: fallback, fill: fill, src: src, gridArea: gridArea, margin: margin, opacity: opacity })));
};

/* eslint-disable @typescript-eslint/no-unused-expressions */
const Card = ({ dataTestId, toolBar, secondaryHeader, headerBorder = false, headerBackground, background, title, fill, footer, footerCollapsed, children, borderRadius = 4, }) => {
    const [open, setOpen] = React.useState(false);
    const brand = useCuroColor('brand');
    const toolbarStyles = (el) => ({
        cursor: 'pointer',
        borderBottom: el.active ? `solid 2px ${brand}` : undefined,
        padding: '0 10px 6px 10px',
        margin: '0 2px 0 2px',
    });
    const header = !(title === undefined || toolbar === undefined);
    return (React.createElement(Box, Object.assign({ style: { boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.2)', maxHeight: '100%' }, round: `${borderRadius}px`, fill: fill, justify: "around", background: background }, getTestIdAttribute(dataTestId)),
        (title || toolBar) && (React.createElement(Box, { direction: "row", justify: title ? 'between' : 'end', align: "center", height: "45px", flex: { shrink: 0 }, background: headerBackground, pad: { top: header ? '14px' : undefined, horizontal: '20px' }, border: headerBorder && header ? { side: 'bottom' } : undefined },
            title && (React.createElement(Box, { fill: true, pad: { bottom: 'small' } },
                typeof title === 'string' && (React.createElement(Text, { label: title, type: "title4", dataTestId: `${dataTestId}-title` })),
                typeof title !== 'string' && title)),
            toolBar && (React.createElement(Box, { fill: true, direction: "row", align: "center", justify: "end" }, toolBar.map((el, index) => {
                if (el.icon && el.text) {
                    return (React.createElement(Box, { key: index.toString(), style: toolbarStyles(el), direction: "row", gap: "1.5px", onClick: el.onClick },
                        React.createElement(Icon, { size: "medium", dataTestId: `${dataTestId}-action`, name: el.icon }),
                        React.createElement(Text$1, null, el.text)));
                }
                if (el.icon) {
                    return (React.createElement(Box, { key: index.toString(), style: toolbarStyles(el) },
                        React.createElement(Icon, { size: "medium", dataTestId: `${dataTestId}-action`, onClick: el.onClick, name: el.icon })));
                }
                if (el.text)
                    return (React.createElement(Box, { key: index.toString(), style: toolbarStyles(el) },
                        React.createElement(Text$1, { onClick: el.onClick }, el.text)));
                return undefined;
            }))))),
        secondaryHeader && (React.createElement(Box, { flex: { shrink: 0 }, background: "light-2" }, secondaryHeader)),
        React.createElement(Box, { style: { overflow: 'auto', maxHeight: '100%' } }, children),
        footer && (React.createElement(Box, { pad: "small", flex: { shrink: 0 } },
            React.createElement(Box, { direction: "row", justify: "between" },
                footer,
                footerCollapsed && (React.createElement(Icon, { name: open ? 'up' : 'down', size: "medium", dataTestId: `${dataTestId}-footer-expand`, onClick: () => setOpen(!open) }))),
            React.createElement(Collapsible, { open: open }, footerCollapsed)))));
};

const LinkWrapper = styled.div.withConfig({ displayName: "LinkWrapper", componentId: "sc-11q2e3y" }) `
  padding: 6px 8px;
  margin: -6px -8px;
  border-radius: 4px;
  &:hover {
    background-color: ${props => getStyledInternalColor(props, 'lightCoolGray')};
  }
`;
const SummaryCardItem = ({ value, label, dataTestId, href }) => {
    const getValue = () => {
        if (typeof value === 'string') {
            return React.createElement(Text, { label: value, dataTestId: `${dataTestId}-value`, type: "jumbo", weight: "medium" });
        }
        return value; // JSX.Element
    };
    const getSummaryCardItemText = () => (React.createElement(React.Fragment, null,
        React.createElement(Row, { noPad: true }, getValue()),
        label && (React.createElement(Row, { noPad: true },
            React.createElement(Text, { label: label, dataTestId: `${dataTestId}-label`, type: "label" })))));
    return (React.createElement(React.Fragment, null, href ? (React.createElement(React.Fragment, null,
        React.createElement(Link, { dataTestId: `${dataTestId}-link`, href: href },
            React.createElement(LinkWrapper, null, getSummaryCardItemText())))) : getSummaryCardItemText()));
};
const SummaryCardLoading = ({ dataTestId }) => {
    const white = useCuroColor('white');
    return (React.createElement(Card, { fill: true, background: white, title: React.createElement(Skeleton, { width: "100%", height: "24px", dataTestId: `${dataTestId}-skeleton-card-title` }) },
        React.createElement(Panel, { noShrink: true, noMarginBottom: true, direction: "column" },
            React.createElement(Skeleton, { width: "100%", height: "34px", dataTestId: "skeleton-content" }),
            React.createElement(Row, { pad: "xxsmall" }),
            React.createElement(Skeleton, { width: "100%", height: "14px", dataTestId: "skeleton-label" }))));
};
const SummaryCard = ({ title, titleContext, cardItems, size, dataTestId, isLoading = false, skeleton, borderRadius, gap = 'none', }) => {
    const vSize = useContext(ResponsiveContext);
    const [summaryCardSize, setSummaryCardSize] = useState('');
    const [titleSize, setTitleSize] = useState();
    const [titleContextSize, setTitleContextSize] = useState();
    const [isTitleContextInTooltip, setIsTitleContextInTooltip] = useState(false);
    const summaryCardRef = useRef(null);
    const titleRef = useRef(null);
    const titleContextRef = useRef(null);
    useEffect(() => {
        if (size) {
            const cardSize = getColumnSize(vSize, size);
            if (cardSize)
                setSummaryCardSize(cardSize);
        }
    }, [size, vSize]);
    useEffect(() => {
        var _a;
        if (!isLoading && typeof title === 'string' && titleContext) {
            const summaryCardWidth = summaryCardRef.current.clientWidth;
            const titleWidth = titleRef.current.childNodes[0].clientWidth;
            const titleContextWidth = (_a = titleContextRef === null || titleContextRef === void 0 ? void 0 : titleContextRef.current) === null || _a === void 0 ? void 0 : _a.childNodes[0].clientWidth;
            const tSize = (titleWidth * 100) / summaryCardWidth;
            setTitleSize(tSize);
            const tcSize = 100 - tSize;
            setTitleContextSize(tcSize);
            setIsTitleContextInTooltip(false);
            if (titleWidth + 20 + titleContextWidth < summaryCardWidth) {
                setIsTitleContextInTooltip(false);
            }
            else {
                setIsTitleContextInTooltip(true);
            }
        }
    }, [vSize, summaryCardSize, isLoading, titleContext, title]);
    const getTitle = () => {
        let titleLabel = title;
        if (typeof title === 'string') {
            titleLabel = (React.createElement(React.Fragment, null,
                React.createElement(Column, { align: "start", justify: "start", size: titleContext ? titleSize : '100%', dataTestId: `${dataTestId}-summary-card-title-column`, noPad: true, colRef: titleRef },
                    React.createElement(Text, { label: title, dataTestId: `${dataTestId}-summary-card-title`, type: "title3" })),
                !isTitleContextInTooltip && (React.createElement(Column, { align: "end", justify: "end", size: titleContextSize, dataTestId: `${dataTestId}-summary-card-subtitle-column`, expand: true, pad: { left: '20px' }, colRef: titleContextRef },
                    React.createElement(Text, { label: titleContext, dataTestId: `${dataTestId}-summary-card-subtitle`, type: "label" })))));
        }
        if (isTitleContextInTooltip) {
            return (React.createElement(Tooltip, { target: titleLabel, tooltip: titleContext, dataTestId: `${dataTestId}-summary-card-tooltip` }));
        }
        return titleLabel;
    };
    const white = useCuroColor('white');
    return (React.createElement(LoadingContainer, { isLoading: isLoading === true, skeleton: skeleton ? skeleton : React.createElement(SummaryCardLoading, { dataTestId: `${dataTestId}-skeleton` }), fill: "vertical", size: summaryCardSize ? summaryCardSize : undefined, pad: "xsmall", style: { flex: summaryCardSize ? undefined : 1 } },
        React.createElement(Card, { fill: true, borderRadius: borderRadius, background: white, title: React.createElement(Box, { ref: summaryCardRef, pad: "none", direction: "row" }, getTitle()), dataTestId: `${dataTestId}-summary-card` },
            React.createElement(Panel, { noShrink: true, noMarginBottom: true, direction: "row", pad: { horizontal: '20px', vertical: '14px' }, gap: gap }, cardItems.length > 0 &&
                cardItems.map((cardItem, index) => (React.createElement(Column, { align: "start", noPad: true, size: cardItem.size || `${100 / cardItems.length}%`, key: cardItem.label || `card-${index}` },
                    React.createElement(SummaryCardItem, Object.assign({}, cardItem, { dataTestId: cardItem.dataTestId || `${dataTestId}-item-${index}` })))))))));
};

const UnitInSecObj = {
    month: 30 * 24 * 60 * 60,
    week: 7 * 24 * 60 * 60,
    day: 24 * 60 * 60,
    hour: 60 * 60,
    minute: 60,
};
const StatsIntervalInitVal = {
    startTime: 0,
    endTime: 0,
    interval: 0,
    option: 'all',
    label: getI18nStr('all'),
};
const getCustomInterval = (startTime, endTime) => {
    const now = moment().unix();
    const startTimeOffset = now - startTime;
    // per sec stats
    if (startTimeOffset <= UnitInSecObj.minute) {
        return 1;
    }
    // per min stats
    const durationInSec = endTime - startTime;
    if (startTimeOffset <= 3 * UnitInSecObj.day) {
        if (durationInSec <= 3 * UnitInSecObj.hour) {
            return UnitInSecObj.minute;
        }
        const powerIndex = Math.ceil(Math.log(durationInSec / 180 / UnitInSecObj.minute) / Math.log(2));
        return Math.pow(2, powerIndex) * UnitInSecObj.minute;
    }
    // per hour stats
    if (durationInSec <= 3 * 60 * UnitInSecObj.hour) {
        return UnitInSecObj.hour;
    }
    const powerIndex = Math.ceil(Math.log(durationInSec / 180 / UnitInSecObj.hour) / Math.log(2));
    return Math.pow(2, powerIndex) * UnitInSecObj.hour;
};
const StatsIntervalOptions = {
    all: () => StatsIntervalInitVal,
    realTime: () => ({
        startTime: moment()
            .subtract(5, 'minute')
            .unix(),
        endTime: moment().unix(),
        interval: 1,
        refresh: 1,
        option: 'realTime',
        label: getI18nStr('realTime'),
    }),
    last1Hour: () => ({
        startTime: moment()
            .subtract(1, 'hour')
            .unix(),
        endTime: moment().unix(),
        interval: UnitInSecObj.minute,
        refresh: UnitInSecObj.minute,
        option: 'last1Hour',
        label: getI18nStr('last1Hour'),
    }),
    last3Hours: () => ({
        startTime: moment()
            .subtract(3, 'hour')
            .unix(),
        endTime: moment().unix(),
        interval: UnitInSecObj.minute,
        refresh: UnitInSecObj.minute,
        option: 'last3Hours',
        label: getI18nStr('last3Hours'),
    }),
    last8Hours: () => ({
        startTime: moment()
            .subtract(8, 'hour')
            .unix(),
        endTime: moment().unix(),
        interval: 4 * UnitInSecObj.minute,
        refresh: UnitInSecObj.minute,
        option: 'last8Hours',
        label: getI18nStr('last8Hours'),
    }),
    last1Day: () => ({
        startTime: moment()
            .subtract(1, 'day')
            .unix(),
        endTime: moment().unix(),
        interval: 8 * UnitInSecObj.minute,
        refresh: UnitInSecObj.minute,
        option: 'last1Day',
        label: getI18nStr('last1Day'),
    }),
    last1Week: () => ({
        startTime: moment()
            .subtract(1, 'week')
            .unix(),
        endTime: moment().unix(),
        interval: UnitInSecObj.hour,
        refresh: UnitInSecObj.hour,
        option: 'last1Week',
        label: getI18nStr('last1Week'),
    }),
    last1Month: () => ({
        startTime: moment()
            .subtract(1, 'month')
            .unix(),
        endTime: moment().unix(),
        interval: 4 * UnitInSecObj.hour,
        refresh: UnitInSecObj.hour,
        option: 'last1Month',
        label: getI18nStr('last1Month'),
    }),
    last3Months: () => ({
        startTime: moment()
            .subtract(3, 'month')
            .unix(),
        endTime: moment().unix(),
        interval: 16 * UnitInSecObj.hour,
        refresh: UnitInSecObj.hour,
        option: 'last3Months',
        label: getI18nStr('last3Months'),
    }),
    last1Year: () => ({
        startTime: moment()
            .subtract(12, 'month')
            .unix(),
        endTime: moment().unix(),
        interval: 1 * UnitInSecObj.day,
        refresh: UnitInSecObj.hour,
        option: 'last1Year',
        label: getI18nStr('last1Year'),
    }),
    custom: (startTime, endTime) => ({
        startTime,
        endTime,
        interval: getCustomInterval(startTime, endTime),
        option: 'custom',
        label: getI18nStr('custom'),
    }),
};

const ChartColorMap = {
    series1: '#2AD2C9',
    series2: '#1973CB',
    series3: '#7630EA',
    series4: '#77BC1F',
    series5: '#ACD9FF',
    series6: '#FFBC45',
    series7: '#F740FF',
    series8: '#425563',
    forecast: '#002E6D',
};
const ChartHeightOBJ = {
    tall: 300,
    medium: 200,
    short: 100,
};
const ChartYTicksOBJ = {
    tall: 4,
    medium: 3,
    short: 2,
};
const AlignConstants = {
    offsetTop: 7,
    offsetRight: 26,
    yTitleWidth: 20,
    xTitleHeight: 24,
    YAxisBase: 40,
    YAxisChar: 7,
    margin: 10,
    lineStroke: 2,
    tooltipLineStroke: 1,
    lineDash: '5, 5',
    minWidth: 150,
    areaOpacity: 0.6,
};
const TimeFormatConst = {
    month: '%Y-%m',
    week: '%d %b',
    day: '%d %b',
    hour: '%H:%M',
    minute: '%H:%M:%S',
};
const getDateInSec = (date) => {
    return Math.round(date.getTime() / 1000);
};
const isSameDate = (d1, d2) => {
    if (d1.getDate() !== d2.getDate()) {
        return false;
    }
    if (d1.getMonth() !== d2.getMonth()) {
        return false;
    }
    return d1.getFullYear() === d2.getFullYear();
};
const getTimeFormat = (date, start, end, index) => {
    const dateAt0 = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    if (Math.abs(dateAt0.getTime() - date.getTime()) < 500) {
        return timeFormat(TimeFormatConst.day);
    }
    const now = new Date();
    const startInSec = getDateInSec(start);
    const secFromStart = getDateInSec(now) - startInSec;
    if (secFromStart < 15 * UnitInSecObj.minute) {
        // show seconds to avoid duplicated minutes
        return timeFormat(TimeFormatConst.minute);
    }
    const todayAt0InSec = getDateInSec(new Date(now.getFullYear(), now.getMonth(), now.getDate()));
    if (index === 0 && isSameDate(start, end) && getDateInSec(end) < todayAt0InSec) {
        // historical time where there need a date
        return timeFormat(TimeFormatConst.day);
    }
    return timeFormat(TimeFormatConst.hour);
};
const removeAllChildren = (element) => {
    if (element && element.selectAll) {
        element.selectAll('*').remove();
    }
};
const borderRadius$1 = 2;
const getCurve = (ex, ey) => {
    return `A${borderRadius$1},${borderRadius$1} 0 0,1 ${ex} ${ey}`;
};
const getChartStatusColor = (status, colors, id) => {
    const colorInfo = colors || LightCuroColors;
    switch (status) {
        case 'striped':
            return `url(#${id || 'linear-gradient'})`;
        case 'forecast':
            return colorInfo.forecast;
        default:
            return colorInfo[typeof status === 'number' ? `series${status + 1}` : status];
    }
};
const getPercentDataColor = (item, index, colors) => {
    if (typeof item === 'number') {
        return getChartStatusColor(index, colors);
    }
    return getChartStatusColor(item.status, colors);
};

const segmentPercent = 0.2;
const bgName = '__bg';
const donutAlignConstants = {
    // margin: [0.98, 1],
    highlight: [0.93, 0.98],
    // space: [0.91, 0.93],
    data: [0.81, 0.91],
    dataSegment: [0.81, 0.91],
};
const titleAlign = 0.44; /* 1 - 0.8 * sqrt 2 / 2 */
const titleSides = 1.12; /* 0.8 * sqrt 2 */
const maxTitleScale = 3;
const minTitleScaleUpdate = 0.005;
const getTitle = ({ title, subTitle, children, dataTestId }) => {
    if (children) {
        return children;
    }
    if (title) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Column, { align: "center", size: "100%", noPad: true },
                React.createElement(Text, { label: title, type: "jumbo", dataTestId: `${dataTestId}-title` })),
            subTitle && (React.createElement(Column, { align: "center", size: "100%", noPad: true },
                React.createElement(Text, { label: subTitle, type: "default", dataTestId: `${dataTestId}-subtitle` })))));
    }
    return React.createElement("div", null);
};
const TitleDiv = styled.div.withConfig({ displayName: "TitleDiv", componentId: "sc-19smuvl" }) `
  display: flex;
  flex: inherit;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-align: center;
  -webkit-text-size-adjust: none;
  overflow: visible;
`;
const DonutChart = (props) => {
    const { dataTestId, data, updateHoveredName, width } = props;
    const svgRef = useRef(null);
    const titleRef = useRef(null);
    const [halfWidth, setHalfWidth] = useState(0);
    const [arcs, setArcs] = useState([]);
    const [hoverArc, setHoverArc] = useState();
    const [titleScale, setTitleScale] = useState([1, 1]);
    useEffect(() => {
        const handleResize = () => {
            if (width) {
                if (halfWidth !== width / 2) {
                    setHalfWidth(width / 2);
                }
            }
            else if (svgRef &&
                svgRef.current &&
                svgRef.current.parentElement &&
                svgRef.current.parentElement.clientWidth) {
                const parentHalfWidth = svgRef.current.parentElement.clientWidth / 2;
                if (halfWidth !== parentHalfWidth) {
                    setHalfWidth(parentHalfWidth);
                }
                // resize title
                setTimeout(() => {
                    if (titleRef && titleRef.current && titleRef.current.firstElementChild) {
                        const titleWidth = halfWidth * titleSides;
                        const { scrollHeight, scrollWidth } = titleRef.current.firstElementChild;
                        const getRatio = () => {
                            if (scrollHeight && scrollWidth && titleWidth) {
                                const ratio = titleWidth / Math.max(scrollWidth, scrollHeight);
                                if (ratio < 1 || (ratio > 2 && ratio < maxTitleScale)) {
                                    return ratio;
                                }
                                if (ratio >= 1 && ratio < 2) {
                                    return 1;
                                }
                                return maxTitleScale;
                            }
                            return 1;
                        };
                        const scale = getRatio();
                        if (Math.abs(scale - titleScale[0]) > minTitleScaleUpdate) {
                            setTitleScale([scale, scale]);
                        }
                    }
                }, 40);
            }
        };
        if (svgRef && svgRef.current) {
            handleResize();
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [svgRef, halfWidth, width, titleScale]);
    const colors = useColors();
    useEffect(() => {
        if (halfWidth > 0) {
            let sum = 0;
            const curArcs = [];
            const getArcD = (start, end, type) => {
                const d = arc()
                    .innerRadius(halfWidth * donutAlignConstants[type][0])
                    .outerRadius(halfWidth * donutAlignConstants[type][1])
                    .startAngle((start * Math.PI * 2) / 100)
                    .endAngle((end * Math.PI * 2) / 100);
                return d();
            };
            const getArc = (start, end, type, color, name) => {
                const d = getArcD(start, end, type);
                const mouseHandlers = {
                    mouseOverOrMove: () => {
                        if (updateHoveredName) {
                            updateHoveredName(name);
                        }
                        const curHoverArc = (React.createElement("path", { d: getArcD(start, end, 'highlight'), fill: color, opacity: "0.6" }));
                        setHoverArc(curHoverArc);
                    },
                    mouseLeave: () => {
                        if (updateHoveredName) {
                            updateHoveredName(undefined);
                        }
                        setHoverArc(undefined);
                    },
                };
                const getListenerObj = () => {
                    if (type === 'data' && name !== bgName) {
                        return {
                            onMouseOver: mouseHandlers.mouseOverOrMove,
                            onFocus: mouseHandlers.mouseOverOrMove,
                            onMouseMove: mouseHandlers.mouseOverOrMove,
                            onMouseLeave: mouseHandlers.mouseLeave,
                        };
                    }
                    return {};
                };
                const listenerObj = getListenerObj();
                return (React.createElement("path", Object.assign({}, getTestIdAttribute(`test-${name}`), { key: `path-${end}`, d: d, fill: color }, listenerObj)));
            };
            if (data) {
                data.forEach((item, index) => {
                    const percentage = typeof item === 'number' ? item : item.percentage;
                    if (percentage > 0) {
                        const itemColor = getPercentDataColor(item, index, colors);
                        const itemName = typeof item !== 'number' && item.name ? item.name : `${index}`;
                        const begin = sum;
                        sum += percentage;
                        if (percentage === 100) {
                            // No gap for full donut
                            curArcs.push(getArc(begin, sum, 'data', itemColor, itemName));
                        }
                        else {
                            curArcs.push(getArc(begin, sum - segmentPercent, 'data', itemColor, itemName));
                            curArcs.push(getArc(sum - segmentPercent, sum, 'dataSegment', colors.white, itemName));
                        }
                    }
                });
            }
            if (sum === 0) {
                curArcs.push(getArc(sum, 100, 'data', colors.lightGray, bgName));
            }
            else if (sum < 100) {
                curArcs.push(getArc(sum, 100 - segmentPercent, 'data', colors.lightGray, bgName));
                curArcs.push(getArc(100 - segmentPercent, 100, 'dataSegment', colors.white, bgName));
            }
            setArcs(curArcs);
        }
    }, [halfWidth, data, updateHoveredName, colors]);
    return (React.createElement("svg", Object.assign({ ref: svgRef, height: 2 * halfWidth }, getTestIdAttribute(dataTestId)),
        React.createElement("circle", { fill: colors.white, cx: halfWidth, cy: halfWidth, r: halfWidth }),
        React.createElement("g", { transform: `translate(${halfWidth}, ${halfWidth})` },
            arcs,
            hoverArc),
        React.createElement("foreignObject", { x: halfWidth * titleAlign, y: halfWidth * titleAlign, width: halfWidth * titleSides, height: halfWidth * titleSides },
            React.createElement(Panel, { fill: true, noPad: true, noMarginBottom: true, align: "center", direction: "row", noShrink: false },
                React.createElement(TitleDiv, { ref: titleRef, style: {
                        transform: `scale(${(titleScale[0], titleScale[1])})`,
                    } },
                    React.createElement(Row, { noPad: true, align: "center", justify: "center" }, getTitle(props)))))));
};

const plotBandsColorSourceMap = Object.assign(Object.assign({}, curoColorSourceMap), { forecast: getChartColorMapping('forecast'), lightGray: getInternalColorMapping('lightGray') });
const PlotBands = ({ bands, status, scaleObj, dataTestId, opacity, }) => {
    const plotBandRef = useRef(null);
    const { xType, xScaleDomain, xScaleRange, yScaleDomain, yScaleRange } = scaleObj;
    // const [forecase, lightGray] = useColorList(plotBandColorKeyList);
    const colors = useColors(plotBandsColorSourceMap);
    useEffect(() => {
        if (plotBandRef && plotBandRef.current) {
            let xScale;
            if (xType === 'time') {
                xScale = scaleTime()
                    .domain(xScaleDomain)
                    .range(xScaleRange);
            }
            else {
                xScale = scaleLinear()
                    .domain(xScaleDomain)
                    .range(xScaleRange);
            }
            const yScale = scaleLinear()
                .domain(yScaleDomain)
                .range(yScaleRange);
            const container = select(plotBandRef.current);
            removeAllChildren(container);
            for (let i = 0; i < bands.length; i++) {
                const [bandStart, bandEnd] = bands[i];
                const bandStartScale = xScale(new Date(bandStart));
                const getOpacity = () => {
                    if (opacity !== undefined) {
                        return opacity;
                    }
                    return status === 'lightGray' ? 1 : AlignConstants.areaOpacity;
                };
                const getPercentDataColor = () => {
                    switch (status) {
                        case 'lightGray':
                            return colors.lightGray;
                        case 'forecast':
                            return colors.forecast;
                        default:
                            return colors[status];
                    }
                };
                container
                    .append('rect')
                    .attr('x', bandStartScale)
                    .attr('y', yScale(yScaleDomain[1]))
                    .attr('width', xScale(new Date(bandEnd)) - bandStartScale || 1)
                    .attr('height', yScale(yScaleDomain[0]) - yScale(yScaleDomain[1]))
                    .attr('opacity', getOpacity())
                    .attr('fill', getPercentDataColor());
            }
        }
    }, [
        plotBandRef,
        bands,
        xScaleDomain,
        xScaleRange,
        yScaleDomain,
        yScaleRange,
        status,
        opacity,
        colors,
    ]);
    return React.createElement("g", Object.assign({ ref: plotBandRef }, getTestIdAttribute(dataTestId)));
};
PlotBands.defaultProps = {
    opacity: undefined,
};

const StyledSVGText$1 = styled.text.withConfig({ displayName: "StyledSVGText", componentId: "sc-1p30olg" }) `
  font-size: ${TextConfigs.label[0]};
  dominant-baseline: middle;
  text-anchor: middle;
`;
const NoDataChart = ({ label, dataTestId }) => {
    const gray = useCuroColor('gray');
    const fill = useInternalColor('lightGray');
    return (React.createElement(React.Fragment, null,
        React.createElement("rect", Object.assign({ width: "100%", height: "100%", fill: fill }, getTestIdAttribute(`${dataTestId}-no-data-rect`))),
        React.createElement(StyledSVGText$1, Object.assign({ x: "50%", y: "50%", fill: gray }, getTestIdAttribute(`${dataTestId}-no-data`)), label)));
};

const findClosestItems = (pointX, previousSeries) => {
    const preLength = previousSeries.length;
    if (pointX < previousSeries[0].x) {
        return [previousSeries[0], previousSeries[1]];
    }
    if (pointX > previousSeries[preLength - 1].x) {
        return [previousSeries[preLength - 2], previousSeries[preLength - 1]];
    }
    for (let i = 1; i < preLength; i++) {
        if (previousSeries[i - 1].x < pointX && previousSeries[i].x > pointX) {
            return [previousSeries[i - 1], previousSeries[i]];
        }
    }
    return [previousSeries[0], previousSeries[1]];
};
const getStackedDataPoint = (pointX, pointValue, previousSeries) => {
    let flatPreviousSeries = [];
    for (let i = 0; i < previousSeries.length; i++) {
        flatPreviousSeries = flatPreviousSeries.concat(previousSeries[i]);
    }
    const previousSeriesItem = flatPreviousSeries.find(({ x }) => {
        return pointX === x;
    });
    if (previousSeriesItem) {
        return {
            stackedValue: previousSeriesItem.value + pointValue,
            stackedBase: previousSeriesItem.value,
        };
    }
    const [item1, item2] = findClosestItems(pointX, flatPreviousSeries);
    const base = ((item2.value - item1.value) * (pointX - item1.x)) / (item2.x - item1.x);
    return {
        stackedBase: base,
        stackedValue: pointValue + base,
    };
};
const updateOverlappingNulls = (start, end, nulls, nulls2) => {
    for (let i = 0; i < nulls2.length; i++) {
        const [start2, end2] = nulls2[i];
        const newEnd = end2 > end ? end : end2;
        if (start2 <= start && end2 > start) {
            nulls.push([start, newEnd]);
        }
        else if (start2 > start && start2 < end) {
            nulls.push([start2, newEnd]);
        }
    }
};
const joinNulls = (nulls1, nulls2) => {
    const nulls = [];
    for (let i = 0; i < nulls1.length; i++) {
        const [start, end] = nulls1[i];
        updateOverlappingNulls(start, end, nulls, nulls2);
    }
    return nulls;
};
const getNulls = (nullsSeries) => {
    if (nullsSeries.length < 1) {
        return [];
    }
    const isAnyEmpty = nullsSeries.some(item => {
        return item.length < 1;
    });
    if (isAnyEmpty) {
        return [];
    }
    let nulls = nullsSeries[0];
    if (nullsSeries.length === 1) {
        return nulls;
    }
    for (let i = 1; i < nullsSeries.length && nulls.length > 0; i++) {
        nulls = joinNulls(nulls, nullsSeries[i]);
    }
    return nulls;
};
const getLogInfo = (val) => {
    if (val >= 1 && val < 10) {
        return {
            base: 1,
            powerIndex: 0,
        };
    }
    const base = val > 1 ? 10 : 0.1;
    const powerIndex = Math.log(val) / Math.log(base);
    return {
        base,
        powerIndex: base === 10 ? Math.floor(powerIndex) : Math.ceil(powerIndex),
    };
};
// match by index:  0, 1, 2, 3, 4, 5, 6, 7, 8, 9,  10
const axisMaxArr = [0, 1, 2, 4, 4, 6, 6, 8, 8, 10, 10];
const getAxisMaxValue = (val) => {
    const max = val || 100;
    const { base, powerIndex } = getLogInfo(max); // set max to 100 when all 0s
    const num = Math.ceil(max / Math.pow(base, powerIndex));
    const axisNum = axisMaxArr[num] * Math.pow(base, powerIndex);
    return Math.round(axisNum * 100) / 100; // toFixed(2)
};
const getStartXValue = (xType, t, v) => {
    switch (xType) {
        case 'time': return t;
        case 'value': return v;
        default: return 0;
    }
};
const getSeriesChartStatsData = (chartType, series, colors) => {
    let xType = 'category';
    let xRatio = 1; // Time based * 1000 to get milli seconds
    let [maxYValue, minXValue, maxXValue] = [0, 0, 0];
    const statsData = [];
    if (series[0].startTime) {
        xType = 'time';
        minXValue = series[0].startTime;
        xRatio = 1000;
    }
    else if (series[0].startValue !== undefined) {
        xType = 'value';
        minXValue = series[0].startValue;
    }
    const firstInterval = series[0].interval || 1;
    const nullsSeries = [];
    const halfInterval = ['bar', 'column'].includes(chartType) ? firstInterval * xRatio / 2 : 0;
    series.forEach((item, seriesIndex) => {
        const { startTime = 0, startValue = 0, interval = 1, data, status, points } = item;
        const statusVal = status === undefined ? seriesIndex : status;
        const color = getChartStatusColor(statusVal, colors);
        const dataLength = data.length;
        const itemStartXValue = getStartXValue(xType, startTime, startValue);
        minXValue = itemStartXValue < minXValue ? itemStartXValue : minXValue;
        const endXValue = itemStartXValue + interval * (dataLength - 1);
        maxXValue = endXValue > maxXValue ? endXValue : maxXValue;
        const nullsSeriesItem = [];
        const statsDataItem = [[]];
        let statsDataItemStartIndex = 0;
        let nullStartX = null;
        for (let i = 0; i < dataLength; i++) {
            const value = data[i];
            const xValue = itemStartXValue * xRatio + interval * i * xRatio;
            if (value !== null) {
                const getPointMarker = () => {
                    if (points && points[i]) {
                        return {
                            ptRadius: points[i].percent,
                            ptColor: colors[points[i].status],
                        };
                    }
                    return { ptRadius: undefined, ptColor: undefined };
                };
                const { ptRadius, ptColor } = getPointMarker();
                let pointValue;
                let base;
                if (chartType === 'line' || chartType === 'column' || seriesIndex === 0) {
                    pointValue = value;
                    base = 0;
                }
                else {
                    // area / bar
                    const { stackedValue, stackedBase } = getStackedDataPoint(xValue, value, statsData[seriesIndex - 1]);
                    pointValue = stackedValue;
                    base = stackedBase;
                }
                maxYValue = pointValue > maxYValue ? pointValue : maxYValue;
                if (nullStartX !== null) {
                    nullsSeriesItem.push([nullStartX, xValue - halfInterval]);
                    nullStartX = null;
                    if (statsDataItem[statsDataItem.length - 1].length > 0) {
                        statsDataItem.push([]);
                        statsDataItemStartIndex++;
                    }
                }
                statsDataItem[statsDataItemStartIndex].push({
                    x: xValue,
                    value: pointValue,
                    base,
                    color,
                    ptRadius,
                    ptColor,
                });
            }
            else if (nullStartX === null) {
                // value === null
                nullStartX = i === 0 ? xValue - halfInterval : xValue - interval * xRatio + halfInterval;
            }
        }
        if (nullStartX !== null) {
            nullsSeriesItem.push([
                nullStartX,
                itemStartXValue * xRatio + interval * (dataLength - 1) * xRatio + halfInterval,
            ]);
        }
        nullsSeries.push(nullsSeriesItem);
        statsData.push(statsDataItem);
    });
    const nulls = getNulls(nullsSeries);
    const fallBackLabels = (new Array(series[0].data.length)).fill('0');
    return {
        xType,
        xRatio,
        labels: series[0].labels || fallBackLabels,
        statsData,
        nulls,
        maxValue: getAxisMaxValue(maxYValue),
        minXValue: minXValue * xRatio - halfInterval,
        maxXValue: maxXValue * xRatio + halfInterval,
        halfInterval,
    };
};

const { yTitleWidth: yTitleWidth$1, offsetTop: offsetTop$2 } = AlignConstants;
const getStyledGray = (props) => getStyledCuroColor(props, 'gray');
const StyledXAxisG = styled.g.withConfig({ displayName: "StyledXAxisG", componentId: "sc-11cd3m1" }) `
  line {
    stroke: ${getStyledGray};
  }
  path {
    stroke: ${getStyledGray};
  }
  text {
    color: ${getStyledGray};
    font-size: ${TextConfigs.fine[0]};
  }
`;
const XAxis = ({ dataTestId, chartHeight, chartWidth, chartType, scaleObj: { xType, labels, xScaleDomain, xScaleRange }, }) => {
    const xAxisRef = useRef(null);
    useEffect(() => {
        if (xAxisRef && xAxisRef.current) {
            if (xType === 'time') {
                const xScaleDomainTime = xScaleDomain;
                const xScale = scaleTime()
                    .domain(xScaleDomainTime)
                    .range(xScaleRange);
                const multiTimeFormat = (date, index) => {
                    return getTimeFormat(date, xScaleDomainTime[0], xScaleDomainTime[1], index)(date);
                };
                const num = Math.ceil(chartWidth / 130);
                const xAxisTicks = axisBottom(xScale)
                    .tickFormat(multiTimeFormat)
                    .tickSizeOuter(0)
                    .ticks(num > 3 ? num : 3);
                select(xAxisRef.current).call(xAxisTicks);
            }
            else if (xType === 'category') {
                let range = xScaleRange;
                if (['bar', 'column'].includes(chartType) && labels.length > 0) {
                    const [xStart, xEnd] = xScaleRange;
                    const halfWidth = (xEnd - xStart) / labels.length / 2;
                    range = [xStart + halfWidth, xEnd - halfWidth];
                }
                const xScale = scalePoint().domain(labels).range(range);
                const xAxisTicks = axisBottom(xScale)
                    .tickSizeOuter(0)
                    .ticks(labels.length);
                select(xAxisRef.current).call(xAxisTicks);
            }
            else {
                // Value
                const xScale = scaleLinear()
                    .domain(xScaleDomain)
                    .range(xScaleRange);
                const num = Math.ceil(chartWidth / 130);
                const xAxisTicks = axisBottom(xScale)
                    .tickSizeOuter(0)
                    .ticks(num > 3 ? num : 3);
                select(xAxisRef.current).call(xAxisTicks);
            }
        }
    }, [chartWidth, xAxisRef, xScaleDomain, xScaleRange]);
    return (React.createElement(StyledXAxisG, Object.assign({ transform: `translate(0,${offsetTop$2 + chartHeight})`, ref: xAxisRef }, getTestIdAttribute(`${dataTestId}-x-axis`))));
};
const StyledYAxisG = styled.g.withConfig({ displayName: "StyledYAxisG", componentId: "sc-1nkxcpx" }) `
  line {
    stroke: ${getStyledGray};
  }
  path {
    display: none;
  }
  text {
    color: ${getStyledGray};
    font-size: ${TextConfigs.fine[0]};
  }
`;
const YAxis = ({ scaleObj: { yScaleDomain, yScaleRange }, height, dataTestId, chartWidth, yAxisWidth, }) => {
    const yAxisRef = useRef(null);
    useEffect(() => {
        if (yAxisRef && yAxisRef.current) {
            const yScale = scaleLinear()
                .domain(yScaleDomain)
                .range(yScaleRange);
            const yAxis = axisLeft(yScale)
                .ticks(ChartYTicksOBJ[height])
                .tickSize(-chartWidth)
                .tickPadding(10);
            select(yAxisRef.current).call(yAxis);
        }
    }, [chartWidth, height, yAxisRef, yScaleDomain, yScaleRange]);
    return (React.createElement(StyledYAxisG, Object.assign({ transform: `translate(${yTitleWidth$1 + yAxisWidth},0)`, ref: yAxisRef }, getTestIdAttribute(`${dataTestId}-y-axis`))));
};
const StyledYTitleText = styled.text.withConfig({ displayName: "StyledYTitleText", componentId: "sc-1ifsnk6" }) `
  font-size: ${TextConfigs.label[0]};
  transform-box: fill-box;
  transform-origin: center;
  transform: rotate(270deg);
  text-anchor: middle;
  dominant-baseline: central;
`;
const YTitle = ({ label, x, y, dataTestId }) => {
    const fill = useCuroColor('gray');
    return (React.createElement(StyledYTitleText, Object.assign({ fill: fill, x: `${x}px`, y: `${y}px` }, getTestIdAttribute(`${dataTestId}-y-title`)), label));
};

const LineAreaBar = ({ scaleObj, chartType, timeSeriesData, dataTestId, }) => {
    const areaLineRef = useRef(null);
    const colors = useColors();
    useEffect(() => {
        const { xType, xScaleDomain, xScaleRange, yScaleDomain, yScaleRange, halfInterval } = scaleObj;
        if (areaLineRef && areaLineRef.current) {
            let xScale;
            let fullHalfWith;
            if (xType === 'time') {
                xScale = scaleTime()
                    .domain(xScaleDomain)
                    .range(xScaleRange);
                fullHalfWith =
                    xScale(xScaleDomain[1]) - xScale(new Date(xScaleDomain[1].getTime() - halfInterval));
            }
            else {
                xScale = scaleLinear()
                    .domain(xScaleDomain)
                    .range(xScaleRange);
                fullHalfWith =
                    xScale(xScaleDomain[1]) - xScale(xScaleDomain[1] - halfInterval);
            }
            const yScale = scaleLinear()
                .domain(yScaleDomain)
                .range(yScaleRange);
            const container = select(areaLineRef.current);
            removeAllChildren(container);
            const getHalfWidth = () => {
                if (fullHalfWith * 0.15 > 1) {
                    return fullHalfWith * 0.85;
                }
                if (fullHalfWith > 3) {
                    return fullHalfWith - 1;
                }
                return fullHalfWith * 0.5;
            };
            const halfWidth = getHalfWidth();
            const seriesLastIndex = timeSeriesData.length - 1;
            for (let i = seriesLastIndex; i >= 0; i--) {
                const timeSeriesDataItem = timeSeriesData[i];
                for (let j = 0; j < timeSeriesDataItem.length; j++) {
                    const timeSeriesDataInItem = timeSeriesDataItem[j];
                    const seriesColor = timeSeriesDataItem[j][0].color;
                    if (chartType === 'bar') {
                        timeSeriesDataInItem.forEach(({ value, base, x: xVal }, itemIndex) => {
                            const getLastItemValue = () => {
                                for (let k = seriesLastIndex; k > i; k--) {
                                    if (timeSeriesData[k][j] && timeSeriesData[k][j][itemIndex]) {
                                        return timeSeriesData[k][j][itemIndex].value;
                                    }
                                }
                                return value;
                            };
                            const checkIsLastItem = () => {
                                if (i === seriesLastIndex) {
                                    return true;
                                }
                                return getLastItemValue() === value;
                            };
                            const isLastItem = checkIsLastItem();
                            const x = xScale(xVal) - halfWidth;
                            const y = yScale(value);
                            const y0 = yScale(base);
                            const barHeight = y0 - y;
                            const w = 2 * halfWidth;
                            if (isLastItem && barHeight > borderRadius$1 && halfWidth > borderRadius$1) {
                                const d = `M${x},${y + borderRadius$1} ${getCurve(x + borderRadius$1, y)} L${x + w - borderRadius$1},${y} ${getCurve(x + w, y + borderRadius$1)} L${x + w},${y0} L${x},${y0} L${x},${y + borderRadius$1}`;
                                container
                                    .append('path')
                                    .attr('d', d)
                                    .attr('fill', seriesColor)
                                    .attr('stroke-width', 0);
                            }
                            else if (value > base) {
                                if (!isLastItem) {
                                    // segement
                                    container
                                        .append('rect')
                                        .attr('x', x)
                                        .attr('y', y)
                                        .attr('width', w)
                                        .attr('height', 1)
                                        .attr('fill', colors.white);
                                }
                                container
                                    .append('rect')
                                    .attr('x', x)
                                    .attr('y', isLastItem ? y : y + 1)
                                    .attr('width', w)
                                    .attr('height', isLastItem ? barHeight : barHeight - 1)
                                    .attr('fill', seriesColor);
                            }
                        });
                    }
                    else if (chartType === 'column') {
                        timeSeriesDataInItem.forEach(({ value, x: xVal }) => {
                            const colCount = timeSeriesData.length;
                            const groupGap = colCount > 1 ? fullHalfWith / 3 : 0;
                            const w = (fullHalfWith - groupGap) * 0.85 * 2 / colCount;
                            const halfGap = (fullHalfWith - groupGap) * 0.15 / colCount;
                            const x = xScale(xVal) - fullHalfWith + groupGap + i * (w + halfGap * 2) + halfGap;
                            const y = yScale(value);
                            const y0 = yScale(0);
                            const d = `M${x},${y + borderRadius$1} ${getCurve(x + borderRadius$1, y)} L${x + w - borderRadius$1},${y} ${getCurve(x + w, y + borderRadius$1)} L${x + w},${y0} L${x},${y0} L${x},${y + borderRadius$1}`;
                            container
                                .append('path')
                                .attr('d', d)
                                .attr('fill', seriesColor)
                                .attr('stroke-width', 0);
                        });
                    }
                    else {
                        // Line, Area
                        const xAccessor = (d) => xScale(d.x);
                        const yAccessor = (d) => yScale(d.value);
                        const lineCurve = line()
                            .x(xAccessor)
                            .y(yAccessor);
                        if (chartType === 'area') {
                            const areaPath = area()
                                .x(xAccessor)
                                .y1(yAccessor)
                                .y0((d) => yScale(d.base));
                            container
                                .append('path')
                                .data([timeSeriesDataInItem])
                                .attr('transform', 'translate(0, 0 )')
                                .attr('fill', colors.white)
                                .attr('d', areaPath);
                            container
                                .append('path')
                                .data([timeSeriesDataInItem])
                                .attr('transform', 'translate(0, 0 )')
                                .attr('fill', seriesColor)
                                .attr('opacity', AlignConstants.areaOpacity)
                                .attr('d', areaPath);
                        }
                        container
                            .append('path')
                            .data([timeSeriesDataInItem])
                            .attr('transform', 'translate(0, 0 )')
                            .attr('stroke', seriesColor)
                            .attr('fill', 'none')
                            .attr('stroke-width', AlignConstants.lineStroke)
                            .attr('d', lineCurve);
                    }
                    timeSeriesDataInItem.forEach(({ value, x: xVal, ptColor, ptRadius }) => {
                        if (ptColor && ptRadius !== undefined) {
                            const xDate = xScale(xVal);
                            const x = chartType === 'bar' ? xDate - halfWidth : xDate;
                            const y = yScale(value);
                            const pr = (ptRadius * yScaleRange[1] * (yScaleDomain[1] - yScaleDomain[0])) / 100;
                            container
                                .append('circle')
                                .attr('cx', x)
                                .attr('cy', y)
                                .attr('r', pr + 1)
                                .attr('fill', colors.white);
                            container
                                .append('circle')
                                .attr('cx', x)
                                .attr('cy', y)
                                .attr('r', pr)
                                .attr('fill', ptColor);
                        }
                    });
                }
            }
        }
    }, [areaLineRef, chartType, timeSeriesData, scaleObj]);
    return React.createElement("g", Object.assign({ ref: areaLineRef }, getTestIdAttribute(`${dataTestId}-line-area-bar`)));
};

const PlotLines = ({ scaleObj, plotLines }) => {
    const plotLinesRef = useRef(null);
    const colors = useCuroColors();
    useEffect(() => {
        if (plotLinesRef && plotLinesRef.current) {
            const { xScaleRange, yScaleDomain, yScaleRange } = scaleObj;
            const yScale = scaleLinear()
                .domain(yScaleDomain)
                .range(yScaleRange);
            const container = select(plotLinesRef.current);
            removeAllChildren(container);
            for (let i = 0; i < plotLines.length; i++) {
                const { value, status, style } = plotLines[i];
                if (value <= yScaleDomain[1]) {
                    const y = yScale(value);
                    const strokeDash = style === 'dash' ? AlignConstants.lineDash : false;
                    container
                        .append('line')
                        .attr('x1', xScaleRange[0])
                        .attr('x2', xScaleRange[1])
                        .attr('y1', y)
                        .attr('y2', y)
                        .attr('stroke', colors[status])
                        .attr('stroke-width', AlignConstants.lineStroke)
                        .attr('stroke-dasharray', strokeDash);
                }
            }
        }
    }, [plotLinesRef, plotLines, scaleObj]);
    return React.createElement("g", Object.assign({}, getTestIdAttribute('plot-lines'), { ref: plotLinesRef }));
};

const HoveredLine = ({ scaleObj, hoveredXValue, dataTestId, plotLines, timeSeriesData, }) => {
    const hoveredLineRef = useRef(null);
    const { xType, xRatio, xScaleDomain, xScaleRange, yScaleDomain, yScaleRange } = scaleObj;
    const colors = useColors();
    useEffect(() => {
        if (hoveredLineRef && hoveredLineRef.current) {
            let xScale;
            if (xType === 'time') {
                xScale = scaleTime()
                    .domain(xScaleDomain)
                    .range(xScaleRange);
            }
            else {
                xScale = scaleLinear()
                    .domain(xScaleDomain)
                    .range(xScaleRange);
            }
            const yScale = scaleLinear()
                .domain(yScaleDomain)
                .range(yScaleRange);
            const container = select(hoveredLineRef.current);
            removeAllChildren(container);
            const x = xScale(xType === 'time' ? new Date(hoveredXValue * xRatio) : hoveredXValue);
            container
                .append('line')
                .attr('x1', x)
                .attr('x2', x)
                .attr('y1', yScale(yScaleDomain[0]))
                .attr('y2', yScale(yScaleDomain[1]))
                .attr('stroke', colors.default)
                .attr('stroke-width', AlignConstants.tooltipLineStroke);
            const appendCircle = (value, color) => {
                const y = yScale(value);
                // white background
                container
                    .append('circle')
                    .attr('cx', x)
                    .attr('cy', y)
                    .attr('r', 6)
                    .attr('fill', colors.white);
                // outter light color circle
                container
                    .append('circle')
                    .attr('cx', x)
                    .attr('cy', y)
                    .attr('r', 6)
                    .attr('fill', color)
                    .attr('fill-opacity', AlignConstants.areaOpacity);
                // inner circle and white border
                container
                    .append('circle')
                    .attr('cx', x)
                    .attr('cy', y)
                    .attr('r', 3)
                    .attr('fill', color)
                    .attr('stroke', colors.white)
                    .attr('stroke-width', 1);
            };
            if (plotLines && plotLines.length > 0) {
                plotLines.forEach(({ value, status }) => {
                    appendCircle(value, colors[status]);
                });
            }
            timeSeriesData.forEach(item1 => {
                item1.forEach(item2 => {
                    item2.forEach(({ x, value, color, ptColor, ptRadius }) => {
                        if (x / xRatio === hoveredXValue) {
                            if (ptColor && ptRadius !== undefined) {
                                const y = yScale(value);
                                const r = (ptRadius * yScaleRange[1] * (yScaleDomain[1] - yScaleDomain[0])) / 100;
                                container
                                    .append('circle')
                                    .attr('cx', x)
                                    .attr('cy', y)
                                    .attr('r', r + 1)
                                    .attr('fill', colors.white);
                                container
                                    .append('circle')
                                    .attr('cx', x)
                                    .attr('cy', y)
                                    .attr('r', r)
                                    .attr('fill', ptColor)
                                    .attr('fill-opacity', AlignConstants.areaOpacity);
                            }
                            else {
                                appendCircle(value, color);
                            }
                        }
                    });
                });
            });
        }
    }, [
        hoveredLineRef,
        hoveredXValue,
        plotLines,
        timeSeriesData,
        xScaleDomain,
        xScaleRange,
        yScaleDomain,
        yScaleRange,
    ]);
    return React.createElement("g", Object.assign({ ref: hoveredLineRef }, getTestIdAttribute(dataTestId || 'hovered-line')));
};

const { offsetTop: offsetTop$1 } = AlignConstants;
const getXOnDataPoint = (xVal, seriesData) => {
    let xOnDataPoint = 0;
    let minGap = Math.abs(xVal - xOnDataPoint);
    seriesData.forEach(item1 => {
        item1.forEach(item2 => {
            item2.forEach(({ x }) => {
                const gap = Math.abs(xVal - x);
                if (gap < minGap) {
                    minGap = gap;
                    xOnDataPoint = x;
                }
            });
        });
    });
    return xOnDataPoint;
};
const HoverListener = ({ updateHoveredChartName, dataTestId, chartName, nullBands, scaleObj, timeSeriesData, hoveredXValue, updateHoveredXValue, onDrag, }) => {
    const { xType, xRatio, xScaleDomain, xScaleRange, yScaleRange } = scaleObj;
    let xScale;
    if (xType === 'time') {
        xScale = scaleTime()
            .domain(xScaleDomain)
            .range(xScaleRange);
    }
    else {
        xScale = scaleLinear()
            .domain(xScaleDomain)
            .range(xScaleRange);
    }
    const getHoveredX = (event) => {
        if (xType === 'time') {
            const hoveredTime = new Date(xScale.invert(event.nativeEvent.offsetX));
            return hoveredTime.getTime();
        }
        else {
            const hoveredX = xScale.invert(event.nativeEvent.offsetX);
            return hoveredX;
        }
    };
    const [dragStart, setDragStart] = useState(0);
    const [dragMove, setDragMove] = useState(0);
    const mouseHandlers = {
        mouseOverOrMove: (event) => {
            if (dragStart > 0 && onDrag) {
                // Drag and Zoom in
                setDragMove(getHoveredX(event));
            }
            updateHoveredChartName(chartName);
            const hoveredX = getHoveredX(event);
            const isOnNullsBand = nullBands.some(([start, end]) => {
                return hoveredX >= start && hoveredX <= end;
            });
            const x = Math.round(getXOnDataPoint(hoveredX, timeSeriesData) / xRatio);
            if (updateHoveredXValue) {
                if (!isOnNullsBand) {
                    if (hoveredXValue !== x) {
                        updateHoveredXValue(x);
                    }
                }
                else {
                    updateHoveredXValue(undefined);
                }
            }
        },
        mouseLeave: () => {
            console.error('mouseLeave called');
            updateHoveredChartName(undefined);
            if (updateHoveredXValue) {
                updateHoveredXValue(undefined);
            }
        },
        mouseUp: (event) => {
            if (onDrag) {
                const end = getHoveredX(event) / xRatio;
                const start = dragStart / xRatio;
                setDragStart(0);
                if (end > start) {
                    onDrag(Math.round(start), Math.round(end));
                }
            }
        },
        mouseDown: (event) => {
            setDragStart(getHoveredX(event));
        },
    };
    return (React.createElement(React.Fragment, null,
        dragStart > 0 && dragMove > dragStart && (React.createElement(PlotBands, { bands: [[dragStart, dragMove]], status: "forecast", opacity: 0.2, dataTestId: `${dataTestId}-drag-brand`, scaleObj: scaleObj })),
        React.createElement("rect", Object.assign({ x: xScaleRange[0], y: offsetTop$1, width: xScaleRange[1] - xScaleRange[0], height: yScaleRange[0] - yScaleRange[1], fill: "none", fillOpacity: "0", pointerEvents: "all", strokeWidth: "0", strokeOpacity: "0", onMouseOver: mouseHandlers.mouseOverOrMove, onFocus: mouseHandlers.mouseOverOrMove, onMouseMove: mouseHandlers.mouseOverOrMove, onMouseLeave: mouseHandlers.mouseLeave, onMouseDown: onDrag ? mouseHandlers.mouseDown : undefined, onMouseUp: onDrag ? mouseHandlers.mouseUp : undefined }, getTestIdAttribute(`${dataTestId}-hover-listener-rect`)))));
};

const ChartBody = ({ timeSeriesData, scaleObj, chartType, nullBands, plotBands, plotLines, dataTestId, chartName, updateHoveredChartName, hoveredXValue, updateHoveredXValue, onDrag, }) => {
    const { xRatio } = scaleObj;
    return (React.createElement(React.Fragment, null,
        plotBands &&
            plotBands.length > 0 &&
            plotBands.map(({ range, status, top }, i) => {
                const rangeInMs = range.map(([s, e]) => {
                    return [s * xRatio, e * xRatio];
                });
                if (top !== true) {
                    return (
                    // eslint-disable-next-line react/no-array-index-key
                    React.createElement(Fragment, { key: `${status}-${i}` },
                        React.createElement(PlotBands, { key: `plot-${rangeInMs[0]}`, scaleObj: scaleObj, bands: rangeInMs, dataTestId: `${dataTestId}-plot-band-${i}`, status: status })));
                }
                // eslint-disable-next-line react/no-array-index-key
                return React.createElement(Fragment, { key: `${status}-${i}` });
            }),
        React.createElement(LineAreaBar, { scaleObj: scaleObj, timeSeriesData: timeSeriesData, chartType: chartType, dataTestId: dataTestId }),
        plotBands &&
            plotBands.length > 0 &&
            plotBands.map(({ range, status, top }, i) => {
                const rangeInMs = range.map(([s, e]) => {
                    return [s * xRatio, e * xRatio];
                });
                if (top === true) {
                    return (
                    // eslint-disable-next-line react/no-array-index-key
                    React.createElement(Fragment, { key: `${status}-${i}` },
                        React.createElement(PlotBands, { key: `plot-${rangeInMs[0]}`, scaleObj: scaleObj, bands: rangeInMs, dataTestId: `${dataTestId}-plot-band-${i}`, status: status, opacity: 1 })));
                }
                // eslint-disable-next-line react/no-array-index-key
                return React.createElement(Fragment, { key: `${status}-${i}` });
            }),
        plotLines && plotLines.length > 0 && React.createElement(PlotLines, { scaleObj: scaleObj, plotLines: plotLines }),
        hoveredXValue !== undefined && (React.createElement(HoveredLine, { scaleObj: scaleObj, hoveredXValue: hoveredXValue, dataTestId: `${dataTestId}-hovered-line`, timeSeriesData: timeSeriesData, plotLines: plotLines })),
        updateHoveredChartName && updateHoveredXValue && (React.createElement(HoverListener, { scaleObj: scaleObj, nullBands: nullBands, chartName: chartName || dataTestId, updateHoveredChartName: updateHoveredChartName, hoveredXValue: hoveredXValue, updateHoveredXValue: updateHoveredXValue, dataTestId: dataTestId, timeSeriesData: timeSeriesData, onDrag: onDrag }))));
};

const { yTitleWidth, offsetTop, offsetRight, xTitleHeight, YAxisBase, YAxisChar, margin, minWidth, } = AlignConstants;
const seriesChartStatsInitData = {
    xType: 'category',
    xRatio: 1,
    statsData: [],
    labels: [],
    nulls: [],
    maxValue: 0,
    minXValue: 0,
    maxXValue: 0,
    halfInterval: 0,
};
const StyledSVG = styled.svg.withConfig({ displayName: "StyledSVG", componentId: "sc-wbdydi" }) `
  margin: ${margin}px;
  width: calc(100% - ${2 * margin}px);
  min-width: ${minWidth}px;
`;
const SeriesChartBase = ({ yTitle, chartName, height = 'medium', series, dataTestId, isLoading = false, emptyMessage = 'No data available', chartType, 
// TODO deprecated, remove in next Major release
hoveredTimeStamp, 
// TODO deprecated, remove in next Major release
updateHoveredTimeStamp, hoveredXValue, updateHoveredXValue, updateHoveredChartName, yScaleMax, updateYscaleMax, plotLines, plotBands, onDrag, }) => {
    const svgHeight = ChartHeightOBJ[height];
    const svgRef = useRef(null);
    const [noDataOrLoading, setNoDataOrLoading] = useState(false);
    const [width, setWidth] = useState(0);
    const [chartWidth, setChartWidth] = useState(0);
    const [chartHeight, setChartHeight] = useState(0);
    const [yAxisWidth, setYAxisWidth] = useState(30);
    const [scaleObj, setScaleObj] = useState({
        xType: 'category',
        xRatio: 1,
        labels: [],
        xScaleDomain: [0, 0],
        xScaleRange: [0, 0],
        yScaleDomain: [0, 0],
        yScaleRange: [0, 0],
        halfInterval: 0,
    });
    const [seriesChartStatsData, setSeriesChartStatsData] = useState(seriesChartStatsInitData);
    useEffect(() => {
        const handleResize = () => {
            if (svgRef &&
                svgRef.current &&
                svgRef.current.parentElement &&
                svgRef.current.parentElement.clientWidth) {
                const parentWidth = svgRef.current.parentElement.clientWidth - 2 * margin;
                if (width !== parentWidth) {
                    setWidth(parentWidth > minWidth ? parentWidth : minWidth);
                }
            }
        };
        if (svgRef && svgRef.current) {
            handleResize();
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [svgRef, width]);
    useEffect(() => {
        // componentWillUnmount
        return () => {
            if (updateHoveredXValue && updateHoveredChartName) {
                updateHoveredChartName(undefined);
                updateHoveredXValue(undefined);
            }
            // TODO deprecated, remove in next Major release
            if (updateHoveredTimeStamp && updateHoveredChartName) {
                logger('hoveredTimeStamp and updateHoveredTimeStamp is deprecated, use hoveredXValue and updateHoveredXValue', 'error');
                updateHoveredChartName(undefined);
                updateHoveredTimeStamp(undefined);
            }
        };
    }, [updateHoveredChartName, updateHoveredTimeStamp, updateHoveredXValue]);
    useEffect(() => {
        const noData = series === undefined || series.length === 0 || series.every(item => item.data.length === 0);
        const isNoData = isLoading || noData;
        setNoDataOrLoading(isNoData);
    }, [isLoading, series]);
    const colors = useColors();
    useEffect(() => {
        if (series && series.length > 0 && width > 0) {
            const nonEmptySeries = series;
            const curData = getSeriesChartStatsData(chartType, nonEmptySeries, colors);
            setSeriesChartStatsData(curData);
        }
        else {
            setSeriesChartStatsData(seriesChartStatsInitData);
        }
    }, [chartType, series, width, colors]);
    useEffect(() => {
        if (seriesChartStatsData.maxValue > 0) {
            const { xType, xRatio, labels, maxValue, minXValue, maxXValue, halfInterval } = seriesChartStatsData;
            const yMax = yScaleMax || maxValue;
            if (!yScaleMax && updateYscaleMax) {
                updateYscaleMax(yMax);
            }
            // TODO: Category
            const xScaleDomain = xType === 'time' ? extent([new Date(minXValue), new Date(maxXValue)]) : [minXValue, maxXValue];
            const yMaxLength = yMax.toString().length;
            const YAxisExtra = yMaxLength > 3 ? (yMaxLength - 2) * YAxisChar : 0;
            const curYAxisWidth = YAxisBase + YAxisExtra;
            const curChartWidth = width - yTitleWidth - curYAxisWidth - offsetRight;
            const curChartHeight = svgHeight - xTitleHeight - offsetTop;
            setYAxisWidth(curYAxisWidth);
            setChartWidth(curChartWidth);
            setChartHeight(curChartHeight);
            setScaleObj({
                xType,
                xRatio,
                labels,
                xScaleDomain,
                xScaleRange: [yTitleWidth + curYAxisWidth, width - offsetRight],
                yScaleDomain: [0, yMax],
                yScaleRange: [svgHeight - xTitleHeight, offsetTop],
                halfInterval,
            });
        }
    }, [svgHeight, seriesChartStatsData, updateYscaleMax, width, yScaleMax]);
    return (React.createElement(StyledSVG, Object.assign({ ref: svgRef, height: svgHeight }, getTestIdAttribute(dataTestId)),
        noDataOrLoading && (React.createElement(NoDataChart, { dataTestId: dataTestId, label: isLoading ? 'Loading' : emptyMessage })),
        !noDataOrLoading && scaleObj.yScaleDomain[1] > 0 && (React.createElement(React.Fragment, null,
            seriesChartStatsData.nulls && seriesChartStatsData.nulls.length > 0 && (React.createElement(PlotBands, { scaleObj: scaleObj, bands: seriesChartStatsData.nulls, status: "lightGray", dataTestId: `${dataTestId}-gray-band` })),
            React.createElement(YAxis, { scaleObj: scaleObj, height: height, dataTestId: dataTestId, chartWidth: chartWidth, yAxisWidth: yAxisWidth }),
            React.createElement(ChartBody, { timeSeriesData: seriesChartStatsData.statsData, scaleObj: scaleObj, nullBands: seriesChartStatsData.nulls, chartType: chartType, plotBands: plotBands, plotLines: plotLines, hoveredXValue: hoveredTimeStamp || hoveredXValue, chartName: chartName, dataTestId: dataTestId, updateHoveredChartName: updateHoveredChartName, updateHoveredXValue: updateHoveredTimeStamp || updateHoveredXValue, onDrag: onDrag }),
            React.createElement(XAxis, { scaleObj: scaleObj, dataTestId: dataTestId, chartHeight: chartHeight, chartWidth: chartWidth, chartType: chartType }),
            React.createElement(YTitle, { label: yTitle, x: yTitleWidth / 2, y: chartHeight / 2 + offsetTop, dataTestId: dataTestId })))));
};

const LineChart = (props) => {
    return React.createElement(SeriesChartBase, Object.assign({ chartType: "line" }, props));
};

const AreaChart = (props) => {
    return React.createElement(SeriesChartBase, Object.assign({ chartType: "area" }, props));
};

const BarChart = (props) => {
    return React.createElement(SeriesChartBase, Object.assign({ chartType: "bar" }, props));
};

const ColumnChart = (props) => {
    return React.createElement(SeriesChartBase, Object.assign({ chartType: "column" }, props));
};

const colorSourceMap = {
    neutral: getInternalColorMapping('neutral'),
    striped: 'meter.striped',
};
const LinearGradientDef = () => {
    const colors = useColors(colorSourceMap);
    const id = useLinearGradientId();
    return (React.createElement("defs", null,
        React.createElement("pattern", { id: id, patternUnits: "userSpaceOnUse", width: "4", height: "4" },
            React.createElement("rect", { width: "4", height: "4", fill: ` ${colors.neutral}` }),
            React.createElement("path", { d: "M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2", stroke: colors.striped, strokeWidth: "1" }))));
};

const barThicknessSizes = {
    xsmall: 4,
    small: 6,
    medium: 8,
    large: 12,
};
const getPathD = (sum, percentage, width, height, firstItem, lastItem) => {
    const start = (width * (sum - percentage)) / 100;
    const end = (width * sum) / 100;
    // LEFT curve / rect, start from bottom
    let pathD = `M${start + borderRadius$1},${height}`;
    if (firstItem || start < borderRadius$1) {
        pathD = `${pathD} ${getCurve(start, height - borderRadius$1)} L${start},${borderRadius$1}`;
        pathD = `${pathD} ${getCurve(start + borderRadius$1, 0)}`;
    }
    else {
        pathD = `${pathD} L${start},${height} L${start},0 L${start + borderRadius$1},0`;
    }
    // TOP line
    pathD = `${pathD} L${end - borderRadius$1},0`;
    // Right curve/line, start from top
    if (lastItem || end - width < borderRadius$1) {
        pathD = `${pathD} ${getCurve(end, borderRadius$1)} L${end},${height - borderRadius$1}`;
        pathD = `${pathD} ${getCurve(end - borderRadius$1, height)}`;
    }
    else {
        pathD = `${pathD} L${end - 1},0 L${end - 1},${height} L${end - borderRadius$1},${height}`;
    }
    // Bottom line
    pathD = `${pathD} M${end - borderRadius$1},${height} L${start + borderRadius$1},${height}`;
    return { pathD, end };
};
const minWdith = 10;
const StackedBar = ({ dataTestId, data, size, thickness = 'medium' }) => {
    const svgRef = useRef(null);
    const height = barThicknessSizes[thickness];
    const [width, setWidth] = useState(0);
    useEffect(() => {
        const handleResize = () => {
            if (size) {
                const sizeWidth = parseInt(StackedBarTheme.global.size[size].split('px')[0], 10);
                if (width !== sizeWidth) {
                    setWidth(sizeWidth);
                }
            }
            else if (svgRef && svgRef.current && svgRef.current.parentElement) {
                let curWidth = svgRef.current.parentElement.clientWidth;
                curWidth = curWidth < minWdith ? minWdith : curWidth;
                if (curWidth && width !== curWidth) {
                    setWidth(curWidth);
                }
            }
        };
        if (svgRef && svgRef.current) {
            handleResize();
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [size, svgRef, width]);
    const [bars, setBars] = useState([]);
    const colors = useColors();
    const barBg = useColor('meter.color');
    useEffect(() => {
        const svgElements = [];
        const segmentDividers = [];
        let sum = 0;
        if (width > 0 && data && data.length > 0) {
            data.forEach((item, index) => {
                const percentage = typeof item === 'number' ? item : item.percentage;
                if (percentage > 0) {
                    sum += percentage;
                    const { pathD, end } = getPathD(sum, percentage, width, height, svgElements.length < 1, sum >= 100);
                    const style = {
                        fill: getPercentDataColor(item, index, colors),
                    };
                    // @ts-ignore
                    svgElements.push(React.createElement("path", { key: `path-${sum}`, d: pathD, style: style }));
                    if (sum < 100) {
                        segmentDividers.push(React.createElement("rect", { key: `divider-${sum}`, x: end - 1, y: "0", width: "1", height: height, fill: colors.white }));
                    }
                }
            });
        }
        const bgPathD = getPathD(100, 100 - sum, width, height, svgElements.length < 1, true).pathD;
        svgElements.push(React.createElement("path", { key: "path-bg", d: bgPathD, fill: barBg }));
        setBars([...svgElements, ...segmentDividers]);
    }, [data, height, width, colors, barBg]);
    return (React.createElement("svg", Object.assign({ ref: svgRef, width: width, height: height }, getTestIdAttribute(dataTestId)),
        React.createElement(LinearGradientDef, null),
        React.createElement("rect", { width: width, height: height, fill: barBg, rx: borderRadius$1, ry: borderRadius$1 }),
        bars.length > 0 &&
            bars.map((item) => {
                return item;
            })));
};

const BarItem = (barItemProps) => {
    const { percentage, dataTestId, isLoading, hasData } = barItemProps;
    if (isLoading || !hasData || percentage === undefined) {
        return (React.createElement(Row, { pad: "none", dataTestId: `${dataTestId}-no-data-row` },
            React.createElement(Column, { pad: "none", size: "100%", align: "end", dataTestId: `${dataTestId}-no-data-column` },
                React.createElement(Text, { label: isLoading ? 'Loading' : 'No Data Available', type: "label", weight: "medium", dataTestId: `${dataTestId}-no-data` }))));
    }
    const { value, seriesIndex } = barItemProps;
    const data = [{ status: seriesIndex, percentage }];
    return (React.createElement(Row, { pad: "xxsmall", dataTestId: `${dataTestId}-data-row` },
        React.createElement(Column, { noPad: true, size: "70%", dataTestId: `${dataTestId}-data-bar-column`, alignSelf: "center" },
            React.createElement(StackedBar, { dataTestId: `${dataTestId}-data-bar`, data: data })),
        React.createElement(Column, { noPad: true, size: "30%", dataTestId: `${dataTestId}-data-column`, alignSelf: "center" },
            React.createElement(Text, { label: (value !== undefined && ` ${value.toString()}`) || '', type: "label", dataTestId: `${dataTestId}-data` }))));
};
const BarSeriesItem = ({ label, unit, barItemArr, dataTestId }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { pad: "xxsmall", dataTestId: `${dataTestId}-label-row` },
            React.createElement(Column, { pad: "none", dataTestId: `${dataTestId}-label-column`, alignSelf: "center" },
                React.createElement(Text, { label: label, type: "title3", weight: "medium", dataTestId: `${dataTestId}-label` })),
            React.createElement(Column, { pad: "none", dataTestId: `${dataTestId}-label-column`, alignSelf: "center" },
                React.createElement(Text, { label: ` (${unit})`, type: "default", weight: "normal", dataTestId: `${dataTestId}-unit` }))),
        barItemArr.map((barItem) => (React.createElement(Fragment, { key: barItem.dataTestId },
            barItem.barLabel && (React.createElement(Row, { pad: "none", dataTestId: `${barItem.dataTestId}-label-row` },
                React.createElement(Column, { pad: "none", dataTestId: `${barItem.dataTestId}-label-column` },
                    React.createElement(Text, { label: ` ${barItem.barLabel}`, type: "label", weight: "medium", dataTestId: `${barItem.dataTestId}-label` })))),
            React.createElement(BarItem, Object.assign({}, barItem)))))));
};
const ChartSideBar = ({ dataTestId, isLoading, hasData, barSeries }) => {
    const barSeriesArr = barSeries.map((item, serIdx) => {
        const barSeriesId = `${dataTestId}-${serIdx}`;
        const barItemArr = item.barItems.map((barItem, barIdx) => {
            return Object.assign(Object.assign({}, barItem), { isLoading,
                hasData, dataTestId: `${barSeriesId}-${barIdx}` });
        });
        return Object.assign(Object.assign({}, item), { barItemArr, dataTestId: barSeriesId });
    });
    return (React.createElement(React.Fragment, null, barSeriesArr.map(item => (React.createElement(BarSeriesItem, Object.assign({ key: item.dataTestId }, item))))));
};

const borderRadius = 2;
const barSizes = {
    small: [12, 12],
    medium: [18, 18],
    large: [120, 60],
};
const d = 'M0,1.63636364 C0,0.732627273 0.732627273,0 1.63636364,0 L10.3636364,0 C11.2674,0 12,0.732627273 12,1.63636364 L12,10.3636364 C12,11.2674 11.2674,12 10.3636364,12 L1.63636364,12 C0.732627273,12 0,11.2674 0,10.3636364 L0,1.63636364 Z M1.85777778,1.34 C1.57181947,1.34 1.34,1.57181947 1.34,1.85777778 L1.34,10.1422222 C1.34,10.4281909 1.57181947,10.66 1.85777778,10.66 L10.1422222,10.66 C10.4281909,10.66 10.66,10.4281909 10.66,10.1422222 L10.66,1.85777778 C10.66,1.57181947 10.4281909,1.34 10.1422222,1.34 L1.85777778,1.34 Z';
const StackedBarBox = ({ dataTestId, status, size = 'small', isActive = true, }) => {
    const [w, h] = barSizes[size];
    const viewBox = `0 0 ${w} ${h}`;
    const colors = useColors();
    const linearGradientId = useLinearGradientId();
    const color = getChartStatusColor(status, colors, linearGradientId);
    const getIcon = () => {
        if (isActive) {
            return (React.createElement("rect", { width: barSizes[size][0], height: barSizes[size][1], fill: color, rx: borderRadius }));
        }
        return React.createElement("path", { d: d, fill: color, strokeWidth: "0" });
    };
    return (React.createElement("svg", Object.assign({ width: w, height: h, viewBox: viewBox }, getTestIdAttribute(dataTestId)),
        React.createElement(LinearGradientDef, null),
        getIcon()));
};

const StyledButton = styled.button.withConfig({ displayName: "StyledButton", componentId: "sc-1opkm1g" }) `
  padding: 5px;
  border-radius: 3px;
  white-space: nowrap;
  border: none;
  display: inline;
  background: none;
  font: inherit;
  cursor: pointer;
  &:hover {
    background: ${props => getStyledInternalColor(props, 'solitude')} !important;
  }
  &:focus {
    outline: none;
  }
`;
const StyledSpan = styled.span.withConfig({ displayName: "StyledSpan", componentId: "sc-d5mx40" }) `
  padding: 5px;
  white-space: nowrap;
  border: none;
  display: inline;
  background: none;
`;
const getLabelText = (label, id) => {
    return React.createElement(Text, { label: label, type: "label", dataTestId: id });
};
const getLabelInColumn = (label, id) => {
    return (React.createElement(Column, { pad: "none", alignSelf: "center" }, getLabelText(label, id)));
};
const getLegendItem = (status, labelOrComp, id, isActive, stacked) => {
    const comp = typeof labelOrComp === 'string' ? getLabelText(labelOrComp, id) : labelOrComp;
    return (React.createElement(React.Fragment, null,
        React.createElement(Column, { noPad: true, alignSelf: "center" },
            React.createElement(StackedBarBox, { dataTestId: `${id}-box`, status: status, isActive: isActive })),
        getLabelInColumn(' ', 'space'),
        React.createElement(Column, { noPad: true, expand: stacked, alignSelf: "center" }, comp)));
};
const getLegendBody = (item, index, prefix, stacked) => {
    const id = `${prefix}-${index}`;
    if (typeof item === 'string') {
        return {
            body: getLegendItem(index, item, id, true, stacked),
            isButton: false,
        };
    }
    const isString = typeof item.label === 'string';
    const status = item.status === undefined ? index : item.status;
    const isActive = item.active === undefined ? true : item.active;
    if (item.href) {
        // Link Legend
        if (isString) {
            const linkComp = (React.createElement(Link, { label: item.label, type: "label", dataTestId: `${id}-text`, href: item.href }));
            return {
                body: getLegendItem(status, linkComp, id, isActive, stacked),
                isButton: false,
            };
        }
        const linkComp = (React.createElement(Link, { type: "label", dataTestId: `${id}-text`, href: item.href }, item.label));
        return {
            body: getLegendItem(status, linkComp, id, isActive, stacked),
            isButton: false,
        };
    }
    if (!item.onClick) {
        return {
            body: getLegendItem(status, item.label, id, isActive, stacked),
            isButton: false,
        };
    }
    // Clickable Legend
    const comp = isString ? getLabelText(item.label, id) : item.label;
    return {
        body: getLegendItem(status, comp, id, isActive, stacked),
        isButton: true,
    };
};
const getLegend = (item, index, prefix, stacked) => {
    const { body, isButton } = getLegendBody(item, index, prefix, stacked);
    if (stacked) {
        return body;
    }
    const Wrapper = isButton ? StyledButton : StyledSpan;
    const anyItem = item;
    return (React.createElement(React.Fragment, null,
        React.createElement(Column, { noPad: true },
            React.createElement(Wrapper, Object.assign({ onClick: () => {
                    if (anyItem && anyItem.onClick) {
                        anyItem.onClick();
                    }
                } }, getTestIdAttribute(`${prefix}-${index}-wrapper`)),
                React.createElement(Row, { noPad: true }, body))),
        getLabelInColumn('   ', 'space')));
};
const getPlotItem = ({ label, value, icon, status }, prefix) => {
    const id = `${prefix}-${label}-${value}`;
    return (React.createElement(Column, { noPad: true },
        React.createElement(StyledSpan, Object.assign({}, getTestIdAttribute(`${id}-wrapper`)),
            React.createElement(Row, { noPad: true },
                React.createElement(Column, { noPad: true, alignSelf: "center" },
                    React.createElement(Icon, { name: icon, status: status, dataTestId: `${id}-icon`, size: "xsmall" })),
                getLabelInColumn(' ', 'space'),
                getLabelInColumn(label, id),
                getLabelInColumn(' ', 'space'),
                React.createElement(Column, { noPad: true },
                    React.createElement(Text, { label: value, type: "label", status: "default", dataTestId: `${id}-value` })),
                getLabelInColumn('   ', 'space')))));
};
const Legend = ({ legendLabels, plotLegends = [], dataTestId, stacked = false, }) => {
    const getLegendWrapper = (item, index, prefix) => {
        const key = `${prefix}-${index}`;
        if (stacked) {
            return (React.createElement(Row, { align: "start", pad: { horizontal: '5px', vertical: '5px' }, key: key, dataTestId: key }, getLegend(item, index, prefix, stacked)));
        }
        return React.createElement(Fragment, { key: key }, getLegend(item, index, prefix, false));
    };
    const getPlotWrapper = (item, prefix) => {
        const key = `${prefix}-${item.label}-${item.value}`;
        if (stacked) {
            return (React.createElement(Row, { align: "start", noPad: true, key: key, dataTestId: key }, getPlotItem(item, prefix)));
        }
        return React.createElement(Fragment, { key: key }, getPlotItem(item, prefix));
    };
    return (React.createElement(Row, { align: "center", noPad: true, dataTestId: dataTestId },
        legendLabels.map((item, index) => getLegendWrapper(item, index, `${dataTestId}-legend`)),
        plotLegends.map(item => getPlotWrapper(item, `${dataTestId}-plot`))));
};

const areSameIds = (arr1, arr2) => {
    return arr1.every((item, i) => {
        return item.id === arr2[i].id;
    });
};
const getIds = (arr) => {
    return arr
        .map(({ id }) => {
        return id;
    })
        .join('-');
};
const StatsDataFetch = (props) => {
    const { statsInterval, setRefreshedInterval, statsSelectedOption, setStatsData, setIsLoadingStats, } = props;
    const { statsList, getStatsRequestInfoList, fetchStatsData, statsPaused } = props;
    const [statsRequestInfo, setStatsRequestInfo] = useState([]);
    const [curFetchId, setCurFetchId] = useState('');
    const [intervalId, setIntervalId] = useState();
    const mounted = useRef(null);
    useEffect(() => {
        const isListDiff = !statsList || !statsRequestInfo || statsList.length !== statsRequestInfo.length || !areSameIds(statsList, statsRequestInfo);
        if (isListDiff && mounted && mounted.current) {
            setStatsRequestInfo(getStatsRequestInfoList(statsList));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mounted, statsList]);
    useEffect(() => {
        const isValidOption = statsInterval &&
            statsInterval.startTime > 0 &&
            statsRequestInfo &&
            statsRequestInfo.length > 0;
        if (isValidOption) {
            const statsRequestInfoIds = getIds(statsRequestInfo);
            const newStatsFetchId = `${statsRequestInfoIds}-${statsInterval.interval}-${statsInterval.startTime}-${statsPaused}-${statsSelectedOption}`;
            if (newStatsFetchId !== curFetchId && mounted && mounted.current) {
                setCurFetchId(newStatsFetchId);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statsRequestInfo, statsPaused, statsSelectedOption, statsInterval]);
    useEffect(() => {
        const pollStatsCallback = (isFirstPolling) => __awaiter(void 0, void 0, void 0, function* () {
            if (!(mounted && mounted.current)) {
                return;
            }
            if (statsSelectedOption === 'realTime' && statsPaused) {
                return;
            }
            const newInterval = statsSelectedOption === 'custom'
                ? statsInterval
                : StatsIntervalOptions[statsSelectedOption]();
            if (setRefreshedInterval) {
                yield setRefreshedInterval(newInterval);
            }
            const dataToReturn = [];
            const promises = statsRequestInfo.map((statsRequestItem) => {
                return fetchStatsData(newInterval, statsRequestItem, dataToReturn);
            });
            if (isFirstPolling) {
                yield setIsLoadingStats(true);
            }
            yield Promise.all(promises).then(( /* response */) => {
                if (mounted && mounted.current) {
                    setStatsData(dataToReturn);
                    if (isFirstPolling) {
                        setTimeout(() => {
                            setIsLoadingStats(false);
                        }, 100); // add a short delay to cover rendering
                    }
                }
            });
        });
        const updateAndPull = () => {
            if (!curFetchId) {
                return;
            }
            pollStatsCallback(true);
            const { refresh } = statsInterval;
            if (refresh) {
                if (intervalId !== undefined) {
                    clearInterval(intervalId);
                }
                const newId = window.setInterval(() => {
                    if (mounted && mounted.current) {
                        if (intervalId !== newId) {
                            setIntervalId(newId);
                        }
                        pollStatsCallback(false);
                    }
                }, refresh * 1000);
            }
        };
        updateAndPull();
        return () => {
            // componentWillUnmount
            if (intervalId !== undefined) {
                clearInterval(intervalId);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [curFetchId]);
    return React.createElement("div", { ref: mounted });
};

/* eslint-disable react/require-default-props */
const start = {
    date: 'Start',
    dateName: 'startDate',
    time: '',
    timeName: 'startTime',
};
const end = {
    date: 'End',
    dateName: 'endDate',
    time: '',
    timeName: 'endTime',
};
const DateAndTimeInput = ({ dateTimeInfo, setDataTimeInfo, dataTestId, isStart = false, isFocusStart, setIsFocusStart, }) => {
    const label = isStart ? start : end;
    const [date, setDate] = useState(dateTimeInfo.date);
    const [time, setTime] = useState(dateTimeInfo.time);
    const [timeInputClick, setTimeInputClick] = useState(false);
    const focus = useInternalColor('focus');
    const targetRef = useRef(null);
    const inputBoxColor = useCuroColor('default');
    useEffect(() => {
        setDate(dateTimeInfo.date);
    }, [dateTimeInfo.date]);
    const dateUpdated = (d) => {
        setDate(d);
    };
    const dateUpdatedInCalender = () => {
        if (date) {
            const d = getDateByString(date);
            setDate(d);
            setDataTimeInfo(Object.assign(Object.assign({}, dateTimeInfo), { date: d }));
        }
    };
    const timeUpdated = (t) => {
        setTime(t);
    };
    const updateTimetoCorrectFormat = () => {
        if (time) {
            const t = getHHMMByString(time);
            setTime(t);
            setDataTimeInfo(Object.assign(Object.assign({}, dateTimeInfo), { time: t }));
        }
    };
    const initialFocusSetup = () => {
        const isFocusEnd = !isFocusStart;
        if (targetRef) {
            if (label.dateName === 'startDate') {
                targetRef.current.childNodes[0].childNodes[0].style.boxShadow =
                    isFocusStart && !timeInputClick ? `0 0 2px 3px  ${focus}` : 'none';
            }
            if (label.dateName === 'endDate') {
                targetRef.current.childNodes[0].childNodes[0].style.boxShadow =
                    isFocusEnd && !timeInputClick ? `0 0 2px 3px  ${focus}` : 'none';
            }
        }
    };
    useEffect(initialFocusSetup, [isFocusStart, timeInputClick]); // componentDidMount for by default focus
    useEffect(() => {
        if ((isFocusStart && timeInputClick && label.dateName === 'endDate') ||
            (!isFocusStart && timeInputClick && label.dateName === 'startDate')) {
            setTimeInputClick(false);
        }
    }, [isFocusStart, label.dateName, timeInputClick]);
    const updateFocusOnClick = () => {
        if (label.dateName === 'startDate') {
            setTimeInputClick(false);
            setIsFocusStart(true);
        }
        if (label.dateName === 'endDate') {
            setIsFocusStart(false);
            setTimeInputClick(false);
        }
    };
    const updateFocusOnClickTime = () => {
        if (label.timeName === 'startTime') {
            setIsFocusStart(true);
            setTimeInputClick(true);
        }
        if (label.timeName === 'endTime') {
            setIsFocusStart(false);
            setTimeInputClick(true);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Column, { noPad: true, size: "1%", dataTestId: `${dataTestId}-date-gap` }),
        React.createElement(Column, { noPad: true, size: "26%", dataTestId: `${dataTestId}-date-col` },
            React.createElement(FormField, { label: label.date, name: `${label.dateName}-field`, dataTestId: `${dataTestId}-date`, onBlur: dateUpdatedInCalender },
                React.createElement(Box, { ref: targetRef, onClick: updateFocusOnClick, style: { color: inputBoxColor } },
                    React.createElement(TextInput, { value: date, onChange: (e) => {
                            dateUpdated(e.target.value);
                        }, name: label.dateName, mask: dateMaskYYYYMMDD })))),
        React.createElement(Column, { noPad: true, size: "1%", dataTestId: `${dataTestId}-date-gap` }),
        React.createElement(Column, { noPad: true, size: "18%", dataTestId: `${dataTestId}-time-col` },
            React.createElement(FormField, { label: label.time, name: `${label.timeName}-field`, dataTestId: `${dataTestId}-time`, onBlur: updateTimetoCorrectFormat },
                React.createElement(Box, { onClick: updateFocusOnClickTime, style: { color: inputBoxColor } },
                    React.createElement(TextInput, { value: time, onChange: (e) => {
                            timeUpdated(e.target.value);
                        }, name: label.timeName, mask: timeMaskHHMM })))),
        React.createElement(Column, { noPad: true, size: "1%", dataTestId: `${dataTestId}-date-gap` })));
};

const SvgTooltip = ({ x, y, width, height, dataTestId, tooltip, tooltipWidth }) => {
    const target = React.createElement("div", { style: { width, height } });
    return (React.createElement("foreignObject", { x: x, y: y, width: width, height: height },
        React.createElement(Tooltip, { dataTestId: `${dataTestId}-tooltip`, tooltip: tooltip, target: target, align: ['bottom', 'left'], width: tooltipWidth })));
};

const daysOfWeekArr = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
const boxSize = 27.42;
const halfSize = 13.71; // boxSize / 2
const dateFormat = 'YYYY-MM-DD';
const getOpacity = (date, dates) => {
    const l = dates.length;
    /* istanbul ignore else */
    if (l < 1) {
        return 0;
    }
    /* istanbul ignore else */
    if (date === dates[0] || date === dates[l - 1]) {
        return 1;
    }
    /* istanbul ignore else */
    if (dates.includes(date)) {
        return 0.15;
    }
    return 0;
};
const StyledSVGText = styled.text.withConfig({ displayName: "StyledSVGText", componentId: "sc-1xvz8vl" }) `
  font-size: ${TextConfigs.label[0]};
  dominant-baseline: middle;
  text-anchor: middle;
`;
const getDaysInMonth = (d) => {
    const refObj = d ? moment(d, dateFormat) : moment();
    const daysInMonth = refObj.daysInMonth();
    const yearMonth = refObj.format('YYYY-MM');
    const day1InWeek = moment(`${yearMonth}-01`, dateFormat).day();
    const daysArr = new Array(daysInMonth);
    for (let i = 0; i < daysInMonth; i++) {
        const val = i + day1InWeek;
        const dayPrefix = i < 9 ? '0' : ''; // day = i + 1
        daysArr[i] = {
            x: val % 7,
            y: Math.floor(val / 7) + 1,
            day: i + 1,
            date: `${yearMonth}-${dayPrefix}${i + 1}`,
        };
    }
    return daysArr;
};

const DateIcon = ({ d, dates, onSelect, tooltip, validRange, dataTestId, }) => {
    const { x, y, day, date } = d;
    const today = moment().format(dateFormat);
    const [opacity, setOpacity] = useState(0);
    const [isHover, setIsHover] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const colors = useCuroColors();
    const [color, setColor] = useState(colors.default);
    useEffect(() => {
        let isValid = true;
        /* istanbul ignore else */
        if (validRange) {
            const [s, e] = validRange;
            isValid = moment(date).isBetween(s, e, 'day') || validRange.includes(date);
        }
        if (isValid) {
            const o = isHover ? 0.3 : getOpacity(date, dates);
            if (o !== opacity) {
                setIsDisabled(false);
                setOpacity(o);
                setColor(o === 1 ? colors.white : colors.default);
            }
            else if (tooltip === getI18nStr('setStartDate') && (date <= today || date >= dates[0])) {
                setColor(colors.default);
            }
        }
        else {
            setOpacity(0);
            setColor(colors.disabled);
            setIsDisabled(true);
        }
    }, [date, dates, isHover, opacity, validRange, colors]);
    const xPos = boxSize * x;
    const yPos = boxSize * y;
    const hoverProps = {
        onMouseOver: () => {
            /* istanbul ignore else */
            if (!isHover) {
                setIsHover(true);
            }
        },
        onMouseLeave: () => {
            setIsHover(false);
        },
        onFocus: () => {
            /* istanbul ignore else */
            if (!isHover) {
                setIsHover(true);
            }
        },
        onBlur: () => {
            setIsHover(false);
        },
    };
    const pos = { x: xPos, y: yPos, width: boxSize, height: boxSize };
    const onClick = () => {
        /* istanbul ignore else */
        if (!isDisabled) {
            onSelect(date);
        }
    };
    return (React.createElement("g", Object.assign({ onClick: onClick }, hoverProps, { style: { cursor: isDisabled ? 'default' : 'pointer' }, key: date }, getTestIdAttribute(dataTestId)),
        React.createElement("rect", Object.assign({}, pos, { fill: colors.brand, opacity: opacity })),
        React.createElement(StyledSVGText, { x: xPos + halfSize, y: yPos + halfSize },
            React.createElement("tspan", { fill: color, fontWeight: opacity === 1 ? 'bold' : 'normal' }, day)),
        today === date && (React.createElement("circle", { cx: xPos + halfSize, cy: yPos + boxSize - 5, r: 2.5, fill: color })),
        isHover && tooltip && (React.createElement(SvgTooltip, Object.assign({ tooltip: isDisabled ? 'Not Applicable' : tooltip }, pos, { dataTestId: "tip" })))));
};

const Calendar = ({ dataTestId, a11yTitle, reference, dates, onSelect, tooltip, validRange, header = true, }) => {
    const [calRef, setCalRef] = useState(reference);
    const [daysArr, setDaysArr] = useState([]);
    useEffect(() => {
        /* istanbul ignore else */
        if (header !== true && reference !== calRef) {
            // external reference management
            setCalRef(reference);
        }
    }, [calRef, header, reference]);
    useEffect(() => {
        const arr = getDaysInMonth(calRef);
        /* istanbul ignore else */
        if (arr.length !== daysArr.length || arr[0].date !== daysArr[0].date) {
            setDaysArr(arr);
        }
    }, [calRef, daysArr]);
    const defaultHeader = (React.createElement(Row, { noPad: true, align: "center", dataTestId: "calendar-row" },
        React.createElement(Column, { noPad: true, size: "24%", align: "center", dataTestId: `${dataTestId}-col` },
            React.createElement(IconButton, { icon: "previous", onClick: () => {
                    setCalRef(getPreviousMonth(calRef));
                }, dataTestId: "header-start" })),
        React.createElement(Column, { noPad: true, expand: true, align: "center", dataTestId: `${dataTestId}-header-col` },
            React.createElement(Text, { label: getMonthYearByIso(calRef), type: "title3", dataTestId: `${dataTestId}-header-text` })),
        React.createElement(Column, { noPad: true, size: "24%", align: "center", dataTestId: `${dataTestId}-col` },
            React.createElement(IconButton, { icon: "next", onClick: () => {
                    setCalRef(getNextMonth(calRef));
                }, dataTestId: "header-start" }))));
    const black = useCuroColor('black');
    return (React.createElement(Box, Object.assign({ flex: { shrink: 1, grow: 1 }, style: { width: `${boxSize * 7}px` }, direction: "column" }, getTestIdAttribute(dataTestId), { a11yTitle: a11yTitle }),
        header !== false && (React.createElement(Panel, { noPad: true, noShrink: true },
            header === true && defaultHeader,
            header !== true && header)),
        React.createElement(Panel, { noPad: true, noShrink: true, noMarginBottom: true },
            React.createElement("svg", Object.assign({ width: boxSize * 7, height: boxSize * 7 }, getTestIdAttribute(dataTestId), { "aria-label": a11yTitle }),
                daysOfWeekArr.map((d, index) => (
                // eslint-disable-next-line react/no-array-index-key
                React.createElement("g", { key: `${d}-${index}` },
                    React.createElement("rect", { x: boxSize * index, y: 0, width: boxSize, height: boxSize, fill: "none" }),
                    React.createElement(StyledSVGText, { x: boxSize * index + halfSize, y: halfSize, fill: black, fontWeight: getTextWeight('default', 'bold') }, d)))),
                daysArr.map((d) => (React.createElement(DateIcon, { d: d, dates: dates, key: d.date, onSelect: onSelect, tooltip: tooltip, validRange: validRange, dataTestId: `${dataTestId}-${d.day}` })))))));
};

const CalendarSelection = ({ dates, dataTestId, reference, dateClicked, isStart = false, validRange, iconAction, left, }) => {
    const header = (React.createElement(Row, { noPad: true, align: "center", dataTestId: "calendar-row" },
        React.createElement(Column, { noPad: true, size: "24%", align: "center", dataTestId: `${dataTestId}-col` }, left === true && (React.createElement(IconButton, { icon: "previous", type: "button", onClick: iconAction, dataTestId: `${dataTestId}-header-previous` }))),
        React.createElement(Column, { noPad: true, expand: true, align: "center", dataTestId: `${dataTestId}-header-col` },
            React.createElement(Text, { label: getMonthYearByIso(reference), type: "title4", dataTestId: `${dataTestId}-header-text` })),
        React.createElement(Column, { noPad: true, size: "24%", align: "center", dataTestId: `${dataTestId}-col` }, left !== true && (React.createElement(IconButton, { icon: "next", type: "button", onClick: iconAction, dataTestId: `${dataTestId}-header-next` })))));
    return (React.createElement(Column, { noPad: true, size: "47%", dataTestId: `${dataTestId}-col` },
        React.createElement(Calendar, { header: header, onSelect: (date) => {
                dateClicked(date);
            }, reference: reference, dates: dates, dataTestId: dataTestId, a11yTitle: reference, tooltip: isStart ? getI18nStr('setStartDate') : getI18nStr('setEndDate'), validRange: validRange })));
};

const width = 520;
const getValidDates = (validRange) => {
    const { startTime, endTime } = typeof validRange === 'string' ? StatsIntervalOptions[validRange]() : validRange();
    return [getDateBySeconds(startTime), getDateBySeconds(endTime)];
};
const CustomSelection = ({ refElement, setShowCustomModal, dataTestId, setStatsInterval, validRange, startInfo, endInfo, setStartInfo, setEndInfo, }) => {
    const [dateRange, setDateRange] = useState([]);
    const [firstCalRef, setFirstCalRef] = useState(getPreviousMonth());
    const [secondCalRef, setSecondCalRef] = useState(getDate());
    const [isFocusStart, setIsFocusStart] = useState(true);
    const validDates = validRange ? getValidDates(validRange) : undefined;
    const [updatedValidRange, setupdatedValidRange] = useState(validDates);
    const today = moment().format(dateFormat$1);
    const goPreviousMonth = () => {
        setFirstCalRef(getPreviousMonth(firstCalRef));
        setSecondCalRef(getPreviousMonth(secondCalRef));
    };
    const goNextMonth = () => {
        setFirstCalRef(getNextMonth(firstCalRef));
        setSecondCalRef(getNextMonth(secondCalRef));
    };
    useEffect(() => {
        const l = dateRange.length;
        const rangeNeeded = l < 1 || dateRange[0] !== startInfo.date || dateRange[l - 1] !== endInfo.date;
        if (rangeNeeded) {
            const getDateRange = (startDate, endDate) => {
                const range = [];
                if (startDate === '' || endDate === '') {
                    return range;
                }
                let startDay = moment(startDate);
                let endDay = moment(endDate).endOf('day');
                if (startDay.isValid() && endDay.isValid()) {
                    if (!startDay.isBefore(endDay)) {
                        if (isFocusStart) {
                            endDay = startDay.endOf('day');
                            endInfo.date = startDate;
                            endInfo.time = '23:59';
                        }
                        else {
                            startDay = endDay.startOf('day');
                            startInfo.date = endDate;
                            startInfo.time = '00:00';
                        }
                    }
                    for (let day = startDay; day.isBefore(endDay); day = startDay.add(1, 'day')) {
                        range.push(day.format('YYYY-MM-DD'));
                    }
                }
                return range;
            };
            setDateRange(getDateRange(startInfo.date, endInfo.date));
        }
    }, [startInfo.date, endInfo.date, dateRange, startInfo.time, endInfo.time, isFocusStart]);
    useEffect(() => {
        if (!isFocusStart) {
            setupdatedValidRange([startInfo.date, today]);
        }
        else {
            setupdatedValidRange(validDates);
        }
    }, [isFocusStart]);
    const getInterval = () => {
        const startTime = new Date(`${startInfo.date} ${startInfo.time}`);
        const endTime = new Date(`${endInfo.date} ${endInfo.time}`);
        return StatsIntervalOptions.custom(startTime.getTime() / 1000, endTime.getTime() / 1000);
    };
    const handleApplyClicked = () => {
        setShowCustomModal(false);
        const interval = getInterval();
        setStatsInterval(interval);
    };
    const dateClicked = (date) => {
        const object = isFocusStart ? startInfo : endInfo;
        object.date = date;
        object.time = isFocusStart ? '00:00' : '23:59';
        setIsFocusStart(!isFocusStart);
    };
    const Gap = React.createElement(Column, { noPad: true, size: "1%", dataTestId: `${dataTestId}-gap` });
    const CustomForm = (React.createElement(Form, { formTitle: "Select date/time range", submitButtonContent: "Apply", onCancel: () => {
            setShowCustomModal(false);
        }, onSubmit: handleApplyClicked, dataTestId: dataTestId },
        React.createElement(Row, { noPad: true, dataTestId: `${dataTestId}-row`, align: 'end' },
            React.createElement(DateAndTimeInput, { dateTimeInfo: startInfo, dataTestId: `${dataTestId}-start`, setDataTimeInfo: setStartInfo, isFocusStart: isFocusStart, setIsFocusStart: setIsFocusStart, isStart: true }),
            Gap,
            React.createElement(DateAndTimeInput, { dateTimeInfo: endInfo, dataTestId: `${dataTestId}-end`, setDataTimeInfo: setEndInfo, isFocusStart: isFocusStart, setIsFocusStart: setIsFocusStart })),
        React.createElement(Row, { noPad: true, dataTestId: "calendar-row" },
            React.createElement(CalendarSelection, { dates: dateRange, dataTestId: `${dataTestId}-calendar-1`, reference: firstCalRef, dateClicked: dateClicked, isStart: isFocusStart, validRange: updatedValidRange, iconAction: goPreviousMonth, left: true }),
            Gap,
            React.createElement(CalendarSelection, { dates: dateRange, dataTestId: `${dataTestId}-calendar-2`, reference: secondCalRef, dateClicked: dateClicked, isStart: isFocusStart, validRange: updatedValidRange, iconAction: goNextMonth }))));
    return (React.createElement(Tooltip, { eventType: "pinned", dataTestId: `${dataTestId}-custom-range`, tooltip: CustomForm, refElement: refElement, align: ['bottom', 'right'], light: true, width: width, height: 460 }));
};

const statsDefaultOptions = [
    'realTime',
    'last8Hours',
    'last1Day',
    'last1Week',
    'last1Month',
    'last3Months',
    'custom',
];
const emptyInfo = { date: '', time: '' };
const getRangeLabel = ({ startTime, endTime }, statsSelectedOption) => {
    if (startTime === 0) {
        return '';
    }
    const isRealTime = statsSelectedOption === 'realTime';
    const startMethod = isRealTime ? getFullTimeDisplay : getLongTimeDisplay;
    let endMethod = startMethod;
    if (getDate(startTime) === getDate(endTime)) {
        endMethod = isRealTime ? getHHMMSS : getHHMM;
    }
    const label = `${startMethod(startTime)} - ${endMethod(endTime)}`;
    return label;
};
const getDataAndTime = (timeInSec) => {
    const d = getLongTimeDisplay(timeInSec);
    const [date, time] = d.split(' ');
    return { date, time };
};
const StatsTimeSelector = (_a) => {
    var { dataTestId = 'stats-time-selector', statsOptions = statsDefaultOptions } = _a, rest = __rest(_a, ["dataTestId", "statsOptions"]);
    const { setStatsInterval, statsSelectedOption, setStatsSelectedOption, refreshedInterval, statsPaused, setStatsPaused, validRange, } = rest;
    const [showCustomModal, setShowCustomModal] = useState(false);
    const index = statsOptions.indexOf(statsSelectedOption);
    const defaultOption = index !== undefined ? [index] : undefined;
    const ref = useRef(null);
    const [statsPreCusomOption, setStatsPreCusomOption] = useState(statsSelectedOption);
    const [customSelectionStartInfo, setCustomSelectionStartInfo] = useState(emptyInfo);
    const [customSelectionEndInfo, setCustomSelectionEndInfo] = useState(emptyInfo);
    const initialRenderSetup = () => {
        setCustomSelectionStartInfo(getDataAndTime(moment()
            .startOf('day')
            .unix()));
        setCustomSelectionEndInfo(getDataAndTime(moment().unix()));
        if ((!refreshedInterval || refreshedInterval.startTime === 0) &&
            statsSelectedOption !== 'custom') {
            setStatsInterval(StatsIntervalOptions[statsSelectedOption]());
        }
        if (validRange && typeof validRange !== 'string') {
            const { startTime, endTime } = validRange();
            setCustomSelectionStartInfo(getDataAndTime(startTime));
            setCustomSelectionEndInfo(getDataAndTime(endTime));
        }
    };
    useEffect(initialRenderSetup, []);
    const [hasRealTime, setHasRealTime] = useState(false);
    const getButtonOptions = () => {
        const options = [];
        statsOptions.forEach((statsOption) => {
            if (statsOption === 'realTime' && !hasRealTime) {
                setHasRealTime(true);
            }
            const { label, option } = StatsIntervalOptions[statsOption]();
            if (statsOption === 'custom') {
                options.push({
                    icon: 'calendar',
                    onClick: () => {
                        if (showCustomModal && statsSelectedOption === 'custom') {
                            setShowCustomModal(false);
                            setStatsSelectedOption(statsPreCusomOption);
                        }
                        else {
                            setShowCustomModal(true);
                            setStatsPreCusomOption(statsSelectedOption);
                            setStatsSelectedOption('custom');
                        }
                    },
                    clickToUnselect: false,
                    dataTestId: `${dataTestId}-custom`,
                });
            }
            else {
                options.push({
                    label,
                    onClick: (selected) => {
                        const selectedOption = statsOptions[selected[0]];
                        if (statsSelectedOption !== selectedOption) {
                            if (statsSelectedOption === 'realTime' && statsPaused && setStatsPaused) {
                                setStatsPaused(!statsPaused);
                            }
                            setStatsInterval(StatsIntervalOptions[selectedOption]());
                            setStatsSelectedOption(selectedOption);
                        }
                    },
                    clickToUnselect: false,
                    dataTestId: `${dataTestId}-${option}`,
                });
            }
        });
        return options;
    };
    return (React.createElement(Panel, { dataTestId: "state-time-selector-card" },
        React.createElement(Row, { noPad: true, dataTestId: `${dataTestId}-row`, align: "end", justify: "end" },
            hasRealTime && statsSelectedOption === 'realTime' && (React.createElement("span", { style: { marginBottom: '-2px' } },
                React.createElement(Button$1, { size: "small", label: statsPaused ? getI18nStr('resume') : getI18nStr('pause'), onClick: () => {
                        if (setStatsPaused) {
                            setStatsPaused(!statsPaused);
                        }
                    }, dataTestId: `${dataTestId}-pause-resume` }),
                React.createElement(Text, { label: "  ", dataTestId: "space" }))),
            React.createElement(ToggleButton, { defaultOptions: defaultOption, options: getButtonOptions(), dataTestId: "date-time-selector" }),
            React.createElement("span", { ref: ref })),
        React.createElement(Row, { dataTestId: `${dataTestId}-label-row`, align: "end", justify: "end" }, refreshedInterval && refreshedInterval.startTime > 0 && (React.createElement(Text, { label: getRangeLabel(refreshedInterval, statsSelectedOption), dataTestId: `${dataTestId}-time-range` }))),
        React.createElement(React.Fragment, null, showCustomModal && statsSelectedOption === 'custom' && (React.createElement(CustomSelection, { startInfo: customSelectionStartInfo, setStartInfo: setCustomSelectionStartInfo, endInfo: customSelectionEndInfo, setEndInfo: setCustomSelectionEndInfo, setShowCustomModal: setShowCustomModal, refElement: ref, dataTestId: `${dataTestId}-custom-select`, setStatsInterval: setStatsInterval, validRange: validRange })))));
};

const nodeWidth$2 = 130;
const nodeHeight$2 = 48;
const nodeR$1 = 4;
const nodeGap$2 = 30;
const linkHeight$2 = 50;
const padding$2 = 8;
const getWidth = (nodeCount) => {
    return nodeCount * (nodeWidth$2 + nodeGap$2) + padding$2 * 2 - nodeGap$2;
};
const getHeight = (nodeCount = 2) => {
    return (nodeHeight$2 + linkHeight$2 + padding$2) * nodeCount;
};
const size = { nodeWidth: nodeWidth$2, nodeHeight: nodeHeight$2, nodeR: nodeR$1, nodeGap: nodeGap$2, linkHeight: linkHeight$2, padding: padding$2 };
const initPos$1 = {
    startId: '',
    endId: '',
    startLayer: 1,
    startIndex: 0,
    endLayer: 1,
    endIndex: 0,
    startOffset: 0,
    endOffset: 0,
};
const getLinkPosArr = ({ layerNodes, linkProperty, links, renderLinkTooltip, }) => {
    const arr = links.map(linkItem => {
        const pos = Object.assign(Object.assign(Object.assign({}, initPos$1), linkItem), { renderLinkTooltip });
        const { startId, endId } = linkItem;
        layerNodes.forEach((node) => {
            if (node[linkProperty] === startId) {
                pos.startLayer = node.layer;
                pos.startIndex = node.index;
            }
            if (node[linkProperty] === endId) {
                pos.endLayer = node.layer;
                pos.endIndex = node.index;
            }
        });
        return pos;
    });
    arr.forEach(item => {
        const { startId, endId, startIndex, endIndex } = item;
        // start
        const startArr = links.filter(linkItem => {
            return linkItem.startId === startId;
        });
        const linkStartIndex = startArr.findIndex(linkItem => {
            return linkItem.startId === startId && linkItem.endId === endId;
        });
        const startCount = startArr.length;
        item.startOffset = linkStartIndex - startCount / 2;
        // end
        const endArr = links.filter(linkItem => {
            return linkItem.endId === endId;
        });
        const endCount = endArr.length;
        const linkEndIndex = endArr.findIndex(linkItem => {
            return linkItem.startId === startId && linkItem.endId === endId;
        });
        item.endOffset = startIndex === endIndex ? item.startOffset : linkEndIndex - endCount / 2;
    });
    return arr;
};

const textpadding = 10;
const ErrorIcon = ({ x, y, curoColors }) => {
    return (React.createElement("svg", { viewBox: "0 0 24 24", x: x - 9, y: y - 9, width: 18, height: 18 }, Error('error', { size: 'xsmall', colors: curoColors })));
};
const WarningIcon = ({ x, y, curoColors }) => {
    return (React.createElement("svg", { viewBox: "0 0 24 24", x: x - 9, y: y - 9, width: 18, height: 18 }, Warning('warning', { size: 'xsmall', colors: curoColors })));
};
const { nodeWidth: nodeWidth$1, nodeHeight: nodeHeight$1, nodeR, nodeGap: nodeGap$1, linkHeight: linkHeight$1, padding: padding$1 } = size;
const TitleText = styled.text.withConfig({ displayName: "TitleText", componentId: "sc-1mr4jxv" }) `
  font-size: 16px;
  font-weight: 600;
`;
const SubTitleText = styled.text.withConfig({ displayName: "SubTitleText", componentId: "sc-rii807" }) `
  font-size: 14px;
  font-weight: 400;
`;
const NetworkNode = ({ dataTestId, index, layer, borderStatus = 'slate', status, title, subTitle, background = false, renderNodeTooltip, dataItem, }) => {
    const x = padding$1 + (nodeWidth$1 + nodeGap$1) * index;
    const y = padding$1 + (nodeHeight$1 + linkHeight$1) * (layer - 1);
    const [isHover, setIsHover] = useState(false);
    const tooltip = renderNodeTooltip ? renderNodeTooltip(dataItem) : undefined;
    const hoverProps = {
        onMouseOver: () => {
            if (!isHover) {
                setIsHover(true);
            }
        },
        onMouseLeave: () => {
            if (isHover) {
                setIsHover(false);
            }
        },
        onFocus: () => {
            if (!isHover) {
                setIsHover(true);
            }
        },
        onBlur: () => {
            if (isHover) {
                setIsHover(false);
            }
        },
        onMouseUp: () => { },
    };
    const getNodeDetails = () => {
        if (typeof title === 'string') {
            return (React.createElement(React.Fragment, null,
                React.createElement(TitleText, Object.assign({ x: 0, y: 19 }, getTestIdAttribute(`${dataTestId}-title`)), title),
                subTitle &&
                    React.createElement(SubTitleText, Object.assign({ x: 0, y: 40 }, getTestIdAttribute(`${dataTestId}-sub-title`)), subTitle)));
        }
        return (React.createElement("foreignObject", { x: 0, y: 0, width: nodeWidth$1 - 2 * textpadding, height: nodeHeight$1 }, title));
    };
    const curoColors = useCuroColors();
    return (React.createElement("g", Object.assign({}, hoverProps, getTestIdAttribute(dataTestId)),
        React.createElement("rect", { x: x, y: y, width: nodeWidth$1, height: nodeHeight$1, rx: nodeR, strokeWidth: isHover ? 3 : 1, stroke: curoColors[borderStatus], fill: background ? curoColors[borderStatus] : 'none', fillOpacity: 0.15 }),
        React.createElement("svg", { x: x + textpadding, y: y, width: nodeWidth$1 - 2 * textpadding, height: nodeHeight$1, style: { overflow: 'hidden' }, fill: curoColors.default }, getNodeDetails()),
        status === 'error' && React.createElement(ErrorIcon, { x: x, y: y, curoColors: curoColors }),
        status === 'warning' && React.createElement(WarningIcon, { x: x, y: y, curoColors: curoColors }),
        React.createElement("rect", { x: x, y: y, width: nodeWidth$1, height: nodeHeight$1, strokeWidth: 0, fillOpacity: 0, fill: curoColors.white }),
        isHover && tooltip !== undefined && (React.createElement(SvgTooltip, { x: x, y: y, width: nodeWidth$1, height: nodeHeight$1, tooltip: tooltip, dataTestId: "tip", tooltipWidth: 280 }))));
};

const offsetWidth = 6;
const arrowHeight = 6;
const halfArrowWidth = 2.8;
const dashArr = '5,2';
const { nodeWidth, nodeHeight, nodeGap, linkHeight, padding } = size;
const maxOffset = nodeWidth * 0.45;
const getLeftPos = (layer, index, offset) => {
    if (offset) {
        let yOffset = offset * offsetWidth;
        if (Math.abs(yOffset) > maxOffset) {
            yOffset = offset > 0 ? maxOffset : -maxOffset;
        }
        return {
            x: padding + (nodeWidth + nodeGap) * index + nodeWidth,
            y: padding + (nodeHeight + linkHeight) * (layer - 1) + nodeHeight / 2 + yOffset,
        };
    }
    else {
        return {
            x: padding + (nodeWidth + nodeGap) * index + nodeWidth,
            y: padding + (nodeHeight + linkHeight) * (layer - 1) + nodeHeight / 2,
        };
    }
};
const getRightPos = (layer, index, offset) => {
    if (offset) {
        let yOffset = offset * offsetWidth;
        if (Math.abs(yOffset) > maxOffset) {
            yOffset = offset > 0 ? maxOffset : -maxOffset;
        }
        return {
            x: padding + (nodeWidth + nodeGap) * index,
            y: padding + (nodeHeight + linkHeight) * (layer - 1) + nodeHeight / 2 + yOffset,
        };
    }
    else {
        return {
            x: padding + (nodeWidth + nodeGap) * index,
            y: padding + (nodeHeight + linkHeight) * (layer - 1) + nodeHeight / 2,
        };
    }
};
const getTopPos = (layer, index, offset) => {
    let xOffset = offset * offsetWidth;
    if (Math.abs(xOffset) > maxOffset) {
        xOffset = offset > 0 ? maxOffset : -maxOffset;
    }
    return {
        x: padding + (nodeWidth + nodeGap) * index + nodeWidth / 2 + xOffset,
        y: padding + (nodeHeight + linkHeight) * (layer - 1),
    };
};
const getBottomPos = (layer, index, offset) => {
    let xOffset = offset * offsetWidth;
    if (Math.abs(xOffset) > maxOffset) {
        xOffset = offset > 0 ? maxOffset : -maxOffset;
    }
    return {
        x: padding + (nodeWidth + nodeGap) * index + nodeWidth / 2 + xOffset,
        y: padding + (nodeHeight + linkHeight) * (layer - 1) + nodeHeight,
    };
};
const useStatusColor = (status) => useCuroColor(status);
const Path = ({ d, style, status, isOnHover = false }) => {
    const color = useStatusColor(status);
    return (React.createElement("path", { strokeDasharray: style === 'dash' ? dashArr : undefined, d: d, strokeWidth: isOnHover ? 2 : 1, stroke: color }));
};
const Polygon = ({ points, status, isOnHover }) => {
    const color = useStatusColor(status);
    return React.createElement("polygon", { strokeWidth: isOnHover ? 1 : 0, points: points, fill: color, stroke: color });
};
const TooltipComp = ({ x, y, width, height, tip }) => {
    const [isHover, setIsHover] = useState(false);
    const { renderLinkTooltip, startId, endId, setIsOnHover } = tip;
    const tooltip = renderLinkTooltip ? renderLinkTooltip(startId, endId) : undefined;
    const updateHover = (val) => {
        setIsHover(val);
        setIsOnHover(val);
    };
    const hoverProps = {
        onMouseOver: () => {
            if (!isHover) {
                updateHover(true);
            }
        },
        onMouseLeave: () => {
            if (isHover) {
                updateHover(false);
            }
        },
        onFocus: () => {
            if (!isHover) {
                updateHover(true);
            }
        },
        onBlur: () => {
            if (isHover) {
                updateHover(false);
            }
        },
        onMouseUp: () => { },
    };
    const white = useCuroColor('white');
    return (React.createElement("g", Object.assign({}, hoverProps),
        React.createElement("rect", { x: x, y: y, width: width, height: height, fill: white, fillOpacity: 0, strokeWidth: 0 }),
        isHover && tooltip !== undefined && (React.createElement(SvgTooltip, { x: x, y: y, width: width, height: height, tooltip: tooltip, dataTestId: "tip", tooltipWidth: 280 }))));
};
const hasStartArrow = (direction) => {
    return ['bi', 'in'].includes(direction);
};
const hasEndArrow = (direction) => {
    return ['bi', 'out'].includes(direction);
};
const Line = ({ left, right, style, direction, status, tip, isOnHover }) => {
    const { y, x: x1 } = left;
    const { x: x2 } = right;
    const sharedProps = { isOnHover, status };
    return (React.createElement("g", null,
        React.createElement(Path, Object.assign({ d: `M${x1},${y} L${x2},${y}`, style: style }, sharedProps)),
        hasStartArrow(direction) && (React.createElement(Polygon, Object.assign({ points: `${x1} ${y} ${x1 + arrowHeight} ${y + halfArrowWidth} ${x1 + arrowHeight} ${y -
                halfArrowWidth}` }, sharedProps))),
        hasEndArrow(direction) && (React.createElement(Polygon, Object.assign({ points: `${x2} ${y} ${x2 - arrowHeight} ${y + halfArrowWidth} ${x2 - arrowHeight} ${y -
                halfArrowWidth}` }, sharedProps))),
        React.createElement(TooltipComp, { x: Math.min(x1, x2), y: y - halfArrowWidth, width: Math.abs(x2 - x1), height: halfArrowWidth * 2, tip: tip })));
};
const ConnectorAdjacentLayers = ({ startLayer, startIndex, endLayer, endIndex, startOffset, endOffset, style, direction, status, isOnHover, tip, }) => {
    const s = getBottomPos(startLayer, startIndex, startOffset);
    const e = getTopPos(endLayer, endIndex, endOffset);
    const y = s.y + linkHeight / 2 - startOffset * offsetWidth;
    const sharedProps = { isOnHover, status };
    const pathProps = Object.assign({ style }, sharedProps);
    return (React.createElement("g", null,
        React.createElement(Path, Object.assign({ d: `M${s.x},${s.y} L${s.x},${y}` }, pathProps)),
        React.createElement(Path, Object.assign({ d: `M${s.x},${y} L${e.x},${y}` }, pathProps)),
        React.createElement(Path, Object.assign({ d: `M${e.x},${y} L${e.x},${e.y}` }, pathProps)),
        hasStartArrow(direction) && (React.createElement(Polygon, Object.assign({ points: `${s.x} ${s.y} ${s.x + halfArrowWidth} ${s.y + arrowHeight} ${s.x -
                halfArrowWidth} ${s.y + arrowHeight}` }, sharedProps))),
        hasEndArrow(direction) && (React.createElement(Polygon, Object.assign({ points: `${e.x} ${e.y} ${e.x + halfArrowWidth} ${e.y - arrowHeight} ${e.x -
                halfArrowWidth} ${e.y - arrowHeight}` }, sharedProps))),
        React.createElement(TooltipComp, { x: s.x - halfArrowWidth, y: Math.min(s.y, y), width: halfArrowWidth * 2, height: Math.abs(s.y - y), tip: tip }),
        React.createElement(TooltipComp, { x: e.x - halfArrowWidth, y: Math.min(e.y, y), width: halfArrowWidth * 2, height: Math.abs(e.y - y), tip: tip }),
        e.x !== s.x && (React.createElement(TooltipComp, { x: Math.min(s.x, e.x) - halfArrowWidth, y: y - halfArrowWidth, width: Math.abs(e.x - s.x) - halfArrowWidth * 2, height: halfArrowWidth * 2, tip: tip }))));
};
const ConnectorSameLayer = ({ startLayer, startIndex, endIndex, startOffset, endOffset, style, direction, status, isOnHover, tip, }) => {
    const s = getBottomPos(startLayer, startIndex, -startOffset);
    const e = getBottomPos(startLayer, endIndex, endOffset);
    const y = s.y + linkHeight / 2 + startOffset * offsetWidth;
    const sharedProps = { isOnHover, status };
    const pathProps = Object.assign({ style }, sharedProps);
    return (React.createElement("g", null,
        React.createElement(Path, Object.assign({ d: `M${s.x},${s.y} L${s.x},${y}` }, pathProps)),
        React.createElement(Path, Object.assign({ d: `M${s.x},${y} L${e.x},${y}` }, pathProps)),
        React.createElement(Path, Object.assign({ d: `M${e.x},${y} L${e.x},${e.y}` }, pathProps)),
        hasStartArrow(direction) && (React.createElement(Polygon, Object.assign({ points: `${s.x} ${s.y} ${s.x + halfArrowWidth} ${s.y + arrowHeight} ${s.x -
                halfArrowWidth} ${s.y + arrowHeight}` }, sharedProps))),
        hasEndArrow(direction) && (React.createElement(Polygon, Object.assign({ points: `${e.x} ${e.y} ${e.x + halfArrowWidth} ${e.y + arrowHeight} ${e.x -
                halfArrowWidth} ${e.y + arrowHeight}` }, sharedProps))),
        React.createElement(TooltipComp, { x: s.x - halfArrowWidth, y: Math.min(s.y, y), width: halfArrowWidth * 2, height: Math.abs(s.y - y), tip: tip }),
        React.createElement(TooltipComp, { x: e.x - halfArrowWidth, y: Math.min(e.y, y), width: halfArrowWidth * 2, height: Math.abs(e.y - y), tip: tip }),
        React.createElement(TooltipComp, { x: Math.min(s.x, e.x) - halfArrowWidth, y: y - halfArrowWidth, width: Math.abs(e.x - s.x) - halfArrowWidth * 2, height: halfArrowWidth * 2, tip: tip })));
};
const ConnectorSameIndexCrossLayer = ({ startLayer, startIndex, endLayer, endIndex, startOffset, endOffset, style, direction, status, isOnHover, tip, }) => {
    const startLeft = getLeftPos(startLayer, startIndex, startOffset);
    const endLeft = getLeftPos(endLayer, endIndex, endOffset);
    const x = startLeft.x + nodeGap / 2 + startOffset * offsetWidth;
    const y = startLeft.y + linkHeight / 2 + startOffset * offsetWidth;
    const sharedProps = { isOnHover, status };
    const pathProps = Object.assign({ style }, sharedProps);
    return (React.createElement("g", null,
        React.createElement(Path, Object.assign({ d: `M${startLeft.x},${startLeft.y} L${x},${startLeft.y}` }, pathProps)),
        React.createElement(Path, Object.assign({ d: `M${x},${startLeft.y} L${x},${endLeft.y}` }, pathProps)),
        React.createElement(Path, Object.assign({ d: `M${x},${endLeft.y} L${endLeft.x},${endLeft.y}` }, pathProps)),
        hasStartArrow(direction) && (React.createElement(Polygon, Object.assign({ points: `${startLeft.x} ${startLeft.y} ${startLeft.x + arrowHeight} ${startLeft.y + halfArrowWidth} ${startLeft.x + arrowHeight} ${startLeft.y - halfArrowWidth}` }, sharedProps))),
        hasEndArrow(direction) && (React.createElement(Polygon, Object.assign({ points: `${endLeft.x} ${endLeft.y} ${endLeft.x + arrowHeight} ${endLeft.y + halfArrowWidth} ${endLeft.x +
                arrowHeight} ${endLeft.y - halfArrowWidth}` }, sharedProps))),
        React.createElement(TooltipComp, { x: startLeft.x + arrowHeight, y: Math.min(startLeft.y, y), width: halfArrowWidth * 2, height: Math.abs(startLeft.y - y), tip: tip }),
        React.createElement(TooltipComp, { x: endLeft.x + halfArrowWidth, y: Math.min(endLeft.y, y), width: halfArrowWidth * 2, height: Math.abs(endLeft.y - y), tip: tip }),
        React.createElement(TooltipComp, { x: Math.min(startLeft.x, endLeft.x) - halfArrowWidth, y: y - halfArrowWidth, width: Math.abs(endLeft.x - startLeft.x) - halfArrowWidth * 2, height: halfArrowWidth * 2, tip: tip })));
};
const ConnectorDifferentIndexCrossLayer = ({ startLayer, startIndex, endLayer, endIndex, startOffset, endOffset, style, direction, status, isOnHover, tip, }) => {
    const startLeft = getLeftPos(startLayer, startIndex, startOffset);
    const e = getBottomPos(endLayer, endIndex, endOffset);
    const x = startLeft.x + nodeGap - startOffset * offsetWidth;
    const y = e.y + linkHeight / 2 + startOffset * offsetWidth;
    const sharedProps = { isOnHover, status };
    const pathProps = Object.assign({ style }, sharedProps);
    return (React.createElement("g", null,
        React.createElement(Path, Object.assign({ d: `M${startLeft.x},${startLeft.y} L${x},${startLeft.y}` }, pathProps)),
        React.createElement(Path, Object.assign({ d: `M${x},${startLeft.y} L${x},${y}` }, pathProps)),
        React.createElement(Path, Object.assign({ d: `M${x},${y} L${e.x},${y}` }, pathProps)),
        React.createElement(Path, Object.assign({ d: `M${e.x},${y} L${e.x},${e.y}` }, pathProps)),
        hasStartArrow(direction) && (React.createElement(Polygon, Object.assign({ points: `${startLeft.x} ${startLeft.y} ${startLeft.x + arrowHeight} ${startLeft.y + halfArrowWidth} ${startLeft.x + arrowHeight} ${startLeft.y - halfArrowWidth}` }, sharedProps))),
        hasEndArrow(direction) && (React.createElement(Polygon, Object.assign({ points: `${e.x} ${e.y} ${e.x + halfArrowWidth} ${e.y + arrowHeight} ${e.x -
                halfArrowWidth} ${e.y + arrowHeight}` }, sharedProps))),
        React.createElement(TooltipComp, { x: startLeft.x - halfArrowWidth, y: Math.min(startLeft.y, y), width: halfArrowWidth * 2, height: Math.abs(startLeft.y - y), tip: tip }),
        React.createElement(TooltipComp, { x: e.x - halfArrowWidth, y: Math.min(e.y, y), width: halfArrowWidth * 2, height: Math.abs(e.y - y), tip: tip }),
        React.createElement(TooltipComp, { x: Math.min(startLeft.x, e.x) - halfArrowWidth, y: y - halfArrowWidth, width: Math.abs(e.x - startLeft.x) - halfArrowWidth * 2, height: halfArrowWidth * 2, tip: tip })));
};

const NetworkLink = (l) => {
    const { startLayer, startIndex, endLayer, endIndex, style = 'dash', direction = 'bi', status = 'slate', renderLinkTooltip, startId, endId } = l;
    const [isOnHover, setIsOnHover] = useState(false);
    const tip = { setIsOnHover, renderLinkTooltip, startId, endId };
    const sharedProps = { isOnHover, style, direction, status, tip };
    const connectorProps = Object.assign(Object.assign({}, l), sharedProps);
    if (startLayer === endLayer) {
        if (endIndex - startIndex === 1) {
            const left = getLeftPos(startLayer, startIndex);
            const right = getRightPos(endLayer, endIndex);
            return React.createElement(Line, Object.assign({ left: left, right: right }, sharedProps));
        }
        return React.createElement(ConnectorSameLayer, Object.assign({}, connectorProps));
    }
    // startLayer !== endLayer
    if (endLayer - startLayer === 1) {
        return React.createElement(ConnectorAdjacentLayers, Object.assign({}, connectorProps));
    }
    else {
        if (startIndex === endIndex) {
            return React.createElement(ConnectorSameIndexCrossLayer, Object.assign({}, connectorProps));
        }
        return React.createElement(ConnectorDifferentIndexCrossLayer, Object.assign({}, connectorProps));
    }
};

/* eslint-disable react-hooks/exhaustive-deps */
const StyledDiv = styled.div.withConfig({ displayName: "StyledDiv", componentId: "sc-emnt09" }) `
  width: 100%;
  height: ${(props) => `${props['data-height']}px`}};
  max-height: ${(props) => `${props['data-height']}px`}};
  overflow: auto;
  &::-webkit-scrollbar {
    display: none; // Chrome, Safari and Opera
  }
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
`;
const initPos = { pageX: 0, pageY: 0 };
const initPre = { x: 0, y: 0 };
const MaxMoveRatio = 0.8;
const NetworkGraph = ({ dataTestId, nodes, links, linkProperty = 'id', renderNodeTooltip, renderLinkTooltip, legend, graphHeight, }) => {
    const layersArray = [...new Set(nodes.map(node => node.layer))];
    const maxNodeCount = Math.max(nodes.length);
    const maxLayerCount = Math.max(layersArray.length);
    const width = getWidth(maxNodeCount);
    const height = getHeight(maxLayerCount);
    const heightPx = `${height}px`;
    const [ratio, updateRatio] = useState(graphHeight ? graphHeight / height : 1);
    const [layerNodes, setLayerNodes] = useState([]);
    const [size, setSize] = useState({
        width: width * ratio,
        height: graphHeight || height,
    });
    const [rectWidth, setRectWidth] = useState('100%');
    const setRatio = (r) => {
        updateRatio(r);
        setSize({ width: width * r, height: height * r });
    };
    const linkPosArr = getLinkPosArr({ layerNodes, linkProperty, links, renderLinkTooltip });
    const divRef = useRef(null);
    // Drag and Move
    const [startPos, setStartPos] = useState(initPos);
    const [newPos, setNewPos] = useState(initPos);
    const [prePos, setPrePos] = useState(initPre);
    const mouseDownRef = useRef(false);
    const [pos, setPos] = useState(initPre);
    useEffect(() => {
        let tempLayerNodes;
        const nodesLayers = [];
        layersArray.map(layer => {
            tempLayerNodes = nodes.filter(node => {
                return node.layer === layer;
            });
            tempLayerNodes.forEach((layer, index) => {
                nodesLayers.push(Object.assign(Object.assign({}, layer), { index }));
            });
        });
        setLayerNodes(nodesLayers);
    }, [nodes]);
    useEffect(() => {
        const handleResize = () => {
            var _a;
            let x = startPos.pageX && newPos.pageX ? newPos.pageX - startPos.pageX : 0;
            x += prePos.x;
            const maxW = size.width * MaxMoveRatio;
            if (Math.abs(x) > maxW) {
                x = x > 0 ? maxW : -maxW;
            }
            let y = startPos.pageY && newPos.pageY ? (newPos.pageY - startPos.pageY) : 0;
            y += prePos.y;
            const maxH = size.height * MaxMoveRatio;
            if (Math.abs(y) > maxH) {
                y = y > 0 ? maxH : -maxH;
            }
            setPos({ x, y });
            const w = ((_a = divRef === null || divRef === void 0 ? void 0 : divRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || size.width;
            setRectWidth(Math.min(w, size.width));
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [startPos, newPos, prePos, ratio]);
    const initAllPos = () => {
        setStartPos(initPos);
        setNewPos(initPos);
        mouseDownRef.current = false;
    };
    const mouseHandlers = {
        mouseMove: (event) => {
            if (mouseDownRef.current) {
                const { pageX, pageY } = event;
                setNewPos({ pageX, pageY });
            }
            event.preventDefault();
        },
        mouseLeaveOrUp: (event) => {
            if (mouseDownRef.current) {
                setPrePos(pos);
                initAllPos();
            }
            event.preventDefault();
        },
        mouseDown: (event) => {
            const { pageX, pageY } = event;
            setStartPos({ pageX, pageY });
            mouseDownRef.current = true;
            event.preventDefault();
        },
    };
    const setToFit = () => {
        if (divRef && divRef.current) {
            const divWidth = divRef.current.clientWidth;
            const r = width > divWidth ? divWidth / width : 1;
            setRatio(r);
            initAllPos();
            setPrePos(initPre);
        }
    };
    return (React.createElement(Row, { pad: "xsmall", align: "end" },
        React.createElement(Column, { noPad: true, expand: true },
            React.createElement(Row, { noPad: true },
                React.createElement(StyledDiv, { ref: divRef, "data-height": graphHeight || height },
                    React.createElement("div", { style: { width: size.width, height: size.height } },
                        React.createElement("svg", { width: size.width, height: size.height },
                            React.createElement("rect", { x: 0, y: 0, onMouseOver: mouseHandlers.mouseMove, onMouseLeave: mouseHandlers.mouseLeaveOrUp, onMouseMove: mouseHandlers.mouseMove, onMouseDown: mouseHandlers.mouseDown, onMouseUp: mouseHandlers.mouseLeaveOrUp, width: rectWidth, height: heightPx, style: { cursor: 'move' }, opacity: 0 }),
                            React.createElement("svg", Object.assign({ "aria-label": "network-chart", x: pos.x, y: pos.y, width: size.width, height: height * ratio, viewBox: `0 0 ${width} ${height}` }, getTestIdAttribute(dataTestId)),
                                layerNodes.map((node) => (React.createElement(NetworkNode, Object.assign({ dataTestId: node.dataTestId || `${dataTestId}-node-${node.title}`, key: node.id, renderNodeTooltip: renderNodeTooltip }, node)))),
                                linkPosArr.map(pos => (React.createElement(NetworkLink, Object.assign({}, pos, { key: `${pos.startId}-${pos.endId}` }))))))))),
            React.createElement(Row, { noPad: true }, legend)),
        React.createElement(Column, { pad: "small" },
            React.createElement(IconButton, { dataTestId: "plus", icon: "fit", onClick: () => {
                    setToFit();
                } }),
            React.createElement(IconButton, { dataTestId: "plus", icon: "add", onClick: () => {
                    setRatio(ratio + 0.1);
                } }),
            React.createElement(IconButton, { dataTestId: "plus", icon: "line", onClick: () => {
                    setRatio(ratio - 0.1);
                } }))));
};

/* eslint-disable @typescript-eslint/indent */
const TaskManagerBox = styled(Box).withConfig({ displayName: "TaskManagerBox", componentId: "sc-wax5fm" }) `
  height: 54px;
`;
const Percentage = styled(Text$1).withConfig({ displayName: "Percentage", componentId: "sc-1nk3hqu" }) `
  font-weight: 800;
  font-size: 16px;
`;
const Title = styled(Text$1).withConfig({ displayName: "Title", componentId: "sc-wiugsr" }) `
  font-weight: 800;
  font-size: 16px;
  margin-right: 10px;
  white-space: nowrap;
`;
const CurrentTask = styled(Text$1).withConfig({ displayName: "CurrentTask", componentId: "sc-1guo5yv" }) `
  font-size: 14px;
  font-weight: 800;
`;
const TotalTasks = styled(Text$1).withConfig({ displayName: "TotalTasks", componentId: "sc-1yllptb" }) `
  font-size: 14px;
`;
const SupplementalLink = styled(Text$1).withConfig({ displayName: "SupplementalLink", componentId: "sc-9ulz2a" }) `
  font-size: 16px;
  white-space: nowrap;
  cursor: pointer;
`;
/** The responsive grid use Flexbox under the hood, and exposed several flex properties in the API. <br>
 Default Row component with children. Represents the horizontal axis oriented from the left to the right
*/
const TaskManager = ({ title, navigation, status, description, percentageComplete, onAcknowledgeClick, onViewDetailsClick, dataTestId, }) => {
    const colors = useColors();
    const size = useContext(ResponsiveContext);
    const [collapse, setCollapse] = useState(true);
    const bottomPanel = navigation || onAcknowledgeClick || onViewDetailsClick;
    const desktop = (React.createElement(TaskManagerBox, Object.assign({ fill: "horizontal", background: colors.darkDefault }, getTestIdAttribute(dataTestId)),
        React.createElement(StackedBar, { dataTestId: `${dataTestId}-progress-bar`, data: [{ percentage: percentageComplete, status: status || 'series1' }], thickness: "xsmall" }),
        React.createElement(Box, { direction: "row", justify: "between", fill: true, align: "center", pad: { horizontal: '20px' } },
            React.createElement(Box, { direction: "row", align: "center" },
                !status && (React.createElement(Box, { flex: { shrink: 0 }, margin: { right: '9px' } },
                    React.createElement(Percentage, { color: colors.default },
                        percentageComplete,
                        "%"))),
                status && (React.createElement(Box, { flex: { shrink: 0 }, margin: { right: '14px' } },
                    React.createElement(Icon, { dataTestId: `${dataTestId}-status-icon`, name: status, size: "medium" }))),
                title && React.createElement(Title, { color: colors.default }, title),
                description && React.createElement(Truncate, { label: description, dataTestId: `${dataTestId}-description` }),
                React.createElement(Box, { direction: "row", flex: { shrink: 0 } },
                    onViewDetailsClick && (React.createElement(SupplementalLink, { color: colors.info, onClick: onViewDetailsClick }, getI18nStr('viewDetails'))),
                    onViewDetailsClick && onAcknowledgeClick && (React.createElement(Box, { border: "left", background: colors.gray, margin: { horizontal: '8px' } })),
                    onAcknowledgeClick && (React.createElement(SupplementalLink, { color: colors.info, onClick: onAcknowledgeClick }, getI18nStr('acknowledge'))))),
            navigation && (React.createElement(Box, { direction: "row", margin: { left: '48px' }, flex: { shrink: 0 }, gap: "20px", align: "center" },
                React.createElement(Box, { direction: "row" },
                    React.createElement(CurrentTask, { color: colors.default },
                        navigation.currentTask,
                        " "),
                    React.createElement(TotalTasks, { color: colors.gray },
                        "\u00A0",
                        getI18nStr('of'),
                        "\u00A0",
                        navigation.totalTasks)),
                React.createElement(ToggleButton, { linearNavigation: true, options: [
                        {
                            icon: 'previous',
                            disabled: navigation.leftIcon.disabled || false,
                            onClick: navigation.leftIcon.onClick,
                            dataTestId: `${dataTestId}-previous-icon`,
                        },
                        {
                            icon: 'next',
                            disabled: navigation.rightIcon.disabled || false,
                            onClick: navigation.rightIcon.onClick,
                            dataTestId: `${dataTestId}-next-icon`,
                        },
                    ] }))))));
    const mobile = (React.createElement(Box, Object.assign({ fill: "horizontal", background: colors.darkDefault }, getTestIdAttribute(dataTestId)),
        React.createElement(StackedBar, { dataTestId: `${dataTestId}-progress-bar`, data: [{ percentage: percentageComplete, status: status || 'series1' }], thickness: "xsmall" }),
        React.createElement(Box, { direction: "row", pad: "20px" },
            !status && (React.createElement(Box, { flex: { shrink: 0 }, margin: { right: '9px' } },
                React.createElement(Percentage, { color: colors.default },
                    percentageComplete,
                    "%"))),
            status && (React.createElement(Box, { flex: { shrink: 0 }, pad: { top: '1px' }, margin: { right: '14px' } },
                React.createElement(Icon, { dataTestId: `${dataTestId}-status-icon`, name: status, size: "medium" }))),
            React.createElement(Box, { fill: true },
                React.createElement(Box, { direction: "row", align: "center" },
                    title && React.createElement(Title, { color: colors.default }, title),
                    description && (React.createElement(Truncate, { label: description, dataTestId: `${dataTestId}-description` }))),
                !collapse && (React.createElement(Box, { direction: "row", justify: "between", margin: { top: 'medium' }, wrap: true },
                    React.createElement(Box, { direction: "row", align: "center" },
                        onViewDetailsClick && (React.createElement(SupplementalLink, { color: colors.info, onClick: onViewDetailsClick }, getI18nStr('viewDetails'))),
                        onViewDetailsClick && onAcknowledgeClick && (React.createElement(Box, { border: "left", background: colors.gray, height: "65%", margin: { horizontal: '4px' } })),
                        onAcknowledgeClick && (React.createElement(SupplementalLink, { color: colors.info, onClick: onAcknowledgeClick }, getI18nStr('acknowledge')))),
                    navigation && (React.createElement(Box, { direction: "row", gap: "10px", align: "center" },
                        React.createElement(Box, { direction: "row" },
                            React.createElement(CurrentTask, { color: colors.default },
                                navigation.currentTask,
                                " "),
                            React.createElement(TotalTasks, { color: colors.gray },
                                "\u00A0",
                                getI18nStr('of'),
                                "\u00A0",
                                navigation.totalTasks)),
                        React.createElement(ToggleButton, { linearNavigation: true, options: [
                                {
                                    icon: 'previous',
                                    disabled: navigation.leftIcon.disabled || false,
                                    onClick: navigation.leftIcon.onClick,
                                    dataTestId: `${dataTestId}-previous-icon`,
                                },
                                {
                                    icon: 'next',
                                    disabled: navigation.rightIcon.disabled || false,
                                    onClick: navigation.rightIcon.onClick,
                                    dataTestId: `${dataTestId}-next-icon`,
                                },
                            ] })))))),
            bottomPanel && (React.createElement(Box, { pad: { top: '1px' } },
                React.createElement(Icon, { name: collapse ? 'down' : 'up', size: "medium", onClick: () => setCollapse(!collapse), dataTestId: "yash" }))))));
    return size === 'small' || size === 'medium' ? mobile : desktop;
};

const StyledWrapperbox = styled(Box).withConfig({ displayName: "StyledWrapperbox", componentId: "sc-85c6cw" }) `
  .drop-down-with-more-icon{
    border-color : ${props => getStyledCuroColor(props, 'slate')};
    svg path {
      fill : ${props => getStyledCuroColor(props, 'slate')};
    }
    &:hover {
      box-shadow: ${props => `0px 0px 0px 2px ${getStyledCuroColor(props, 'slate')}`}
  }
 
  
`;
const getSecondaryElements = (items, exportCsv) => {
    const dropContent = [];
    const { children: data = [] } = items.props || {};
    const children = exportCsv ? [exportCsv, ...data] : data;
    const addDropConent = (element) => {
        var _a, _b, _c;
        const { label = '', disabled, dataTestId, onClick, tooltip } = ((_a = element === null || element === void 0 ? void 0 : element.props) === null || _a === void 0 ? void 0 : _a.target) ? (_c = (_b = element === null || element === void 0 ? void 0 : element.props) === null || _b === void 0 ? void 0 : _b.target) === null || _c === void 0 ? void 0 : _c.props : element.props || {};
        (label || typeof tooltip === 'string') &&
            dropContent.push({
                content: label || tooltip,
                onClick: () => {
                    onClick && onClick();
                },
                dataTestId: `${dataTestId}`,
                disabled,
            });
    };
    if (children.length && typeof children !== 'string') {
        children.forEach((_child) => {
            addDropConent(_child);
        });
    }
    else if (React.isValidElement(items)) {
        // Single element without having parent wrapper will go inside
        addDropConent(items);
    }
    if (!dropContent.length)
        return null;
    return (React.createElement(DropdownActionMenu, { content: dropContent || [], secondary: true, dataTestId: "dropdown-action-button", responsive: true, size: "small" }));
};
const Toolbar = (_a) => {
    var { searchBar, onFilterClick, appliedFilters, primaryCrud, secondaryCrud, customActions, groupAnchorSet, exportToCSV, dataTestId } = _a, rest = __rest(_a, ["searchBar", "onFilterClick", "appliedFilters", "primaryCrud", "secondaryCrud", "customActions", "groupAnchorSet", "exportToCSV", "dataTestId"]);
    // Added the logger for unused props..!
    // eslint-disable-next-line array-callback-return
    Object.keys(rest).map((key) => {
        if (rest[key] &&
            (rest.selectionCounter || rest.sortByOrder || rest.sortBySelectionList || rest.viewToggle)) {
            logger(`Attribute ${key} is deprecated and will be removed in future release. If this attribute is needed, please contact us.`, 'error');
        }
    });
    const topRow = appliedFilters;
    const primaryRow = searchBar || onFilterClick || primaryCrud || secondaryCrud || customActions || exportToCSV;
    const [download, setDownload] = useState(false);
    const [searchBox, setSearchBox] = useState(searchBar);
    const vSize = useContext(ResponsiveContext);
    useEffect(() => {
        if (searchBar) {
            const { props: searchBarProps } = searchBar;
            if (vSize === 'small') {
                setSearchBox(React.cloneElement(searchBar, Object.assign({ searchBarOpen: true }, searchBarProps)));
            }
            else {
                setSearchBox(React.cloneElement(searchBar, Object.assign({ searchBarOpen: false }, searchBarProps)));
            }
        }
    }, [searchBar, vSize]);
    const isScreenSizeXL = !(vSize === 'medium' || vSize === 'small' || vSize === 'large');
    const internalColors = useInternalColors();
    const exportCsvButton = (React.createElement(IconButton, { icon: "export", label: "Export", dataTestId: `${dataTestId}-export`, border: true, onClick: () => {
            setDownload(true);
            setTimeout(() => {
                // To download on second click
                setDownload(false);
            }, 100);
        } }));
    return (React.createElement(StyledWrapperbox, Object.assign({}, getTestIdAttribute(dataTestId), { justify: "between", fill: "horizontal" }),
        topRow && (React.createElement(Box, { direction: "row", align: "center", height: "50px" }, appliedFilters && React.createElement(Box, null, appliedFilters))),
        vSize === 'small' && searchBox && (React.createElement(Box, { align: "end", height: "50px", direction: "column-reverse", pad: { horizontal: 'small' } },
            React.createElement(Box, { align: "end", height: "50px", width: "100%", direction: "column-reverse", gap: "8px" }, searchBox))),
        primaryRow && (React.createElement(Box, { background: internalColors.lightCoolGray, direction: "row", justify: "between", pad: { horizontal: 'small' }, height: "50px", border: { side: 'bottom', color: internalColors.mediumGray } },
            React.createElement(Box, { direction: "row", align: "center", gap: isScreenSizeXL ? '16px' : '8px' },
                primaryCrud && React.createElement(Box, null, primaryCrud),
                (secondaryCrud || exportToCSV) && (React.createElement(Box, { border: { side: 'left', color: internalColors.mediumGray }, fill: "vertical" })),
                secondaryCrud && !isScreenSizeXL ? (getSecondaryElements(secondaryCrud, exportToCSV ? exportCsvButton : undefined)) : (React.createElement(Box, null,
                    React.createElement(Row, { gap: "8px", noPad: true, wrap: false },
                        exportToCSV && download && React.createElement(CSVDownload, { data: exportToCSV }),
                        exportToCSV && exportCsvButton,
                        secondaryCrud))),
                customActions && (React.createElement(Box, { border: { side: 'left', color: internalColors.mediumGray }, fill: "vertical" })),
                customActions && React.createElement(Box, null, customActions)),
            React.createElement(Box, { direction: "row", align: "center", gap: "8px" },
                exportToCSV && download && React.createElement(CSVDownload, { data: exportToCSV }),
                vSize !== 'small' && searchBox && React.createElement(Box, { direction: "row" }, searchBox),
                onFilterClick && (React.createElement(IconButton, { icon: "filter", dataTestId: `${dataTestId}-filter`, onClick: onFilterClick }))))),
        groupAnchorSet && (React.createElement(Box, { height: "50px", justify: "end", alignSelf: "end", align: "center", pad: "small" }, groupAnchorSet))));
};

const Iframe = ({ title, src, scrollToEnd, dataTestId }) => {
    const isBottom = (el) => {
        return el.getBoundingClientRect().bottom <= window.innerHeight;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const trackScrolling = () => {
        const wrappedElement = document.getElementById('frame');
        if (isBottom(wrappedElement)) {
            if (scrollToEnd)
                scrollToEnd();
            document.removeEventListener('scroll', trackScrolling);
        }
    };
    useEffect(() => {
        document.addEventListener('scroll', trackScrolling);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        // componentWillUnmount
        return () => {
            document.removeEventListener('scroll', trackScrolling);
        };
    }, [trackScrolling]);
    return (React.createElement(RIframe, Object.assign({ title: title, width: "100%", height: "100%", url: src, id: "frame", allowFullScreen: true }, getTestIdAttribute(dataTestId))));
};

const subPad = 34;
const pad = 4;
const MenuItemBody = ({ label, icon, isActive, foldIcon, dataTestId, isSub, }) => {
    const status = isActive ? 'default' : 'gray';
    const weight = isActive ? 'medium' : 'normal';
    const textType = isSub ? 'default' : 'title4';
    const borderStr = `${pad}px solid ${useCuroColor('brand')}`;
    return (React.createElement(Box, { pad: isSub ? { horizontal: '20px', vertical: '10px' } : { horizontal: '20px', vertical: '15px' }, wrap: false, style: {
            borderLeft: isActive ? borderStr : 'none',
        }, direction: "row" },
        React.createElement(Row, { gap: isSub ? 'none' : 'small', pad: { left: `${(isSub ? subPad : pad) - (isActive ? pad : 0)}px` } },
            React.createElement(Column, { noPad: true }, icon && (React.createElement(Icon, { name: icon, size: "medium", status: status, dataTestId: `${dataTestId}-icon` }))),
            React.createElement(Column, { noPad: true, expand: true },
                typeof label === 'string' && (React.createElement(Text, { label: label, type: textType, status: status, weight: weight, dataTestId: `${dataTestId}-label` })),
                typeof label !== 'string' && label)),
        foldIcon && (React.createElement(Icon, { name: foldIcon, status: status, size: "medium", dataTestId: `${dataTestId}-fold-icon` }))));
};

const SidebarMenuItem = ({ icon, label, dataTestId, href = '/', subItems, pathName, isSub = false, isLastChild = false, isFirstChild = false, isEven = false, onMenuItemClick, }) => {
    const isActive = href !== undefined && pathName === href;
    const [isHover, setIsHover] = useState(false);
    const [showSubItems, setShowSubItems] = useState(false);
    const hover = {
        onMouseOver: () => {
            setIsHover(true);
        },
        onMouseLeave: () => {
            setIsHover(false);
        },
    };
    const onSideBarClick = (e) => {
        e.preventDefault();
        setShowSubItems(!showSubItems);
    };
    const getFolderIcon = () => {
        if (subItems) {
            if (showSubItems) {
                return 'up';
            }
            return 'down';
        }
        return undefined;
    };
    const borderStr = `1px solid ${useCuroColor('darkDefault')}`;
    const getHasBorder = () => {
        // Parent
        if (subItems) {
            return !showSubItems;
        }
        // no child
        if (!isSub) {
            return true;
        }
        // last child
        return isLastChild;
    };
    const hoverBg = useInternalColor('lighterGray');
    const activeBg = useInternalColor('lightCoolGray');
    const evenBg = useInternalColor('lighterGray');
    const getbackground = () => {
        if (isHover) {
            return hoverBg;
        }
        if (isActive) {
            return activeBg;
        }
        if (isEven) {
            return evenBg;
        }
        return 'none';
    };
    const getOnClick = () => {
        if (subItems) {
            return onSideBarClick;
        }
        if (onMenuItemClick) {
            return (e) => {
                onMenuItemClick(href, e);
            };
        }
        return undefined;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Link, { href: href, dataTestId: dataTestId, onClick: getOnClick(), as: subItems ? 'anchor' : undefined },
            React.createElement(Box, { fill: true, onMouseEnter: hover.onMouseOver, onMouseLeave: hover.onMouseLeave, direction: "column", style: {
                    borderBottom: getHasBorder() ? borderStr : 'none',
                    borderTop: isFirstChild ? borderStr : 'none',
                    background: getbackground(),
                } },
                React.createElement(MenuItemBody, { label: label, icon: icon, isActive: isActive, dataTestId: dataTestId, foldIcon: getFolderIcon(), isSub: isSub, isHover: isHover }))),
        (subItems && showSubItems) && subItems.map(({ label: subLabel, href: subHref, dataTestId: id }, index) => (React.createElement(SidebarMenuItem, { isSub: true, label: subLabel, href: subHref, dataTestId: id, pathName: pathName, key: id, isLastChild: index === (subItems.length - 1), isEven: index % 2 === 0, onMenuItemClick: onMenuItemClick })))));
};

const Sidebar = ({ dataTestId = 'sidebar', clickOutsideClose = true, menuItems, footer, pathName, setShowSidebar, onMenuItemClick }) => {
    const wrapperRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                // eslint-disable-next-line no-unused-expressions
                if (clickOutsideClose) {
                    setShowSidebar(false);
                }
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [wrapperRef]);
    return (React.createElement(Box, Object.assign({ overflow: "hidden", style: { position: 'fixed', left: '0px', right: '0px', zIndex: 10, backgroundColor: useCuroColor('black', 0.5) }, height: "100vh" }, getTestIdAttribute(dataTestId)),
        React.createElement("div", Object.assign({ ref: wrapperRef, style: {
                overflow: 'auto',
                width: '270px',
                height: '100%',
                borderRadius: '2px',
                background: useCuroColor('white'),
                boxShadow: `3px 0 20px 0 ${useCuroColor('black', 0.45)}`,
            } }, getTestIdAttribute(`${dataTestId}-inner-wrapper`)),
            React.createElement(Box, { justify: "between", fill: "vertical", background: "white" },
                React.createElement(Panel, { noMarginBottom: true, noPad: true, style: { transition: 'width 2s, height 2s, background-color 2s, transform 2s' } },
                    React.createElement(Row, null,
                        React.createElement(IconButton, { icon: "remove", size: 'small', dataTestId: `${dataTestId}-close-button`, onClick: () => setShowSidebar(false) })),
                    menuItems.map((item, index) => (React.createElement(SidebarMenuItem, Object.assign({ pathName: pathName }, item, { key: item.dataTestId, isFirstChild: index === 0, onMenuItemClick: onMenuItemClick }))))),
                footer !== undefined && (React.createElement(Panel, { noShrink: true, direction: "row", noMarginBottom: true }, footer))))));
};

const InputElementMixin = () => `
  background: none; /* get rid of white Chrome background */
  font: inherit; /* fix too small font-size in both Chrome & Firefox */
  margin: 0;
  pointer-events: none; /* let clicks pass through */
  position: absolute;
  width: 100%;
  border-radius: 8px;
  & {
    -webkit-appearance: none;
  }
`;
const MozRangeThumbMixin = (props) => `
  width: 24px;
  height: 24px;
  background: ${LightCuroColors.white};
  pointer-events: all;
  border-radius: 50%;
  cursor: ${props['data-disabled'] ? 'default' : 'pointer'};
`;
const SliderThumbMixin = (props) => `
  -webkit-appearance: none;
  appearance: none;
  width: 24px;
  height: 24px;
  background: ${LightCuroColors.white};
  cursor: ${props['data-disabled'] ? 'default' : 'pointer'};
  pointer-events: all;
  border-radius: 50%;
`;
const dynamicColor = (props) => props['data-linear-gradient'].map((res, i, arr) => {
    if (arr.length - 1 === i) {
        return `${res.colorName} ${res.start}, ${res.colorName} ${res.end}`;
    }
    return `${res.colorName} ${res.start}, ${res.colorName} ${res.end},`;
});
const StyledInput = styled.input.withConfig({ displayName: "StyledInput", componentId: "sc-6f2y9d" }) `
  &[type='range'] {
    border-radius: 8px;
    opacity: ${props => (props['data-disabled'] ? '0.5' : '1')};
    height: 10px;
    -webkit-appearance: none;
    background: linear-gradient(to right, ${props => props && dynamicColor(props)});
    &::-webkit-slider-thumb {
      ${SliderThumbMixin}
      box-shadow: ${props => `0px 0px 4px ${getStyledCuroColor(props, 'black', 0.2)}`}
    }
    &::-moz-range-thumb {
      ${MozRangeThumbMixin}
       box-shadow: ${props => `0px 0px 4px ${getStyledCuroColor(props, 'black', 0.2)}`}
    }
  }
`;
// To-Do: Use CURO Text
const StyledOutput = styled.output.withConfig({ displayName: "StyledOutput", componentId: "sc-1wnay07" }) `
  color: ${props => getStyledCuroColor(props, 'default')};
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  padding: 4px 12px;
  position: absolute;
  transform: translateX(-50%);
  left: ${props => props['data-left']};
  opacity: ${props => (props['data-disabled'] ? '0.5' : '1')};
  margin-top: 15px;
`;
const StyledBox = styled(Box).withConfig({ displayName: "StyledBox", componentId: "sc-ygxc8g" }) `
  position: relative;
`;
const StyledInputStartRange = styled.input.withConfig({ displayName: "StyledInputStartRange", componentId: "sc-sdm2rn" }) `
  &[type='range'] {
    z-index: ${props => (props.value === props.min ? 3 : 4)};
    ${InputElementMixin}
    &::-webkit-slider-thumb {
      ${SliderThumbMixin}
      box-shadow: ${props => `0px 0px 4px ${getStyledCuroColor(props, 'black', 0.2)}`}

    }
    &::-moz-range-thumb {
      ${MozRangeThumbMixin}
      box-shadow: ${props => `0px 0px 4px ${getStyledCuroColor(props, 'black', 0.2)}`}

    }
  }
`;
const StyledInputEndRange = styled.input.withConfig({ displayName: "StyledInputEndRange", componentId: "sc-19iw7o3" }) `
  &[type='range'] {
    z-index: ${props => (props.value === props.max ? 3 : 4)};
    ${InputElementMixin}
    &::-webkit-slider-thumb {
      ${SliderThumbMixin}
      box-shadow: ${props => `0px 0px 4px ${getStyledCuroColor(props, 'black', 0.2)}`}

    }
    &::-moz-range-thumb {
      ${MozRangeThumbMixin}
      box-shadow: ${props => `0px 0px 4px ${getStyledCuroColor(props, 'black', 0.2)}`}
    }
 }
  }
`;
const StyledSliderOutput = styled(Box).withConfig({ displayName: "StyledSliderOutput", componentId: "sc-drjqmh" }) `
  position: relative;
  display: flex;
  justify-content: center;
  height: 4px;
  border-radius: 12px;
  margin-top: 14px;
  background: ${props => getStyledInternalColor(props, isStyledDark(props) ? 'neutral' : 'coolGray')};
`;
const Slider_Selected_Range = styled(Box).withConfig({ displayName: "Slider_Selected_Range", componentId: "sc-1ylckuf" }) `
  opacity: ${props => (props['disabled'] ? '0.4' : '1')};
  position: absolute;
  border-radius: 2px;
  height: 4px;
  background-color: ${props => getStyledChartColor(props, 'series1')};
  z-index: 2;
`;
const RangeInput = ({ value: valueArg, min, max, disabled, step, name, onChange, label, colors, unit, hasStart = false, dataTestId, }) => {
    const getMaxVal = () => {
        if (!hasStart) {
            return typeof valueArg === 'string' || typeof valueArg === 'number' ? Number(valueArg) : 0;
        }
        return typeof valueArg === 'object' ? Number(valueArg[1]) : Number(max);
    };
    const [minVal, setMinVal] = useState(typeof valueArg === 'object' ? Number(valueArg[0]) : Number(min));
    const [maxVal, setMaxVal] = useState(getMaxVal());
    const minValRef = useRef(null);
    const maxValRef = useRef(null);
    const range = useRef(null);
    const brand = useCuroColor('brand');
    const dataLinearGradient = colors || [{ colorName: brand, start: '0%', end: '100%' }];
    const inputRefElement = useRef(null);
    // Convert to percentage
    const minPercentRage = (min === null || min === void 0 ? void 0 : min.toString()) ? Number(min) : Number(valueArg === null || valueArg === void 0 ? void 0 : valueArg[0]);
    const maxPercentRage = (max === null || max === void 0 ? void 0 : max.toString()) ? Number(max) : Number(valueArg === null || valueArg === void 0 ? void 0 : valueArg[1]);
    const getPercent = useCallback((value) => Math.round(((value - minPercentRage) / (maxPercentRage - minPercentRage)) * 100), [minVal, maxVal]);
    useEffect(() => {
        if (typeof min === 'string') {
            logger('String is deprecated for min. Use numbers only', 'error');
        }
        if (typeof max === 'string') {
            logger('String is deprecated for max. Use numbers only', 'error');
        }
        if (typeof valueArg === 'string') {
            logger('String is deprecated for Value. Use numbers only', 'error');
        }
        if (typeof step === 'string') {
            logger('String is deprecated for step. Use numbers only', 'error');
        }
    }, [minVal, maxVal]);
    useEffect(() => {
        var _a;
        if (!hasStart) {
            (_a = inputRefElement === null || inputRefElement === void 0 ? void 0 : inputRefElement.current) === null || _a === void 0 ? void 0 : _a.addEventListener('input', (e) => {
                setMaxVal(e.target.value);
            });
        }
        else {
            if (maxValRef.current) {
                const minPercent = getPercent(minVal);
                const maxPercent = getPercent(+maxValRef.current.value); // Preceding with '+' converts the value from type string to type number
                if (range.current) {
                    range.current.style.left = `${minPercent}%`;
                    range.current.style.width = `${maxPercent - minPercent}%`;
                }
            }
            if (minValRef.current) {
                const minPercent = getPercent(+minValRef.current.value);
                const maxPercent = getPercent(maxVal);
                if (range.current) {
                    range.current.style.width = `${maxPercent - minPercent}%`;
                }
            }
        }
    }, [dataTestId, name, minVal, maxVal, getPercent]);
    useEffect(() => {
        onChange ? onChange({ min: minVal, max: maxVal }) : '';
    }, [minVal, maxVal, onChange]);
    const setMinimumRangeValue = (event) => {
        const value = Math.min(+event.target.value, maxVal);
        setMinVal(value);
    };
    const setMaximumRangeValue = (event) => {
        const value = Math.max(+event.target.value, minVal);
        setMaxVal(value);
    };
    return (React.createElement(StyledBox, null, !hasStart ? (React.createElement(React.Fragment, null,
        React.createElement(StyledInput, Object.assign({}, getTestIdAttribute(dataTestId || name), { value: maxVal, type: "range", min: min, disabled: disabled, max: max, step: step, name: name, id: `styled-range-input-${dataTestId || name}`, onChange: (e) => (onChange ? onChange(e) : undefined), "data-linear-gradient": dataLinearGradient, "data-disabled": disabled, ref: inputRefElement })),
        React.createElement(StyledOutput, { "data-disabled": disabled, "data-left": `calc(${maxVal}% + (${12 - maxVal * 0.15}px))` }, label ? `${maxVal}% ${label}` : `${maxVal}%`))) : (React.createElement(React.Fragment, null,
        React.createElement(Box, { gap: "xxsmall" },
            React.createElement(Text, { label: `${label}`, dataTestId: "input-range-label", weight: "normal" }),
            React.createElement(Text, { dataTestId: "input-range-unit", weight: "medium", nowrap: true, type: "label", status: "default" },
                minVal,
                unit,
                " - ",
                maxVal,
                unit)),
        React.createElement(StyledSliderOutput, null,
            React.createElement(StyledInputStartRange, Object.assign({}, getTestIdAttribute(dataTestId || name), { value: minVal, type: "range", id: `styled-sliderRange-input-${dataTestId || name}`, min: minPercentRage, max: maxPercentRage, disabled: disabled, step: step, name: name, onChange: (event) => setMinimumRangeValue(event), "data-linear-gradient": dataLinearGradient, "data-disabled": disabled, ref: minValRef })),
            React.createElement(StyledInputEndRange, Object.assign({}, getTestIdAttribute(dataTestId || name), { value: maxVal, type: "range", id: `styled-sliderRange-input2-${dataTestId || name}`, min: minPercentRage, max: maxPercentRage, disabled: disabled, step: step, name: name, onChange: (event) => setMaximumRangeValue(event), "data-linear-gradient": dataLinearGradient, "data-disabled": disabled, ref: maxValRef })),
            React.createElement(Slider_Selected_Range, { ref: range, disabled: disabled }))))));
};

const DashboardContainer = ({ basis, children }) => {
    return (React.createElement(Box, { responsive: true, justify: "stretch", direction: "row", align: "start", alignContent: "stretch", wrap: true, basis: basis || 'full' }, children));
};

const DashboardCardTitle = ({ title, titleContext, dataTestId }) => {
    const leftRef = useRef(null);
    const rightRef = useRef(null);
    const [subWrapped, setSubWrapped] = useState(false);
    useLayoutEffect(() => {
        const onResize = () => {
            var _a, _b;
            setSubWrapped(((_a = leftRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left) === ((_b = rightRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().left));
        };
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);
    const mainTitle = typeof title === 'string' ? (React.createElement(Text, { label: title, type: "title3", dataTestId: `${dataTestId}-title` })) : (title);
    const subTitle = typeof titleContext === 'string' ? (React.createElement(Text, { label: titleContext, type: "label", dataTestId: `${dataTestId}-sub` })) : (titleContext);
    const titleHeight = useMemo(() => { var _a, _b; return (_b = (_a = leftRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) === null || _b === void 0 ? void 0 : _b.toString(); }, [leftRef.current]);
    return (React.createElement(Box, { flex: "grow", direction: "row", justify: "between", align: "baseline", alignContent: "start", wrap: true, overflow: "hidden", pad: { bottom: 'small' }, style: { maxHeight: titleHeight && `${titleHeight}px` } },
        React.createElement(Box, { ref: leftRef }, titleContext && subWrapped ? (React.createElement(Tooltip, { dataTestId: `${dataTestId}-sub`, target: mainTitle, tooltip: subTitle })) : (mainTitle)),
        subTitle && React.createElement(Box, { ref: rightRef }, subTitle)));
};

const DashboardCardLoadingContainer = ({ children, isLoading, skeleton, height, pad, }) => {
    return (React.createElement(LoadingContainer, { height: height, size: "full", pad: pad, noPad: !pad, skeleton: skeleton || true, isLoading: isLoading }, children));
};

const defaultTitleHeight = 46;
const smallPaddingPixels = 12;
const BaseDashboardCard = ({ dataTestId, title, titleContext, children, customActions, fill = true, maxHeight = '100%', minHeight = '120px', skeleton, isLoading = false, }) => {
    const height = parseInt(minHeight.slice(0, minHeight.length - 2));
    return (React.createElement(Box, Object.assign({ responsive: true, fill: true, pad: "xsmall" }, getTestIdAttribute(dataTestId)),
        React.createElement(LoadingContainer, { skeleton: skeleton || true, size: "full", height: parseInt(minHeight.slice(0, minHeight.length - 2)), isLoading: (skeleton && typeof skeleton !== 'boolean' && isLoading) || false },
            React.createElement(Box, { direction: "column", fill: fill, background: "white", flex: { shrink: 0 }, round: "4px", style: {
                    boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.2)',
                    maxHeight,
                    minHeight,
                } },
                (title || titleContext || customActions) && (React.createElement(Box, { pad: { top: '14px', horizontal: '20px' }, style: { minHeight: `${defaultTitleHeight}px` }, direction: "row", justify: "between", align: "start", alignContent: "start", wrap: true },
                    React.createElement(DashboardCardTitle, { title: title, titleContext: titleContext }),
                    customActions && React.createElement(Box, null, customActions))),
                React.createElement(Box, { flex: "grow", align: "start", style: { overflow: 'auto', maxHeight: '100%' } },
                    React.createElement(DashboardCardLoadingContainer, { height: height - defaultTitleHeight - 2 * smallPaddingPixels, 
                        // height={30}
                        pad: !!isLoading ? 'small' : 'none', isLoading: !!isLoading },
                        React.createElement(Box, { pad: { bottom: '14px', horizontal: '20px' } }, children)))))));
};
const DashboardCard = (props) => {
    return React.createElement(BaseDashboardCard, Object.assign({}, props));
};

const ListCardItemSkeleton = () => {
    return (React.createElement(Row, { gap: "small", pad: "xsmall", wrap: false },
        React.createElement(Column, { noPad: true },
            React.createElement(Skeleton, { width: "xxsmall", height: "xxsmall", type: "circle" })),
        React.createElement(Column, { expand: true, noPad: true, gap: "xsmall" },
            React.createElement(Skeleton, { width: "medium", height: 30, type: "rectangle" }),
            React.createElement(Skeleton, { width: "medium", height: "xxsmall", type: "rectangle" }))));
};
const IconButtonDrop = ({ dataTestId, icon = 'moreVertical', actionPanel, onOpen, onClose, }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const onDropOpen = () => {
        setOpen(true);
        if (onOpen)
            onOpen();
    };
    const onDropClose = () => {
        setOpen(false);
        if (onClose)
            onClose();
    };
    return (React.createElement(Box, { ref: ref },
        React.createElement(IconButton, { dataTestId: dataTestId, icon: icon, size: "small", status: "default", onClick: () => (!open ? onDropOpen() : onDropClose()) }),
        open && ref.current && (React.createElement(Tooltip, { eventType: "pinned", dataTestId: `${dataTestId}-tooltip`, tooltip: actionPanel, refElement: ref, align: ['right', 'bottom'], light: true, onClickOutside: onDropClose }))));
};
const ListCard = ({ dataTestId, title, data, titleContext, customActions, isLoading = false, }) => {
    const noData = !data || data.length === 0;
    const cardProps = {
        dataTestId: `${dataTestId}-card`,
        title,
        titleContext,
        customActions,
        minHeight: '300px',
    };
    new Date().getTime();
    return (React.createElement(DashboardCard, Object.assign({}, cardProps),
        React.createElement(Column, { noPad: true, justify: "start", fill: "horizontal" },
            noData &&
                (isLoading ? (React.createElement(React.Fragment, null,
                    React.createElement(ListCardItemSkeleton, null),
                    React.createElement(ListCardItemSkeleton, null),
                    React.createElement(ListCardItemSkeleton, null))) : (React.createElement(Box, { pad: "large" }, getI18nStr('noDataAvailable')))),
            data.map(({ title, icon, actions, content }, i) => {
                return (React.createElement(LoadingContainer, { key: i.toString(), isLoading: isLoading && !noData, skeleton: React.createElement(ListCardItemSkeleton, null) },
                    React.createElement(Box, { direction: "row", justify: "start", align: "start", pad: { vertical: 'small' }, border: {
                            size: i === 0 ? 'none' : 'xsmall',
                            side: 'top',
                            color: 'lightMediumGray',
                        } },
                        React.createElement(Box, { direction: "row" },
                            icon && (React.createElement(Box, { direction: "column", flex: "grow", pad: { horizontal: 'small' } },
                                React.createElement(Icon, { name: icon, dataTestId: "list-item-icon" }))),
                            React.createElement(Box, { direction: "column" },
                                React.createElement(Row, { noPad: true },
                                    React.createElement(Truncate, { dataTestId: `${dataTestId}-${i}-title`, label: title, type: "title3", lineCount: 2 })),
                                content && React.createElement(Row, { noPad: true }, content))),
                        React.createElement(Box, { direction: "row", justify: "end", flex: "grow" }, actions && (React.createElement(IconButtonDrop, { dataTestId: `${dataTestId}-actions`, actionPanel: React.createElement(React.Fragment, null, actions) }))))));
            }))));
};

const AppContainer = ({ fitToContent = false, fitToParent = false, dataTestId, isRoot = false, children, theme = 'curo', darkMode = false, containerTarget, min, background, }) => {
    const style = {};
    if (isRoot) {
        style.width = '100%';
        style.overflowX = 'hidden';
        style.display = 'flex';
        style.flexDirection = 'column';
    }
    else if (fitToContent) {
        // !isRoot
        style.width = 'auto';
        style.height = 'auto';
    }
    else if (fitToParent) {
        // !isRoot
        style.width = '100%';
        style.height = '100%';
    }
    const themeObject = theme === 'vega' ? vegaTheme : curoTheme;
    themeObject.darkMode = darkMode;
    if (theme === 'vega')
        logger('Usage of vega theme will be deprecated', 'error');
    return (React.createElement(Grommet, Object.assign({ theme: themeObject, themeMode: darkMode ? 'dark' : 'light', full: min || (isRoot || !fitToContent || !fitToParent), style: style, background: background || CuroColors.white }, getTestIdAttribute(dataTestId), { containerTarget: containerTarget }), children));
};

const AppContainerStories = ({ children }) => {
    return (React.createElement(Grommet, { theme: curoTheme },
        React.createElement(Box, { fill: true }, children)));
};

const InnerContainer = styled(Box).withConfig({ displayName: "InnerContainer", componentId: "sc-5b7m04" }) `
  background: ${props => getStyledInternalColor(props, 'lightCoolGray')};
  padding: 6px;
  border: ${props => props['data-border'] ? `1px solid ${getStyledInternalColor(props, 'mediumGray')}` : null};
  height: 100%;
  width: 100%;
`;
const FullViewLayoutContainer = styled(Box).withConfig({ displayName: "FullViewLayoutContainer", componentId: "sc-1c7sacf" }) `
  background: ${props => getStyledCuroColor(props, 'white')};
  border: ${props => props['data-border'] ? `1px solid ${getStyledInternalColor(props, 'mediumGray')}` : null};
  margin: 6px;
  padding: 20px;
  max-height: 100%;
  height: 100%;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
`;
const ContentContainer = ({ contentHeader, contentFooter, children, sidebar, leftColumn, rightColumn, summaryDetails, border = true, fullViewLayout = false, dataTestId, borderRadius = 8, }) => {
    const vSize = useContext(ResponsiveContext);
    const Header = (React.createElement(Box, { direction: "row", pad: "xsmall", align: "center", flex: { shrink: 0 } }, contentHeader));
    const Footer = contentFooter && (React.createElement(Box, { flex: { shrink: 0 }, height: "40px" }, contentFooter));
    let BodyContent;
    if (fullViewLayout && children) {
        BodyContent = (React.createElement(FullViewLayoutContainer, { round: border && borderRadius ? `${borderRadius}px` : '8px', "data-border": border }, children));
    }
    else {
        BodyContent = children && children;
    }
    if (!BodyContent && !(leftColumn && rightColumn))
        logger('Please provide children or the values of both leftColumn & rightColumn', 'warning');
    const colSizes = ['large', 'customBreakpoint', 'medium', 'small'];
    return (React.createElement(Box, Object.assign({ direction: "row", fill: true }, getTestIdAttribute(dataTestId)),
        sidebar && sidebar,
        React.createElement(InnerContainer, { fill: true, "data-border": border, round: border && borderRadius ? `${borderRadius}px` : undefined },
            contentHeader && Header,
            summaryDetails && (React.createElement(Box, { direction: "row", flex: { shrink: 0 } }, summaryDetails)),
            BodyContent,
            leftColumn && rightColumn && (React.createElement(Box, { fill: true, justify: "between", direction: colSizes.includes(vSize) ? 'column' : 'row' },
                React.createElement(Box, { style: {
                        // 352 => 340 (contextual panel) + 6 (margin-left) + 6 (margin-right)
                        width: colSizes.includes(vSize) ? '100%' : 'calc(100% - 352px)',
                    } }, leftColumn),
                React.createElement(Box, null, rightColumn))),
            Footer)));
};

const Container = styled(Box).withConfig({ displayName: "Container", componentId: "sc-1ghipl3" }) `
  background: ${props => getStyledCuroColor(props, 'white')};
  border: ${props => props['data-border'] ? `1px solid ${getStyledInternalColor(props, 'mediumGray')};` : null};
  margin: 6px;
  padding: 20px;
  height: 100%;
  width: auto;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
`;
const Span = styled.span.withConfig({ displayName: "Span", componentId: "sc-nluoyz" }) `
  font-weight: ${WeightType.medium};
  font-size: ${TextConfigs.title1[0]};
`;
const DetailContainer = ({ title, filter, tabs, footer, children, scroll = true, border = true, dataTestId, borderRadius = 4, }) => {
    const Header = (React.createElement(Box, { direction: "row", justify: !title ? 'start' : 'between', align: "center", flex: { shrink: 0 } },
        title && typeof title === 'string' ? React.createElement(Span, null, title) : title,
        filter && filter));
    const Footer = footer && (React.createElement(Box, { flex: { shrink: 0 }, height: "40px" }, footer));
    const hideHeader = !title && !filter;
    return (React.createElement(Container, Object.assign({ height: scroll ? '100%' : undefined, "data-border": border, gap: "20px", round: `${borderRadius}px` }, getTestIdAttribute(dataTestId)),
        !hideHeader && Header,
        React.createElement(React.Fragment, null,
            React.createElement(Box, { fill: true, overflow: "auto" },
                tabs && tabs,
                children && children)),
        Footer));
};

const StyledSubtitle = styled(Text).withConfig({ displayName: "StyledSubtitle", componentId: "sc-12n526n" }) `
  line-height: 20px;
`;
const ContextualLoading = ({ dataTestId, count, customTitle, showScroll }) => {
    return (React.createElement(React.Fragment, null,
        customTitle,
        React.createElement(Box, { overflow: showScroll ? 'auto' : 'visible' }, [...new Array(count)].map((item, index) => (React.createElement(Box, { border: count - 1 === index ? false : 'bottom', direction: "row", gap: "20px", pad: index === 0 ? { bottom: '13px', top: '40px' } : { vertical: '13px' }, key: `${dataTestId}-${item}-${index}` },
            React.createElement(Column, { size: "50%", noPad: true },
                React.createElement(Skeleton, { width: "100%", height: "17px", dataTestId: "skeleton-label" })),
            React.createElement(Column, { size: "50%", noPad: true },
                React.createElement(Skeleton, { width: "100%", height: "17px", dataTestId: "skeleton-label" }))))))));
};
const ContextualPanel = ({ title, content, showScroll, border = true, seperator, dataTestId, isLoading, contentCount, skeleton, truncate = false, borderRadius = 4, }) => {
    if (seperator !== undefined) {
        logger('seperator is deprecated', 'error');
    }
    const customTitle = typeof title === 'string' ? (React.createElement(Text, { type: "title4", dataTestId: `${dataTestId}-title`, label: title })) : (title);
    const white = useCuroColor('white');
    const lightCoolGray = useInternalColor('lightCoolGray');
    const CustomLabel = ({ obj, index }) => {
        return truncate ? (React.createElement(Truncate, { type: "label", status: "gray", label: obj.left, dataTestId: `${dataTestId}-label-${index}` })) : (React.createElement(Text, { type: "label", status: "gray", dataTestId: `${dataTestId}-label-${index}`, label: obj.left }));
    };
    const CustomValue = ({ obj, index }) => {
        return truncate ? (React.createElement(Truncate, { type: "label", status: "default", label: obj.right, dataTestId: `${dataTestId}-value-${index}` })) : (React.createElement(Text, { type: "label", status: "default", dataTestId: `${dataTestId}-value-${index}`, label: obj.right }));
    };
    const defaultLoading = (React.createElement(ContextualLoading, { dataTestId: dataTestId, count: contentCount || (content === null || content === void 0 ? void 0 : content.length) || 8, customTitle: customTitle, showScroll: showScroll }));
    const RenderLabelAndValue = ({ obj, index, length }) => {
        const lastElIndex = length - 1;
        return (React.createElement(Box, { border: lastElIndex === index ? false : 'bottom', direction: "row", gap: vSize === 'xlarge' ? '20px' : '48px', pad: { vertical: '12px' }, key: index },
            React.createElement(Box, { width: "50%", justify: "center" }, typeof obj.left === 'string' ? React.createElement(CustomLabel, { obj: obj, index: index }) : obj.left),
            React.createElement(Box, { width: "50%", justify: "center" }, typeof obj.right === 'string' ? React.createElement(CustomValue, { obj: obj, index: index }) : obj.right)));
    };
    const RenderLabelAndValueWithSections = ({ obj, index }) => {
        return (React.createElement(Box, { pad: { top: '40px' }, key: index.toString() },
            React.createElement(Box, { pad: { vertical: '6px', horizontal: '12px' }, background: lightCoolGray },
                React.createElement(StyledSubtitle, { type: "label", weight: "medium", status: "default", dataTestId: `${dataTestId}-section-${index}-sub-title`, label: obj.subTitle })),
            obj.section &&
                obj.section.map((section, sectionIndex) => (React.createElement(Box, { pad: { horizontal: 'small' }, key: `${index.toString()}-${sectionIndex.toString()}` },
                    React.createElement(RenderLabelAndValue, { obj: section, index: `${index}-${sectionIndex}`, length: obj.section.length }))))));
    };
    const vSize = useContext(ResponsiveContext);
    return (React.createElement(LoadingContainer, { style: {
            flexShrink: 0,
            width: vSize === 'xlarge' ? '340px' : '100%',
            boxShadow: border ? `0px 0px 4px ${useCuroColor('black', 0.2)}` : undefined,
            borderRadius: `${borderRadius}px`,
            padding: '20px',
            backgroundColor: white,
        }, dataTestId: dataTestId, isLoading: isLoading === true, gap: "20px", skeleton: skeleton || defaultLoading }, isLoading !== true && (React.createElement(React.Fragment, null,
        customTitle,
        React.createElement(Box, { overflow: showScroll ? 'auto' : 'visible' }, content &&
            content.map((obj, index) => {
                return obj.subTitle ? (React.createElement(RenderLabelAndValueWithSections, { obj: obj, index: index, key: index.toString() })) : (React.createElement(Box, { pad: index === 0 ? { top: '28px' } : '', key: index.toString() },
                    React.createElement(RenderLabelAndValue, { obj: obj, index: index, length: content.length })));
            }))))));
};

/* eslint-disable react-hooks/exhaustive-deps */
const StyledIcon = styled(Icon).withConfig({ displayName: "StyledIcon", componentId: "sc-1ueps49" }) `
  svg {
    circle {
      fill: ${props => getStyledInternalColor(props, 'mediumGray')};
    }
  }
  &:hover:not([disabled]) {
    svg {
      path[fill='none'] {
        stroke: ${props => getStyledCuroColor(props, 'white')};
      }
      circle {
        fill: ${props => getStyledCuroColor(props, 'disabled')};
      }
    }
  }
`;
const SearchBar = ({ placeholder = 'Enter search term', value, onSelect, onSuggestionsOpen, searchBarOpen = true, size = 'medium', onSuggestionsClose, suggestions, onClear, onChange, dataTestId, }) => {
    const inputEl = useRef(null);
    const [isSearchBoxOpen, setIsSearchBoxOpen] = useState(searchBarOpen);
    const [valueEntered, setValueEntered] = useState(value && value.length > 0);
    const focusInput = () => {
        if (isSearchBoxOpen && inputEl && inputEl.current) {
            inputEl.current.focus();
        }
    };
    useEffect(() => {
        focusInput();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSearchBoxOpen]);
    useEffect(() => {
        setIsSearchBoxOpen(searchBarOpen);
    }, [searchBarOpen]);
    const gainsboro = useInternalColor('gainsboro');
    const white = useCuroColor('white');
    const content = () => {
        if (isSearchBoxOpen) {
            return (React.createElement(Box, { fill: "horizontal", direction: "row", border: { color: gainsboro }, background: white, align: "center", round: "4px", onClick: () => { }, focusIndicator: true },
                React.createElement(TextInput$1, Object.assign({}, getTestIdAttribute(dataTestId), { ref: inputEl, onBlur: (e) => !searchBarOpen && e.target.value.length === 0 && setIsSearchBoxOpen(!isSearchBoxOpen), placeholder: placeholder, value: value, onChange: e => {
                        if (onChange)
                            onChange(e);
                        if (e.target.value.length > 0)
                            setValueEntered(true);
                        else
                            setValueEntered(false);
                    }, onSelect: onSelect, onSuggestionsOpen: onSuggestionsOpen, onSuggestionsClose: onSuggestionsClose, suggestions: suggestions, reverse: !valueEntered, plain: true, style: { height: size === 'small' ? '32px' : '40px', boxShadow: 'none' } })),
                valueEntered && onClear && (React.createElement(Box, { pad: { right: 'small', top: 'xsmall' } },
                    React.createElement(StyledIcon, { name: "close", onClick: () => {
                            onClear();
                            focusInput();
                            setValueEntered(false);
                        }, dataTestId: `${dataTestId}-close-icon` })))));
        }
        return (React.createElement(IconButton, { onClick: () => setIsSearchBoxOpen(true), icon: "search", size: size === 'small' ? 'small' : 'medium', dataTestId: `${dataTestId}-search-button` }));
    };
    return content();
};

const TabBox = styled(Box).withConfig({ displayName: "TabBox", componentId: "sc-1g91vtp" }) `
  display: flex;
  flex-direction: row;
  &[data-badge]:after {
    content: attr(data-badge);
    position: relative;
    left: 3px;
    font-size: 0.7em;
    background: darkred;
    color: white;
    min-width: 18px;
    height: 15px;
    text-align: center;
    line-height: 15px;
    border-radius: 50%;
    box-shadow: 0 0 1px #333;
  }
`;
const LocalNavigation = (_a) => {
    var { pageTitle, tabs, tabAlign = 'horizontal', tabClick, dataTestId } = _a, rest = __rest(_a, ["pageTitle", "tabs", "tabAlign", "tabClick", "dataTestId"]);
    // Maintains active tab
    const [active, setActive] = useState(0);
    const onActive = (index) => {
        setActive(index);
    };
    // Handle Left & Right Navigation from keyboard.
    // To-Do: Space or Enter: Activates the tab if it was not activated automatically on focus.
    const handleKeyDown = (e) => {
        // Handle Right Arrow
        if (e.keyCode === 39 && active < tabs.length - 1 && !tabs[active + 1].disabled)
            setActive(active + 1);
        // Handle Left Arrow
        if (e.keyCode === 37 && active > 0 && !tabs[active - 1].disabled)
            setActive(active - 1);
    };
    const tabFlow = tabAlign === 'horizontal' ? 'row' : 'column';
    return (React.createElement(Box, { margin: { bottom: 'xxsmall' } },
        React.createElement(Box, Object.assign({ direction: "row", border: {
                side: 'bottom',
                color: 'light-4',
                style: `${tabAlign === 'horizontal' ? 'solid' : 'hidden'}`,
            }, height: `${tabAlign === 'horizontal' ? '52px' : 'auto'}`, "data-test-id": `${dataTestId}-local-nav`, background: "white", align: "center", a11yTitle: "local-navigation", flex: { grow: 1, shrink: 0 }, basis: "auto" }, rest),
            React.createElement(Box, { direction: tabFlow, fill: true },
                pageTitle && (React.createElement(Box, { pad: "small", margin: { right: 'large' }, basis: "auto", flex: { grow: 1, shrink: 0 } },
                    React.createElement(Text$1, { size: "large", weight: 600 }, pageTitle))),
                React.createElement(Box, { direction: "row", style: { overflow: 'auto' } },
                    React.createElement(Box, { direction: tabFlow, margin: tabAlign === 'horizontal' ? { right: 'large' } : '', basis: "auto", flex: { grow: 1, shrink: 0 } }, tabs &&
                        tabs.map((tab, index) => (
                        // Map through each of the tab
                        React.createElement(TabBox, { fill: tabAlign !== 'horizontal', 
                            // Pad & margin values are according to Grommet specs not the UX specs
                            key: index.toString(), onKeyDown: handleKeyDown, alignSelf: "center", 
                            // Set border when tab is active
                            // TODO: cannot pass eslint, need to reorg the code
                            border: index === active
                                ? {
                                    side: tabAlign === 'horizontal' ? 'bottom' : 'left',
                                    size: 'medium',
                                    color: 'brand',
                                }
                                : { style: 'hidden' }, background: index === active ? `${tabAlign === 'vertical' ? 'light-1' : ''}` : '', style: {
                                // flex: `${index === active ? '1 0 auto' : ''}`,
                                // Tab cannot be pointed when disabled
                                pointerEvents: `${tab.disabled ? 'none' : 'auto'}`,
                                padding: '12px 20px',
                            }, "data-badge": tab.badgeCount },
                            React.createElement(Button$2, { onClick: (e) => {
                                    onActive(index);
                                    tabClick(e, tab);
                                } },
                                React.createElement(Text$1
                                // Sentence to stay in the same line
                                , { 
                                    // Sentence to stay in the same line
                                    style: {
                                        whiteSpace: 'nowrap',
                                        fontWeight: `${index === active ? 600 : 400}`,
                                    }, color: `${tab.disabled ? 'dark-5' : ''}` }, tab.label)))))))))));
};

// To-Do: Add marker styles for decimal
styled.ol.withConfig({ displayName: "Ol", componentId: "sc-1gam94z" }) `
  list-style-type: ${props => props['data-list-style-type']};
`;
const Ul = styled.ul.withConfig({ displayName: "Ul", componentId: "sc-bwrnea" }) `
  list-style-type: ${props => props['data-list-style-type']};
`;
const List = ({ children, dataTestId }) => {
    // Until listStyleType is exposed as API, use it from constant where it defaults to disc
    const listStyleType = 'disc';
    // @ts-ignore
    const Wrapper = Ul;
    return (React.createElement(Wrapper, Object.assign({ "data-list-style-type": listStyleType }, getTestIdAttribute(dataTestId)), children));
};
const ListItem = ({ value, children, dataTestId }) => (React.createElement("li", Object.assign({ value: value }, getTestIdAttribute(dataTestId)),
    typeof children === 'string' && React.createElement(Text, { label: children, dataTestId: `${dataTestId}-text` }),
    typeof children !== 'string' && children));

export { Accordion, ActionRow, AddRemove, AddRemoveControlled, AddRemoveItem, AppContainer, AppContainerStories, AreaChart, BarChart, Breadcrumbs, Button$1 as Button, Calendar, Card, Carousel, ChartColorMap, ChartSideBar, CheckBox, LightCuroColors as ColorType, Column, ColumnChart, ContentContainer, ContextualPanel, DashboardCard, DashboardContainer, ListCard as DashboardListCard, DateSelector, DetailContainer, DigitInput, DonutChart, DropdownActionMenu, FieldSet, FileInput, FlashMessage, Form, FormField, Grid, Icon, IconButton, Iframe, Image, Legend, LineChart, Link, List, ListItem, LoadingContainer, LocalNavigation, LoginPage, Modal, NetworkGraph, PageHeader, Panel, Paragraph, RadioButton, RadioButtonGroup, RangeInput, Table as ReactTable, Row, SearchBar, Select, SelectMultiple, Shuttle$1 as Shuttle, Shuttle as Shuttlev2, Sidebar, Skeleton, Slider, StackedBar, StackedBarBox, StatsDataFetch, StatsIntervalInitVal, StatsIntervalOptions, StatsTimeSelector, SummaryCard, SvgTooltip, Tab, Table$2 as Table, Table$1 as TableDeprecated, Tabs, TabsContext, Tag, TagContainer, TaskManager, Text, TextArea, TextInput, ToggleButton, Toolbar, Tooltip, TreeItem, TreeView, Truncate, Wizard, WizardStep, configI18n, configure, en, getChartStatusColor, getDate, getFullTimeDisplay, getLastSeconds, getLongTimeDisplay, getMonthYear, getMonthYearByIso, getNextMonth, getPreviousMonth, getTestIdAttribute, logger };
//# sourceMappingURL=index.js.map
